
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire91fc"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire91fc"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lDZ5d", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.37
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    "use strict";
    //////////////
    // Constants
    /////////////
    var LIBVERSION = "1.0.37", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        "ME": "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        "2000": "NT 5.0",
        "XP": [
            "NT 5.1",
            "NT 5.2"
        ],
        "Vista": "NT 6.0",
        "7": "NT 6.1",
        "8": "NT 6.2",
        "8.1": "NT 6.3",
        "10": [
            "NT 6.4",
            "NT 10.0"
        ],
        "RT": "ARM"
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                // Trident based
                /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i // 360
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/2345 Browser
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i // Panasonic Viera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

// TODO generate on build from git tag
var $b53ace5c1f7fa838$exports = {};
$b53ace5c1f7fa838$exports = JSON.parse('{"name":"@slashid/slashid","private":false,"publishConfig":{"access":"public"},"version":"3.28.0","description":"Client SDK for the /id platform","homepage":"https://slashid.dev","author":"SlashID","license":"MIT","main":"./dist/bundle/slashid.js","module":"./dist/esmodule/slashid.esm.js","esmodule":"./dist/esmodule/slashid.esm.js","commonjs":"./dist/commonjs/slashid.cjs.js","bundle":"./dist/bundle/slashid.js","types":"./dist/types/slashid.d.ts","exports":{".":{"require":"./dist/commonjs/slashid.cjs.js","import":"./dist/esmodule/slashid.esm.js","default":"./dist/commonjs/slashid.cjs.js","types":"./dist/types/slashid.d.ts"}},"targets":{"esmodule":{"source":"src/targets/package.ts","context":"browser","isLibrary":true,"outputFormat":"esmodule","engines":{"browsers":["and_chr >= 73","chrome >= 73","and_ff >= 67","android >= 114","edge >= 79","samsung >= 11.2","safari >= 13","ios_saf >= 13.1","opera >= 60","firefox >= 67","unreleased and_chr versions","unreleased chrome versions","unreleased and_ff versions","unreleased android versions","unreleased edge versions","unreleased samsung versions","unreleased safari versions","unreleased ios_saf versions","unreleased opera versions","unreleased firefox versions"]}},"commonjs":{"source":"src/targets/package.ts","context":"node","isLibrary":true,"outputFormat":"commonjs","engines":{"node":">= 12"}},"bundle":{"source":"src/targets/bundle.ts","context":"browser","outputFormat":"global","engines":{"browsers":["> 0.5%","last 2 versions","not dead"]}},"page":{"source":"static/sdk.html","context":"browser","engines":{"browsers":["and_chr >= 73","chrome >= 73","and_ff >= 67","android >= 114","edge >= 79","samsung >= 11.2","safari >= 13","ios_saf >= 13.1","opera >= 60","firefox >= 67","unreleased and_chr versions","unreleased chrome versions","unreleased and_ff versions","unreleased android versions","unreleased edge versions","unreleased samsung versions","unreleased safari versions","unreleased ios_saf versions","unreleased opera versions","unreleased firefox versions"]}},"types":{"source":"src/targets/package.ts"}},"files":["dist/*"],"keywords":["slashid","SlashID","auth","openid","authentication","jwt","browser"],"scripts":{"clean":"rm -rf dist docs","lint":"eslint ./src --ext .ts","format":"prettier --config .prettierrc.json \'src/**/*.ts\' --write","test:ts":"tsc --project tsconfig.json --noEmit","test:unit":"jest","test:unit:watch":"jest --watch","test:unit:ci":"jest --ci","test:integration":"playwright test","build":"rm -rf dist && parcel build --no-cache && cp compat/esmodule/package.json dist/esmodule","docs":"rm -rf docs && typedoc","dist":"npm run lint && npm run build","all":"npm run dist && npm run docs","serve:all":"parcel serve \'static/*.html\' --port 8080 --no-cache","serve:example":"parcel serve static/index.html --port 8080 --no-cache","serve:jump":"parcel serve static/sdk.html --port 8080 --no-cache","serve:docs":"parcel serve docs/index.html --port 8081 --no-cache","push:docs":"aws s3 sync docs s3://slashiddoc/sdk/v$(node tools/version.js --major) && (aws cloudfront create-invalidation --distribution-id ETLBNGAAF97EN --paths \\"/*\\")","changeset":"changeset","prepublishOnly":"npm run all","publish:ci":"npm run build && changeset publish"},"devDependencies":{"@parcel/core":"2.12.0","@parcel/packager-ts":"2.12.0","@parcel/resolver-default":"^2.13.2","@parcel/transformer-babel":"2.12.0","@parcel/transformer-js":"2.12.0","@parcel/transformer-json":"2.12.0","@parcel/transformer-react-refresh-wrap":"2.12.0","@parcel/transformer-typescript-types":"2.12.0","@playwright/test":"1.42.1","@types/jest":"^28.1.7","@types/node":"~15.0.2","@types/qrcode":"^1.5.0","@types/ua-parser-js":"^0.7.39","@typescript-eslint/eslint-plugin":"^4.15.1","@typescript-eslint/parser":"^4.15.1","danger":"^11.2.6","eslint":"^7.20.0","eslint-config-prettier":"^8.5.0","eslint-plugin-prettier":"^4.2.1","https-proxy-agent":"^7.0.5","isomorphic-fetch":"^3.0.0","jest":"^28.1.3","jest-environment-jsdom":"^28.1.3","jest-fetch-mock":"^3.0.3","parcel":"2.12.0","prettier":"^2.7.1","ts-jest":"^28.0.8","typedoc":"^0.23.00","typedoc-plugin-mdn-links":"^2.0.0","typedoc-plugin-missing-exports":"^1.0.0","typescript":"~4.7.0"},"dependencies":{"@changesets/cli":"^2.27.5","@types/uuid":"8.3.4","compare-versions":"^6.1.0","docdash":"^1.2.0","jwt-decode":"^3.1.2","qrcode":"^1.5.1","querystring-es3":"^0.2.1","regenerator-runtime":"^0.13.9","ua-parser-js":"^1.0.37","url":"^0.11.0","uuid":"8.3.2"}}');


const [$0c9d6ccd124360dc$var$major, $0c9d6ccd124360dc$var$minor, $0c9d6ccd124360dc$var$patch] = (0, $b53ace5c1f7fa838$exports.version).split(".");
const $0c9d6ccd124360dc$export$f9582ef3c55143f = {
    major: $0c9d6ccd124360dc$var$major,
    minor: $0c9d6ccd124360dc$var$minor,
    patch: $0c9d6ccd124360dc$var$patch,
    raw: (0, $b53ace5c1f7fa838$exports.version)
};


/* tslint:disable */ /* eslint-disable */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ const $168d06aed8b3cdb0$export$2812a1fb15aca49c = "https://api.slashid.com".replace(/\/+$/, "");
class $168d06aed8b3cdb0$export$fa89be98fe0936f2 {
    set config(configuration) {
        this.configuration = configuration;
    }
    get basePath() {
        return this.configuration.basePath != null ? this.configuration.basePath : $168d06aed8b3cdb0$export$2812a1fb15aca49c;
    }
    get fetchApi() {
        return this.configuration.fetchApi;
    }
    get middleware() {
        return this.configuration.middleware || [];
    }
    get queryParamsStringify() {
        return this.configuration.queryParamsStringify || $168d06aed8b3cdb0$export$ac4103b836844853;
    }
    get username() {
        return this.configuration.username;
    }
    get password() {
        return this.configuration.password;
    }
    get apiKey() {
        const apiKey = this.configuration.apiKey;
        if (apiKey) return typeof apiKey === "function" ? apiKey : ()=>apiKey;
        return undefined;
    }
    get accessToken() {
        const accessToken = this.configuration.accessToken;
        if (accessToken) return typeof accessToken === "function" ? accessToken : async ()=>accessToken;
        return undefined;
    }
    get headers() {
        return this.configuration.headers;
    }
    get credentials() {
        return this.configuration.credentials;
    }
    constructor(configuration = {}){
        this.configuration = configuration;
    }
}
const $168d06aed8b3cdb0$export$ac4f8128ea29c5 = new $168d06aed8b3cdb0$export$fa89be98fe0936f2();
class $168d06aed8b3cdb0$export$70edad7ad5bb3f5d {
    withMiddleware(...middlewares) {
        const next = this.clone();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }
    withPreMiddleware(...preMiddlewares) {
        const middlewares = preMiddlewares.map((pre)=>({
                pre: pre
            }));
        return this.withMiddleware(...middlewares);
    }
    withPostMiddleware(...postMiddlewares) {
        const middlewares = postMiddlewares.map((post)=>({
                post: post
            }));
        return this.withMiddleware(...middlewares);
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */ isJsonMime(mime) {
        if (!mime) return false;
        return $168d06aed8b3cdb0$export$70edad7ad5bb3f5d.jsonRegex.test(mime);
    }
    async request(context, initOverrides) {
        const { url: url, init: init } = await this.createFetchParams(context, initOverrides);
        const response = await this.fetchApi(url, init);
        if (response && response.status >= 200 && response.status < 300) return response;
        throw new $168d06aed8b3cdb0$export$286baf652d0b1206(response, "Response returned an error code");
    }
    async createFetchParams(context, initOverrides) {
        let url = this.configuration.basePath + context.path;
        if (context.query !== undefined && Object.keys(context.query).length !== 0) // only add the querystring to the URL if there are query parameters.
        // this is done to avoid urls ending with a "?" character which buggy webservers
        // do not handle correctly sometimes.
        url += "?" + this.configuration.queryParamsStringify(context.query);
        const headers = Object.assign({}, this.configuration.headers, context.headers);
        Object.keys(headers).forEach((key)=>headers[key] === undefined ? delete headers[key] : {});
        const initOverrideFn = typeof initOverrides === "function" ? initOverrides : async ()=>initOverrides;
        const initParams = {
            method: context.method,
            headers: headers,
            body: context.body,
            credentials: this.configuration.credentials
        };
        const overriddenInit = {
            ...initParams,
            ...await initOverrideFn({
                init: initParams,
                context: context
            })
        };
        const init = {
            ...overriddenInit,
            body: $168d06aed8b3cdb0$var$isFormData(overriddenInit.body) || overriddenInit.body instanceof URLSearchParams || $168d06aed8b3cdb0$var$isBlob(overriddenInit.body) ? overriddenInit.body : JSON.stringify(overriddenInit.body)
        };
        return {
            url: url,
            init: init
        };
    }
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */ clone() {
        const constructor = this.constructor;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
    constructor(configuration = $168d06aed8b3cdb0$export$ac4f8128ea29c5){
        this.configuration = configuration;
        this.fetchApi = async (url, init)=>{
            let fetchParams = {
                url: url,
                init: init
            };
            for (const middleware of this.middleware)if (middleware.pre) fetchParams = await middleware.pre({
                fetch: this.fetchApi,
                ...fetchParams
            }) || fetchParams;
            let response = undefined;
            try {
                response = await (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
            } catch (e) {
                for (const middleware of this.middleware)if (middleware.onError) response = await middleware.onError({
                    fetch: this.fetchApi,
                    url: fetchParams.url,
                    init: fetchParams.init,
                    error: e,
                    response: response ? response.clone() : undefined
                }) || response;
                if (response === undefined) {
                    if (e instanceof Error) throw new $168d06aed8b3cdb0$export$26e841bcf1aeb894(e, "The request failed and the interceptors did not return an alternative response");
                    else throw e;
                }
            }
            for (const middleware of this.middleware)if (middleware.post) response = await middleware.post({
                fetch: this.fetchApi,
                url: fetchParams.url,
                init: fetchParams.init,
                response: response.clone()
            }) || response;
            return response;
        };
        this.middleware = configuration.middleware;
    }
}
$168d06aed8b3cdb0$export$70edad7ad5bb3f5d.jsonRegex = new RegExp("^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$", "i");
function $168d06aed8b3cdb0$var$isBlob(value) {
    return typeof Blob !== "undefined" && value instanceof Blob;
}
function $168d06aed8b3cdb0$var$isFormData(value) {
    return typeof FormData !== "undefined" && value instanceof FormData;
}
class $168d06aed8b3cdb0$export$286baf652d0b1206 extends Error {
    constructor(response, msg){
        super(msg);
        this.response = response;
        this.name = "ResponseError";
    }
}
class $168d06aed8b3cdb0$export$26e841bcf1aeb894 extends Error {
    constructor(cause, msg){
        super(msg);
        this.cause = cause;
        this.name = "FetchError";
    }
}
class $168d06aed8b3cdb0$export$a27bea7cdb975d70 extends Error {
    constructor(field, msg){
        super(msg);
        this.field = field;
        this.name = "RequiredError";
    }
}
const $168d06aed8b3cdb0$export$83cb526776fb323d = {
    csv: ",",
    ssv: " ",
    tsv: "	",
    pipes: "|"
};
function $168d06aed8b3cdb0$export$f7e9f41ea797a17(json, key) {
    const value = json[key];
    return value !== null && value !== undefined;
}
function $168d06aed8b3cdb0$export$ac4103b836844853(params, prefix = "") {
    return Object.keys(params).map((key)=>$168d06aed8b3cdb0$var$querystringSingleKey(key, params[key], prefix)).filter((part)=>part.length > 0).join("&");
}
function $168d06aed8b3cdb0$var$querystringSingleKey(key, value, keyPrefix = "") {
    const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
    if (value instanceof Array) {
        const multiValue = value.map((singleValue)=>encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
        return `${encodeURIComponent(fullKey)}=${multiValue}`;
    }
    if (value instanceof Set) {
        const valueAsArray = Array.from(value);
        return $168d06aed8b3cdb0$var$querystringSingleKey(key, valueAsArray, keyPrefix);
    }
    if (value instanceof Date) return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
    if (value instanceof Object) return $168d06aed8b3cdb0$export$ac4103b836844853(value, fullKey);
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}
function $168d06aed8b3cdb0$export$825e789796ab7275(data, fn) {
    return Object.keys(data).reduce((acc, key)=>({
            ...acc,
            [key]: fn(data[key])
        }), {});
}
function $168d06aed8b3cdb0$export$59072c3750441c02(consumes) {
    for (const consume of consumes){
        if ("multipart/form-data" === consume.contentType) return true;
    }
    return false;
}
class $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4 {
    async value() {
        return this.transformer(await this.raw.json());
    }
    constructor(raw, transformer = (jsonValue)=>jsonValue){
        this.raw = raw;
        this.transformer = transformer;
    }
}
class $168d06aed8b3cdb0$export$20446dc680588cc3 {
    async value() {
        return undefined;
    }
    constructor(raw){
        this.raw = raw;
    }
}
class $168d06aed8b3cdb0$export$9d707f60a06b41f8 {
    async value() {
        return await this.raw.blob();
    }
    constructor(raw){
        this.raw = raw;
    }
}
class $168d06aed8b3cdb0$export$bf40ae8c274ef99b {
    async value() {
        return await this.raw.text();
    }
    constructor(raw){
        this.raw = raw;
    }
}


/* tslint:disable */ /* eslint-disable */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $0eadbd49a71751c9$export$2caf5cdeee54129b(value) {
    let isInstance = true;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "offset" in value;
    isInstance = isInstance && "total_count" in value;
    return isInstance;
}
function $0eadbd49a71751c9$export$c449262465ba2bb9(json) {
    return $0eadbd49a71751c9$export$3fe7617ab48f3b5c(json, false);
}
function $0eadbd49a71751c9$export$3fe7617ab48f3b5c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "limit": json["limit"],
        "offset": json["offset"],
        "total_count": json["total_count"]
    };
}
function $0eadbd49a71751c9$export$9c53a26884a83ec6(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "limit": value.limit,
        "offset": value.offset,
        "total_count": value.total_count
    };
}


function $39b4d090739e0edb$export$90742f18fb91b1a8(value) {
    let isInstance = true;
    return isInstance;
}
function $39b4d090739e0edb$export$70023f934842ce53(json) {
    return $39b4d090739e0edb$export$9057b09091c07cb0(json, false);
}
function $39b4d090739e0edb$export$9057b09091c07cb0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "pagination": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "pagination") ? undefined : (0, $0eadbd49a71751c9$export$c449262465ba2bb9)(json["pagination"])
    };
}
function $39b4d090739e0edb$export$a688b751866cf7f3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "pagination": (0, $0eadbd49a71751c9$export$9c53a26884a83ec6)(value.pagination)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $a9bac9599bd76c1d$export$6c620df6ac3163e7(value) {
    let isInstance = true;
    return isInstance;
}
function $a9bac9599bd76c1d$export$9a91be5fb3879fb9(json) {
    return $a9bac9599bd76c1d$export$39dc308db371e81(json, false);
}
function $a9bac9599bd76c1d$export$39dc308db371e81(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "httpcode": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "httpcode") ? undefined : json["httpcode"],
        "message": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "message") ? undefined : json["message"]
    };
}
function $a9bac9599bd76c1d$export$797f61dd859e886c(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "httpcode": value.httpcode,
        "message": value.message
    };
}


function $98d4ae80407991f3$export$2b7c18f96ce69490(value) {
    let isInstance = true;
    return isInstance;
}
function $98d4ae80407991f3$export$53557473c48f27d7(json) {
    return $98d4ae80407991f3$export$488f61d1ca30688d(json, false);
}
function $98d4ae80407991f3$export$488f61d1ca30688d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9))
    };
}
function $98d4ae80407991f3$export$9f307ab67ab58299(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $ad52f4b379329356$export$b1f97c3099fc6872 = {
    UsIowa: "us-iowa",
    EuropeBelgium: "europe-belgium",
    AsiaJapan: "asia-japan",
    EuropeEngland: "europe-england",
    AustraliaSydney: "australia-sydney"
};
function $ad52f4b379329356$export$4599c92435bbba6e(json) {
    return $ad52f4b379329356$export$9f38cecf57c7d495(json, false);
}
function $ad52f4b379329356$export$9f38cecf57c7d495(json, ignoreDiscriminator) {
    return json;
}
function $ad52f4b379329356$export$2ac40160f30291ff(value) {
    return value;
}


function $4c2582984183ae37$export$35d1912a6e65a4d3(value) {
    let isInstance = true;
    return isInstance;
}
function $4c2582984183ae37$export$f24df1e4bf994e2e(json) {
    return $4c2582984183ae37$export$77e0f518496a5152(json, false);
}
function $4c2582984183ae37$export$77e0f518496a5152(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "region": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "region") ? undefined : (0, $ad52f4b379329356$export$4599c92435bbba6e)(json["region"])
    };
}
function $4c2582984183ae37$export$da1543be29a31e9e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "region": (0, $ad52f4b379329356$export$2ac40160f30291ff)(value.region)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $6efd4ce2feb2bdc3$export$7962c6bffc1da42 = {
    UiCustomization: "ui_customization",
    AuthnContextUpdate: "authn_context_update",
    Proxy: "proxy",
    WebauthnCreate: "webauthn_create",
    WebauthnGet: "webauthn_get",
    Nonce: "nonce",
    Otp: "otp",
    Oidc: "oidc",
    Saml: "saml",
    PasswordSet: "password_set",
    PasswordVerify: "password_verify",
    PasswordReset: "password_reset",
    TotpRegister: "totp_register",
    TotpVerify: "totp_verify"
};
function $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3(json) {
    return $6efd4ce2feb2bdc3$export$b1e18bb9237bd017(json, false);
}
function $6efd4ce2feb2bdc3$export$b1e18bb9237bd017(json, ignoreDiscriminator) {
    return json;
}
function $6efd4ce2feb2bdc3$export$e418cafec408031e(value) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $5db1ceb0857c067d$export$bab851ae817d28dd(value) {
    let isInstance = true;
    return isInstance;
}
function $5db1ceb0857c067d$export$703f66b537d92f5c(json) {
    return $5db1ceb0857c067d$export$a4e33e976363db18(json, false);
}
function $5db1ceb0857c067d$export$a4e33e976363db18(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "challenge": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "challenge") ? undefined : json["challenge"]
    };
}
function $5db1ceb0857c067d$export$91e7f239824ee67f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "challenge": value.challenge
    };
}


function $938a3eca74e6d666$export$88b5d910b589cf13(value) {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;
    return isInstance;
}
function $938a3eca74e6d666$export$dea5b50d6ead812(json) {
    return $938a3eca74e6d666$export$fe0ec9eae36a9b35(json, false);
}
function $938a3eca74e6d666$export$fe0ec9eae36a9b35(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "challenge_id": json["challenge_id"],
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["challenge_type"]),
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : (0, $5db1ceb0857c067d$export$703f66b537d92f5c)(json["data"])
    };
}
function $938a3eca74e6d666$export$2ddc20e282619fc3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "challenge_id": value.challenge_id,
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.challenge_type),
        "data": (0, $5db1ceb0857c067d$export$91e7f239824ee67f)(value.data)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $7531f066927bc183$export$1d9a2093aa5b8546(value) {
    let isInstance = true;
    return isInstance;
}
function $7531f066927bc183$export$bb8ecc995265609e(json) {
    return $7531f066927bc183$export$fe08176e0964d56a(json, false);
}
function $7531f066927bc183$export$fe08176e0964d56a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "otp": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "otp") ? undefined : json["otp"]
    };
}
function $7531f066927bc183$export$6da0bcef5e0a8fdb(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "otp": value.otp
    };
}


function $f449912ebe4a113d$export$3e31be0f0b2d293a(value) {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;
    return isInstance;
}
function $f449912ebe4a113d$export$1898d4ed4a0ad45e(json) {
    return $f449912ebe4a113d$export$4285315b0ce1487c(json, false);
}
function $f449912ebe4a113d$export$4285315b0ce1487c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "challenge_id": json["challenge_id"],
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["challenge_type"]),
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : (0, $7531f066927bc183$export$bb8ecc995265609e)(json["data"])
    };
}
function $f449912ebe4a113d$export$9e8a349f91c23ca8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "challenge_id": value.challenge_id,
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.challenge_type),
        "data": (0, $7531f066927bc183$export$6da0bcef5e0a8fdb)(value.data)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $4c15086ce037a833$export$3e7a5827055f8c1f(value) {
    let isInstance = true;
    isInstance = isInstance && "password" in value;
    return isInstance;
}
function $4c15086ce037a833$export$531fea8f5c0d835d(json) {
    return $4c15086ce037a833$export$d9419205450c9d50(json, false);
}
function $4c15086ce037a833$export$d9419205450c9d50(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "password": json["password"]
    };
}
function $4c15086ce037a833$export$b0b890df0497afa3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "password": value.password
    };
}


function $7129eb840d90c811$export$40bbbf642a3a69ad(value) {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;
    return isInstance;
}
function $7129eb840d90c811$export$5d2326fd568db8d0(json) {
    return $7129eb840d90c811$export$d45d032a25047716(json, false);
}
function $7129eb840d90c811$export$d45d032a25047716(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "challenge_id": json["challenge_id"],
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["challenge_type"]),
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : (0, $4c15086ce037a833$export$531fea8f5c0d835d)(json["data"])
    };
}
function $7129eb840d90c811$export$7b6f5d07bfad78e9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "challenge_id": value.challenge_id,
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.challenge_type),
        "data": (0, $4c15086ce037a833$export$b0b890df0497afa3)(value.data)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $daf2c31c3fecb469$export$a964533c60d268fd(value) {
    let isInstance = true;
    isInstance = isInstance && "password" in value;
    return isInstance;
}
function $daf2c31c3fecb469$export$fe9d75047753248b(json) {
    return $daf2c31c3fecb469$export$756838b7787a84f1(json, false);
}
function $daf2c31c3fecb469$export$756838b7787a84f1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "password": json["password"]
    };
}
function $daf2c31c3fecb469$export$69b7ca2907b53e3d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "password": value.password
    };
}


function $8660c4b56cb27ecd$export$c8ecde44d2fa41f4(value) {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;
    return isInstance;
}
function $8660c4b56cb27ecd$export$17063cb6a2c93912(json) {
    return $8660c4b56cb27ecd$export$539bcbef6d641f12(json, false);
}
function $8660c4b56cb27ecd$export$539bcbef6d641f12(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "challenge_id": json["challenge_id"],
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["challenge_type"]),
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : (0, $daf2c31c3fecb469$export$fe9d75047753248b)(json["data"])
    };
}
function $8660c4b56cb27ecd$export$751a8f178b8690f0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "challenge_id": value.challenge_id,
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.challenge_type),
        "data": (0, $daf2c31c3fecb469$export$69b7ca2907b53e3d)(value.data)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $532c77d166192e4f$export$486889bd75e3b780(value) {
    let isInstance = true;
    isInstance = isInstance && "password" in value;
    return isInstance;
}
function $532c77d166192e4f$export$3fe1672863804c9d(json) {
    return $532c77d166192e4f$export$f4579e3d10a997c7(json, false);
}
function $532c77d166192e4f$export$f4579e3d10a997c7(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "password": json["password"]
    };
}
function $532c77d166192e4f$export$27fad2cccc00f212(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "password": value.password
    };
}


function $a81d20114b11fe07$export$52d6565f54833912(value) {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;
    return isInstance;
}
function $a81d20114b11fe07$export$6d7d3f7497bac8da(json) {
    return $a81d20114b11fe07$export$10d1c2ecf0d72392(json, false);
}
function $a81d20114b11fe07$export$10d1c2ecf0d72392(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "challenge_id": json["challenge_id"],
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["challenge_type"]),
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : (0, $532c77d166192e4f$export$3fe1672863804c9d)(json["data"])
    };
}
function $a81d20114b11fe07$export$b7b281ec8692f580(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "challenge_id": value.challenge_id,
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.challenge_type),
        "data": (0, $532c77d166192e4f$export$27fad2cccc00f212)(value.data)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $a4725d28872dfb5f$export$92ceb7a6bfbf2d2d(value) {
    let isInstance = true;
    return isInstance;
}
function $a4725d28872dfb5f$export$ef169f01af6d5676(json) {
    return $a4725d28872dfb5f$export$54cbfb7c20102b70(json, false);
}
function $a4725d28872dfb5f$export$54cbfb7c20102b70(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "otp": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "otp") ? undefined : json["otp"]
    };
}
function $a4725d28872dfb5f$export$87e83845366bd7e3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "otp": value.otp
    };
}


function $a36427e2ebdb7b90$export$be01d18bf69a8fa(value) {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;
    return isInstance;
}
function $a36427e2ebdb7b90$export$d0c1bdc637e5e895(json) {
    return $a36427e2ebdb7b90$export$b44518c38b369723(json, false);
}
function $a36427e2ebdb7b90$export$b44518c38b369723(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "challenge_id": json["challenge_id"],
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["challenge_type"]),
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : (0, $a4725d28872dfb5f$export$ef169f01af6d5676)(json["data"])
    };
}
function $a36427e2ebdb7b90$export$167110d9a40e7fcd(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "challenge_id": value.challenge_id,
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.challenge_type),
        "data": (0, $a4725d28872dfb5f$export$87e83845366bd7e3)(value.data)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $238a8c60393afa86$export$a3014234fe6a2b9b(value) {
    let isInstance = true;
    return isInstance;
}
function $238a8c60393afa86$export$d31be9a6034a3ec9(json) {
    return $238a8c60393afa86$export$e09d6c39e39b5175(json, false);
}
function $238a8c60393afa86$export$e09d6c39e39b5175(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "otp": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "otp") ? undefined : json["otp"]
    };
}
function $238a8c60393afa86$export$a789f8fc51697f53(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "otp": value.otp
    };
}


function $377b248c78313117$export$752b6405c46bdbd6(value) {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;
    return isInstance;
}
function $377b248c78313117$export$66ec8e67bf59fda(json) {
    return $377b248c78313117$export$afdbafa9ab0915af(json, false);
}
function $377b248c78313117$export$afdbafa9ab0915af(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "challenge_id": json["challenge_id"],
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["challenge_type"]),
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : (0, $238a8c60393afa86$export$d31be9a6034a3ec9)(json["data"])
    };
}
function $377b248c78313117$export$1be77b6cf29772e6(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "challenge_id": value.challenge_id,
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.challenge_type),
        "data": (0, $238a8c60393afa86$export$a789f8fc51697f53)(value.data)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $68761697813975d9$export$a5ca1d3b297dbd23(value) {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;
    return isInstance;
}
function $68761697813975d9$export$14a4778736916973(json) {
    return $68761697813975d9$export$dbc4437c51d4130d(json, false);
}
function $68761697813975d9$export$dbc4437c51d4130d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "challenge_id": json["challenge_id"],
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["challenge_type"]),
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : json["data"]
    };
}
function $68761697813975d9$export$2704f2dae5463d10(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "challenge_id": value.challenge_id,
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.challenge_type),
        "data": value.data
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $b1e25c535a095a1e$export$de882eb450d20938(value) {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;
    return isInstance;
}
function $b1e25c535a095a1e$export$33a30dd12c6f8c8d(json) {
    return $b1e25c535a095a1e$export$d4d9b4c10592863c(json, false);
}
function $b1e25c535a095a1e$export$d4d9b4c10592863c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "challenge_id": json["challenge_id"],
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["challenge_type"]),
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : json["data"]
    };
}
function $b1e25c535a095a1e$export$1181dc7f727e9334(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "challenge_id": value.challenge_id,
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.challenge_type),
        "data": value.data
    };
}


function $ec04d4058abe68eb$export$f2a65bfde9fd2807(json) {
    return $ec04d4058abe68eb$export$f931041f10007c40(json, false);
}
function $ec04d4058abe68eb$export$f931041f10007c40(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    switch(json["challenge_type"]){
        case "nonce":
            return {
                ...(0, $938a3eca74e6d666$export$fe0ec9eae36a9b35)(json, true),
                challenge_type: "nonce"
            };
        case "otp":
            return {
                ...(0, $f449912ebe4a113d$export$4285315b0ce1487c)(json, true),
                challenge_type: "otp"
            };
        case "password_reset":
            return {
                ...(0, $7129eb840d90c811$export$d45d032a25047716)(json, true),
                challenge_type: "password_reset"
            };
        case "password_set":
            return {
                ...(0, $8660c4b56cb27ecd$export$539bcbef6d641f12)(json, true),
                challenge_type: "password_set"
            };
        case "password_verify":
            return {
                ...(0, $a81d20114b11fe07$export$10d1c2ecf0d72392)(json, true),
                challenge_type: "password_verify"
            };
        case "totp_register":
            return {
                ...(0, $a36427e2ebdb7b90$export$b44518c38b369723)(json, true),
                challenge_type: "totp_register"
            };
        case "totp_verify":
            return {
                ...(0, $377b248c78313117$export$afdbafa9ab0915af)(json, true),
                challenge_type: "totp_verify"
            };
        case "webauthn_create":
            return {
                ...(0, $68761697813975d9$export$dbc4437c51d4130d)(json, true),
                challenge_type: "webauthn_create"
            };
        case "webauthn_get":
            return {
                ...(0, $b1e25c535a095a1e$export$d4d9b4c10592863c)(json, true),
                challenge_type: "webauthn_get"
            };
        default:
            throw new Error(`No variant of Attestation exists with 'challenge_type=${json["challenge_type"]}'`);
    }
}
function $ec04d4058abe68eb$export$d7f719716c0ef239(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    switch(value["challenge_type"]){
        case "nonce":
            return (0, $938a3eca74e6d666$export$2ddc20e282619fc3)(value);
        case "otp":
            return (0, $f449912ebe4a113d$export$9e8a349f91c23ca8)(value);
        case "password_reset":
            return (0, $7129eb840d90c811$export$7b6f5d07bfad78e9)(value);
        case "password_set":
            return (0, $8660c4b56cb27ecd$export$751a8f178b8690f0)(value);
        case "password_verify":
            return (0, $a81d20114b11fe07$export$b7b281ec8692f580)(value);
        case "totp_register":
            return (0, $a36427e2ebdb7b90$export$167110d9a40e7fcd)(value);
        case "totp_verify":
            return (0, $377b248c78313117$export$1be77b6cf29772e6)(value);
        case "webauthn_create":
            return (0, $68761697813975d9$export$2704f2dae5463d10)(value);
        case "webauthn_get":
            return (0, $b1e25c535a095a1e$export$1181dc7f727e9334)(value);
        default:
            throw new Error(`No variant of Attestation exists with 'challenge_type=${value["challenge_type"]}'`);
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $3631ba6a1c3f226f$export$3115cb5e7f1d8877(value) {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;
    return isInstance;
}
function $3631ba6a1c3f226f$export$514140d1566d2164(json) {
    return $3631ba6a1c3f226f$export$7e04f5374583ac72(json, false);
}
function $3631ba6a1c3f226f$export$7e04f5374583ac72(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "challenge_id": json["challenge_id"],
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["challenge_type"])
    };
}
function $3631ba6a1c3f226f$export$43ad8a418ad29a9f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "challenge_id": value.challenge_id,
        "challenge_type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.challenge_type)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * Allowed login factor
 * @export
 */ const $d180e6976bd68c99$export$8279f5e63c6521d8 = {
    Webauthn: "webauthn",
    EmailLink: "email_link",
    SmsLink: "sms_link",
    OtpViaSms: "otp_via_sms",
    OtpViaEmail: "otp_via_email",
    Totp: "totp",
    Oidc: "oidc",
    Saml: "saml",
    Api: "api",
    DirectId: "direct_id",
    Password: "password",
    Impersonate: "impersonate",
    Anonymous: "anonymous"
};
function $d180e6976bd68c99$export$67789e1d0e9f3dc1(json) {
    return $d180e6976bd68c99$export$db3563c2b590c7be(json, false);
}
function $d180e6976bd68c99$export$db3563c2b590c7be(json, ignoreDiscriminator) {
    return json;
}
function $d180e6976bd68c99$export$6eefe3f1006b48e7(value) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $1221773f83e5dbf8$export$885886f088cd0586 = {
    EmailAddress: "email_address",
    PhoneNumber: "phone_number",
    Username: "username"
};
function $1221773f83e5dbf8$export$4298639bc743d812(json) {
    return $1221773f83e5dbf8$export$a40e0eed0469a814(json, false);
}
function $1221773f83e5dbf8$export$a40e0eed0469a814(json, ignoreDiscriminator) {
    return json;
}
function $1221773f83e5dbf8$export$501f062f75ed6632(value) {
    return value;
}


function $c40c5abb0dd863b2$export$fe8bf34cf162832e(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
function $c40c5abb0dd863b2$export$11c41aa448e0ad82(json) {
    return $c40c5abb0dd863b2$export$68e40d7b475f3dd1(json, false);
}
function $c40c5abb0dd863b2$export$68e40d7b475f3dd1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "type": (0, $1221773f83e5dbf8$export$4298639bc743d812)(json["type"]),
        "value": json["value"]
    };
}
function $c40c5abb0dd863b2$export$82ff335443c9930(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "type": (0, $1221773f83e5dbf8$export$501f062f75ed6632)(value.type),
        "value": value.value
    };
}


function $b875578786480fb6$export$d8b8de51640512f3(value) {
    let isInstance = true;
    isInstance = isInstance && "handle" in value;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "method" in value;
    return isInstance;
}
function $b875578786480fb6$export$6ba513db151a5ff1(json) {
    return $b875578786480fb6$export$80085d460a32fb43(json, false);
}
function $b875578786480fb6$export$80085d460a32fb43(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "handle": (0, $c40c5abb0dd863b2$export$11c41aa448e0ad82)(json["handle"]),
        "timestamp": new Date(json["timestamp"]),
        "method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["method"])
    };
}
function $b875578786480fb6$export$7f86f8f881fe1819(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "handle": (0, $c40c5abb0dd863b2$export$82ff335443c9930)(value.handle),
        "timestamp": value.timestamp.toISOString(),
        "method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.method)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $4ba44489166ff9c3$export$970f02a6ce675a69(value) {
    let isInstance = true;
    isInstance = isInstance && "method" in value;
    return isInstance;
}
function $4ba44489166ff9c3$export$3f9239ada79a5958(json) {
    return $4ba44489166ff9c3$export$86c6648ad39ee43e(json, false);
}
function $4ba44489166ff9c3$export$86c6648ad39ee43e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["method"]),
        "redirect_target": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "redirect_target") ? undefined : json["redirect_target"]
    };
}
function $4ba44489166ff9c3$export$39b54d7983c93bbb(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.method),
        "redirect_target": value.redirect_target
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $d47b7440d51128d8$export$96d4e4cf27d59030 = {
    Google: "google",
    Github: "github",
    Bitbucket: "bitbucket",
    Gitlab: "gitlab",
    Facebook: "facebook",
    Line: "line",
    Azuread: "azuread",
    Okta: "okta",
    Apple: "apple"
};
function $d47b7440d51128d8$export$272e68d050da029c(json) {
    return $d47b7440d51128d8$export$2ec5a77196a86283(json, false);
}
function $d47b7440d51128d8$export$2ec5a77196a86283(json, ignoreDiscriminator) {
    return json;
}
function $d47b7440d51128d8$export$a580c37c81d39e5c(value) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * Determines whether the OIDC call should fetch groups data.
 * @export
 */ const $c41e576d640a3178$export$940d1b18414d4add = {
    True: "true",
    False: "false"
};
function $c41e576d640a3178$export$ae2357be849f0edb(json) {
    return $c41e576d640a3178$export$c74e2e8e7051ac34(json, false);
}
function $c41e576d640a3178$export$c74e2e8e7051ac34(json, ignoreDiscriminator) {
    return json;
}
function $c41e576d640a3178$export$b42e5b86fe0f6b7a(value) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * Determines how the OIDC login page is presented to the user; defaults to popup.
 * @export
 */ const $d978296a495364e5$export$947f28fa7e24f5f5 = {
    Popup: "popup",
    Redirect: "redirect"
};
function $d978296a495364e5$export$1565a9e6f4df9f73(json) {
    return $d978296a495364e5$export$24cd40860efc684b(json, false);
}
function $d978296a495364e5$export$24cd40860efc684b(json, ignoreDiscriminator) {
    return json;
}
function $d978296a495364e5$export$970d15fc8587f099(value) {
    return value;
}


function $5a60a1ef94cb77c3$export$4f622a4d4faaed73(value) {
    let isInstance = true;
    isInstance = isInstance && "method" in value;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "provider" in value;
    return isInstance;
}
function $5a60a1ef94cb77c3$export$55789d35f259e162(json) {
    return $5a60a1ef94cb77c3$export$9a6f82502338cf90(json, false);
}
function $5a60a1ef94cb77c3$export$9a6f82502338cf90(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["method"]),
        "client_id": json["client_id"],
        "provider": (0, $d47b7440d51128d8$export$272e68d050da029c)(json["provider"]),
        "ux_mode": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "ux_mode") ? undefined : (0, $d978296a495364e5$export$1565a9e6f4df9f73)(json["ux_mode"]),
        "redirect_target": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "redirect_target") ? undefined : json["redirect_target"],
        "requires_groups": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "requires_groups") ? undefined : (0, $c41e576d640a3178$export$ae2357be849f0edb)(json["requires_groups"]),
        "pkce_code_challenge": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "pkce_code_challenge") ? undefined : json["pkce_code_challenge"],
        "csrf_token": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "csrf_token") ? undefined : json["csrf_token"]
    };
}
function $5a60a1ef94cb77c3$export$c452db75c4efa107(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.method),
        "client_id": value.client_id,
        "provider": (0, $d47b7440d51128d8$export$a580c37c81d39e5c)(value.provider),
        "ux_mode": (0, $d978296a495364e5$export$970d15fc8587f099)(value.ux_mode),
        "redirect_target": value.redirect_target,
        "requires_groups": (0, $c41e576d640a3178$export$b42e5b86fe0f6b7a)(value.requires_groups),
        "pkce_code_challenge": value.pkce_code_challenge,
        "csrf_token": value.csrf_token
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $92e0f83426266efd$export$8c25ea31c0257dee(value) {
    let isInstance = true;
    isInstance = isInstance && "method" in value;
    return isInstance;
}
function $92e0f83426266efd$export$344e23d4f22c0c7b(json) {
    return $92e0f83426266efd$export$8d57634ad9c9264(json, false);
}
function $92e0f83426266efd$export$8d57634ad9c9264(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["method"])
    };
}
function $92e0f83426266efd$export$37d30c38263c9a87(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.method)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $e39665aa2e65c204$export$bab6ab7a5bd0d76a(value) {
    let isInstance = true;
    isInstance = isInstance && "method" in value;
    return isInstance;
}
function $e39665aa2e65c204$export$2c8e130c1f24a472(json) {
    return $e39665aa2e65c204$export$a568fb9d80f2262f(json, false);
}
function $e39665aa2e65c204$export$a568fb9d80f2262f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["method"])
    };
}
function $e39665aa2e65c204$export$f9288874575eda39(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.method)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $02bb4dd94c2286d5$export$ce64efd41c88f0cd(value) {
    let isInstance = true;
    isInstance = isInstance && "method" in value;
    return isInstance;
}
function $02bb4dd94c2286d5$export$39720b9a738a1119(json) {
    return $02bb4dd94c2286d5$export$5286999a970dc62c(json, false);
}
function $02bb4dd94c2286d5$export$5286999a970dc62c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["method"])
    };
}
function $02bb4dd94c2286d5$export$26f4d7f6c522321c(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.method)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * Determines how the SSO login page is presented to the user; defaults to popup.
 * @export
 */ const $13463f5a948e6169$export$6dc0f627c99c13a9 = {
    Popup: "popup",
    Redirect: "redirect"
};
function $13463f5a948e6169$export$9f582d126e097dfd(json) {
    return $13463f5a948e6169$export$be52b3ff0e8c895d(json, false);
}
function $13463f5a948e6169$export$be52b3ff0e8c895d(json, ignoreDiscriminator) {
    return json;
}
function $13463f5a948e6169$export$bac7eaac8cc3a2f6(value) {
    return value;
}


function $29485475e30fbd17$export$a75b0e545407f1d9(value) {
    let isInstance = true;
    isInstance = isInstance && "method" in value;
    isInstance = isInstance && "provider_credentials_id" in value;
    return isInstance;
}
function $29485475e30fbd17$export$f5a4bb1f0d9842b5(json) {
    return $29485475e30fbd17$export$29382291ad0763af(json, false);
}
function $29485475e30fbd17$export$29382291ad0763af(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["method"]),
        "provider_credentials_id": json["provider_credentials_id"],
        "ux_mode": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "ux_mode") ? undefined : (0, $13463f5a948e6169$export$9f582d126e097dfd)(json["ux_mode"]),
        "redirect_target": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "redirect_target") ? undefined : json["redirect_target"],
        "pkce_code_challenge": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "pkce_code_challenge") ? undefined : json["pkce_code_challenge"],
        "csrf_token": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "csrf_token") ? undefined : json["csrf_token"]
    };
}
function $29485475e30fbd17$export$a811b2d26736ed97(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.method),
        "provider_credentials_id": value.provider_credentials_id,
        "ux_mode": (0, $13463f5a948e6169$export$bac7eaac8cc3a2f6)(value.ux_mode),
        "redirect_target": value.redirect_target,
        "pkce_code_challenge": value.pkce_code_challenge,
        "csrf_token": value.csrf_token
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $8296e1695436aef1$export$d320fa6a297c990e(value) {
    let isInstance = true;
    isInstance = isInstance && "method" in value;
    return isInstance;
}
function $8296e1695436aef1$export$3b0c6c72db8bb60e(json) {
    return $8296e1695436aef1$export$d9e33269b3ce3ef5(json, false);
}
function $8296e1695436aef1$export$d9e33269b3ce3ef5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["method"]),
        "redirect_target": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "redirect_target") ? undefined : json["redirect_target"]
    };
}
function $8296e1695436aef1$export$1a7803bb6cb3450b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.method),
        "redirect_target": value.redirect_target
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $cf3942d59fca756c$export$ec638b545a706bf7(value) {
    let isInstance = true;
    isInstance = isInstance && "method" in value;
    return isInstance;
}
function $cf3942d59fca756c$export$268eac4d8ebc266f(json) {
    return $cf3942d59fca756c$export$f72eeb70c589fe28(json, false);
}
function $cf3942d59fca756c$export$f72eeb70c589fe28(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["method"])
    };
}
function $cf3942d59fca756c$export$7414add94b20f6f6(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.method)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $fd99e17397a87416$export$c1ff3c79d2429507 = {
    None: "none",
    Indirect: "indirect",
    Direct: "direct"
};
function $fd99e17397a87416$export$5a312d017eee0d3e(json) {
    return $fd99e17397a87416$export$e734f3544dd52101(json, false);
}
function $fd99e17397a87416$export$e734f3544dd52101(json, ignoreDiscriminator) {
    return json;
}
function $fd99e17397a87416$export$1b6988785f1528c4(value) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $db804c8fc7fc378a$export$51952aaa367c79db = {
    Any: "any",
    Platform: "platform",
    CrossPlatform: "cross_platform"
};
function $db804c8fc7fc378a$export$c466d5bdc96128fd(json) {
    return $db804c8fc7fc378a$export$29d83669df3c633c(json, false);
}
function $db804c8fc7fc378a$export$29d83669df3c633c(json, ignoreDiscriminator) {
    return json;
}
function $db804c8fc7fc378a$export$4eab872925fbdd55(value) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $5d22f1c59e3d2c7d$export$df3e12f65ba023ba = {
    Discouraged: "discouraged",
    Preferred: "preferred",
    Required: "required"
};
function $5d22f1c59e3d2c7d$export$48180f46ce0fdeef(json) {
    return $5d22f1c59e3d2c7d$export$a2a5e890ec53e8c(json, false);
}
function $5d22f1c59e3d2c7d$export$a2a5e890ec53e8c(json, ignoreDiscriminator) {
    return json;
}
function $5d22f1c59e3d2c7d$export$ab058d07d3f47953(value) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $4422b127d07e08ac$export$1bc598454e9d0dfc = {
    Discouraged: "discouraged",
    Preferred: "preferred",
    Required: "required"
};
function $4422b127d07e08ac$export$2f6b567f7a129d2(json) {
    return $4422b127d07e08ac$export$bf309234c5a66b70(json, false);
}
function $4422b127d07e08ac$export$bf309234c5a66b70(json, ignoreDiscriminator) {
    return json;
}
function $4422b127d07e08ac$export$191e871d68094046(value) {
    return value;
}


function $28a0fc7152f59fd1$export$be6248ff0e0e157f(value) {
    let isInstance = true;
    isInstance = isInstance && "method" in value;
    return isInstance;
}
function $28a0fc7152f59fd1$export$b6dfeaa8eedeb41b(json) {
    return $28a0fc7152f59fd1$export$fee9c51fd9d40010(json, false);
}
function $28a0fc7152f59fd1$export$fee9c51fd9d40010(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["method"]),
        "scope": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "scope") ? undefined : json["scope"],
        "available_credential_ids": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "available_credential_ids") ? undefined : json["available_credential_ids"],
        "attachment": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "attachment") ? undefined : (0, $db804c8fc7fc378a$export$c466d5bdc96128fd)(json["attachment"]),
        "user_verification": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "user_verification") ? undefined : (0, $4422b127d07e08ac$export$2f6b567f7a129d2)(json["user_verification"]),
        "resident_key": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "resident_key") ? undefined : (0, $5d22f1c59e3d2c7d$export$48180f46ce0fdeef)(json["resident_key"]),
        "attestation": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "attestation") ? undefined : (0, $fd99e17397a87416$export$5a312d017eee0d3e)(json["attestation"])
    };
}
function $28a0fc7152f59fd1$export$143dc34f19152636(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.method),
        "scope": value.scope,
        "available_credential_ids": value.available_credential_ids,
        "attachment": (0, $db804c8fc7fc378a$export$4eab872925fbdd55)(value.attachment),
        "user_verification": (0, $4422b127d07e08ac$export$191e871d68094046)(value.user_verification),
        "resident_key": (0, $5d22f1c59e3d2c7d$export$ab058d07d3f47953)(value.resident_key),
        "attestation": (0, $fd99e17397a87416$export$1b6988785f1528c4)(value.attestation)
    };
}


function $763d426bb5dfc23e$export$d0c68b16e37ea6b7(json) {
    return $763d426bb5dfc23e$export$35996414b62a8dd5(json, false);
}
function $763d426bb5dfc23e$export$35996414b62a8dd5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    switch(json["method"]){
        case "email_link":
            return {
                ...(0, $4ba44489166ff9c3$export$86c6648ad39ee43e)(json, true),
                method: "email_link"
            };
        case "oidc":
            return {
                ...(0, $5a60a1ef94cb77c3$export$9a6f82502338cf90)(json, true),
                method: "oidc"
            };
        case "otp_via_email":
            return {
                ...(0, $92e0f83426266efd$export$8d57634ad9c9264)(json, true),
                method: "otp_via_email"
            };
        case "otp_via_sms":
            return {
                ...(0, $e39665aa2e65c204$export$a568fb9d80f2262f)(json, true),
                method: "otp_via_sms"
            };
        case "password":
            return {
                ...(0, $02bb4dd94c2286d5$export$5286999a970dc62c)(json, true),
                method: "password"
            };
        case "saml":
            return {
                ...(0, $29485475e30fbd17$export$29382291ad0763af)(json, true),
                method: "saml"
            };
        case "sms_link":
            return {
                ...(0, $8296e1695436aef1$export$d9e33269b3ce3ef5)(json, true),
                method: "sms_link"
            };
        case "totp":
            return {
                ...(0, $cf3942d59fca756c$export$f72eeb70c589fe28)(json, true),
                method: "totp"
            };
        case "webauthn":
            return {
                ...(0, $28a0fc7152f59fd1$export$fee9c51fd9d40010)(json, true),
                method: "webauthn"
            };
        default:
            throw new Error(`No variant of FactorOptions exists with 'method=${json["method"]}'`);
    }
}
function $763d426bb5dfc23e$export$ba0c7e27b8aa00e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    switch(value["method"]){
        case "email_link":
            return (0, $4ba44489166ff9c3$export$39b54d7983c93bbb)(value);
        case "oidc":
            return (0, $5a60a1ef94cb77c3$export$c452db75c4efa107)(value);
        case "otp_via_email":
            return (0, $92e0f83426266efd$export$37d30c38263c9a87)(value);
        case "otp_via_sms":
            return (0, $e39665aa2e65c204$export$f9288874575eda39)(value);
        case "password":
            return (0, $02bb4dd94c2286d5$export$26f4d7f6c522321c)(value);
        case "saml":
            return (0, $29485475e30fbd17$export$a811b2d26736ed97)(value);
        case "sms_link":
            return (0, $8296e1695436aef1$export$1a7803bb6cb3450b)(value);
        case "totp":
            return (0, $cf3942d59fca756c$export$7414add94b20f6f6)(value);
        case "webauthn":
            return (0, $28a0fc7152f59fd1$export$143dc34f19152636)(value);
        default:
            throw new Error(`No variant of FactorOptions exists with 'method=${value["method"]}'`);
    }
}


function $ed86b74be8b8eb89$export$e5c50aee111b9e06(value) {
    let isInstance = true;
    return isInstance;
}
function $ed86b74be8b8eb89$export$f532260b06e67d79(json) {
    return $ed86b74be8b8eb89$export$46af48a00ab1f3b5(json, false);
}
function $ed86b74be8b8eb89$export$46af48a00ab1f3b5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "method": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "method") ? undefined : (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["method"]),
        "options": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "options") ? undefined : (0, $763d426bb5dfc23e$export$d0c68b16e37ea6b7)(json["options"])
    };
}
function $ed86b74be8b8eb89$export$288f5f309e052c1d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.method),
        "options": (0, $763d426bb5dfc23e$export$ba0c7e27b8aa00e)(value.options)
    };
}


function $40bdfd8888ff6e29$export$3867aea3709e6d5c(value) {
    let isInstance = true;
    isInstance = isInstance && "target_org_id" in value;
    return isInstance;
}
function $40bdfd8888ff6e29$export$c5e83b69854f0282(json) {
    return $40bdfd8888ff6e29$export$e876b8b22e45a012(json, false);
}
function $40bdfd8888ff6e29$export$e876b8b22e45a012(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "target_org_id": json["target_org_id"],
        "factor": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "factor") ? undefined : (0, $ed86b74be8b8eb89$export$f532260b06e67d79)(json["factor"])
    };
}
function $40bdfd8888ff6e29$export$7ea90c6e05c22e43(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "target_org_id": value.target_org_id,
        "factor": (0, $ed86b74be8b8eb89$export$288f5f309e052c1d)(value.factor)
    };
}




function $6e44eb913fba4949$export$8c528054ac1973bd(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    isInstance = isInstance && "options" in value;
    return isInstance;
}
function $6e44eb913fba4949$export$8d335ca8241b9f4e(json) {
    return $6e44eb913fba4949$export$c7b869a25b419e6(json, false);
}
function $6e44eb913fba4949$export$c7b869a25b419e6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["type"]),
        "authentication_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["authentication_method"]),
        "options": (0, $40bdfd8888ff6e29$export$c5e83b69854f0282)(json["options"])
    };
}
function $6e44eb913fba4949$export$1bba6c46c28de3a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.type),
        "authentication_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.authentication_method),
        "options": (0, $40bdfd8888ff6e29$export$7ea90c6e05c22e43)(value.options)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $c25b6df632bbfb75$export$396f98dc54c28653(value) {
    let isInstance = true;
    isInstance = isInstance && "options" in value;
    return isInstance;
}
function $c25b6df632bbfb75$export$a93ea98c53af645c(json) {
    return $c25b6df632bbfb75$export$252b6829dc5649f5(json, false);
}
function $c25b6df632bbfb75$export$252b6829dc5649f5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "options": (0, $40bdfd8888ff6e29$export$c5e83b69854f0282)(json["options"])
    };
}
function $c25b6df632bbfb75$export$a586e4b1e9a15007(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "options": (0, $40bdfd8888ff6e29$export$7ea90c6e05c22e43)(value.options)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $c38206bdac81bf08$export$92654280fa341a19 = {
    Length: "length",
    PasswordVariants: "password_variants",
    AdminVariants: "admin_variants",
    UserVariants: "user_variants",
    AlphanumericSequences1: "alphanumeric_sequences_1",
    AlphanumericSequences2: "alphanumeric_sequences_2",
    NumericSequencesAscending: "numeric_sequences_ascending",
    NumericSequencesDescending: "numeric_sequences_descending",
    NumericSubsequencesAscending: "numeric_subsequences_ascending",
    NumericSubsequencesDescending: "numeric_subsequences_descending",
    CommonPasswordXkcd: "common_password_xkcd"
};
function $c38206bdac81bf08$export$292cf3eb24b36615(json) {
    return $c38206bdac81bf08$export$139fad42c8f6d603(json, false);
}
function $c38206bdac81bf08$export$139fad42c8f6d603(json, ignoreDiscriminator) {
    return json;
}
function $c38206bdac81bf08$export$f789e2ae354140f9(value) {
    return value;
}


function $913a4c1ce2dbdf14$export$c5459ab3d3525af9(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
function $913a4c1ce2dbdf14$export$794a97c33188e2cf(json) {
    return $913a4c1ce2dbdf14$export$182e1ae9b4b1a286(json, false);
}
function $913a4c1ce2dbdf14$export$182e1ae9b4b1a286(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "name": (0, $c38206bdac81bf08$export$292cf3eb24b36615)(json["name"])
    };
}
function $913a4c1ce2dbdf14$export$3cc18af1b4b5aed9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "name": (0, $c38206bdac81bf08$export$f789e2ae354140f9)(value.name)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $cb37c6bf124abb86$export$17f7ef3862c4dda9(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    return isInstance;
}
function $cb37c6bf124abb86$export$6e7bcb022586c1f6(json) {
    return $cb37c6bf124abb86$export$ff1bb9fe67f257bd(json, false);
}
function $cb37c6bf124abb86$export$ff1bb9fe67f257bd(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["type"]),
        "authentication_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["authentication_method"])
    };
}
function $cb37c6bf124abb86$export$9e42112df54de254(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.type),
        "authentication_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.authentication_method)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $c3dfd57c89c1e2e4$export$962ec99ccb777e5d(value) {
    let isInstance = true;
    return isInstance;
}
function $c3dfd57c89c1e2e4$export$fccc5f59fb10fb43(json) {
    return $c3dfd57c89c1e2e4$export$6ae5a046f2854d1f(json, false);
}
function $c3dfd57c89c1e2e4$export$6ae5a046f2854d1f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "challenge": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "challenge") ? undefined : json["challenge"]
    };
}
function $c3dfd57c89c1e2e4$export$5a6bb73c099af14b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "challenge": value.challenge
    };
}


function $d31daadb48d86051$export$381060df3b43f694(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    return isInstance;
}
function $d31daadb48d86051$export$12bce9f63d0d1b43(json) {
    return $d31daadb48d86051$export$c89b7013df12088e(json, false);
}
function $d31daadb48d86051$export$c89b7013df12088e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["type"]),
        "authentication_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["authentication_method"]),
        "options": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "options") ? undefined : (0, $c3dfd57c89c1e2e4$export$fccc5f59fb10fb43)(json["options"])
    };
}
function $d31daadb48d86051$export$e8c577ab91ee698f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.type),
        "authentication_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.authentication_method),
        "options": (0, $c3dfd57c89c1e2e4$export$5a6bb73c099af14b)(value.options)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $9bd594023bed0442$export$eda7d4da6f3d214f(value) {
    let isInstance = true;
    isInstance = isInstance && "auth_code_url" in value;
    return isInstance;
}
function $9bd594023bed0442$export$c53683eed796cca6(json) {
    return $9bd594023bed0442$export$3bee7ccd7ffe9afb(json, false);
}
function $9bd594023bed0442$export$3bee7ccd7ffe9afb(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "auth_code_url": json["auth_code_url"]
    };
}
function $9bd594023bed0442$export$b34b72165a81ac38(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "auth_code_url": value.auth_code_url
    };
}


function $0f7f42b4792df871$export$c2d3203f268f2103(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    isInstance = isInstance && "options" in value;
    return isInstance;
}
function $0f7f42b4792df871$export$12547b38dcf4ab61(json) {
    return $0f7f42b4792df871$export$52281bb8e2d4eb8a(json, false);
}
function $0f7f42b4792df871$export$52281bb8e2d4eb8a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["type"]),
        "authentication_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["authentication_method"]),
        "options": (0, $9bd594023bed0442$export$c53683eed796cca6)(json["options"])
    };
}
function $0f7f42b4792df871$export$b237322a72e22d30(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.type),
        "authentication_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.authentication_method),
        "options": (0, $9bd594023bed0442$export$b34b72165a81ac38)(value.options)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $731c3bb20387fcbc$export$1d66095413b818dc(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    return isInstance;
}
function $731c3bb20387fcbc$export$ba2757049816016b(json) {
    return $731c3bb20387fcbc$export$11c938a12b9e7a4e(json, false);
}
function $731c3bb20387fcbc$export$11c938a12b9e7a4e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["type"]),
        "authentication_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["authentication_method"])
    };
}
function $731c3bb20387fcbc$export$39ee8e97c506a89d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.type),
        "authentication_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.authentication_method)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $4a50563666f772e4$export$1bf91e9b22ea6e9c = {
    Match: "must_match",
    NotMatch: "must_not_match"
};
function $4a50563666f772e4$export$211fa31f693d0fc5(json) {
    return $4a50563666f772e4$export$b53c74a1fbea099b(json, false);
}
function $4a50563666f772e4$export$b53c74a1fbea099b(json, ignoreDiscriminator) {
    return json;
}
function $4a50563666f772e4$export$65d68d5d70683e8c(value) {
    return value;
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $86793b8acec4395c$export$db87cce2ebf1e21b = {
    CaseInsensitive: "case_insensitive"
};
function $86793b8acec4395c$export$1a54fab7686d0d4d(json) {
    return $86793b8acec4395c$export$1b5003399216bcb9(json, false);
}
function $86793b8acec4395c$export$1b5003399216bcb9(json, ignoreDiscriminator) {
    return json;
}
function $86793b8acec4395c$export$c013f8bf67b81bfd(value) {
    return value;
}


function $6a615095d8161257$export$b52ff546cf6e791e(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "pattern" in value;
    isInstance = isInstance && "match_type" in value;
    return isInstance;
}
function $6a615095d8161257$export$60a9211431b11430(json) {
    return $6a615095d8161257$export$525b06245bd19793(json, false);
}
function $6a615095d8161257$export$525b06245bd19793(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "name": (0, $c38206bdac81bf08$export$292cf3eb24b36615)(json["name"]),
        "pattern": json["pattern"],
        "match_type": (0, $4a50563666f772e4$export$211fa31f693d0fc5)(json["match_type"]),
        "pattern_qualifiers": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "pattern_qualifiers") ? undefined : json["pattern_qualifiers"].map((0, $86793b8acec4395c$export$1a54fab7686d0d4d))
    };
}
function $6a615095d8161257$export$202895c6317b46b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "name": (0, $c38206bdac81bf08$export$f789e2ae354140f9)(value.name),
        "pattern": value.pattern,
        "match_type": (0, $4a50563666f772e4$export$65d68d5d70683e8c)(value.match_type),
        "pattern_qualifiers": value.pattern_qualifiers === undefined ? undefined : value.pattern_qualifiers.map((0, $86793b8acec4395c$export$c013f8bf67b81bfd))
    };
}


function $5e48e35a23bda832$export$1c758cbe8a736efe(value) {
    let isInstance = true;
    return isInstance;
}
function $5e48e35a23bda832$export$7fa65e60d0ba4afc(json) {
    return $5e48e35a23bda832$export$415672afe02a8c95(json, false);
}
function $5e48e35a23bda832$export$415672afe02a8c95(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "regular_expressions": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "regular_expressions") ? undefined : json["regular_expressions"].map((0, $6a615095d8161257$export$60a9211431b11430))
    };
}
function $5e48e35a23bda832$export$6aadfbfa6597f211(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "regular_expressions": value.regular_expressions === undefined ? undefined : value.regular_expressions.map((0, $6a615095d8161257$export$202895c6317b46b))
    };
}


function $1a3219a78db1ede2$export$f58e34146dd3c886(value) {
    let isInstance = true;
    isInstance = isInstance && "validation_rules" in value;
    return isInstance;
}
function $1a3219a78db1ede2$export$9e3e7e437375c546(json) {
    return $1a3219a78db1ede2$export$a7fcc83d003f1d88(json, false);
}
function $1a3219a78db1ede2$export$a7fcc83d003f1d88(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "validation_rules": (0, $5e48e35a23bda832$export$7fa65e60d0ba4afc)(json["validation_rules"])
    };
}
function $1a3219a78db1ede2$export$6274b0e68c67e72a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "validation_rules": (0, $5e48e35a23bda832$export$6aadfbfa6597f211)(value.validation_rules)
    };
}


function $552b2b986ce10206$export$93aa968ce48fce07(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    isInstance = isInstance && "options" in value;
    return isInstance;
}
function $552b2b986ce10206$export$dbcbef80979fd2e8(json) {
    return $552b2b986ce10206$export$e5fe87714f320c28(json, false);
}
function $552b2b986ce10206$export$e5fe87714f320c28(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["type"]),
        "authentication_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["authentication_method"]),
        "options": (0, $1a3219a78db1ede2$export$9e3e7e437375c546)(json["options"])
    };
}
function $552b2b986ce10206$export$ee2fef0e2b3251ae(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.type),
        "authentication_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.authentication_method),
        "options": (0, $1a3219a78db1ede2$export$6274b0e68c67e72a)(value.options)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $ae8bf495805fa03d$export$cd7f0c3fc9794977(value) {
    let isInstance = true;
    isInstance = isInstance && "validation_rules" in value;
    return isInstance;
}
function $ae8bf495805fa03d$export$f4038b507713b142(json) {
    return $ae8bf495805fa03d$export$a17d017c59274ff8(json, false);
}
function $ae8bf495805fa03d$export$a17d017c59274ff8(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "validation_rules": (0, $5e48e35a23bda832$export$7fa65e60d0ba4afc)(json["validation_rules"])
    };
}
function $ae8bf495805fa03d$export$7e6df8572e78556b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "validation_rules": (0, $5e48e35a23bda832$export$6aadfbfa6597f211)(value.validation_rules)
    };
}


function $2cd13ff80d3626b9$export$9a062f703f34347a(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    isInstance = isInstance && "options" in value;
    return isInstance;
}
function $2cd13ff80d3626b9$export$5477c9fab2d7bd3a(json) {
    return $2cd13ff80d3626b9$export$e4f7639cf60c1778(json, false);
}
function $2cd13ff80d3626b9$export$e4f7639cf60c1778(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["type"]),
        "authentication_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["authentication_method"]),
        "options": (0, $ae8bf495805fa03d$export$f4038b507713b142)(json["options"])
    };
}
function $2cd13ff80d3626b9$export$8dba8265a6f7070c(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.type),
        "authentication_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.authentication_method),
        "options": (0, $ae8bf495805fa03d$export$7e6df8572e78556b)(value.options)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $d6a124919832e9d9$export$15329ecd0bdefeaa(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    return isInstance;
}
function $d6a124919832e9d9$export$7a5b20871392ef1a(json) {
    return $d6a124919832e9d9$export$b8669a208e58c77c(json, false);
}
function $d6a124919832e9d9$export$b8669a208e58c77c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["type"]),
        "authentication_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["authentication_method"])
    };
}
function $d6a124919832e9d9$export$3b2df7bcf8c9a0ac(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.type),
        "authentication_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.authentication_method)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $e6643d9a3244a168$export$2aa312c401d27633(value) {
    let isInstance = true;
    return isInstance;
}
function $e6643d9a3244a168$export$f1b0b8bf9576e182(json) {
    return $e6643d9a3244a168$export$c12821ff4657af79(json, false);
}
function $e6643d9a3244a168$export$c12821ff4657af79(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "challenge_id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "challenge_id") ? undefined : json["challenge_id"]
    };
}
function $e6643d9a3244a168$export$f9c2a4907f4de151(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "challenge_id": value.challenge_id
    };
}


function $ced0e7bcad159a72$export$e4a96b1ac70d6952(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    return isInstance;
}
function $ced0e7bcad159a72$export$a8e5d6ad8457d255(json) {
    return $ced0e7bcad159a72$export$2886b0dfa544935e(json, false);
}
function $ced0e7bcad159a72$export$2886b0dfa544935e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["type"]),
        "authentication_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["authentication_method"]),
        "options": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "options") ? undefined : (0, $e6643d9a3244a168$export$f1b0b8bf9576e182)(json["options"])
    };
}
function $ced0e7bcad159a72$export$149d00a24fa85ed5(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.type),
        "authentication_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.authentication_method),
        "options": (0, $e6643d9a3244a168$export$f9c2a4907f4de151)(value.options)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $84d4b0b0bfe56e36$export$651a7485e3024dfa(value) {
    let isInstance = true;
    isInstance = isInstance && "start_authentication_url" in value;
    return isInstance;
}
function $84d4b0b0bfe56e36$export$69d72f503d5a95ba(json) {
    return $84d4b0b0bfe56e36$export$31dc24e629860ee2(json, false);
}
function $84d4b0b0bfe56e36$export$31dc24e629860ee2(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "start_authentication_url": json["start_authentication_url"]
    };
}
function $84d4b0b0bfe56e36$export$9cee4e2f30c94128(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "start_authentication_url": value.start_authentication_url
    };
}


function $ef69dd8298107877$export$bfba04cf17e59ab8(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    isInstance = isInstance && "options" in value;
    return isInstance;
}
function $ef69dd8298107877$export$872d304ec9d9766(json) {
    return $ef69dd8298107877$export$19245043fc4758a9(json, false);
}
function $ef69dd8298107877$export$19245043fc4758a9(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["type"]),
        "authentication_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["authentication_method"]),
        "options": (0, $84d4b0b0bfe56e36$export$69d72f503d5a95ba)(json["options"])
    };
}
function $ef69dd8298107877$export$73be0b9f120503f8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.type),
        "authentication_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.authentication_method),
        "options": (0, $84d4b0b0bfe56e36$export$9cee4e2f30c94128)(value.options)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $c2423cca4895e8d1$export$d21e8fc2bb12c7ca(value) {
    let isInstance = true;
    isInstance = isInstance && "key_uri" in value;
    isInstance = isInstance && "qr_code_data_b64" in value;
    isInstance = isInstance && "recovery_codes" in value;
    return isInstance;
}
function $c2423cca4895e8d1$export$f66b99a7ee22c7be(json) {
    return $c2423cca4895e8d1$export$a30c0f82bae007a7(json, false);
}
function $c2423cca4895e8d1$export$a30c0f82bae007a7(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "key_uri": json["key_uri"],
        "qr_code_data_b64": json["qr_code_data_b64"],
        "recovery_codes": json["recovery_codes"]
    };
}
function $c2423cca4895e8d1$export$acdf6a8f9dfbfedb(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "key_uri": value.key_uri,
        "qr_code_data_b64": value.qr_code_data_b64,
        "recovery_codes": value.recovery_codes
    };
}


function $a08fca4e09ec6e78$export$6dee3609dee6bc4c(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    return isInstance;
}
function $a08fca4e09ec6e78$export$144c08ba7abb6f17(json) {
    return $a08fca4e09ec6e78$export$5e35a68aca6442a8(json, false);
}
function $a08fca4e09ec6e78$export$5e35a68aca6442a8(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["type"]),
        "authentication_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["authentication_method"]),
        "options": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "options") ? undefined : (0, $c2423cca4895e8d1$export$f66b99a7ee22c7be)(json["options"])
    };
}
function $a08fca4e09ec6e78$export$abe3671e10ab522b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.type),
        "authentication_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.authentication_method),
        "options": (0, $c2423cca4895e8d1$export$acdf6a8f9dfbfedb)(value.options)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $fbe1166f07bd9fdc$export$53c74f53dd3d420b(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    return isInstance;
}
function $fbe1166f07bd9fdc$export$3c0444006eabbf01(json) {
    return $fbe1166f07bd9fdc$export$b389d0c8295c56f6(json, false);
}
function $fbe1166f07bd9fdc$export$b389d0c8295c56f6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["type"]),
        "authentication_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["authentication_method"])
    };
}
function $fbe1166f07bd9fdc$export$cceadf6b335284aa(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.type),
        "authentication_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.authentication_method)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $c1877c09ccf110e4$export$6b62ce698944fdc6(value) {
    let isInstance = true;
    return isInstance;
}
function $c1877c09ccf110e4$export$dcd5b8b66f15246b(json) {
    return $c1877c09ccf110e4$export$b5f9d8088544176f(json, false);
}
function $c1877c09ccf110e4$export$b5f9d8088544176f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "authn_redirect_page_ui_config": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "authn_redirect_page_ui_config") ? undefined : json["authn_redirect_page_ui_config"]
    };
}
function $c1877c09ccf110e4$export$2f17748153b0485a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "authn_redirect_page_ui_config": value.authn_redirect_page_ui_config
    };
}


function $30fdd8ec501ca24a$export$19475da50fcc2e61(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    return isInstance;
}
function $30fdd8ec501ca24a$export$efad740b9c9f084e(json) {
    return $30fdd8ec501ca24a$export$60d1f2ae02a0447b(json, false);
}
function $30fdd8ec501ca24a$export$60d1f2ae02a0447b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["type"]),
        "authentication_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["authentication_method"]),
        "options": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "options") ? undefined : (0, $c1877c09ccf110e4$export$dcd5b8b66f15246b)(json["options"])
    };
}
function $30fdd8ec501ca24a$export$9587cea8d8b99873(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.type),
        "authentication_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.authentication_method),
        "options": (0, $c1877c09ccf110e4$export$2f17748153b0485a)(value.options)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $f46e79312b38cc71$export$9bc0b18b61797527(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    return isInstance;
}
function $f46e79312b38cc71$export$b7a0e49579dce760(json) {
    return $f46e79312b38cc71$export$13d6aef7f9d716af(json, false);
}
function $f46e79312b38cc71$export$13d6aef7f9d716af(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["type"]),
        "authentication_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["authentication_method"]),
        "options": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "options") ? undefined : json["options"]
    };
}
function $f46e79312b38cc71$export$8189205342ed27d2(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.type),
        "authentication_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.authentication_method),
        "options": value.options
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $c35f4da18c4a6ef9$export$9c42d132abe91501(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    return isInstance;
}
function $c35f4da18c4a6ef9$export$5b300f7354c5b32(json) {
    return $c35f4da18c4a6ef9$export$90f387175041abdf(json, false);
}
function $c35f4da18c4a6ef9$export$90f387175041abdf(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "type": (0, $6efd4ce2feb2bdc3$export$7da7fa2b5d7d85f3)(json["type"]),
        "authentication_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["authentication_method"]),
        "options": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "options") ? undefined : json["options"]
    };
}
function $c35f4da18c4a6ef9$export$9a8e42c9faeafe3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "type": (0, $6efd4ce2feb2bdc3$export$e418cafec408031e)(value.type),
        "authentication_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.authentication_method),
        "options": value.options
    };
}


function $dad19632247d7ad3$export$2b369be06dcbfccd(json) {
    return $dad19632247d7ad3$export$c8d0f078679e0082(json, false);
}
function $dad19632247d7ad3$export$c8d0f078679e0082(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    switch(json["type"]){
        case "authn_context_update":
            return {
                ...(0, $6e44eb913fba4949$export$c7b869a25b419e6)(json, true),
                type: "authn_context_update"
            };
        case "nonce":
            return {
                ...(0, $d31daadb48d86051$export$c89b7013df12088e)(json, true),
                type: "nonce"
            };
        case "oidc":
            return {
                ...(0, $0f7f42b4792df871$export$52281bb8e2d4eb8a)(json, true),
                type: "oidc"
            };
        case "otp":
            return {
                ...(0, $731c3bb20387fcbc$export$11c938a12b9e7a4e)(json, true),
                type: "otp"
            };
        case "password_reset":
            return {
                ...(0, $552b2b986ce10206$export$e5fe87714f320c28)(json, true),
                type: "password_reset"
            };
        case "password_set":
            return {
                ...(0, $2cd13ff80d3626b9$export$e4f7639cf60c1778)(json, true),
                type: "password_set"
            };
        case "password_verify":
            return {
                ...(0, $d6a124919832e9d9$export$b8669a208e58c77c)(json, true),
                type: "password_verify"
            };
        case "proxy":
            return {
                ...(0, $ced0e7bcad159a72$export$2886b0dfa544935e)(json, true),
                type: "proxy"
            };
        case "saml":
            return {
                ...(0, $ef69dd8298107877$export$19245043fc4758a9)(json, true),
                type: "saml"
            };
        case "totp_register":
            return {
                ...(0, $a08fca4e09ec6e78$export$5e35a68aca6442a8)(json, true),
                type: "totp_register"
            };
        case "totp_verify":
            return {
                ...(0, $fbe1166f07bd9fdc$export$b389d0c8295c56f6)(json, true),
                type: "totp_verify"
            };
        case "ui_customization":
            return {
                ...(0, $30fdd8ec501ca24a$export$60d1f2ae02a0447b)(json, true),
                type: "ui_customization"
            };
        case "webauthn_create":
            return {
                ...(0, $f46e79312b38cc71$export$13d6aef7f9d716af)(json, true),
                type: "webauthn_create"
            };
        case "webauthn_get":
            return {
                ...(0, $c35f4da18c4a6ef9$export$90f387175041abdf)(json, true),
                type: "webauthn_get"
            };
        default:
            throw new Error(`No variant of ChallengeListInner exists with 'type=${json["type"]}'`);
    }
}
function $dad19632247d7ad3$export$6177497a9ebb14ed(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    switch(value["type"]){
        case "authn_context_update":
            return (0, $6e44eb913fba4949$export$1bba6c46c28de3a)(value);
        case "nonce":
            return (0, $d31daadb48d86051$export$e8c577ab91ee698f)(value);
        case "oidc":
            return (0, $0f7f42b4792df871$export$b237322a72e22d30)(value);
        case "otp":
            return (0, $731c3bb20387fcbc$export$39ee8e97c506a89d)(value);
        case "password_reset":
            return (0, $552b2b986ce10206$export$ee2fef0e2b3251ae)(value);
        case "password_set":
            return (0, $2cd13ff80d3626b9$export$8dba8265a6f7070c)(value);
        case "password_verify":
            return (0, $d6a124919832e9d9$export$3b2df7bcf8c9a0ac)(value);
        case "proxy":
            return (0, $ced0e7bcad159a72$export$149d00a24fa85ed5)(value);
        case "saml":
            return (0, $ef69dd8298107877$export$73be0b9f120503f8)(value);
        case "totp_register":
            return (0, $a08fca4e09ec6e78$export$abe3671e10ab522b)(value);
        case "totp_verify":
            return (0, $fbe1166f07bd9fdc$export$cceadf6b335284aa)(value);
        case "ui_customization":
            return (0, $30fdd8ec501ca24a$export$9587cea8d8b99873)(value);
        case "webauthn_create":
            return (0, $f46e79312b38cc71$export$8189205342ed27d2)(value);
        case "webauthn_get":
            return (0, $c35f4da18c4a6ef9$export$9a8e42c9faeafe3)(value);
        default:
            throw new Error(`No variant of ChallengeListInner exists with 'type=${value["type"]}'`);
    }
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * The type of the credential
 * @export
 */ const $c2a276139e1508e8$export$eca2dc7e6e608a68 = {
    PublicKey: "public-key",
    Password: "password",
    Totp: "totp"
};
function $c2a276139e1508e8$export$7bbec83240b0eeeb(json) {
    return $c2a276139e1508e8$export$4abdb906a4385f20(json, false);
}
function $c2a276139e1508e8$export$4abdb906a4385f20(json, ignoreDiscriminator) {
    return json;
}
function $c2a276139e1508e8$export$ee7a066c014b3dac(value) {
    return value;
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $d393f165a83b0afb$export$8e49444f78fbbdb8 = {
    AuthenticationSucceededV1: "AuthenticationSucceeded_v1",
    AuthenticationFailedV1: "AuthenticationFailed_v1",
    PersonCreatedV1: "PersonCreated_v1",
    AnonymousPersonCreatedV1: "AnonymousPersonCreated_v1",
    PersonDeletedV1: "PersonDeleted_v1",
    VirtualPageLoadedV1: "VirtualPageLoaded_v1",
    SlashIdsdkLoadedV1: "SlashIDSDKLoaded_v1",
    PersonIdentifiedV1: "PersonIdentified_v1",
    PersonLoggedOutV1: "PersonLoggedOut_v1",
    TokenMintedV1: "TokenMinted_v1",
    AnonymousTokenMintedV1: "AnonymousTokenMinted_v1",
    PasswordChangedV1: "PasswordChanged_v1",
    GdprConsentsChangedV1: "GdprConsentsChanged_v1",
    GateServerStartedV1: "GateServerStarted_v1",
    GateRequestHandledV1: "GateRequestHandled_v1",
    GateRequestCredentialFoundV1: "GateRequestCredentialFound_v1",
    PermissionCreatedInRegionV1: "PermissionCreated_InRegion_v1",
    PermissionCreatedV1: "PermissionCreated_v1",
    PermissionDeletedInRegionV1: "PermissionDeleted_InRegion_v1",
    PermissionDeletedV1: "PermissionDeleted_v1",
    RoleCreatedInRegionV1: "RoleCreated_InRegion_v1",
    RoleCreatedV1: "RoleCreated_v1",
    RoleDeletedInRegionV1: "RoleDeleted_InRegion_v1",
    RoleDeletedV1: "RoleDeleted_v1",
    RoleUpdatedInRegionV1: "RoleUpdated_InRegion_v1",
    RoleUpdatedV1: "RoleUpdated_v1",
    RolesSetToPersonInRegionV1: "RolesSetToPerson_InRegion_v1",
    RolesSetToPersonV1: "RolesSetToPerson_v1",
    PermissionsSetToPersonInRegionV1: "PermissionsSetToPerson_InRegion_v1",
    PermissionsSetToPersonV1: "PermissionsSetToPerson_v1",
    MitmAttackDetectedV1: "MitmAttackDetected_v1",
    PermissionUpdatedInRegionV1: "PermissionUpdated_InRegion_v1",
    PermissionUpdatedV1: "PermissionUpdated_v1"
};
function $d393f165a83b0afb$export$9b4cd0a6cee9140c(json) {
    return $d393f165a83b0afb$export$97ba4f6074fb0666(json, false);
}
function $d393f165a83b0afb$export$97ba4f6074fb0666(json, ignoreDiscriminator) {
    return json;
}
function $d393f165a83b0afb$export$ca1aceefe82885b(value) {
    return value;
}


function $f73411540e836a6c$export$aaae14f4a8a8cf0a(value) {
    let isInstance = true;
    isInstance = isInstance && "event_name" in value;
    return isInstance;
}
function $f73411540e836a6c$export$79bd163dd2c25c4(json) {
    return $f73411540e836a6c$export$73ef40828bd37093(json, false);
}
function $f73411540e836a6c$export$73ef40828bd37093(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "event_name": (0, $d393f165a83b0afb$export$9b4cd0a6cee9140c)(json["event_name"])
    };
}
function $f73411540e836a6c$export$234c0234de4b43e3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "event_name": (0, $d393f165a83b0afb$export$ca1aceefe82885b)(value.event_name)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 



function $fe91a0ee8cd31d25$export$d77fc2e077575409(value) {
    let isInstance = true;
    isInstance = isInstance && "event_name" in value;
    isInstance = isInstance && "failed_authn_method" in value;
    isInstance = isInstance && "failure_reason" in value;
    return isInstance;
}
function $fe91a0ee8cd31d25$export$2cd8fd49b27feed9(json) {
    return $fe91a0ee8cd31d25$export$8c07b43d35ce3886(json, false);
}
function $fe91a0ee8cd31d25$export$8c07b43d35ce3886(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "event_name": (0, $d393f165a83b0afb$export$9b4cd0a6cee9140c)(json["event_name"]),
        "person_id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "person_id") ? undefined : json["person_id"],
        "authenticated_methods": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "authenticated_methods") ? undefined : json["authenticated_methods"].map((0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)),
        "failed_authn_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["failed_authn_method"]),
        "failure_reason": json["failure_reason"],
        "failure_detail": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "failure_detail") ? undefined : json["failure_detail"],
        "handle": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "handle") ? undefined : (0, $c40c5abb0dd863b2$export$11c41aa448e0ad82)(json["handle"]),
        "challenge_id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "challenge_id") ? undefined : json["challenge_id"]
    };
}
function $fe91a0ee8cd31d25$export$a72f46cfd2ab2833(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "event_name": (0, $d393f165a83b0afb$export$ca1aceefe82885b)(value.event_name),
        "person_id": value.person_id,
        "authenticated_methods": value.authenticated_methods === undefined ? undefined : value.authenticated_methods.map((0, $d180e6976bd68c99$export$6eefe3f1006b48e7)),
        "failed_authn_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.failed_authn_method),
        "failure_reason": value.failure_reason,
        "failure_detail": value.failure_detail,
        "handle": (0, $c40c5abb0dd863b2$export$82ff335443c9930)(value.handle),
        "challenge_id": value.challenge_id
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 



function $a5d8de5bca3957eb$export$fa4ead11c5330b8d(value) {
    let isInstance = true;
    isInstance = isInstance && "event_name" in value;
    isInstance = isInstance && "person_id" in value;
    isInstance = isInstance && "success_authn_method" in value;
    isInstance = isInstance && "authenticated_methods" in value;
    return isInstance;
}
function $a5d8de5bca3957eb$export$4642b1d23b6be353(json) {
    return $a5d8de5bca3957eb$export$d696d44164fdec7a(json, false);
}
function $a5d8de5bca3957eb$export$d696d44164fdec7a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "event_name": (0, $d393f165a83b0afb$export$9b4cd0a6cee9140c)(json["event_name"]),
        "person_id": json["person_id"],
        "success_authn_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["success_authn_method"]),
        "authenticated_methods": json["authenticated_methods"].map((0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)),
        "handle": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "handle") ? undefined : (0, $c40c5abb0dd863b2$export$11c41aa448e0ad82)(json["handle"])
    };
}
function $a5d8de5bca3957eb$export$5209219e6db8ba4(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "event_name": (0, $d393f165a83b0afb$export$ca1aceefe82885b)(value.event_name),
        "person_id": value.person_id,
        "success_authn_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.success_authn_method),
        "authenticated_methods": value.authenticated_methods.map((0, $d180e6976bd68c99$export$6eefe3f1006b48e7)),
        "handle": (0, $c40c5abb0dd863b2$export$82ff335443c9930)(value.handle)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $eec3bf88135a9003$export$ec6d262ccd90fe6f(value) {
    let isInstance = true;
    isInstance = isInstance && "event_name" in value;
    isInstance = isInstance && "person_id" in value;
    return isInstance;
}
function $eec3bf88135a9003$export$2f267e9b92087f95(json) {
    return $eec3bf88135a9003$export$8d03546989de3ff9(json, false);
}
function $eec3bf88135a9003$export$8d03546989de3ff9(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "event_name": (0, $d393f165a83b0afb$export$9b4cd0a6cee9140c)(json["event_name"]),
        "person_id": json["person_id"]
    };
}
function $eec3bf88135a9003$export$cb23567fd98fa46d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "event_name": (0, $d393f165a83b0afb$export$ca1aceefe82885b)(value.event_name),
        "person_id": value.person_id
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $a8919be709d7e1bd$export$204f5264bda28033(value) {
    let isInstance = true;
    isInstance = isInstance && "event_name" in value;
    isInstance = isInstance && "person_id" in value;
    return isInstance;
}
function $a8919be709d7e1bd$export$16a16565bf100b(json) {
    return $a8919be709d7e1bd$export$a7e31c5db69cadbe(json, false);
}
function $a8919be709d7e1bd$export$a7e31c5db69cadbe(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "event_name": (0, $d393f165a83b0afb$export$9b4cd0a6cee9140c)(json["event_name"]),
        "person_id": json["person_id"]
    };
}
function $a8919be709d7e1bd$export$a76e314527c05f59(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "event_name": (0, $d393f165a83b0afb$export$ca1aceefe82885b)(value.event_name),
        "person_id": value.person_id
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $e22d1c537c1da7c9$export$6a02cd736d48817f(value) {
    let isInstance = true;
    isInstance = isInstance && "event_name" in value;
    return isInstance;
}
function $e22d1c537c1da7c9$export$191664532e9f2da8(json) {
    return $e22d1c537c1da7c9$export$7b634e670fe42f2(json, false);
}
function $e22d1c537c1da7c9$export$7b634e670fe42f2(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "event_name": (0, $d393f165a83b0afb$export$9b4cd0a6cee9140c)(json["event_name"])
    };
}
function $e22d1c537c1da7c9$export$2da1f0d71339461d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "event_name": (0, $d393f165a83b0afb$export$ca1aceefe82885b)(value.event_name)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $1cb67901b3f3a3fc$export$7b2e88c7a989e0f8(value) {
    let isInstance = true;
    isInstance = isInstance && "event_name" in value;
    return isInstance;
}
function $1cb67901b3f3a3fc$export$414cfaf175ea12ce(json) {
    return $1cb67901b3f3a3fc$export$a607e0ecea8fe77d(json, false);
}
function $1cb67901b3f3a3fc$export$a607e0ecea8fe77d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "event_name": (0, $d393f165a83b0afb$export$9b4cd0a6cee9140c)(json["event_name"]),
        "person_id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "person_id") ? undefined : json["person_id"]
    };
}
function $1cb67901b3f3a3fc$export$1fc7ada93ab359fd(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "event_name": (0, $d393f165a83b0afb$export$ca1aceefe82885b)(value.event_name),
        "person_id": value.person_id
    };
}


function $1d78f18e8764654e$export$28fb86dbbcde5730(json) {
    return $1d78f18e8764654e$export$d7da6a32c8ada00c(json, false);
}
function $1d78f18e8764654e$export$d7da6a32c8ada00c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    switch(json["event_name"]){
        case "AuthenticationFailed_v1":
            return {
                ...(0, $fe91a0ee8cd31d25$export$8c07b43d35ce3886)(json, true),
                event_name: "AuthenticationFailed_v1"
            };
        case "AuthenticationSucceeded_v1":
            return {
                ...(0, $a5d8de5bca3957eb$export$d696d44164fdec7a)(json, true),
                event_name: "AuthenticationSucceeded_v1"
            };
        case "PersonIdentified_v1":
            return {
                ...(0, $eec3bf88135a9003$export$8d03546989de3ff9)(json, true),
                event_name: "PersonIdentified_v1"
            };
        case "PersonLoggedOut_v1":
            return {
                ...(0, $a8919be709d7e1bd$export$a7e31c5db69cadbe)(json, true),
                event_name: "PersonLoggedOut_v1"
            };
        case "SlashIDSDKLoaded_v1":
            return {
                ...(0, $e22d1c537c1da7c9$export$7b634e670fe42f2)(json, true),
                event_name: "SlashIDSDKLoaded_v1"
            };
        case "VirtualPageLoaded_v1":
            return {
                ...(0, $1cb67901b3f3a3fc$export$a607e0ecea8fe77d)(json, true),
                event_name: "VirtualPageLoaded_v1"
            };
        default:
            throw new Error(`No variant of EventPostRequestEventData exists with 'event_name=${json["event_name"]}'`);
    }
}
function $1d78f18e8764654e$export$55abdab594c922a4(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    switch(value["event_name"]){
        case "AuthenticationFailed_v1":
            return (0, $fe91a0ee8cd31d25$export$a72f46cfd2ab2833)(value);
        case "AuthenticationSucceeded_v1":
            return (0, $a5d8de5bca3957eb$export$5209219e6db8ba4)(value);
        case "PersonIdentified_v1":
            return (0, $eec3bf88135a9003$export$cb23567fd98fa46d)(value);
        case "PersonLoggedOut_v1":
            return (0, $a8919be709d7e1bd$export$a76e314527c05f59)(value);
        case "SlashIDSDKLoaded_v1":
            return (0, $e22d1c537c1da7c9$export$2da1f0d71339461d)(value);
        case "VirtualPageLoaded_v1":
            return (0, $1cb67901b3f3a3fc$export$1fc7ada93ab359fd)(value);
        default:
            throw new Error(`No variant of EventPostRequestEventData exists with 'event_name=${value["event_name"]}'`);
    }
}


function $9eee0f736eff090c$export$896a897404de84ee(value) {
    let isInstance = true;
    isInstance = isInstance && "organization_id" in value;
    isInstance = isInstance && "analytics_correlation_id" in value;
    isInstance = isInstance && "window_location" in value;
    isInstance = isInstance && "user_agent" in value;
    isInstance = isInstance && "event_data" in value;
    return isInstance;
}
function $9eee0f736eff090c$export$81b8afe50a73d799(json) {
    return $9eee0f736eff090c$export$538e9b4cae762a1f(json, false);
}
function $9eee0f736eff090c$export$538e9b4cae762a1f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "organization_id": json["organization_id"],
        "analytics_correlation_id": json["analytics_correlation_id"],
        "window_location": json["window_location"],
        "user_agent": json["user_agent"],
        "event_data": (0, $1d78f18e8764654e$export$28fb86dbbcde5730)(json["event_data"])
    };
}
function $9eee0f736eff090c$export$66614e5f3c5485b5(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "organization_id": value.organization_id,
        "analytics_correlation_id": value.analytics_correlation_id,
        "window_location": value.window_location,
        "user_agent": value.user_agent,
        "event_data": (0, $1d78f18e8764654e$export$55abdab594c922a4)(value.event_data)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $978d97cd95363e7c$export$6a88ca8fd731b808(value) {
    let isInstance = true;
    isInstance = isInstance && "password_hash" in value;
    return isInstance;
}
function $978d97cd95363e7c$export$928a6f09136df146(json) {
    return $978d97cd95363e7c$export$b1b8ca533ff69fce(json, false);
}
function $978d97cd95363e7c$export$b1b8ca533ff69fce(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "password_hash": json["password_hash"]
    };
}
function $978d97cd95363e7c$export$f9ebf1cd3c73df35(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "password_hash": value.password_hash
    };
}


function $aa6c9d52848835d7$export$9062a3291ff14da0(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "params" in value;
    return isInstance;
}
function $aa6c9d52848835d7$export$903fce13c2af8cb3(json) {
    return $aa6c9d52848835d7$export$15f2d4eabe16d54e(json, false);
}
function $aa6c9d52848835d7$export$15f2d4eabe16d54e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "last_used": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "last_used") ? undefined : new Date(json["last_used"]),
        "type": (0, $c2a276139e1508e8$export$7bbec83240b0eeeb)(json["type"]),
        "params": (0, $978d97cd95363e7c$export$928a6f09136df146)(json["params"]),
        "label": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "label") ? undefined : json["label"]
    };
}
function $aa6c9d52848835d7$export$950a6b723fe0c8d1(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "last_used": value.last_used === undefined ? undefined : value.last_used.toISOString(),
        "type": (0, $c2a276139e1508e8$export$ee7a066c014b3dac)(value.type),
        "params": (0, $978d97cd95363e7c$export$f9ebf1cd3c73df35)(value.params),
        "label": value.label
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $c78c2bc7576ed153$export$a087f084ee0668fc(value) {
    let isInstance = true;
    isInstance = isInstance && "aaguid" in value;
    return isInstance;
}
function $c78c2bc7576ed153$export$193230f03b4e2b5e(json) {
    return $c78c2bc7576ed153$export$55d348d93c04571c(json, false);
}
function $c78c2bc7576ed153$export$55d348d93c04571c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "aaguid": json["aaguid"],
        "sign_count": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "sign_count") ? undefined : json["sign_count"],
        "clone_warning": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "clone_warning") ? undefined : json["clone_warning"]
    };
}
function $c78c2bc7576ed153$export$870360f2c096bfed(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "aaguid": value.aaguid,
        "sign_count": value.sign_count,
        "clone_warning": value.clone_warning
    };
}


function $f1f95dd58d1e6c26$export$6b8c6447a91d8ac2(value) {
    let isInstance = true;
    isInstance = isInstance && "webauthn_credential_id" in value;
    isInstance = isInstance && "public_key" in value;
    isInstance = isInstance && "attestation_type" in value;
    isInstance = isInstance && "authenticator" in value;
    return isInstance;
}
function $f1f95dd58d1e6c26$export$cb838a8294c45d7f(json) {
    return $f1f95dd58d1e6c26$export$95fe40beb2acb37e(json, false);
}
function $f1f95dd58d1e6c26$export$95fe40beb2acb37e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "webauthn_credential_id": json["webauthn_credential_id"],
        "public_key": json["public_key"],
        "attestation_type": json["attestation_type"],
        "authenticator": (0, $c78c2bc7576ed153$export$193230f03b4e2b5e)(json["authenticator"])
    };
}
function $f1f95dd58d1e6c26$export$37444c8007920ed9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "webauthn_credential_id": value.webauthn_credential_id,
        "public_key": value.public_key,
        "attestation_type": value.attestation_type,
        "authenticator": (0, $c78c2bc7576ed153$export$870360f2c096bfed)(value.authenticator)
    };
}


function $f762eada487827e1$export$f26a9e2b3d2f2072(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "params" in value;
    return isInstance;
}
function $f762eada487827e1$export$c9a598d53e893d16(json) {
    return $f762eada487827e1$export$5d6142ad79969801(json, false);
}
function $f762eada487827e1$export$5d6142ad79969801(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "last_used": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "last_used") ? undefined : new Date(json["last_used"]),
        "type": (0, $c2a276139e1508e8$export$7bbec83240b0eeeb)(json["type"]),
        "params": (0, $f1f95dd58d1e6c26$export$cb838a8294c45d7f)(json["params"]),
        "label": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "label") ? undefined : json["label"]
    };
}
function $f762eada487827e1$export$decc37720e3eadc2(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "last_used": value.last_used === undefined ? undefined : value.last_used.toISOString(),
        "type": (0, $c2a276139e1508e8$export$ee7a066c014b3dac)(value.type),
        "params": (0, $f1f95dd58d1e6c26$export$37444c8007920ed9)(value.params),
        "label": value.label
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $7754777971c6d810$export$f1738de301e3f9a2(value) {
    let isInstance = true;
    isInstance = isInstance && "recovery_codes_total" in value;
    isInstance = isInstance && "recovery_codes_unused" in value;
    return isInstance;
}
function $7754777971c6d810$export$d2d4f1400f80c95b(json) {
    return $7754777971c6d810$export$bb2c141edaac59b1(json, false);
}
function $7754777971c6d810$export$bb2c141edaac59b1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recovery_codes_total": json["recovery_codes_total"],
        "recovery_codes_unused": json["recovery_codes_unused"]
    };
}
function $7754777971c6d810$export$da68635ae58103ed(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recovery_codes_total": value.recovery_codes_total,
        "recovery_codes_unused": value.recovery_codes_unused
    };
}


function $e83b9f9e18875d73$export$24f4b3307e2ab25b(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "params" in value;
    return isInstance;
}
function $e83b9f9e18875d73$export$ff6258564bd26741(json) {
    return $e83b9f9e18875d73$export$7b628c1266e614e0(json, false);
}
function $e83b9f9e18875d73$export$7b628c1266e614e0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "last_used": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "last_used") ? undefined : new Date(json["last_used"]),
        "type": (0, $c2a276139e1508e8$export$7bbec83240b0eeeb)(json["type"]),
        "params": (0, $7754777971c6d810$export$d2d4f1400f80c95b)(json["params"]),
        "label": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "label") ? undefined : json["label"]
    };
}
function $e83b9f9e18875d73$export$b7b351f4dd4a219c(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "last_used": value.last_used === undefined ? undefined : value.last_used.toISOString(),
        "type": (0, $c2a276139e1508e8$export$ee7a066c014b3dac)(value.type),
        "params": (0, $7754777971c6d810$export$da68635ae58103ed)(value.params),
        "label": value.label
    };
}


function $5f60ac724ebd3909$export$3724b7510e24ce33(json) {
    return $5f60ac724ebd3909$export$7c9a38e4a1e85b4b(json, false);
}
function $5f60ac724ebd3909$export$7c9a38e4a1e85b4b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    switch(json["type"]){
        case "password":
            return {
                ...(0, $aa6c9d52848835d7$export$15f2d4eabe16d54e)(json, true),
                type: "password"
            };
        case "public-key":
            return {
                ...(0, $f762eada487827e1$export$5d6142ad79969801)(json, true),
                type: "public-key"
            };
        case "totp":
            return {
                ...(0, $e83b9f9e18875d73$export$7b628c1266e614e0)(json, true),
                type: "totp"
            };
        default:
            throw new Error(`No variant of ExportedCredential exists with 'type=${json["type"]}'`);
    }
}
function $5f60ac724ebd3909$export$79e5093d45899443(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    switch(value["type"]){
        case "password":
            return (0, $aa6c9d52848835d7$export$950a6b723fe0c8d1)(value);
        case "public-key":
            return (0, $f762eada487827e1$export$decc37720e3eadc2)(value);
        case "totp":
            return (0, $e83b9f9e18875d73$export$b7b351f4dd4a219c)(value);
        default:
            throw new Error(`No variant of ExportedCredential exists with 'type=${value["type"]}'`);
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $957a6f5b049c1da8$export$3d5e609ff68202cd(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    return isInstance;
}
function $957a6f5b049c1da8$export$a60fb0f1e80eac31(json) {
    return $957a6f5b049c1da8$export$c01099be85a3eac3(json, false);
}
function $957a6f5b049c1da8$export$c01099be85a3eac3(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "last_used": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "last_used") ? undefined : new Date(json["last_used"])
    };
}
function $957a6f5b049c1da8$export$427426ab8fbd2632(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "last_used": value.last_used === undefined ? undefined : value.last_used.toISOString()
    };
}





/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $cff277084c94fd24$export$1289dedeb372552b(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "params" in value;
    return isInstance;
}
function $cff277084c94fd24$export$38fd1a67945ff92a(json) {
    return $cff277084c94fd24$export$3cc643ebdea80b51(json, false);
}
function $cff277084c94fd24$export$3cc643ebdea80b51(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "type": (0, $c2a276139e1508e8$export$7bbec83240b0eeeb)(json["type"]),
        "params": (0, $7754777971c6d810$export$d2d4f1400f80c95b)(json["params"]),
        "label": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "label") ? undefined : json["label"]
    };
}
function $cff277084c94fd24$export$6a66091aae19c219(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "type": (0, $c2a276139e1508e8$export$ee7a066c014b3dac)(value.type),
        "params": (0, $7754777971c6d810$export$da68635ae58103ed)(value.params),
        "label": value.label
    };
}






/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $9cbd7336b515f5ff$export$93b980a799206137 = {
    None: "none",
    Necessary: "necessary",
    Analytics: "analytics",
    Marketing: "marketing",
    Retargeting: "retargeting",
    Tracking: "tracking"
};
function $9cbd7336b515f5ff$export$84b3f9c7224f9426(json) {
    return $9cbd7336b515f5ff$export$2b6529f2847f83f3(json, false);
}
function $9cbd7336b515f5ff$export$2b6529f2847f83f3(json, ignoreDiscriminator) {
    return json;
}
function $9cbd7336b515f5ff$export$44aa2b641bcf85ed(value) {
    return value;
}


function $ee0ffc5480251ffa$export$b97766b7c6c0cc46(value) {
    let isInstance = true;
    isInstance = isInstance && "consent_level" in value;
    isInstance = isInstance && "created_at" in value;
    return isInstance;
}
function $ee0ffc5480251ffa$export$40975273e0c4497a(json) {
    return $ee0ffc5480251ffa$export$b727b488f0f7a4e4(json, false);
}
function $ee0ffc5480251ffa$export$b727b488f0f7a4e4(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "consent_level": (0, $9cbd7336b515f5ff$export$84b3f9c7224f9426)(json["consent_level"]),
        "created_at": new Date(json["created_at"])
    };
}
function $ee0ffc5480251ffa$export$780e4ae93000f66b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "consent_level": (0, $9cbd7336b515f5ff$export$44aa2b641bcf85ed)(value.consent_level),
        "created_at": value.created_at.toISOString()
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $918afe7ca221f314$export$3b26bc4ccb5a8638(value) {
    let isInstance = true;
    isInstance = isInstance && "consent_levels" in value;
    return isInstance;
}
function $918afe7ca221f314$export$e6ed4604e88d95a3(json) {
    return $918afe7ca221f314$export$f4394eac4a865068(json, false);
}
function $918afe7ca221f314$export$f4394eac4a865068(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "consent_levels": json["consent_levels"].map((0, $9cbd7336b515f5ff$export$84b3f9c7224f9426))
    };
}
function $918afe7ca221f314$export$13e148a83364b95(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "consent_levels": value.consent_levels.map((0, $9cbd7336b515f5ff$export$44aa2b641bcf85ed))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $d72477ff18746529$export$d0fc3d616092a245(value) {
    let isInstance = true;
    isInstance = isInstance && "consents" in value;
    return isInstance;
}
function $d72477ff18746529$export$b9e34caf47c08b2(json) {
    return $d72477ff18746529$export$afe857fd8914318a(json, false);
}
function $d72477ff18746529$export$afe857fd8914318a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "consents": json["consents"].map((0, $ee0ffc5480251ffa$export$40975273e0c4497a))
    };
}
function $d72477ff18746529$export$2321b26b111a9baa(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "consents": value.consents.map((0, $ee0ffc5480251ffa$export$780e4ae93000f66b))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $6df6f0c3c1503c39$export$7d97f8bab00baf95(value) {
    let isInstance = true;
    return isInstance;
}
function $6df6f0c3c1503c39$export$b860effd636f4c33(json) {
    return $6df6f0c3c1503c39$export$d11a34d219cd35f6(json, false);
}
function $6df6f0c3c1503c39$export$d11a34d219cd35f6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : json["result"]
    };
}
function $6df6f0c3c1503c39$export$98b678070add2b13(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": value.result
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $c21a4c23e308478a$export$6d703eb338efaa24(value) {
    let isInstance = true;
    return isInstance;
}
function $c21a4c23e308478a$export$4f985c243ccb3ab0(json) {
    return $c21a4c23e308478a$export$f52ac33af3fbf944(json, false);
}
function $c21a4c23e308478a$export$f52ac33af3fbf944(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : json["result"]
    };
}
function $c21a4c23e308478a$export$3586ed5109c54e4e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": value.result
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $38e4ceff1a16944f$export$6e1216be97f1c012(value) {
    let isInstance = true;
    return isInstance;
}
function $38e4ceff1a16944f$export$16028d5073b65888(json) {
    return $38e4ceff1a16944f$export$9423100a03fc92a1(json, false);
}
function $38e4ceff1a16944f$export$9423100a03fc92a1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : json["result"]
    };
}
function $38e4ceff1a16944f$export$aa51becaf6dd0f05(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": value.result
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $6115b36e46be379a$export$e78e3d6610df84fb(value) {
    let isInstance = true;
    return isInstance;
}
function $6115b36e46be379a$export$b48d82c5343ce8a7(json) {
    return $6115b36e46be379a$export$6f6b61ec87bb033f(json, false);
}
function $6115b36e46be379a$export$6f6b61ec87bb033f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : json["result"]
    };
}
function $6115b36e46be379a$export$1e0323cc20438eff(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": value.result
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $39cb95385236689b$export$bb6ed6ccec47107b(value) {
    let isInstance = true;
    return isInstance;
}
function $39cb95385236689b$export$fc7f4a9925d556ff(json) {
    return $39cb95385236689b$export$95db559018dc2213(json, false);
}
function $39cb95385236689b$export$95db559018dc2213(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : json["result"]
    };
}
function $39cb95385236689b$export$b016b87aa3f94563(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": value.result
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $d3001f4b8045257b$export$cdb44509daf8c358(value) {
    let isInstance = true;
    return isInstance;
}
function $d3001f4b8045257b$export$e41063b26bc3f620(json) {
    return $d3001f4b8045257b$export$e6d55d1ff20eadfe(json, false);
}
function $d3001f4b8045257b$export$e6d55d1ff20eadfe(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : json["result"]
    };
}
function $d3001f4b8045257b$export$4c01681119b0eac1(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": value.result
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $de585f0e4fd9d86f$export$2374e01db22e717d(value) {
    let isInstance = true;
    return isInstance;
}
function $de585f0e4fd9d86f$export$859624b73bf55232(json) {
    return $de585f0e4fd9d86f$export$ebb02bfda1ac3737(json, false);
}
function $de585f0e4fd9d86f$export$ebb02bfda1ac3737(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : json["result"]
    };
}
function $de585f0e4fd9d86f$export$5b37eff911dd0edc(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": value.result
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $74a6cc842dc6251c$export$136a779897fe1f5b(value) {
    let isInstance = true;
    return isInstance;
}
function $74a6cc842dc6251c$export$359c01b7eff378b4(json) {
    return $74a6cc842dc6251c$export$92a0db4cde933e25(json, false);
}
function $74a6cc842dc6251c$export$92a0db4cde933e25(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : json["result"]
    };
}
function $74a6cc842dc6251c$export$82c2a4ab6c984457(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": value.result
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 



function $1c6e04be56d36e82$export$6b31ef8e968a4ecf(value) {
    let isInstance = true;
    return isInstance;
}
function $1c6e04be56d36e82$export$d8f7fb0a0d937eb3(json) {
    return $1c6e04be56d36e82$export$357be021b1018458(json, false);
}
function $1c6e04be56d36e82$export$357be021b1018458(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : (0, $d72477ff18746529$export$b9e34caf47c08b2)(json["result"])
    };
}
function $1c6e04be56d36e82$export$2fd73e9f9376edfe(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": (0, $d72477ff18746529$export$2321b26b111a9baa)(value.result)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $85e76430877e7a17$export$62b9844af6fdbf48(value) {
    let isInstance = true;
    return isInstance;
}
function $85e76430877e7a17$export$866d0d81ea17fdbd(json) {
    return $85e76430877e7a17$export$d470afdbb0e73d29(json, false);
}
function $85e76430877e7a17$export$d470afdbb0e73d29(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : (0, $d72477ff18746529$export$b9e34caf47c08b2)(json["result"])
    };
}
function $85e76430877e7a17$export$ef2841fd65a884dd(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": (0, $d72477ff18746529$export$2321b26b111a9baa)(value.result)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $7f29a4ab971b3e8e$export$ae4845536494fe7b(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "org_name" in value;
    isInstance = isInstance && "tenant_name" in value;
    return isInstance;
}
function $7f29a4ab971b3e8e$export$3638d863f491f1bd(json) {
    return $7f29a4ab971b3e8e$export$796c1adabeaa853a(json, false);
}
function $7f29a4ab971b3e8e$export$796c1adabeaa853a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "parent_id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "parent_id") ? undefined : json["parent_id"],
        "org_name": json["org_name"],
        "tenant_name": json["tenant_name"]
    };
}
function $7f29a4ab971b3e8e$export$4148c267d26f471c(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "parent_id": value.parent_id,
        "org_name": value.org_name,
        "tenant_name": value.tenant_name
    };
}


function $2aab34e5b640ab49$export$380d898eedd33f73(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "org_name" in value;
    isInstance = isInstance && "tenant_name" in value;
    return isInstance;
}
function $2aab34e5b640ab49$export$e3c48c2a714dee12(json) {
    return $2aab34e5b640ab49$export$18255b16eead3caf(json, false);
}
function $2aab34e5b640ab49$export$18255b16eead3caf(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "parent_id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "parent_id") ? undefined : json["parent_id"],
        "org_name": json["org_name"],
        "tenant_name": json["tenant_name"],
        "managed_organizations": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "managed_organizations") ? undefined : json["managed_organizations"].map((0, $7f29a4ab971b3e8e$export$3638d863f491f1bd))
    };
}
function $2aab34e5b640ab49$export$7173796126a26aa2(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "parent_id": value.parent_id,
        "org_name": value.org_name,
        "tenant_name": value.tenant_name,
        "managed_organizations": value.managed_organizations === undefined ? undefined : value.managed_organizations.map((0, $7f29a4ab971b3e8e$export$4148c267d26f471c))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 */ const $d5b0d31d90a934fe$export$8a4bc00e165db472 = {
    Regular: "regular",
    Anonymous: "anonymous"
};
function $d5b0d31d90a934fe$export$851ad6a45f8bc66(json) {
    return $d5b0d31d90a934fe$export$27c7bcdfbe0df6dc(json, false);
}
function $d5b0d31d90a934fe$export$27c7bcdfbe0df6dc(json, ignoreDiscriminator) {
    return json;
}
function $d5b0d31d90a934fe$export$5bebd3993c7ac4e8(value) {
    return value;
}



function $b8c6905b3321bf04$export$ccf05bcd0a2c5126(value) {
    let isInstance = true;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "person_id" in value;
    isInstance = isInstance && "person_type" in value;
    isInstance = isInstance && "region" in value;
    return isInstance;
}
function $b8c6905b3321bf04$export$7a11cc6365c7aa2d(json) {
    return $b8c6905b3321bf04$export$43fdfaf085711574(json, false);
}
function $b8c6905b3321bf04$export$43fdfaf085711574(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "active": json["active"],
        "person_id": json["person_id"],
        "person_type": (0, $d5b0d31d90a934fe$export$851ad6a45f8bc66)(json["person_type"]),
        "region": (0, $ad52f4b379329356$export$4599c92435bbba6e)(json["region"]),
        "handles": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "handles") ? undefined : json["handles"].map((0, $c40c5abb0dd863b2$export$11c41aa448e0ad82)),
        "groups": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "groups") ? undefined : json["groups"],
        "attributes": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "attributes") ? undefined : json["attributes"]
    };
}
function $b8c6905b3321bf04$export$44957b028259275f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "active": value.active,
        "person_id": value.person_id,
        "person_type": (0, $d5b0d31d90a934fe$export$5bebd3993c7ac4e8)(value.person_type),
        "region": (0, $ad52f4b379329356$export$2ac40160f30291ff)(value.region),
        "handles": value.handles === undefined ? undefined : value.handles.map((0, $c40c5abb0dd863b2$export$82ff335443c9930)),
        "groups": value.groups,
        "attributes": value.attributes
    };
}


function $d75afd2454a10ab3$export$e1acc152de27b1c1(value) {
    let isInstance = true;
    isInstance = isInstance && "person" in value;
    isInstance = isInstance && "organizations" in value;
    isInstance = isInstance && "handles" in value;
    isInstance = isInstance && "credentials" in value;
    return isInstance;
}
function $d75afd2454a10ab3$export$4acec490369f0cc7(json) {
    return $d75afd2454a10ab3$export$7f6a248c6f964d4a(json, false);
}
function $d75afd2454a10ab3$export$7f6a248c6f964d4a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "person": (0, $b8c6905b3321bf04$export$7a11cc6365c7aa2d)(json["person"]),
        "organizations": json["organizations"].map((0, $2aab34e5b640ab49$export$e3c48c2a714dee12)),
        "handles": json["handles"].map((0, $c40c5abb0dd863b2$export$11c41aa448e0ad82)),
        "credentials": json["credentials"].map((0, $5f60ac724ebd3909$export$3724b7510e24ce33))
    };
}
function $d75afd2454a10ab3$export$70aee247e356fb65(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "person": (0, $b8c6905b3321bf04$export$44957b028259275f)(value.person),
        "organizations": value.organizations.map((0, $2aab34e5b640ab49$export$7173796126a26aa2)),
        "handles": value.handles.map((0, $c40c5abb0dd863b2$export$82ff335443c9930)),
        "credentials": value.credentials.map((0, $5f60ac724ebd3909$export$79e5093d45899443))
    };
}


function $9df250add66fe5a4$export$c01002c6bb4b91f7(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $9df250add66fe5a4$export$bfd68bd3621b7ea1(json) {
    return $9df250add66fe5a4$export$9f278e8bd0ab65d2(json, false);
}
function $9df250add66fe5a4$export$9f278e8bd0ab65d2(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": (0, $d75afd2454a10ab3$export$4acec490369f0cc7)(json["result"])
    };
}
function $9df250add66fe5a4$export$56dc6bc5985d68ce(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": (0, $d75afd2454a10ab3$export$70aee247e356fb65)(value.result)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $729793c8ad52691c$export$46f1d8d771c9bb10(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $729793c8ad52691c$export$28563f0581741ddd(json) {
    return $729793c8ad52691c$export$d6156d968a3a0af0(json, false);
}
function $729793c8ad52691c$export$d6156d968a3a0af0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": (0, $d75afd2454a10ab3$export$4acec490369f0cc7)(json["result"])
    };
}
function $729793c8ad52691c$export$81708d05a0b8dd46(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": (0, $d75afd2454a10ab3$export$70aee247e356fb65)(value.result)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $64960a347c0275fa$export$4c9244d88606dd5f(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "person_in_manager_org" in value;
    isInstance = isInstance && "inherits_rbac_pools" in value;
    return isInstance;
}
function $64960a347c0275fa$export$4032857d9d6cfa90(json) {
    return $64960a347c0275fa$export$feea96848bf6090d(json, false);
}
function $64960a347c0275fa$export$feea96848bf6090d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "parent_id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "parent_id") ? undefined : json["parent_id"],
        "name": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "name") ? undefined : json["name"],
        "tenant_name": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "tenant_name") ? undefined : json["tenant_name"],
        "children_ids": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "children_ids") ? undefined : json["children_ids"],
        "person_pool_orgs_ids": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "person_pool_orgs_ids") ? undefined : json["person_pool_orgs_ids"],
        "group_pool_orgs_ids": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "group_pool_orgs_ids") ? undefined : json["group_pool_orgs_ids"],
        "manager_org_id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "manager_org_id") ? undefined : json["manager_org_id"],
        "person_in_manager_org": json["person_in_manager_org"],
        "inherits_rbac_pools": json["inherits_rbac_pools"]
    };
}
function $64960a347c0275fa$export$fa8c48380a7e566d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "parent_id": value.parent_id,
        "name": value.name,
        "tenant_name": value.tenant_name,
        "children_ids": value.children_ids,
        "person_pool_orgs_ids": value.person_pool_orgs_ids,
        "group_pool_orgs_ids": value.group_pool_orgs_ids,
        "manager_org_id": value.manager_org_id,
        "person_in_manager_org": value.person_in_manager_org,
        "inherits_rbac_pools": value.inherits_rbac_pools
    };
}


function $6c8f885f9cb097c6$export$4bcb03c429977631(value) {
    let isInstance = true;
    isInstance = isInstance && "org_hierarchy" in value;
    return isInstance;
}
function $6c8f885f9cb097c6$export$303d3c6c1e2974a0(json) {
    return $6c8f885f9cb097c6$export$5206ec56be0af3f8(json, false);
}
function $6c8f885f9cb097c6$export$5206ec56be0af3f8(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "org_hierarchy": json["org_hierarchy"].map((0, $64960a347c0275fa$export$4032857d9d6cfa90))
    };
}
function $6c8f885f9cb097c6$export$378ea2f47d6ece9a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "org_hierarchy": value.org_hierarchy.map((0, $64960a347c0275fa$export$fa8c48380a7e566d))
    };
}


function $5a984202a50f2e52$export$fb32339ab4ad0eb0(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $5a984202a50f2e52$export$8a5bc1b2ff07b739(json) {
    return $5a984202a50f2e52$export$65732506bc8ed250(json, false);
}
function $5a984202a50f2e52$export$65732506bc8ed250(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": (0, $6c8f885f9cb097c6$export$303d3c6c1e2974a0)(json["result"])
    };
}
function $5a984202a50f2e52$export$135bb7361b756151(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": (0, $6c8f885f9cb097c6$export$378ea2f47d6ece9a)(value.result)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $531a8583aa18cc8e$export$679fbc925c02af82(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $531a8583aa18cc8e$export$1484840cc1f36a2e(json) {
    return $531a8583aa18cc8e$export$2222e0c1080e1269(json, false);
}
function $531a8583aa18cc8e$export$2222e0c1080e1269(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": (0, $6c8f885f9cb097c6$export$303d3c6c1e2974a0)(json["result"])
    };
}
function $531a8583aa18cc8e$export$ef96e16024fc8c6e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": (0, $6c8f885f9cb097c6$export$378ea2f47d6ece9a)(value.result)
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $eebefe4255826c03$export$eef10d01a2c1f1fd(value) {
    let isInstance = true;
    return isInstance;
}
function $eebefe4255826c03$export$eb7192996dd32ff1(json) {
    return $eebefe4255826c03$export$a1206befefec411c(json, false);
}
function $eebefe4255826c03$export$a1206befefec411c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        ...json,
        "dynamicFlowConfig": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "dynamicFlowConfig") ? undefined : json["dynamicFlowConfig"],
        "dynamicFlowEnabled": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "dynamicFlowEnabled") ? undefined : json["dynamicFlowEnabled"],
        "handleTypes": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "handleTypes") ? undefined : json["handleTypes"],
        "logoUrl": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "logoUrl") ? undefined : json["logoUrl"],
        "pageBackgroundColor": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "pageBackgroundColor") ? undefined : json["pageBackgroundColor"],
        "showBadge": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "showBadge") ? undefined : json["showBadge"],
        "storeLastFactor": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "storeLastFactor") ? undefined : json["storeLastFactor"],
        "supportURL": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "supportURL") ? undefined : json["supportURL"],
        "alternativeAuthURL": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "alternativeAuthURL") ? undefined : json["alternativeAuthURL"],
        "faviconUrl": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "faviconUrl") ? undefined : json["faviconUrl"],
        "pageTitle": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "pageTitle") ? undefined : json["pageTitle"],
        "themeVars": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "themeVars") ? undefined : json["themeVars"],
        "textOverrides": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "textOverrides") ? undefined : json["textOverrides"]
    };
}
function $eebefe4255826c03$export$342cad717a3ff356(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        ...value,
        "dynamicFlowConfig": value.dynamicFlowConfig,
        "dynamicFlowEnabled": value.dynamicFlowEnabled,
        "handleTypes": value.handleTypes,
        "logoUrl": value.logoUrl,
        "pageBackgroundColor": value.pageBackgroundColor,
        "showBadge": value.showBadge,
        "storeLastFactor": value.storeLastFactor,
        "supportURL": value.supportURL,
        "alternativeAuthURL": value.alternativeAuthURL,
        "faviconUrl": value.faviconUrl,
        "pageTitle": value.pageTitle,
        "themeVars": value.themeVars,
        "textOverrides": value.textOverrides
    };
}


function $0b688c0c6753551f$export$249857882e2b6911(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $0b688c0c6753551f$export$d8841886796c20dc(json) {
    return $0b688c0c6753551f$export$50a0305299b21849(json, false);
}
function $0b688c0c6753551f$export$50a0305299b21849(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": (0, $eebefe4255826c03$export$eb7192996dd32ff1)(json["result"])
    };
}
function $0b688c0c6753551f$export$38d8ca40da939ec5(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": (0, $eebefe4255826c03$export$342cad717a3ff356)(value.result)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $29de18e4d853ead1$export$46f1273afc655b5b(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $29de18e4d853ead1$export$2e716306d4034a5a(json) {
    return $29de18e4d853ead1$export$ec199d4b0c4777f0(json, false);
}
function $29de18e4d853ead1$export$ec199d4b0c4777f0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": (0, $eebefe4255826c03$export$eb7192996dd32ff1)(json["result"])
    };
}
function $29de18e4d853ead1$export$dab66814f68b2fd7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": (0, $eebefe4255826c03$export$342cad717a3ff356)(value.result)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 



function $a0d7a1213cc4556e$export$49c721d3b17e45a9(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $a0d7a1213cc4556e$export$e49e5c369c7975ca(json) {
    return $a0d7a1213cc4556e$export$42f0009a6a119705(json, false);
}
function $a0d7a1213cc4556e$export$42f0009a6a119705(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": json["result"].map((0, $b8c6905b3321bf04$export$7a11cc6365c7aa2d))
    };
}
function $a0d7a1213cc4556e$export$63c3dea4ad48cd83(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": value.result.map((0, $b8c6905b3321bf04$export$44957b028259275f))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $633f370cbd07027c$export$1c42688a4f7dc9e2(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $633f370cbd07027c$export$60eb64eaf22dca6e(json) {
    return $633f370cbd07027c$export$c07b38df8307a3aa(json, false);
}
function $633f370cbd07027c$export$c07b38df8307a3aa(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": json["result"].map((0, $b8c6905b3321bf04$export$7a11cc6365c7aa2d))
    };
}
function $633f370cbd07027c$export$78cc8503549011fd(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": value.result.map((0, $b8c6905b3321bf04$export$44957b028259275f))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $dfabc59cb06d24b7$export$470028e44ead592d(value) {
    let isInstance = true;
    isInstance = isInstance && "datetime" in value;
    isInstance = isInstance && "count" in value;
    return isInstance;
}
function $dfabc59cb06d24b7$export$9ae946eeb7d2d068(json) {
    return $dfabc59cb06d24b7$export$2b902a04e44db2c3(json, false);
}
function $dfabc59cb06d24b7$export$2b902a04e44db2c3(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "datetime": new Date(json["datetime"]),
        "count": json["count"]
    };
}
function $dfabc59cb06d24b7$export$5e2f6f2efef84b5(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "datetime": value.datetime.toISOString(),
        "count": value.count
    };
}


function $a317423da2cf7078$export$ad23a0f83a316e8(value) {
    let isInstance = true;
    return isInstance;
}
function $a317423da2cf7078$export$d1a0267c9cd050b1(json) {
    return $a317423da2cf7078$export$9ca7a1c71a73c7b6(json, false);
}
function $a317423da2cf7078$export$9ca7a1c71a73c7b6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "created_persons": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "created_persons") ? undefined : json["created_persons"].map((0, $dfabc59cb06d24b7$export$9ae946eeb7d2d068)),
        "deleted_persons": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "deleted_persons") ? undefined : json["deleted_persons"].map((0, $dfabc59cb06d24b7$export$9ae946eeb7d2d068)),
        "active_persons": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "active_persons") ? undefined : json["active_persons"].map((0, $dfabc59cb06d24b7$export$9ae946eeb7d2d068)),
        "active_persons_total": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "active_persons_total") ? undefined : json["active_persons_total"],
        "persons_failed_authentication_total": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "persons_failed_authentication_total") ? undefined : json["persons_failed_authentication_total"],
        "returning_persons": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "returning_persons") ? undefined : json["returning_persons"].map((0, $dfabc59cb06d24b7$export$9ae946eeb7d2d068)),
        "returning_persons_total": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "returning_persons_total") ? undefined : json["returning_persons_total"],
        "authentications": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "authentications") ? undefined : json["authentications"].map((0, $dfabc59cb06d24b7$export$9ae946eeb7d2d068)),
        "successful_authentications": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "successful_authentications") ? undefined : json["successful_authentications"].map((0, $dfabc59cb06d24b7$export$9ae946eeb7d2d068)),
        "successful_mfa": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "successful_mfa") ? undefined : json["successful_mfa"].map((0, $dfabc59cb06d24b7$export$9ae946eeb7d2d068)),
        "failed_authentications": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "failed_authentications") ? undefined : json["failed_authentications"].map((0, $dfabc59cb06d24b7$export$9ae946eeb7d2d068)),
        "failed_authentications_by_reason": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "failed_authentications_by_reason") ? undefined : json["failed_authentications_by_reason"],
        "failed_authentications_by_handle_type": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "failed_authentications_by_handle_type") ? undefined : json["failed_authentications_by_handle_type"],
        "failed_authentications_by_auth_method": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "failed_authentications_by_auth_method") ? undefined : json["failed_authentications_by_auth_method"],
        "failed_mfa": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "failed_mfa") ? undefined : json["failed_mfa"].map((0, $dfabc59cb06d24b7$export$9ae946eeb7d2d068)),
        "person_retention": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "person_retention") ? undefined : json["person_retention"],
        "gate_server_starts": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "gate_server_starts") ? undefined : json["gate_server_starts"].map((0, $dfabc59cb06d24b7$export$9ae946eeb7d2d068)),
        "gate_requests_handled": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "gate_requests_handled") ? undefined : json["gate_requests_handled"].map((0, $dfabc59cb06d24b7$export$9ae946eeb7d2d068))
    };
}
function $a317423da2cf7078$export$11b5bdcaac9cbacf(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "created_persons": value.created_persons === undefined ? undefined : value.created_persons.map((0, $dfabc59cb06d24b7$export$5e2f6f2efef84b5)),
        "deleted_persons": value.deleted_persons === undefined ? undefined : value.deleted_persons.map((0, $dfabc59cb06d24b7$export$5e2f6f2efef84b5)),
        "active_persons": value.active_persons === undefined ? undefined : value.active_persons.map((0, $dfabc59cb06d24b7$export$5e2f6f2efef84b5)),
        "active_persons_total": value.active_persons_total,
        "persons_failed_authentication_total": value.persons_failed_authentication_total,
        "returning_persons": value.returning_persons === undefined ? undefined : value.returning_persons.map((0, $dfabc59cb06d24b7$export$5e2f6f2efef84b5)),
        "returning_persons_total": value.returning_persons_total,
        "authentications": value.authentications === undefined ? undefined : value.authentications.map((0, $dfabc59cb06d24b7$export$5e2f6f2efef84b5)),
        "successful_authentications": value.successful_authentications === undefined ? undefined : value.successful_authentications.map((0, $dfabc59cb06d24b7$export$5e2f6f2efef84b5)),
        "successful_mfa": value.successful_mfa === undefined ? undefined : value.successful_mfa.map((0, $dfabc59cb06d24b7$export$5e2f6f2efef84b5)),
        "failed_authentications": value.failed_authentications === undefined ? undefined : value.failed_authentications.map((0, $dfabc59cb06d24b7$export$5e2f6f2efef84b5)),
        "failed_authentications_by_reason": value.failed_authentications_by_reason,
        "failed_authentications_by_handle_type": value.failed_authentications_by_handle_type,
        "failed_authentications_by_auth_method": value.failed_authentications_by_auth_method,
        "failed_mfa": value.failed_mfa === undefined ? undefined : value.failed_mfa.map((0, $dfabc59cb06d24b7$export$5e2f6f2efef84b5)),
        "person_retention": value.person_retention,
        "gate_server_starts": value.gate_server_starts === undefined ? undefined : value.gate_server_starts.map((0, $dfabc59cb06d24b7$export$5e2f6f2efef84b5)),
        "gate_requests_handled": value.gate_requests_handled === undefined ? undefined : value.gate_requests_handled.map((0, $dfabc59cb06d24b7$export$5e2f6f2efef84b5))
    };
}


function $70733e07da03f887$export$971608348d0fb0f4(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $70733e07da03f887$export$2fc6c9fe8c3c59d0(json) {
    return $70733e07da03f887$export$ff9f6860e33bd2a0(json, false);
}
function $70733e07da03f887$export$ff9f6860e33bd2a0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": (0, $a317423da2cf7078$export$d1a0267c9cd050b1)(json["result"])
    };
}
function $70733e07da03f887$export$72146de9eb66981f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": (0, $a317423da2cf7078$export$11b5bdcaac9cbacf)(value.result)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $134bce6dc9a41f80$export$9ca835fd9523ced9(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $134bce6dc9a41f80$export$e4a23b6603a96faa(json) {
    return $134bce6dc9a41f80$export$74b46b7c0ea9d0c7(json, false);
}
function $134bce6dc9a41f80$export$74b46b7c0ea9d0c7(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": (0, $a317423da2cf7078$export$d1a0267c9cd050b1)(json["result"])
    };
}
function $134bce6dc9a41f80$export$3de7e6548db80735(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": (0, $a317423da2cf7078$export$11b5bdcaac9cbacf)(value.result)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $3b96434239f63c5f$export$95d176615216f45b(value) {
    let isInstance = true;
    return isInstance;
}
function $3b96434239f63c5f$export$98fd440fa1097925(json) {
    return $3b96434239f63c5f$export$4fbede7b8de492e6(json, false);
}
function $3b96434239f63c5f$export$4fbede7b8de492e6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "billable_persons": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "billable_persons") ? undefined : json["billable_persons"].map((0, $dfabc59cb06d24b7$export$9ae946eeb7d2d068)),
        "billable_persons_total": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "billable_persons_total") ? undefined : json["billable_persons_total"],
        "user_identities": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "user_identities") ? undefined : json["user_identities"].map((0, $dfabc59cb06d24b7$export$9ae946eeb7d2d068)),
        "user_identities_total": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "user_identities_total") ? undefined : json["user_identities_total"],
        "non_human_identities": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "non_human_identities") ? undefined : json["non_human_identities"].map((0, $dfabc59cb06d24b7$export$9ae946eeb7d2d068)),
        "non_human_identities_total": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "non_human_identities_total") ? undefined : json["non_human_identities_total"],
        "credentials": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "credentials") ? undefined : json["credentials"].map((0, $dfabc59cb06d24b7$export$9ae946eeb7d2d068)),
        "credentials_total": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "credentials_total") ? undefined : json["credentials_total"]
    };
}
function $3b96434239f63c5f$export$b4faaead8a04c01f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "billable_persons": value.billable_persons === undefined ? undefined : value.billable_persons.map((0, $dfabc59cb06d24b7$export$5e2f6f2efef84b5)),
        "billable_persons_total": value.billable_persons_total,
        "user_identities": value.user_identities === undefined ? undefined : value.user_identities.map((0, $dfabc59cb06d24b7$export$5e2f6f2efef84b5)),
        "user_identities_total": value.user_identities_total,
        "non_human_identities": value.non_human_identities === undefined ? undefined : value.non_human_identities.map((0, $dfabc59cb06d24b7$export$5e2f6f2efef84b5)),
        "non_human_identities_total": value.non_human_identities_total,
        "credentials": value.credentials === undefined ? undefined : value.credentials.map((0, $dfabc59cb06d24b7$export$5e2f6f2efef84b5)),
        "credentials_total": value.credentials_total
    };
}


function $187256421eb9b5cb$export$6bfb37099391ab90(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $187256421eb9b5cb$export$1da8bec36382d2b9(json) {
    return $187256421eb9b5cb$export$154c0ed8cf64fcd2(json, false);
}
function $187256421eb9b5cb$export$154c0ed8cf64fcd2(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": (0, $3b96434239f63c5f$export$98fd440fa1097925)(json["result"])
    };
}
function $187256421eb9b5cb$export$419a8db6c1c04d5(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": (0, $3b96434239f63c5f$export$b4faaead8a04c01f)(value.result)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $0f92023d825a2f6e$export$a1cb3fb4fb907455(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $0f92023d825a2f6e$export$b86d74e097669c3e(json) {
    return $0f92023d825a2f6e$export$22162959cd08a639(json, false);
}
function $0f92023d825a2f6e$export$22162959cd08a639(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": (0, $3b96434239f63c5f$export$98fd440fa1097925)(json["result"])
    };
}
function $0f92023d825a2f6e$export$c55eac9a1e71950b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": (0, $3b96434239f63c5f$export$b4faaead8a04c01f)(value.result)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $58ab33dcfb592b92$export$aa21bd563cf3e2b5(value) {
    let isInstance = true;
    return isInstance;
}
function $58ab33dcfb592b92$export$c90d5bed9005f12c(json) {
    return $58ab33dcfb592b92$export$c696c877d8f906a0(json, false);
}
function $58ab33dcfb592b92$export$c696c877d8f906a0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "mitm_domain": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "mitm_domain") ? undefined : json["mitm_domain"],
        "view_count": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "view_count") ? undefined : json["view_count"],
        "unique_ip_count": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "unique_ip_count") ? undefined : json["unique_ip_count"],
        "token_tag": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "token_tag") ? undefined : json["token_tag"],
        "allowed_domains": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "allowed_domains") ? undefined : json["allowed_domains"]
    };
}
function $58ab33dcfb592b92$export$b14998057ceceb27(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "mitm_domain": value.mitm_domain,
        "view_count": value.view_count,
        "unique_ip_count": value.unique_ip_count,
        "token_tag": value.token_tag,
        "allowed_domains": value.allowed_domains
    };
}


function $399d80687c4dec31$export$363ad3809eff686d(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $399d80687c4dec31$export$4ec9178c24341b15(json) {
    return $399d80687c4dec31$export$83db56a06b04aec6(json, false);
}
function $399d80687c4dec31$export$83db56a06b04aec6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": json["result"].map((0, $58ab33dcfb592b92$export$c90d5bed9005f12c))
    };
}
function $399d80687c4dec31$export$afdc36ed4a0008a8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": value.result.map((0, $58ab33dcfb592b92$export$b14998057ceceb27))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $35c3eb82d4156ba3$export$f448fb6067509bf4(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $35c3eb82d4156ba3$export$67b765ebbb83cde(json) {
    return $35c3eb82d4156ba3$export$ca55ea7f92841ff8(json, false);
}
function $35c3eb82d4156ba3$export$ca55ea7f92841ff8(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": json["result"].map((0, $58ab33dcfb592b92$export$c90d5bed9005f12c))
    };
}
function $35c3eb82d4156ba3$export$f10f34eb7548f9bb(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": value.result.map((0, $58ab33dcfb592b92$export$b14998057ceceb27))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $84e44e75922d87c6$export$fa01e4739dcca2cf(value) {
    let isInstance = true;
    return isInstance;
}
function $84e44e75922d87c6$export$38478e6caf9c9de9(json) {
    return $84e44e75922d87c6$export$c2bd0afcb86bf051(json, false);
}
function $84e44e75922d87c6$export$c2bd0afcb86bf051(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "handle": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "handle") ? undefined : (0, $c40c5abb0dd863b2$export$11c41aa448e0ad82)(json["handle"]),
        "factor": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "factor") ? undefined : (0, $ed86b74be8b8eb89$export$f532260b06e67d79)(json["factor"])
    };
}
function $84e44e75922d87c6$export$7eb26765f35a90a8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "handle": (0, $c40c5abb0dd863b2$export$82ff335443c9930)(value.handle),
        "factor": (0, $ed86b74be8b8eb89$export$288f5f309e052c1d)(value.factor)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $8f6507bb4817bdac$export$343a7cbbb2623b4(value) {
    let isInstance = true;
    return isInstance;
}
function $8f6507bb4817bdac$export$d4e7f1e09f58bdfe(json) {
    return $8f6507bb4817bdac$export$229a73da8cf1adb0(json, false);
}
function $8f6507bb4817bdac$export$229a73da8cf1adb0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "pkce_code_challenge": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "pkce_code_challenge") ? undefined : json["pkce_code_challenge"],
        "csrf_token": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "csrf_token") ? undefined : json["csrf_token"]
    };
}
function $8f6507bb4817bdac$export$8851c826c823c733(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "pkce_code_challenge": value.pkce_code_challenge,
        "csrf_token": value.csrf_token
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 



function $a943f424e3af82d1$export$b616668d1f2274ba(value) {
    let isInstance = true;
    return isInstance;
}
function $a943f424e3af82d1$export$efac01586d65d94f(json) {
    return $a943f424e3af82d1$export$2f66ee609ab5958d(json, false);
}
function $a943f424e3af82d1$export$2f66ee609ab5958d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "handle": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "handle") ? undefined : (0, $c40c5abb0dd863b2$export$11c41aa448e0ad82)(json["handle"]),
        "factor": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "factor") ? undefined : (0, $ed86b74be8b8eb89$export$f532260b06e67d79)(json["factor"]),
        "metadata": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "metadata") ? undefined : (0, $8f6507bb4817bdac$export$d4e7f1e09f58bdfe)(json["metadata"])
    };
}
function $a943f424e3af82d1$export$511cb15a8242b8a0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "handle": (0, $c40c5abb0dd863b2$export$82ff335443c9930)(value.handle),
        "factor": (0, $ed86b74be8b8eb89$export$288f5f309e052c1d)(value.factor),
        "metadata": (0, $8f6507bb4817bdac$export$8851c826c823c733)(value.metadata)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $380ee0e54cbf9dab$export$5156413c1767706(value) {
    let isInstance = true;
    return isInstance;
}
function $380ee0e54cbf9dab$export$62ec57aaaf69c325(json) {
    return $380ee0e54cbf9dab$export$6704fc837c56e008(json, false);
}
function $380ee0e54cbf9dab$export$6704fc837c56e008(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "aud": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "aud") ? undefined : json["aud"],
        "id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "iat": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "iat") ? undefined : json["iat"],
        "exp": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "exp") ? undefined : json["exp"],
        "nbf": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "nbf") ? undefined : json["nbf"],
        "iss": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "iss") ? undefined : json["iss"],
        "sub": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "sub") ? undefined : json["sub"]
    };
}
function $380ee0e54cbf9dab$export$b0e56383df8f8631(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "aud": value.aud,
        "id": value.id,
        "iat": value.iat,
        "exp": value.exp,
        "nbf": value.nbf,
        "iss": value.iss,
        "sub": value.sub
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $873f9b029e0942b3$export$3cdc7edd85c8dd5a(value) {
    let isInstance = true;
    return isInstance;
}
function $873f9b029e0942b3$export$b24b1d4888c474da(json) {
    return $873f9b029e0942b3$export$cc8a8306664e6d55(json, false);
}
function $873f9b029e0942b3$export$cc8a8306664e6d55(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : (0, $5db1ceb0857c067d$export$703f66b537d92f5c)(json["data"])
    };
}
function $873f9b029e0942b3$export$4fe3d4133308b7c9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "data": (0, $5db1ceb0857c067d$export$91e7f239824ee67f)(value.data)
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $4d9089e055715ba9$export$992eed8a6dc763f5(value) {
    let isInstance = true;
    return isInstance;
}
function $4d9089e055715ba9$export$a18cf712bd45ac97(json) {
    return $4d9089e055715ba9$export$aa3b4373dabfa6da(json, false);
}
function $4d9089e055715ba9$export$aa3b4373dabfa6da(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "options": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "options") ? undefined : (0, $c3dfd57c89c1e2e4$export$fccc5f59fb10fb43)(json["options"])
    };
}
function $4d9089e055715ba9$export$400fa13a042f6924(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "options": (0, $c3dfd57c89c1e2e4$export$5a6bb73c099af14b)(value.options)
    };
}





/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ const $eda6afdba158b369$export$74642ff6513c42f0 = {
    AccessToken: "access_token",
    RefreshToken: "refresh_token"
};
function $eda6afdba158b369$export$3299428192128c4e(value) {
    let isInstance = true;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "token_type" in value;
    return isInstance;
}
function $eda6afdba158b369$export$2b054aa42fb96c00(json) {
    return $eda6afdba158b369$export$9e8b1a926c948613(json, false);
}
function $eda6afdba158b369$export$9e8b1a926c948613(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "client_id": json["client_id"],
        "token": json["token"],
        "token_type": json["token_type"]
    };
}
function $eda6afdba158b369$export$5934f2de036cb99d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "client_id": value.client_id,
        "token": value.token,
        "token_type": value.token_type
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $a91468cfc41e7e6c$export$bc60811295b47e4e(value) {
    let isInstance = true;
    isInstance = isInstance && "options" in value;
    return isInstance;
}
function $a91468cfc41e7e6c$export$9984c8cd0b910e9c(json) {
    return $a91468cfc41e7e6c$export$241b7b3328a03c29(json, false);
}
function $a91468cfc41e7e6c$export$241b7b3328a03c29(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "options": (0, $9bd594023bed0442$export$c53683eed796cca6)(json["options"])
    };
}
function $a91468cfc41e7e6c$export$357c37d480a91e65(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "options": (0, $9bd594023bed0442$export$b34b72165a81ac38)(value.options)
    };
}





/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $89bf3d35f0b5f331$export$221d642ac9e50c72(value) {
    let isInstance = true;
    isInstance = isInstance && "authn_id" in value;
    isInstance = isInstance && "token_types" in value;
    isInstance = isInstance && "provider" in value;
    isInstance = isInstance && "client_id" in value;
    return isInstance;
}
function $89bf3d35f0b5f331$export$76b919b75d277795(json) {
    return $89bf3d35f0b5f331$export$8ab6b61e28fd892c(json, false);
}
function $89bf3d35f0b5f331$export$8ab6b61e28fd892c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "authn_id": json["authn_id"],
        "token_types": json["token_types"],
        "provider": (0, $d47b7440d51128d8$export$272e68d050da029c)(json["provider"]),
        "client_id": json["client_id"],
        "oidc_groups": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "oidc_groups") ? undefined : json["oidc_groups"]
    };
}
function $89bf3d35f0b5f331$export$6c26bd44fa13d939(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "authn_id": value.authn_id,
        "token_types": value.token_types,
        "provider": (0, $d47b7440d51128d8$export$a580c37c81d39e5c)(value.provider),
        "client_id": value.client_id,
        "oidc_groups": value.oidc_groups
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $0e43494cb4f817df$export$c9fce3a1ba8fd0ee(value) {
    let isInstance = true;
    return isInstance;
}
function $0e43494cb4f817df$export$3463e42fa9b6a88c(json) {
    return $0e43494cb4f817df$export$70a75f760fb7cb7c(json, false);
}
function $0e43494cb4f817df$export$70a75f760fb7cb7c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : (0, $7531f066927bc183$export$bb8ecc995265609e)(json["data"])
    };
}
function $0e43494cb4f817df$export$196215f12cb74627(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "data": (0, $7531f066927bc183$export$6da0bcef5e0a8fdb)(value.data)
    };
}








/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $c4291f98abfe1fd2$export$3550f01f94f5c17(value) {
    let isInstance = true;
    return isInstance;
}
function $c4291f98abfe1fd2$export$af53474ab270dfae(json) {
    return $c4291f98abfe1fd2$export$fa3203514d63fcc1(json, false);
}
function $c4291f98abfe1fd2$export$fa3203514d63fcc1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "managed_organizations": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "managed_organizations") ? undefined : json["managed_organizations"].map((0, $7f29a4ab971b3e8e$export$3638d863f491f1bd))
    };
}
function $c4291f98abfe1fd2$export$a217d03c5ca1bf6c(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "managed_organizations": value.managed_organizations === undefined ? undefined : value.managed_organizations.map((0, $7f29a4ab971b3e8e$export$4148c267d26f471c))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $7f54dec30c137d0f$export$2a2d1f6758f48dd2(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "params" in value;
    return isInstance;
}
function $7f54dec30c137d0f$export$9ea85f8c7fcc82aa(json) {
    return $7f54dec30c137d0f$export$4b027521195a9337(json, false);
}
function $7f54dec30c137d0f$export$4b027521195a9337(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "type": (0, $c2a276139e1508e8$export$7bbec83240b0eeeb)(json["type"]),
        "params": (0, $978d97cd95363e7c$export$928a6f09136df146)(json["params"]),
        "label": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "label") ? undefined : json["label"]
    };
}
function $7f54dec30c137d0f$export$3122cf98e8657e57(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "type": (0, $c2a276139e1508e8$export$ee7a066c014b3dac)(value.type),
        "params": (0, $978d97cd95363e7c$export$f9ebf1cd3c73df35)(value.params),
        "label": value.label
    };
}





/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $4c307f8ff36ae117$export$6707878f78a03c0f(value) {
    let isInstance = true;
    return isInstance;
}
function $4c307f8ff36ae117$export$60c8307d1c1a9fd8(json) {
    return $4c307f8ff36ae117$export$9e91f01d1413f61f(json, false);
}
function $4c307f8ff36ae117$export$9e91f01d1413f61f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : (0, $4c15086ce037a833$export$531fea8f5c0d835d)(json["data"])
    };
}
function $4c307f8ff36ae117$export$e18048175cbdd79a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "data": (0, $4c15086ce037a833$export$b0b890df0497afa3)(value.data)
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $0856fdc553df802d$export$a051cf889a540dc(value) {
    let isInstance = true;
    isInstance = isInstance && "options" in value;
    return isInstance;
}
function $0856fdc553df802d$export$3ce4fbbcfce2d5b9(json) {
    return $0856fdc553df802d$export$2a6e5ee679abe325(json, false);
}
function $0856fdc553df802d$export$2a6e5ee679abe325(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "options": (0, $1a3219a78db1ede2$export$9e3e7e437375c546)(json["options"])
    };
}
function $0856fdc553df802d$export$d48adbb0351ff7dd(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "options": (0, $1a3219a78db1ede2$export$6274b0e68c67e72a)(value.options)
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $0087d6f9bb33ac70$export$3d1cd71a473477ba(value) {
    let isInstance = true;
    return isInstance;
}
function $0087d6f9bb33ac70$export$98a577534b89f722(json) {
    return $0087d6f9bb33ac70$export$837c0e64928faf53(json, false);
}
function $0087d6f9bb33ac70$export$837c0e64928faf53(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : (0, $daf2c31c3fecb469$export$fe9d75047753248b)(json["data"])
    };
}
function $0087d6f9bb33ac70$export$5c1c1aacf11dde9f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "data": (0, $daf2c31c3fecb469$export$69b7ca2907b53e3d)(value.data)
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $fffe65e82e41e65c$export$3ca12c17b7c98f20(value) {
    let isInstance = true;
    isInstance = isInstance && "options" in value;
    return isInstance;
}
function $fffe65e82e41e65c$export$cb658136a6cd1426(json) {
    return $fffe65e82e41e65c$export$48b596973d9203a9(json, false);
}
function $fffe65e82e41e65c$export$48b596973d9203a9(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "options": (0, $ae8bf495805fa03d$export$f4038b507713b142)(json["options"])
    };
}
function $fffe65e82e41e65c$export$341af6941aad80b3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "options": (0, $ae8bf495805fa03d$export$7e6df8572e78556b)(value.options)
    };
}






/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $cd117a59faf2b326$export$c8aabbf1c095dcb8(value) {
    let isInstance = true;
    return isInstance;
}
function $cd117a59faf2b326$export$ad6473b4ca3115eb(json) {
    return $cd117a59faf2b326$export$d798a84430a4dfeb(json, false);
}
function $cd117a59faf2b326$export$d798a84430a4dfeb(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : (0, $532c77d166192e4f$export$3fe1672863804c9d)(json["data"])
    };
}
function $cd117a59faf2b326$export$41ec95f257603eed(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "data": (0, $532c77d166192e4f$export$27fad2cccc00f212)(value.data)
    };
}










/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $91e561dc33dbb6e6$export$89cf3f8c1b1c7a44(value) {
    let isInstance = true;
    return isInstance;
}
function $91e561dc33dbb6e6$export$2438463015ae288a(json) {
    return $91e561dc33dbb6e6$export$322c43924fe8a316(json, false);
}
function $91e561dc33dbb6e6$export$322c43924fe8a316(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "token": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "token") ? undefined : json["token"]
    };
}
function $91e561dc33dbb6e6$export$c47763383831190d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "token": value.token
    };
}


function $97456af1ef07f98a$export$c5fff690dcda49e2(value) {
    let isInstance = true;
    return isInstance;
}
function $97456af1ef07f98a$export$bfdb8eb6be454b15(json) {
    return $97456af1ef07f98a$export$b3bc95898c127982(json, false);
}
function $97456af1ef07f98a$export$b3bc95898c127982(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : (0, $91e561dc33dbb6e6$export$2438463015ae288a)(json["result"])
    };
}
function $97456af1ef07f98a$export$57916bf01f85117c(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": (0, $91e561dc33dbb6e6$export$c47763383831190d)(value.result)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $6c231e9d83ce7003$export$758081093e690118(value) {
    let isInstance = true;
    return isInstance;
}
function $6c231e9d83ce7003$export$e152c415552a0eb1(json) {
    return $6c231e9d83ce7003$export$2a33eddc5f62a690(json, false);
}
function $6c231e9d83ce7003$export$2a33eddc5f62a690(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : (0, $91e561dc33dbb6e6$export$2438463015ae288a)(json["result"])
    };
}
function $6c231e9d83ce7003$export$7f076be9c13eef9e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": (0, $91e561dc33dbb6e6$export$c47763383831190d)(value.result)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $c1d470802eb5d4dd$export$2564becf3d7df8bf(value) {
    let isInstance = true;
    return isInstance;
}
function $c1d470802eb5d4dd$export$c5ad9a62b0e0f9c1(json) {
    return $c1d470802eb5d4dd$export$92265434404f74f(json, false);
}
function $c1d470802eb5d4dd$export$92265434404f74f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : json["result"]
    };
}
function $c1d470802eb5d4dd$export$43e020afdf5de077(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": value.result
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $a01b82c1a1c297f8$export$77aad5febf7b6771(value) {
    let isInstance = true;
    return isInstance;
}
function $a01b82c1a1c297f8$export$6739b895c3ed7a1a(json) {
    return $a01b82c1a1c297f8$export$c89ff73594d954ad(json, false);
}
function $a01b82c1a1c297f8$export$c89ff73594d954ad(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : json["result"]
    };
}
function $a01b82c1a1c297f8$export$6f3ed69a87600774(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": value.result
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 



function $c5a2fdac9e1dddc8$export$8e4dc0011f92ce98(value) {
    let isInstance = true;
    return isInstance;
}
function $c5a2fdac9e1dddc8$export$af4b4231cf2b0254(json) {
    return $c5a2fdac9e1dddc8$export$2e7094b7545fa908(json, false);
}
function $c5a2fdac9e1dddc8$export$2e7094b7545fa908(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : json["result"].map((0, $dad19632247d7ad3$export$2b369be06dcbfccd))
    };
}
function $c5a2fdac9e1dddc8$export$343f21e1ccb9a347(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": value.result === undefined ? undefined : value.result.map((0, $dad19632247d7ad3$export$6177497a9ebb14ed))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $5a3ff3336bb6598b$export$f12da6d5709d3764(value) {
    let isInstance = true;
    return isInstance;
}
function $5a3ff3336bb6598b$export$1518025bae65a77f(json) {
    return $5a3ff3336bb6598b$export$98a0e5d64eb47e94(json, false);
}
function $5a3ff3336bb6598b$export$98a0e5d64eb47e94(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : json["result"].map((0, $dad19632247d7ad3$export$2b369be06dcbfccd))
    };
}
function $5a3ff3336bb6598b$export$c8e4cba504bb3f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": value.result === undefined ? undefined : value.result.map((0, $dad19632247d7ad3$export$6177497a9ebb14ed))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $10da6b5e0ce8aa35$export$44cb6a10a172bc79(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $10da6b5e0ce8aa35$export$6cc59d6581215347(json) {
    return $10da6b5e0ce8aa35$export$dd5582c4cefe8245(json, false);
}
function $10da6b5e0ce8aa35$export$dd5582c4cefe8245(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": json["result"]
    };
}
function $10da6b5e0ce8aa35$export$2738242983cb35a0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": value.result
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $f75b7ff402fe43b1$export$a1ecf1855c29eca3(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $f75b7ff402fe43b1$export$238d5042e1ae5ef8(json) {
    return $f75b7ff402fe43b1$export$85d65e0d9863cc9f(json, false);
}
function $f75b7ff402fe43b1$export$85d65e0d9863cc9f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": json["result"]
    };
}
function $f75b7ff402fe43b1$export$2d30b0e1979e4a40(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": value.result
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $317a90900618246c$export$21d3a66e6f16843c(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $317a90900618246c$export$fd10bc7066dcb68(json) {
    return $317a90900618246c$export$f7f5a51deed9412a(json, false);
}
function $317a90900618246c$export$f7f5a51deed9412a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": json["result"]
    };
}
function $317a90900618246c$export$e1bf2284efe0a85b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": value.result
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $e221e6c39208a2d3$export$3eafe0e89bb7ab05(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $e221e6c39208a2d3$export$422a03af8047a0e5(json) {
    return $e221e6c39208a2d3$export$70b589c2556d6a2b(json, false);
}
function $e221e6c39208a2d3$export$70b589c2556d6a2b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": json["result"]
    };
}
function $e221e6c39208a2d3$export$c989947b14abff7f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": value.result
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $6b424a65dc79ab94$export$5bc3de0eceaddcf(value) {
    let isInstance = true;
    isInstance = isInstance && "target_url" in value;
    return isInstance;
}
function $6b424a65dc79ab94$export$17bd01fc1408c51a(json) {
    return $6b424a65dc79ab94$export$521f70f9625079b4(json, false);
}
function $6b424a65dc79ab94$export$521f70f9625079b4(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "target_url": json["target_url"]
    };
}
function $6b424a65dc79ab94$export$6d86ef56b25a83c4(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "target_url": value.target_url
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $95599d8a44282b3d$export$82e781fc0d7e16a1(value) {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "pkce_code_verifier" in value;
    return isInstance;
}
function $95599d8a44282b3d$export$c81fe3455ca9f9b6(json) {
    return $95599d8a44282b3d$export$8d1ff6a39953655(json, false);
}
function $95599d8a44282b3d$export$8d1ff6a39953655(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "challenge_id": json["challenge_id"],
        "code": json["code"],
        "pkce_code_verifier": json["pkce_code_verifier"]
    };
}
function $95599d8a44282b3d$export$7fdfe928bc2b4877(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "challenge_id": value.challenge_id,
        "code": value.code,
        "pkce_code_verifier": value.pkce_code_verifier
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
const $bcf9a87696b945ac$export$80cd9ef7a7c5d538 = {
    InvalidTokenContent: "invalid_token_content",
    Expired: "expired",
    InvalidIssuer: "invalid_issuer",
    NotEnoughFactors: "not_enough_factors",
    PersonNotActive: "person_not_active"
};
function $bcf9a87696b945ac$export$38dbf72c17eda641(value) {
    let isInstance = true;
    isInstance = isInstance && "valid" in value;
    return isInstance;
}
function $bcf9a87696b945ac$export$1d7fdf6b6870e0e7(json) {
    return $bcf9a87696b945ac$export$be603d3798694712(json, false);
}
function $bcf9a87696b945ac$export$be603d3798694712(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "valid": json["valid"],
        "invalidity_reason": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "invalidity_reason") ? undefined : json["invalidity_reason"],
        "expires_in_seconds": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "expires_in_seconds") ? undefined : json["expires_in_seconds"],
        "expires_at": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "expires_at") ? undefined : new Date(json["expires_at"])
    };
}
function $bcf9a87696b945ac$export$6ada45142b7d15a5(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "valid": value.valid,
        "invalidity_reason": value.invalidity_reason,
        "expires_in_seconds": value.expires_in_seconds,
        "expires_at": value.expires_at === undefined ? undefined : value.expires_at.toISOString()
    };
}


function $61bff2e9c70d970f$export$edb1cba5f52eec11(value) {
    let isInstance = true;
    return isInstance;
}
function $61bff2e9c70d970f$export$6b84b521d90710d5(json) {
    return $61bff2e9c70d970f$export$16e23935a5c17df6(json, false);
}
function $61bff2e9c70d970f$export$16e23935a5c17df6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : (0, $bcf9a87696b945ac$export$1d7fdf6b6870e0e7)(json["result"])
    };
}
function $61bff2e9c70d970f$export$22872bcd4560fb07(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": (0, $bcf9a87696b945ac$export$6ada45142b7d15a5)(value.result)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $7b24e8beff14850b$export$29dc583d45d57047(value) {
    let isInstance = true;
    return isInstance;
}
function $7b24e8beff14850b$export$48a3482177fed5ac(json) {
    return $7b24e8beff14850b$export$589a447ab99ae7ec(json, false);
}
function $7b24e8beff14850b$export$589a447ab99ae7ec(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "result") ? undefined : (0, $bcf9a87696b945ac$export$1d7fdf6b6870e0e7)(json["result"])
    };
}
function $7b24e8beff14850b$export$135e1e1d76ff992b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": (0, $bcf9a87696b945ac$export$6ada45142b7d15a5)(value.result)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $c0a5dac8e6ae16e3$export$f285e59419fd2fb3(value) {
    let isInstance = true;
    return isInstance;
}
function $c0a5dac8e6ae16e3$export$b314fb5008156cf9(json) {
    return $c0a5dac8e6ae16e3$export$90113d5e575f3e93(json, false);
}
function $c0a5dac8e6ae16e3$export$90113d5e575f3e93(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "options": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "options") ? undefined : (0, $e6643d9a3244a168$export$f1b0b8bf9576e182)(json["options"])
    };
}
function $c0a5dac8e6ae16e3$export$c182f3ca9657c70b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "options": (0, $e6643d9a3244a168$export$f9c2a4907f4de151)(value.options)
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $1def9358807f3889$export$169e9c926128ac82(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "params" in value;
    return isInstance;
}
function $1def9358807f3889$export$45a23555e4ce3c92(json) {
    return $1def9358807f3889$export$262a7fd3b810b163(json, false);
}
function $1def9358807f3889$export$262a7fd3b810b163(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "type": (0, $c2a276139e1508e8$export$7bbec83240b0eeeb)(json["type"]),
        "params": (0, $f1f95dd58d1e6c26$export$cb838a8294c45d7f)(json["params"]),
        "label": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "label") ? undefined : json["label"]
    };
}
function $1def9358807f3889$export$23bdd0b159ac1803(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "type": (0, $c2a276139e1508e8$export$ee7a066c014b3dac)(value.type),
        "params": (0, $f1f95dd58d1e6c26$export$37444c8007920ed9)(value.params),
        "label": value.label
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 



function $38a16b083a989950$export$fe0e3a34c423c852(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $38a16b083a989950$export$5cffeb8ce2443b10(json) {
    return $38a16b083a989950$export$2e5f50cb2cd6002e(json, false);
}
function $38a16b083a989950$export$2e5f50cb2cd6002e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": (0, $d72477ff18746529$export$b9e34caf47c08b2)(json["result"])
    };
}
function $38a16b083a989950$export$c38eda6721591941(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": (0, $d72477ff18746529$export$2321b26b111a9baa)(value.result)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $c7b976729a4762c3$export$51fa51c0103cfbbf(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $c7b976729a4762c3$export$3bb77053894fc4a6(json) {
    return $c7b976729a4762c3$export$880a014c76b8cd74(json, false);
}
function $c7b976729a4762c3$export$880a014c76b8cd74(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": (0, $d72477ff18746529$export$b9e34caf47c08b2)(json["result"])
    };
}
function $c7b976729a4762c3$export$5626195bc79ee293(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": (0, $d72477ff18746529$export$2321b26b111a9baa)(value.result)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 



function $224d96fd1b9ed7e0$export$87619f8d9400d5e(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $224d96fd1b9ed7e0$export$2c0ca39127b0b0ee(json) {
    return $224d96fd1b9ed7e0$export$bbdc79fff298ed2(json, false);
}
function $224d96fd1b9ed7e0$export$bbdc79fff298ed2(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "meta": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "meta") ? undefined : (0, $39b4d090739e0edb$export$70023f934842ce53)(json["meta"]),
        "errors": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"].map((0, $a9bac9599bd76c1d$export$9a91be5fb3879fb9)),
        "result": (0, $eebefe4255826c03$export$eb7192996dd32ff1)(json["result"])
    };
}
function $224d96fd1b9ed7e0$export$4fa751dbc7b2fdcd(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "meta": (0, $39b4d090739e0edb$export$a688b751866cf7f3)(value.meta),
        "errors": value.errors === undefined ? undefined : value.errors.map((0, $a9bac9599bd76c1d$export$797f61dd859e886c)),
        "result": (0, $eebefe4255826c03$export$342cad717a3ff356)(value.result)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $60e9cd2a54920043$export$b1db77259e44015b(value) {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    return isInstance;
}
function $60e9cd2a54920043$export$2fe5e0f7b727735c(json) {
    return $60e9cd2a54920043$export$97422793d6d991(json, false);
}
function $60e9cd2a54920043$export$97422793d6d991(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "result": (0, $eebefe4255826c03$export$eb7192996dd32ff1)(json["result"])
    };
}
function $60e9cd2a54920043$export$81d6e7953b6d8b41(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "result": (0, $eebefe4255826c03$export$342cad717a3ff356)(value.result)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ /**
 * Authentication factor that can be recovered
 * @export
 */ const $9931288c5449801f$export$bb5e6ee25b0fc7c3 = {
    Password: "password"
};
function $9931288c5449801f$export$398fba7e85f1db2c(json) {
    return $9931288c5449801f$export$f62e5af70cc4ea0(json, false);
}
function $9931288c5449801f$export$f62e5af70cc4ea0(json, ignoreDiscriminator) {
    return json;
}
function $9931288c5449801f$export$423270bccf3787e0(value) {
    return value;
}


function $0172a9322b470861$export$d49ddc28a4137c80(value) {
    let isInstance = true;
    isInstance = isInstance && "method" in value;
    return isInstance;
}
function $0172a9322b470861$export$dfa0f361ed82900(json) {
    return $0172a9322b470861$export$8db160ece1e2bbd6(json, false);
}
function $0172a9322b470861$export$8db160ece1e2bbd6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "method": (0, $9931288c5449801f$export$398fba7e85f1db2c)(json["method"])
    };
}
function $0172a9322b470861$export$8b7251cbcbbc3a83(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "method": (0, $9931288c5449801f$export$423270bccf3787e0)(value.method)
    };
}


function $84e191c0f546a725$export$837a073b52aa896c(value) {
    let isInstance = true;
    isInstance = isInstance && "handle" in value;
    isInstance = isInstance && "factor" in value;
    return isInstance;
}
function $84e191c0f546a725$export$40275694f4ecf42f(json) {
    return $84e191c0f546a725$export$5b2c6615cebf0a90(json, false);
}
function $84e191c0f546a725$export$5b2c6615cebf0a90(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "handle": (0, $c40c5abb0dd863b2$export$11c41aa448e0ad82)(json["handle"]),
        "factor": (0, $0172a9322b470861$export$dfa0f361ed82900)(json["factor"])
    };
}
function $84e191c0f546a725$export$e61274da9e6eaaa0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "handle": (0, $c40c5abb0dd863b2$export$82ff335443c9930)(value.handle),
        "factor": (0, $0172a9322b470861$export$8b7251cbcbbc3a83)(value.factor)
    };
}





/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $f48520698cdfb9fc$export$7ca86809d47cdb1c(value) {
    let isInstance = true;
    isInstance = isInstance && "pattern" in value;
    isInstance = isInstance && "match_type" in value;
    return isInstance;
}
function $f48520698cdfb9fc$export$8cf681900776bc6a(json) {
    return $f48520698cdfb9fc$export$16eb9d6769046fc7(json, false);
}
function $f48520698cdfb9fc$export$16eb9d6769046fc7(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "pattern": json["pattern"],
        "match_type": (0, $4a50563666f772e4$export$211fa31f693d0fc5)(json["match_type"]),
        "pattern_qualifiers": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "pattern_qualifiers") ? undefined : json["pattern_qualifiers"].map((0, $86793b8acec4395c$export$1a54fab7686d0d4d))
    };
}
function $f48520698cdfb9fc$export$66b4fa0b7657eb1e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "pattern": value.pattern,
        "match_type": (0, $4a50563666f772e4$export$65d68d5d70683e8c)(value.match_type),
        "pattern_qualifiers": value.pattern_qualifiers === undefined ? undefined : value.pattern_qualifiers.map((0, $86793b8acec4395c$export$c013f8bf67b81bfd))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $11114717f59a2a5c$export$f422059f8ea5e525(value) {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    return isInstance;
}
function $11114717f59a2a5c$export$bc9b8e9658ece7a(json) {
    return $11114717f59a2a5c$export$2ef8c1fc67b5deb2(json, false);
}
function $11114717f59a2a5c$export$2ef8c1fc67b5deb2(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "token": json["token"]
    };
}
function $11114717f59a2a5c$export$d0f7f45459c0bb03(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "token": value.token
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $ecf09734584c221e$export$99cb3a4329850078(value) {
    let isInstance = true;
    isInstance = isInstance && "options" in value;
    return isInstance;
}
function $ecf09734584c221e$export$ca6deba59c41f6e0(json) {
    return $ecf09734584c221e$export$1a2701dfb3b4eec7(json, false);
}
function $ecf09734584c221e$export$1a2701dfb3b4eec7(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "options": (0, $84d4b0b0bfe56e36$export$69d72f503d5a95ba)(json["options"])
    };
}
function $ecf09734584c221e$export$98d488ef4d19985b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "options": (0, $84d4b0b0bfe56e36$export$9cee4e2f30c94128)(value.options)
    };
}





/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $76f71712ce860cab$export$af8ad63b24036d8d(value) {
    let isInstance = true;
    isInstance = isInstance && "failed_authn_method" in value;
    isInstance = isInstance && "failure_reason" in value;
    return isInstance;
}
function $76f71712ce860cab$export$300326b172827b0c(json) {
    return $76f71712ce860cab$export$ac521d7c41732b54(json, false);
}
function $76f71712ce860cab$export$ac521d7c41732b54(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "person_id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "person_id") ? undefined : json["person_id"],
        "authenticated_methods": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "authenticated_methods") ? undefined : json["authenticated_methods"].map((0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)),
        "failed_authn_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["failed_authn_method"]),
        "failure_reason": json["failure_reason"],
        "failure_detail": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "failure_detail") ? undefined : json["failure_detail"],
        "handle": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "handle") ? undefined : (0, $c40c5abb0dd863b2$export$11c41aa448e0ad82)(json["handle"]),
        "challenge_id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "challenge_id") ? undefined : json["challenge_id"]
    };
}
function $76f71712ce860cab$export$37bb3fad6986a94c(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "person_id": value.person_id,
        "authenticated_methods": value.authenticated_methods === undefined ? undefined : value.authenticated_methods.map((0, $d180e6976bd68c99$export$6eefe3f1006b48e7)),
        "failed_authn_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.failed_authn_method),
        "failure_reason": value.failure_reason,
        "failure_detail": value.failure_detail,
        "handle": (0, $c40c5abb0dd863b2$export$82ff335443c9930)(value.handle),
        "challenge_id": value.challenge_id
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 


function $c5615adf82904551$export$ff0d9c59c3b68253(value) {
    let isInstance = true;
    isInstance = isInstance && "person_id" in value;
    isInstance = isInstance && "success_authn_method" in value;
    isInstance = isInstance && "authenticated_methods" in value;
    return isInstance;
}
function $c5615adf82904551$export$1de24f5e60a15df0(json) {
    return $c5615adf82904551$export$69fa0609e59723dd(json, false);
}
function $c5615adf82904551$export$69fa0609e59723dd(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "person_id": json["person_id"],
        "success_authn_method": (0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)(json["success_authn_method"]),
        "authenticated_methods": json["authenticated_methods"].map((0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)),
        "handle": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "handle") ? undefined : (0, $c40c5abb0dd863b2$export$11c41aa448e0ad82)(json["handle"])
    };
}
function $c5615adf82904551$export$f5276c9c6afb7e2a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "person_id": value.person_id,
        "success_authn_method": (0, $d180e6976bd68c99$export$6eefe3f1006b48e7)(value.success_authn_method),
        "authenticated_methods": value.authenticated_methods.map((0, $d180e6976bd68c99$export$6eefe3f1006b48e7)),
        "handle": (0, $c40c5abb0dd863b2$export$82ff335443c9930)(value.handle)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $e313ab86073460bb$export$7db73d95148cf77a(value) {
    let isInstance = true;
    isInstance = isInstance && "person_id" in value;
    return isInstance;
}
function $e313ab86073460bb$export$28a36daef148624(json) {
    return $e313ab86073460bb$export$3d32ce4ef809ef18(json, false);
}
function $e313ab86073460bb$export$3d32ce4ef809ef18(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "person_id": json["person_id"]
    };
}
function $e313ab86073460bb$export$3e384c2a34bf5318(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "person_id": value.person_id
    };
}





/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $f05b12d9691ad1a7$export$e66798f9e2038917(value) {
    let isInstance = true;
    return isInstance;
}
function $f05b12d9691ad1a7$export$8000b319c10d802c(json) {
    return $f05b12d9691ad1a7$export$9210c16714199377(json, false);
}
function $f05b12d9691ad1a7$export$9210c16714199377(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "person_id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "person_id") ? undefined : json["person_id"]
    };
}
function $f05b12d9691ad1a7$export$f4c31a0617114016(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "person_id": value.person_id
    };
}










/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $dc745208abca46b8$export$8102a2cffe3b5075(value) {
    let isInstance = true;
    return isInstance;
}
function $dc745208abca46b8$export$4009b5fafa539fac(json) {
    return $dc745208abca46b8$export$c18add4167ce49b7(json, false);
}
function $dc745208abca46b8$export$c18add4167ce49b7(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : (0, $a4725d28872dfb5f$export$ef169f01af6d5676)(json["data"])
    };
}
function $dc745208abca46b8$export$ead3d36d1e2438ae(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "data": (0, $a4725d28872dfb5f$export$87e83845366bd7e3)(value.data)
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $1300fe7057d40681$export$4507cd817dfa2ed0(value) {
    let isInstance = true;
    return isInstance;
}
function $1300fe7057d40681$export$3629002ce575b12a(json) {
    return $1300fe7057d40681$export$14fb887596d8abf3(json, false);
}
function $1300fe7057d40681$export$14fb887596d8abf3(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "options": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "options") ? undefined : (0, $c2423cca4895e8d1$export$f66b99a7ee22c7be)(json["options"])
    };
}
function $1300fe7057d40681$export$5de9ac5b95b9e405(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "options": (0, $c2423cca4895e8d1$export$acdf6a8f9dfbfedb)(value.options)
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $fb702cd326170715$export$3900140db4f57521(value) {
    let isInstance = true;
    return isInstance;
}
function $fb702cd326170715$export$dcb304a8a6f6f27d(json) {
    return $fb702cd326170715$export$cb8f973ac652a3d2(json, false);
}
function $fb702cd326170715$export$cb8f973ac652a3d2(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : (0, $238a8c60393afa86$export$d31be9a6034a3ec9)(json["data"])
    };
}
function $fb702cd326170715$export$e0e9bdd80fd45274(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "data": (0, $238a8c60393afa86$export$a789f8fc51697f53)(value.data)
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $9d3e80ffc7ac450e$export$2d9264c742d6943a(value) {
    let isInstance = true;
    isInstance = isInstance && "user_token" in value;
    return isInstance;
}
function $9d3e80ffc7ac450e$export$a365a919a100fd83(json) {
    return $9d3e80ffc7ac450e$export$223ead298c9cf3bd(json, false);
}
function $9d3e80ffc7ac450e$export$223ead298c9cf3bd(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "aud": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "aud") ? undefined : json["aud"],
        "id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "iat": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "iat") ? undefined : json["iat"],
        "exp": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "exp") ? undefined : json["exp"],
        "nbf": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "nbf") ? undefined : json["nbf"],
        "iss": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "iss") ? undefined : json["iss"],
        "sub": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "sub") ? undefined : json["sub"],
        "user_token": json["user_token"],
        "oidc_tokens": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "oidc_tokens") ? undefined : json["oidc_tokens"].map((0, $89bf3d35f0b5f331$export$76b919b75d277795))
    };
}
function $9d3e80ffc7ac450e$export$1ecabdf4344007a6(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "aud": value.aud,
        "id": value.id,
        "iat": value.iat,
        "exp": value.exp,
        "nbf": value.nbf,
        "iss": value.iss,
        "sub": value.sub,
        "user_token": value.user_token,
        "oidc_tokens": value.oidc_tokens === undefined ? undefined : value.oidc_tokens.map((0, $89bf3d35f0b5f331$export$6c26bd44fa13d939))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $c8b658e42a2585ea$export$ec40b7b9801f6682(value) {
    let isInstance = true;
    isInstance = isInstance && "user_token" in value;
    return isInstance;
}
function $c8b658e42a2585ea$export$2f0f11e7f8715b67(json) {
    return $c8b658e42a2585ea$export$4b92f85337c705db(json, false);
}
function $c8b658e42a2585ea$export$4b92f85337c705db(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "user_token": json["user_token"],
        "oidc_tokens": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "oidc_tokens") ? undefined : json["oidc_tokens"].map((0, $89bf3d35f0b5f331$export$76b919b75d277795))
    };
}
function $c8b658e42a2585ea$export$481ac3afcbf710dc(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "user_token": value.user_token,
        "oidc_tokens": value.oidc_tokens === undefined ? undefined : value.oidc_tokens.map((0, $89bf3d35f0b5f331$export$6c26bd44fa13d939))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

function $c81aea91bf9d1c21$export$8221a3b9123a765c(value) {
    let isInstance = true;
    return isInstance;
}
function $c81aea91bf9d1c21$export$c7e2cd77625cdab0(json) {
    return $c81aea91bf9d1c21$export$a941622138040c(json, false);
}
function $c81aea91bf9d1c21$export$a941622138040c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "options": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "options") ? undefined : (0, $c1877c09ccf110e4$export$dcd5b8b66f15246b)(json["options"])
    };
}
function $c81aea91bf9d1c21$export$d0cdf9372c8dc3c(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "options": (0, $c1877c09ccf110e4$export$2f17748153b0485a)(value.options)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 



function $c513f5b618fe51fa$export$ae58097fa9f3a0a(value) {
    let isInstance = true;
    return isInstance;
}
function $c513f5b618fe51fa$export$fc5843c172697631(json) {
    return $c513f5b618fe51fa$export$eec2f87507b4c61c(json, false);
}
function $c513f5b618fe51fa$export$eec2f87507b4c61c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "aud": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "aud") ? undefined : json["aud"],
        "id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "iat": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "iat") ? undefined : json["iat"],
        "exp": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "exp") ? undefined : json["exp"],
        "nbf": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "nbf") ? undefined : json["nbf"],
        "iss": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "iss") ? undefined : json["iss"],
        "sub": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "sub") ? undefined : json["sub"],
        "prev_token_id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "prev_token_id") ? undefined : json["prev_token_id"],
        "oid": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "oid") ? undefined : json["oid"],
        "person_id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "person_id") ? undefined : json["person_id"],
        "person_type": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "person_type") ? undefined : (0, $d5b0d31d90a934fe$export$851ad6a45f8bc66)(json["person_type"]),
        "first_token": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "first_token") ? undefined : json["first_token"],
        "authentications": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "authentications") ? undefined : json["authentications"].map((0, $b875578786480fb6$export$6ba513db151a5ff1)),
        "authenticated_methods": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "authenticated_methods") ? undefined : json["authenticated_methods"].map((0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)),
        "groups_claim_name": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "groups_claim_name") ? undefined : json["groups_claim_name"],
        "prev_anonymous_person_id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "prev_anonymous_person_id") ? undefined : json["prev_anonymous_person_id"]
    };
}
function $c513f5b618fe51fa$export$2bf0bd3743394bdb(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "aud": value.aud,
        "id": value.id,
        "iat": value.iat,
        "exp": value.exp,
        "nbf": value.nbf,
        "iss": value.iss,
        "sub": value.sub,
        "prev_token_id": value.prev_token_id,
        "oid": value.oid,
        "person_id": value.person_id,
        "person_type": (0, $d5b0d31d90a934fe$export$5bebd3993c7ac4e8)(value.person_type),
        "first_token": value.first_token,
        "authentications": value.authentications === undefined ? undefined : value.authentications.map((0, $b875578786480fb6$export$7f86f8f881fe1819)),
        "authenticated_methods": value.authenticated_methods === undefined ? undefined : value.authenticated_methods.map((0, $d180e6976bd68c99$export$6eefe3f1006b48e7)),
        "groups_claim_name": value.groups_claim_name,
        "prev_anonymous_person_id": value.prev_anonymous_person_id
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 



function $898991713100d07c$export$da6f60378a4ffae8(value) {
    let isInstance = true;
    return isInstance;
}
function $898991713100d07c$export$49405bd05d18e505(json) {
    return $898991713100d07c$export$2480706e273e736f(json, false);
}
function $898991713100d07c$export$2480706e273e736f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "prev_token_id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "prev_token_id") ? undefined : json["prev_token_id"],
        "oid": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "oid") ? undefined : json["oid"],
        "person_id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "person_id") ? undefined : json["person_id"],
        "person_type": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "person_type") ? undefined : (0, $d5b0d31d90a934fe$export$851ad6a45f8bc66)(json["person_type"]),
        "first_token": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "first_token") ? undefined : json["first_token"],
        "authentications": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "authentications") ? undefined : json["authentications"].map((0, $b875578786480fb6$export$6ba513db151a5ff1)),
        "authenticated_methods": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "authenticated_methods") ? undefined : json["authenticated_methods"].map((0, $d180e6976bd68c99$export$67789e1d0e9f3dc1)),
        "groups_claim_name": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "groups_claim_name") ? undefined : json["groups_claim_name"],
        "prev_anonymous_person_id": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "prev_anonymous_person_id") ? undefined : json["prev_anonymous_person_id"]
    };
}
function $898991713100d07c$export$db3aaa7b1ac3a014(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "prev_token_id": value.prev_token_id,
        "oid": value.oid,
        "person_id": value.person_id,
        "person_type": (0, $d5b0d31d90a934fe$export$5bebd3993c7ac4e8)(value.person_type),
        "first_token": value.first_token,
        "authentications": value.authentications === undefined ? undefined : value.authentications.map((0, $b875578786480fb6$export$7f86f8f881fe1819)),
        "authenticated_methods": value.authenticated_methods === undefined ? undefined : value.authenticated_methods.map((0, $d180e6976bd68c99$export$6eefe3f1006b48e7)),
        "groups_claim_name": value.groups_claim_name,
        "prev_anonymous_person_id": value.prev_anonymous_person_id
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ function $7be8f15fd333c945$export$574081f636b3004e(value) {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    return isInstance;
}
function $7be8f15fd333c945$export$c19b74f1215c1f46(json) {
    return $7be8f15fd333c945$export$aa09d6fd184f9d48(json, false);
}
function $7be8f15fd333c945$export$aa09d6fd184f9d48(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "token": json["token"]
    };
}
function $7be8f15fd333c945$export$3bd7d2b6a8fd413d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "token": value.token
    };
}






/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $dc5640f6c84d057d$export$c299debc1fd57374(value) {
    let isInstance = true;
    return isInstance;
}
function $dc5640f6c84d057d$export$8bb7916af0b399b2(json) {
    return $dc5640f6c84d057d$export$bb89284bfca19542(json, false);
}
function $dc5640f6c84d057d$export$bb89284bfca19542(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : json["data"]
    };
}
function $dc5640f6c84d057d$export$78aee5059ba243e5(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "data": value.data
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $bf6159f97f58abf0$export$176b39ec143d1fa5(value) {
    let isInstance = true;
    return isInstance;
}
function $bf6159f97f58abf0$export$dd121604c80f6b91(json) {
    return $bf6159f97f58abf0$export$bf4d1968fec6776(json, false);
}
function $bf6159f97f58abf0$export$bf4d1968fec6776(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "options": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "options") ? undefined : json["options"]
    };
}
function $bf6159f97f58abf0$export$53def36f1267104f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "options": value.options
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $0bc96e39e3abdd76$export$e42a4717d53762e1(value) {
    let isInstance = true;
    return isInstance;
}
function $0bc96e39e3abdd76$export$5f684fa44a8dceb7(json) {
    return $0bc96e39e3abdd76$export$31dcda022f0c7fb(json, false);
}
function $0bc96e39e3abdd76$export$31dcda022f0c7fb(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "data": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "data") ? undefined : json["data"]
    };
}
function $0bc96e39e3abdd76$export$b1f525fb87b155b2(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "data": value.data
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 
function $a6729f073297e947$export$296c3704751db5b5(value) {
    let isInstance = true;
    return isInstance;
}
function $a6729f073297e947$export$e0d1ba043a76cd7a(json) {
    return $a6729f073297e947$export$d2cacb72e6566efc(json, false);
}
function $a6729f073297e947$export$d2cacb72e6566efc(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "options": !(0, $168d06aed8b3cdb0$export$f7e9f41ea797a17)(json, "options") ? undefined : json["options"]
    };
}
function $a6729f073297e947$export$9d871e645ef89b11(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "options": value.options
    };
}







class $de791efae2088fc4$export$95d3101c7670792a extends $168d06aed8b3cdb0$export$70edad7ad5bb3f5d {
    /**
     * Delete attributes from a single bucket
     */ async deleteAttributesBucketNameRaw(requestParameters, initOverrides) {
        if (requestParameters.bucketName === null || requestParameters.bucketName === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("bucketName", "Required parameter requestParameters.bucketName was null or undefined when calling deleteAttributesBucketName.");
        const queryParameters = {};
        if (requestParameters.attributes) queryParameters["attributes"] = requestParameters.attributes.join($168d06aed8b3cdb0$export$83cb526776fb323d["csv"]);
        const headerParameters = {};
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/attributes/{bucket_name}`.replace(`{${"bucket_name"}}`, encodeURIComponent(String(requestParameters.bucketName))),
            method: "DELETE",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $98d4ae80407991f3$export$53557473c48f27d7)(jsonValue));
    }
    /**
     * Delete attributes from a single bucket
     */ async deleteAttributesBucketName(requestParameters, initOverrides) {
        const response = await this.deleteAttributesBucketNameRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieve attributes from multiple buckets
     */ async getAttributesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.buckets) queryParameters["buckets"] = requestParameters.buckets.join($168d06aed8b3cdb0$export$83cb526776fb323d["csv"]);
        const headerParameters = {};
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/attributes`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $6df6f0c3c1503c39$export$b860effd636f4c33)(jsonValue));
    }
    /**
     * Retrieve attributes from multiple buckets
     */ async getAttributes(requestParameters = {}, initOverrides) {
        const response = await this.getAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieve attributes from a single bucket
     */ async getAttributesBucketNameRaw(requestParameters, initOverrides) {
        if (requestParameters.bucketName === null || requestParameters.bucketName === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("bucketName", "Required parameter requestParameters.bucketName was null or undefined when calling getAttributesBucketName.");
        const queryParameters = {};
        if (requestParameters.attributes) queryParameters["attributes"] = requestParameters.attributes.join($168d06aed8b3cdb0$export$83cb526776fb323d["csv"]);
        const headerParameters = {};
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/attributes/{bucket_name}`.replace(`{${"bucket_name"}}`, encodeURIComponent(String(requestParameters.bucketName))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $38e4ceff1a16944f$export$16028d5073b65888)(jsonValue));
    }
    /**
     * Retrieve attributes from a single bucket
     */ async getAttributesBucketName(requestParameters, initOverrides) {
        const response = await this.getAttributesBucketNameRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create new attributes or modify existing attributes for a person in one or more attribute buckets.  Any existing attribute that isn\'t referenced by key in the request is left untouched. 
     * Create or modify attributes in multiple buckets
     */ async patchAttributesRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("body", "Required parameter requestParameters.body was null or undefined when calling patchAttributes.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/attributes`,
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $98d4ae80407991f3$export$53557473c48f27d7)(jsonValue));
    }
    /**
     * Create new attributes or modify existing attributes for a person in one or more attribute buckets.  Any existing attribute that isn\'t referenced by key in the request is left untouched. 
     * Create or modify attributes in multiple buckets
     */ async patchAttributes(requestParameters, initOverrides) {
        const response = await this.patchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create new attributes or modify existing attributes for a person in a single bucket.  Any existing attribute that isn\'t referenced by key in the request is left untouched. 
     * Create or modify attributes in a single bucket
     */ async patchAttributesBucketNameRaw(requestParameters, initOverrides) {
        if (requestParameters.bucketName === null || requestParameters.bucketName === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("bucketName", "Required parameter requestParameters.bucketName was null or undefined when calling patchAttributesBucketName.");
        if (requestParameters.body === null || requestParameters.body === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("body", "Required parameter requestParameters.body was null or undefined when calling patchAttributesBucketName.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/attributes/{bucket_name}`.replace(`{${"bucket_name"}}`, encodeURIComponent(String(requestParameters.bucketName))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $98d4ae80407991f3$export$53557473c48f27d7)(jsonValue));
    }
    /**
     * Create new attributes or modify existing attributes for a person in a single bucket.  Any existing attribute that isn\'t referenced by key in the request is left untouched. 
     * Create or modify attributes in a single bucket
     */ async patchAttributesBucketName(requestParameters, initOverrides) {
        const response = await this.patchAttributesBucketNameRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create new attributes or modify existing attributes for a person in one or more attribute buckets.  Replaces the set of existing attributes with those present in the request. In other words, it deletes any existing attributes that aren\'t referenced by key in the request. 
     * Create or modify attributes in multiple buckets
     */ async putAttributesRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("body", "Required parameter requestParameters.body was null or undefined when calling putAttributes.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/attributes`,
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $98d4ae80407991f3$export$53557473c48f27d7)(jsonValue));
    }
    /**
     * Create new attributes or modify existing attributes for a person in one or more attribute buckets.  Replaces the set of existing attributes with those present in the request. In other words, it deletes any existing attributes that aren\'t referenced by key in the request. 
     * Create or modify attributes in multiple buckets
     */ async putAttributes(requestParameters, initOverrides) {
        const response = await this.putAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create new attributes or modify existing attributes for a person in a single bucket.  Replaces the set of existing attributes with those present in the request. In other words, it deletes any existing attributes that aren\'t referenced by key in the request. 
     * Create or modify attributes in a single bucket
     */ async putAttributesBucketNameRaw(requestParameters, initOverrides) {
        if (requestParameters.bucketName === null || requestParameters.bucketName === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("bucketName", "Required parameter requestParameters.bucketName was null or undefined when calling putAttributesBucketName.");
        if (requestParameters.body === null || requestParameters.body === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("body", "Required parameter requestParameters.body was null or undefined when calling putAttributesBucketName.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/attributes/{bucket_name}`.replace(`{${"bucket_name"}}`, encodeURIComponent(String(requestParameters.bucketName))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $98d4ae80407991f3$export$53557473c48f27d7)(jsonValue));
    }
    /**
     * Create new attributes or modify existing attributes for a person in a single bucket.  Replaces the set of existing attributes with those present in the request. In other words, it deletes any existing attributes that aren\'t referenced by key in the request. 
     * Create or modify attributes in a single bucket
     */ async putAttributesBucketName(requestParameters, initOverrides) {
        const response = await this.putAttributesBucketNameRaw(requestParameters, initOverrides);
        return await response.value();
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

class $8dabc67a561e7dc0$export$872437fb2a17cd0e extends $168d06aed8b3cdb0$export$70edad7ad5bb3f5d {
    /**
     */ async getChallengeChallengeIdRaw(requestParameters, initOverrides) {
        if (requestParameters.challengeId === null || requestParameters.challengeId === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("challengeId", "Required parameter requestParameters.challengeId was null or undefined when calling getChallengeChallengeId.");
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/challenge/{challenge_id}`.replace(`{${"challenge_id"}}`, encodeURIComponent(String(requestParameters.challengeId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $39cb95385236689b$export$fc7f4a9925d556ff)(jsonValue));
    }
    /**
     */ async getChallengeChallengeId(requestParameters, initOverrides) {
        const response = await this.getChallengeChallengeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */ async getChallengeChallengeIdV2Raw(requestParameters, initOverrides) {
        if (requestParameters.challengeId === null || requestParameters.challengeId === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("challengeId", "Required parameter requestParameters.challengeId was null or undefined when calling getChallengeChallengeIdV2.");
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/challenge/{challenge_id}/v2`.replace(`{${"challenge_id"}}`, encodeURIComponent(String(requestParameters.challengeId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $de585f0e4fd9d86f$export$859624b73bf55232)(jsonValue));
    }
    /**
     */ async getChallengeChallengeIdV2(requestParameters, initOverrides) {
        const response = await this.getChallengeChallengeIdV2Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */ async getChallengePackChallengePackIdRaw(requestParameters, initOverrides) {
        if (requestParameters.challengePackId === null || requestParameters.challengePackId === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("challengePackId", "Required parameter requestParameters.challengePackId was null or undefined when calling getChallengePackChallengePackId.");
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/challenge_pack/{challenge_pack_id}`.replace(`{${"challenge_pack_id"}}`, encodeURIComponent(String(requestParameters.challengePackId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c5a2fdac9e1dddc8$export$af4b4231cf2b0254)(jsonValue));
    }
    /**
     */ async getChallengePackChallengePackId(requestParameters, initOverrides) {
        const response = await this.getChallengePackChallengePackIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieve details of the person and all the organizations they belong to, including:  - The organization of the request: the person must be a member of the organization you authenticate    with for you to be allowed to retrieve this list  - Any other organizations that share the person pool with the organization specified in the request and to which the person also belongs.    A hierarchy of organizations can be created using [this API endpoint](/docs/api/post-organizations-suborganizations).    When organizations are configured to share a person pool, if the same person registers with multiple organizations    in the pool using the same handle, all organizations will see the same person ID for that person. 
     * Retrieve the person details and list of organizations
     */ async getMeRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/me`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $9df250add66fe5a4$export$bfd68bd3621b7ea1)(jsonValue));
    }
    /**
     * Retrieve details of the person and all the organizations they belong to, including:  - The organization of the request: the person must be a member of the organization you authenticate    with for you to be allowed to retrieve this list  - Any other organizations that share the person pool with the organization specified in the request and to which the person also belongs.    A hierarchy of organizations can be created using [this API endpoint](/docs/api/post-organizations-suborganizations).    When organizations are configured to share a person pool, if the same person registers with multiple organizations    in the pool using the same handle, all organizations will see the same person ID for that person. 
     * Retrieve the person details and list of organizations
     */ async getMe(initOverrides) {
        const response = await this.getMeRaw(initOverrides);
        return await response.value();
    }
    /**
     * Retrieve all the organizations the person belongs to, including:  - The organization of the request: the person must be a member of the organization you authenticate    with for you to be allowed to retrieve this list  - Any other organizations that share the person pool with the organization specified in the request and to which the person also belongs.    A hierarchy of organizations can be created using [this API endpoint](/docs/api/post-organizations-suborganizations).    When organizations are configured to share a person pool, if the same person registers with multiple organizations    in the pool using the same handle, all organizations will see the same person ID for that person. 
     * Retrieve the person list of organizations
     */ async getMeOrgsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/me/orgs`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5a984202a50f2e52$export$8a5bc1b2ff07b739)(jsonValue));
    }
    /**
     * Retrieve all the organizations the person belongs to, including:  - The organization of the request: the person must be a member of the organization you authenticate    with for you to be allowed to retrieve this list  - Any other organizations that share the person pool with the organization specified in the request and to which the person also belongs.    A hierarchy of organizations can be created using [this API endpoint](/docs/api/post-organizations-suborganizations).    When organizations are configured to share a person pool, if the same person registers with multiple organizations    in the pool using the same handle, all organizations will see the same person ID for that person. 
     * Retrieve the person list of organizations
     */ async getMeOrgs(initOverrides) {
        const response = await this.getMeOrgsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Given a token for a Person in an Organization, return a new token for the same user in the Organization specified in the SlashID-OrgID request header. For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */ async getTokenRaw(requestParameters, initOverrides) {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("slashIDOrgID", "Required parameter requestParameters.slashIDOrgID was null or undefined when calling getToken.");
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) headerParameters["SlashID-OrgID"] = String(requestParameters.slashIDOrgID);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/token`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $de585f0e4fd9d86f$export$859624b73bf55232)(jsonValue));
    }
    /**
     * Given a token for a Person in an Organization, return a new token for the same user in the Organization specified in the SlashID-OrgID request header. For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */ async getToken(requestParameters, initOverrides) {
        const response = await this.getTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */ async postAttestationRaw(requestParameters, initOverrides) {
        if (requestParameters.attestation === null || requestParameters.attestation === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("attestation", "Required parameter requestParameters.attestation was null or undefined when calling postAttestation.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/attestation`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $ec04d4058abe68eb$export$d7f719716c0ef239)(requestParameters.attestation)
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $39cb95385236689b$export$fc7f4a9925d556ff)(jsonValue));
    }
    /**
     */ async postAttestation(requestParameters, initOverrides) {
        const response = await this.postAttestationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */ async postAttestationV2Raw(requestParameters, initOverrides) {
        if (requestParameters.attestation === null || requestParameters.attestation === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("attestation", "Required parameter requestParameters.attestation was null or undefined when calling postAttestationV2.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/attestation/v2`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $ec04d4058abe68eb$export$d7f719716c0ef239)(requestParameters.attestation)
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $de585f0e4fd9d86f$export$859624b73bf55232)(jsonValue));
    }
    /**
     */ async postAttestationV2(requestParameters, initOverrides) {
        const response = await this.postAttestationV2Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */ async postAttestationV3Raw(requestParameters, initOverrides) {
        if (requestParameters.attestation === null || requestParameters.attestation === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("attestation", "Required parameter requestParameters.attestation was null or undefined when calling postAttestationV3.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/attestation/v3`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $ec04d4058abe68eb$export$d7f719716c0ef239)(requestParameters.attestation)
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $97456af1ef07f98a$export$bfdb8eb6be454b15)(jsonValue));
    }
    /**
     */ async postAttestationV3(requestParameters, initOverrides) {
        const response = await this.postAttestationV3Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */ async postDirectIdRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/direct-id`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c1d470802eb5d4dd$export$c5ad9a62b0e0f9c1)(jsonValue));
    }
    /**
     */ async postDirectId(requestParameters = {}, initOverrides) {
        const response = await this.postDirectIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */ async postIdRaw(requestParameters, initOverrides) {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("slashIDOrgID", "Required parameter requestParameters.slashIDOrgID was null or undefined when calling postId.");
        if (requestParameters.iDRequest === null || requestParameters.iDRequest === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("iDRequest", "Required parameter requestParameters.iDRequest was null or undefined when calling postId.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) headerParameters["SlashID-OrgID"] = String(requestParameters.slashIDOrgID);
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/id`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $84e44e75922d87c6$export$7eb26765f35a90a8)(requestParameters.iDRequest)
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c5a2fdac9e1dddc8$export$af4b4231cf2b0254)(jsonValue));
    }
    /**
     */ async postId(requestParameters, initOverrides) {
        const response = await this.postIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */ async postIdV2Raw(requestParameters, initOverrides) {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("slashIDOrgID", "Required parameter requestParameters.slashIDOrgID was null or undefined when calling postIdV2.");
        if (requestParameters.iDRequestV2 === null || requestParameters.iDRequestV2 === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("iDRequestV2", "Required parameter requestParameters.iDRequestV2 was null or undefined when calling postIdV2.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) headerParameters["SlashID-OrgID"] = String(requestParameters.slashIDOrgID);
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/id/v2`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $a943f424e3af82d1$export$511cb15a8242b8a0)(requestParameters.iDRequestV2)
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c5a2fdac9e1dddc8$export$af4b4231cf2b0254)(jsonValue));
    }
    /**
     */ async postIdV2(requestParameters, initOverrides) {
        const response = await this.postIdV2Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */ async postRecoverRaw(requestParameters, initOverrides) {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("slashIDOrgID", "Required parameter requestParameters.slashIDOrgID was null or undefined when calling postRecover.");
        if (requestParameters.recoverRequest === null || requestParameters.recoverRequest === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("recoverRequest", "Required parameter requestParameters.recoverRequest was null or undefined when calling postRecover.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) headerParameters["SlashID-OrgID"] = String(requestParameters.slashIDOrgID);
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/recover`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $84e191c0f546a725$export$e61274da9e6eaaa0)(requestParameters.recoverRequest)
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c5a2fdac9e1dddc8$export$af4b4231cf2b0254)(jsonValue));
    }
    /**
     */ async postRecover(requestParameters, initOverrides) {
        const response = await this.postRecoverRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Resolve endpoint for SSO flows using PKCE.
     * SSO resolve challenge endpoint
     */ async postSsoResolveRaw(requestParameters, initOverrides) {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("slashIDOrgID", "Required parameter requestParameters.slashIDOrgID was null or undefined when calling postSsoResolve.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) headerParameters["SlashID-OrgID"] = String(requestParameters.slashIDOrgID);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/sso/resolve`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $95599d8a44282b3d$export$7fdfe928bc2b4877)(requestParameters.postSsoResolveRequest)
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$20446dc680588cc3(response);
    }
    /**
     * Resolve endpoint for SSO flows using PKCE.
     * SSO resolve challenge endpoint
     */ async postSsoResolve(requestParameters, initOverrides) {
        await this.postSsoResolveRaw(requestParameters, initOverrides);
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

class $6d6044a55374bf35$export$9d7eae2d04d44e94 extends $168d06aed8b3cdb0$export$70edad7ad5bb3f5d {
    /**
     * Post information that can used to build and publish an event originating from the SlashID SDK
     * Publish an event from the SDK
     */ async postActionsSdkRaw(requestParameters, initOverrides) {
        if (requestParameters.eventPostRequest === null || requestParameters.eventPostRequest === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("eventPostRequest", "Required parameter requestParameters.eventPostRequest was null or undefined when calling postActionsSdk.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/actions/sdk`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $9eee0f736eff090c$export$66614e5f3c5485b5)(requestParameters.eventPostRequest)
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$20446dc680588cc3(response);
    }
    /**
     * Post information that can used to build and publish an event originating from the SlashID SDK
     * Publish an event from the SDK
     */ async postActionsSdk(requestParameters, initOverrides) {
        await this.postActionsSdkRaw(requestParameters, initOverrides);
    }
    /**
     * Post information that can used to build and publish an event. Deprecated, use `/actions`.
     * Publish an event
     */ async postEventsRaw(requestParameters, initOverrides) {
        if (requestParameters.eventPostRequest === null || requestParameters.eventPostRequest === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("eventPostRequest", "Required parameter requestParameters.eventPostRequest was null or undefined when calling postEvents.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/events`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $9eee0f736eff090c$export$66614e5f3c5485b5)(requestParameters.eventPostRequest)
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$20446dc680588cc3(response);
    }
    /**
     * Post information that can used to build and publish an event. Deprecated, use `/actions`.
     * Publish an event
     */ async postEvents(requestParameters, initOverrides) {
        await this.postEventsRaw(requestParameters, initOverrides);
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

class $252bda330035ad79$export$1e24a9a035ad8fd4 extends $168d06aed8b3cdb0$export$70edad7ad5bb3f5d {
    /**
     * The configuration is used to theme the hosted UI. 
     * Retrieve the configuration for the hosted UI
     */ async getOauth2UiConfigurationRaw(requestParameters, initOverrides) {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("slashIDOrgID", "Required parameter requestParameters.slashIDOrgID was null or undefined when calling getOauth2UiConfiguration.");
        if (requestParameters.oauthClientId === null || requestParameters.oauthClientId === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("oauthClientId", "Required parameter requestParameters.oauthClientId was null or undefined when calling getOauth2UiConfiguration.");
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) headerParameters["SlashID-OrgID"] = String(requestParameters.slashIDOrgID);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/oauth2/clients/{oauth_client_id}/ui-configuration`.replace(`{${"oauth_client_id"}}`, encodeURIComponent(String(requestParameters.oauthClientId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $0b688c0c6753551f$export$d8841886796c20dc)(jsonValue));
    }
    /**
     * The configuration is used to theme the hosted UI. 
     * Retrieve the configuration for the hosted UI
     */ async getOauth2UiConfiguration(requestParameters, initOverrides) {
        const response = await this.getOauth2UiConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * The configuration is used to theme the hosted UI. 
     * Modify the configuration for the hosted UI
     */ async putOauth2UiConfigurationRaw(requestParameters, initOverrides) {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("slashIDOrgID", "Required parameter requestParameters.slashIDOrgID was null or undefined when calling putOauth2UiConfiguration.");
        if (requestParameters.oauthClientId === null || requestParameters.oauthClientId === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("oauthClientId", "Required parameter requestParameters.oauthClientId was null or undefined when calling putOauth2UiConfiguration.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) headerParameters["SlashID-OrgID"] = String(requestParameters.slashIDOrgID);
        if (requestParameters.slashIDRequiredConsistency !== undefined && requestParameters.slashIDRequiredConsistency !== null) headerParameters["SlashID-Required-Consistency"] = String(requestParameters.slashIDRequiredConsistency);
        if (requestParameters.slashIDRequiredConsistencyTimeout !== undefined && requestParameters.slashIDRequiredConsistencyTimeout !== null) headerParameters["SlashID-Required-Consistency-Timeout"] = String(requestParameters.slashIDRequiredConsistencyTimeout);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/oauth2/clients/{oauth_client_id}/ui-configuration`.replace(`{${"oauth_client_id"}}`, encodeURIComponent(String(requestParameters.oauthClientId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $224d96fd1b9ed7e0$export$2c0ca39127b0b0ee)(jsonValue));
    }
    /**
     * The configuration is used to theme the hosted UI. 
     * Modify the configuration for the hosted UI
     */ async putOauth2UiConfiguration(requestParameters, initOverrides) {
        const response = await this.putOauth2UiConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
const $252bda330035ad79$export$1a24f15758dea0bf = {
    LocalRegion: "local_region",
    AllRegions: "all_regions"
};


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

class $0c6907dd33cf20ad$export$ea419959b1ecf403 extends $168d06aed8b3cdb0$export$70edad7ad5bb3f5d {
    /**
     * Retrieve a list of all the team members of your organization.
     * List organization team members
     */ async getOrganizationsTeamRaw(requestParameters, initOverrides) {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("slashIDOrgID", "Required parameter requestParameters.slashIDOrgID was null or undefined when calling getOrganizationsTeam.");
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) headerParameters["SlashID-OrgID"] = String(requestParameters.slashIDOrgID);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/organizations/team`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $a0d7a1213cc4556e$export$e49e5c369c7975ca)(jsonValue));
    }
    /**
     * Retrieve a list of all the team members of your organization.
     * List organization team members
     */ async getOrganizationsTeam(requestParameters, initOverrides) {
        const response = await this.getOrganizationsTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

class $e758e522c3e01abb$export$f2ae3e6781ddb521 extends $168d06aed8b3cdb0$export$70edad7ad5bb3f5d {
    /**
     * Removes the specified GDPR consent, or all consents.
     * Remove GDPR consent of current user
     */ async deleteConsentGdprRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.consentLevels) queryParameters["consent_levels"] = requestParameters.consentLevels;
        if (requestParameters.deleteAll !== undefined) queryParameters["deleteAll"] = requestParameters.deleteAll;
        const headerParameters = {};
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/consent/gdpr`,
            method: "DELETE",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$20446dc680588cc3(response);
    }
    /**
     * Removes the specified GDPR consent, or all consents.
     * Remove GDPR consent of current user
     */ async deleteConsentGdpr(requestParameters = {}, initOverrides) {
        await this.deleteConsentGdprRaw(requestParameters, initOverrides);
    }
    /**
     * Returns the GDPR consent levels and timestamp for current person, if it exists. 
     * Get GDPR consent of current user
     */ async getConsentGdprRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/consent/gdpr`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $1c6e04be56d36e82$export$d8f7fb0a0d937eb3)(jsonValue));
    }
    /**
     * Returns the GDPR consent levels and timestamp for current person, if it exists. 
     * Get GDPR consent of current user
     */ async getConsentGdpr(requestParameters = {}, initOverrides) {
        const response = await this.getConsentGdprRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Stores the GDPR consent levels and timestamp. Returns the consent levels and the timestamp at which the consent information was received. This will overwrite existing GDPR consent levels for the specified person. The consent levels indicate the types of data classes the person has allowed during their use of your services, in accordance with GDPR. 
     * Store GDPR consent of current user
     */ async postConsentGdprRaw(requestParameters, initOverrides) {
        if (requestParameters.gDPRConsentRequest === null || requestParameters.gDPRConsentRequest === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("gDPRConsentRequest", "Required parameter requestParameters.gDPRConsentRequest was null or undefined when calling postConsentGdpr.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/consent/gdpr`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $918afe7ca221f314$export$13e148a83364b95)(requestParameters.gDPRConsentRequest)
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $38a16b083a989950$export$5cffeb8ce2443b10)(jsonValue));
    }
    /**
     * Stores the GDPR consent levels and timestamp. Returns the consent levels and the timestamp at which the consent information was received. This will overwrite existing GDPR consent levels for the specified person. The consent levels indicate the types of data classes the person has allowed during their use of your services, in accordance with GDPR. 
     * Store GDPR consent of current user
     */ async postConsentGdpr(requestParameters, initOverrides) {
        const response = await this.postConsentGdprRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Stores the GDPR consent levels and timestamp. Returns the consent levels and the timestamp at which the consent information was received. This will overwrite existing GDPR consent levels for the specified person. The consent levels indicate the types of data classes the person has allowed during their use of your services, in accordance with GDPR. 
     * Set GDPR consent of current user
     */ async putConsentGdprRaw(requestParameters, initOverrides) {
        if (requestParameters.gDPRConsentRequest === null || requestParameters.gDPRConsentRequest === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("gDPRConsentRequest", "Required parameter requestParameters.gDPRConsentRequest was null or undefined when calling putConsentGdpr.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/consent/gdpr`,
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $918afe7ca221f314$export$13e148a83364b95)(requestParameters.gDPRConsentRequest)
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $38a16b083a989950$export$5cffeb8ce2443b10)(jsonValue));
    }
    /**
     * Stores the GDPR consent levels and timestamp. Returns the consent levels and the timestamp at which the consent information was received. This will overwrite existing GDPR consent levels for the specified person. The consent levels indicate the types of data classes the person has allowed during their use of your services, in accordance with GDPR. 
     * Set GDPR consent of current user
     */ async putConsentGdpr(requestParameters, initOverrides) {
        const response = await this.putConsentGdprRaw(requestParameters, initOverrides);
        return await response.value();
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

class $9490672e7bca0fe8$export$f5f4fdd1b1ffabb3 extends $168d06aed8b3cdb0$export$70edad7ad5bb3f5d {
    /**
     * Create a new anonymous person linked to your organization. Unlike regular persons, anonymous persons\' identities are unknown and they do not have any authentication methods. However, it is still possible to persist information associated with this user, including attributes and GDPR consent. Anonymous persons can be created when a user first enters your website or application. If the person eventually signs up, the person type is upgraded to regular. Anonymous persons are inherently temporary and will be deleted after 30 days. Anonymous persons do not count towards billing and account limits, but their creation is rate-limited based on the organization\'s pricing tier. 
     * Create new anonymous person
     */ async postPersonsAnonymousRaw(requestParameters, initOverrides) {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("slashIDOrgID", "Required parameter requestParameters.slashIDOrgID was null or undefined when calling postPersonsAnonymous.");
        if (requestParameters.anonymousPersonCreateReq === null || requestParameters.anonymousPersonCreateReq === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("anonymousPersonCreateReq", "Required parameter requestParameters.anonymousPersonCreateReq was null or undefined when calling postPersonsAnonymous.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) headerParameters["SlashID-OrgID"] = String(requestParameters.slashIDOrgID);
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/persons/anonymous`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $4c2582984183ae37$export$da1543be29a31e9e)(requestParameters.anonymousPersonCreateReq)
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $10da6b5e0ce8aa35$export$6cc59d6581215347)(jsonValue));
    }
    /**
     * Create a new anonymous person linked to your organization. Unlike regular persons, anonymous persons\' identities are unknown and they do not have any authentication methods. However, it is still possible to persist information associated with this user, including attributes and GDPR consent. Anonymous persons can be created when a user first enters your website or application. If the person eventually signs up, the person type is upgraded to regular. Anonymous persons are inherently temporary and will be deleted after 30 days. Anonymous persons do not count towards billing and account limits, but their creation is rate-limited based on the organization\'s pricing tier. 
     * Create new anonymous person
     */ async postPersonsAnonymous(requestParameters, initOverrides) {
        const response = await this.postPersonsAnonymousRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * This endpoint creates a one-time token to impersonate a specific person. The returned token string must embedded in a URL in the `challenges` query parameter to let you land on a target page already authenticated as the desired person. 
     * Impersonate another person
     */ async postPersonsPersonIdImpersonateRaw(requestParameters, initOverrides) {
        if (requestParameters.personId === null || requestParameters.personId === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("personId", "Required parameter requestParameters.personId was null or undefined when calling postPersonsPersonIdImpersonate.");
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("slashIDOrgID", "Required parameter requestParameters.slashIDOrgID was null or undefined when calling postPersonsPersonIdImpersonate.");
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) headerParameters["SlashID-OrgID"] = String(requestParameters.slashIDOrgID);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/persons/{person_id}/impersonate`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $317a90900618246c$export$fd10bc7066dcb68)(jsonValue));
    }
    /**
     * This endpoint creates a one-time token to impersonate a specific person. The returned token string must embedded in a URL in the `challenges` query parameter to let you land on a target page already authenticated as the desired person. 
     * Impersonate another person
     */ async postPersonsPersonIdImpersonate(requestParameters, initOverrides) {
        const response = await this.postPersonsPersonIdImpersonateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * This endpoint creates a one-time token to impersonate a specific person. The returned token string must embedded in a URL in the `challenges` query parameter to let you land on a target page already authenticated as the desired person. 
     * Impersonate another person
     */ async postPersonsPersonIdImpersonateV2Raw(requestParameters, initOverrides) {
        if (requestParameters.personId === null || requestParameters.personId === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("personId", "Required parameter requestParameters.personId was null or undefined when calling postPersonsPersonIdImpersonateV2.");
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("slashIDOrgID", "Required parameter requestParameters.slashIDOrgID was null or undefined when calling postPersonsPersonIdImpersonateV2.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) headerParameters["SlashID-OrgID"] = String(requestParameters.slashIDOrgID);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/persons/{person_id}/impersonate/v2`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $6b424a65dc79ab94$export$6d86ef56b25a83c4)(requestParameters.postPersonsPersonIdImpersonateV2Request)
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $317a90900618246c$export$fd10bc7066dcb68)(jsonValue));
    }
    /**
     * This endpoint creates a one-time token to impersonate a specific person. The returned token string must embedded in a URL in the `challenges` query parameter to let you land on a target page already authenticated as the desired person. 
     * Impersonate another person
     */ async postPersonsPersonIdImpersonateV2(requestParameters, initOverrides) {
        const response = await this.postPersonsPersonIdImpersonateV2Raw(requestParameters, initOverrides);
        return await response.value();
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

class $958065e8019cd589$export$635f2ea50ea7a4cd extends $168d06aed8b3cdb0$export$70edad7ad5bb3f5d {
    /**
     * Revoke a previously obtained OAuth access or refresh token for an IdP. This endpoint is deprecated. Please use /sso/oidc/tokens/revoke/v2 instead. 
     * (Deprecated) Revoke an OAuth token obtained through SSO with OIDC
     */ async postSsoOidcTokensRevokeRaw(requestParameters, initOverrides) {
        if (requestParameters.oAuthTokenRevokeReq === null || requestParameters.oAuthTokenRevokeReq === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("oAuthTokenRevokeReq", "Required parameter requestParameters.oAuthTokenRevokeReq was null or undefined when calling postSsoOidcTokensRevoke.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/sso/oidc/tokens/revoke`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $eda6afdba158b369$export$5934f2de036cb99d)(requestParameters.oAuthTokenRevokeReq)
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$20446dc680588cc3(response);
    }
    /**
     * Revoke a previously obtained OAuth access or refresh token for an IdP. This endpoint is deprecated. Please use /sso/oidc/tokens/revoke/v2 instead. 
     * (Deprecated) Revoke an OAuth token obtained through SSO with OIDC
     */ async postSsoOidcTokensRevoke(requestParameters, initOverrides) {
        await this.postSsoOidcTokensRevokeRaw(requestParameters, initOverrides);
    }
}


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

class $471d4c7ebb479710$export$536cc970372a085 extends $168d06aed8b3cdb0$export$70edad7ad5bb3f5d {
    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about organization activity
     */ async getStatsRaw(requestParameters, initOverrides) {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("slashIDOrgID", "Required parameter requestParameters.slashIDOrgID was null or undefined when calling getStats.");
        if (requestParameters.bin === null || requestParameters.bin === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("bin", "Required parameter requestParameters.bin was null or undefined when calling getStats.");
        if (requestParameters.start === null || requestParameters.start === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("start", "Required parameter requestParameters.start was null or undefined when calling getStats.");
        const queryParameters = {};
        if (requestParameters.bin !== undefined) queryParameters["bin"] = requestParameters.bin;
        if (requestParameters.start !== undefined) queryParameters["start"] = requestParameters.start.toISOString();
        if (requestParameters.end !== undefined) queryParameters["end"] = requestParameters.end.toISOString();
        const headerParameters = {};
        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) headerParameters["SlashID-OrgID"] = String(requestParameters.slashIDOrgID);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/stats`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $70733e07da03f887$export$2fc6c9fe8c3c59d0)(jsonValue));
    }
    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about organization activity
     */ async getStats(requestParameters, initOverrides) {
        const response = await this.getStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about billable organization activity. Aggregated stats are bound at the 1st day of each month
     */ async getStatsBillingRaw(requestParameters, initOverrides) {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("slashIDOrgID", "Required parameter requestParameters.slashIDOrgID was null or undefined when calling getStatsBilling.");
        if (requestParameters.start === null || requestParameters.start === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("start", "Required parameter requestParameters.start was null or undefined when calling getStatsBilling.");
        const queryParameters = {};
        if (requestParameters.start !== undefined) queryParameters["start"] = requestParameters.start.toISOString();
        if (requestParameters.end !== undefined) queryParameters["end"] = requestParameters.end.toISOString();
        const headerParameters = {};
        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) headerParameters["SlashID-OrgID"] = String(requestParameters.slashIDOrgID);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/stats/billing`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $187256421eb9b5cb$export$1da8bec36382d2b9)(jsonValue));
    }
    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about billable organization activity. Aggregated stats are bound at the 1st day of each month
     */ async getStatsBilling(requestParameters, initOverrides) {
        const response = await this.getStatsBillingRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about MITM detections, grouped by proxied domain.
     */ async getStatsMitmRaw(requestParameters, initOverrides) {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("slashIDOrgID", "Required parameter requestParameters.slashIDOrgID was null or undefined when calling getStatsMitm.");
        if (requestParameters.start === null || requestParameters.start === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("start", "Required parameter requestParameters.start was null or undefined when calling getStatsMitm.");
        const queryParameters = {};
        if (requestParameters.start !== undefined) queryParameters["start"] = requestParameters.start.toISOString();
        if (requestParameters.end !== undefined) queryParameters["end"] = requestParameters.end.toISOString();
        const headerParameters = {};
        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) headerParameters["SlashID-OrgID"] = String(requestParameters.slashIDOrgID);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/stats/mitm`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $399d80687c4dec31$export$4ec9178c24341b15)(jsonValue));
    }
    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about MITM detections, grouped by proxied domain.
     */ async getStatsMitm(requestParameters, initOverrides) {
        const response = await this.getStatsMitmRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
const $471d4c7ebb479710$export$32c133930031d4c3 = {
    NUMBER_60: 60,
    NUMBER_1440: 1440
};


/* tslint:disable */ /* eslint-disable */ /**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */ 

class $01183d3ef1e1dae1$export$72bb25602803ae5f extends $168d06aed8b3cdb0$export$70edad7ad5bb3f5d {
    /**
     * This endpoint revokes a SlashID user token. 
     * Revoke a user token
     */ async postTokenRevokeRaw(requestParameters, initOverrides) {
        if (requestParameters.revokeTokenReq === null || requestParameters.revokeTokenReq === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("revokeTokenReq", "Required parameter requestParameters.revokeTokenReq was null or undefined when calling postTokenRevoke.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (requestParameters.slashIDRequiredConsistency !== undefined && requestParameters.slashIDRequiredConsistency !== null) headerParameters["SlashID-Required-Consistency"] = String(requestParameters.slashIDRequiredConsistency);
        if (requestParameters.slashIDRequiredConsistencyTimeout !== undefined && requestParameters.slashIDRequiredConsistencyTimeout !== null) headerParameters["SlashID-Required-Consistency-Timeout"] = String(requestParameters.slashIDRequiredConsistencyTimeout);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/token/revoke`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $11114717f59a2a5c$export$d0f7f45459c0bb03)(requestParameters.revokeTokenReq)
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$20446dc680588cc3(response);
    }
    /**
     * This endpoint revokes a SlashID user token. 
     * Revoke a user token
     */ async postTokenRevoke(requestParameters, initOverrides) {
        await this.postTokenRevokeRaw(requestParameters, initOverrides);
    }
    /**
     * This endpoint validates a SlashID user token. The response indicates whether the token is valid and its expiration time if so. If the token is not valid, the reason is returned. 
     * Validate a user token
     */ async postTokenValidateRaw(requestParameters, initOverrides) {
        if (requestParameters.validateTokenReq === null || requestParameters.validateTokenReq === undefined) throw new $168d06aed8b3cdb0$export$a27bea7cdb975d70("validateTokenReq", "Required parameter requestParameters.validateTokenReq was null or undefined when calling postTokenValidate.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) headerParameters["SlashID-SdkVersion"] = String(requestParameters.slashIDSdkVersion);
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) headerParameters["Authorization"] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/token/validate`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7be8f15fd333c945$export$3bd7d2b6a8fd413d)(requestParameters.validateTokenReq)
        }, initOverrides);
        return new $168d06aed8b3cdb0$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $61bff2e9c70d970f$export$6b84b521d90710d5)(jsonValue));
    }
    /**
     * This endpoint validates a SlashID user token. The response indicates whether the token is valid and its expiration time if so. If the token is not valid, the reason is returned. 
     * Validate a user token
     */ async postTokenValidate(requestParameters, initOverrides) {
        const response = await this.postTokenValidateRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
const $01183d3ef1e1dae1$export$86071dbb24ab2a0d = {
    LocalRegion: "local_region",
    AllRegions: "all_regions"
};







function $1d209ce78d67cb65$var$getCenteredWindowParams() {
    const width = 400;
    const height = 600;
    const left = window.screenX + (window.innerWidth - width) / 2;
    const top = window.screenY + (window.innerHeight - height) / 2;
    return `width=${width},height=${height},top=${top},left=${left},resizable,scrollbars=yes,status=1`;
}
function $1d209ce78d67cb65$export$5d0606a13b21f3f8() {
    const windowParams = $1d209ce78d67cb65$var$getCenteredWindowParams();
    const myWindow = window.open(window.location.href, "/id:popup", windowParams);
    if (!myWindow) // TODO standardise error handling
    throw new Error("SlashId: Popup blocked, please consider redirect instead");
    const redirectMessage = '<div style="position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);">You will be redirected in a moment...</div>';
    try {
        var _myWindow_document;
        myWindow === null || myWindow === void 0 ? void 0 : (_myWindow_document = myWindow.document) === null || _myWindow_document === void 0 ? void 0 : _myWindow_document.write(redirectMessage);
    } catch (e) {
        console.error(e);
        if (myWindow.document && myWindow.document.body) myWindow.document.body.innerHTML = redirectMessage;
    } finally{
        myWindow.blur();
    }
    const setWindowUrl = (url)=>{
        if (myWindow) {
            myWindow.location = url;
            myWindow.focus();
        }
        return myWindow;
    };
    return [
        myWindow,
        setWindowUrl
    ];
}


/**
 * Compare two complete URLs and check if they are the same looking only at the origin and the pathname.
 * This ignores query params and fragments.
 * @param {URL} base
 * @param {URL} comparison
 * @returns {boolean}
 */ function $3943e8c808f9150b$export$ca8daecbc0756b1b(base, comparison) {
    return base.origin + base.pathname === comparison.origin + comparison.pathname;
}
function $3943e8c808f9150b$export$fc99885b7e473d08(input) {
    let url;
    try {
        url = new URL(input);
    } catch (_) {
        return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
}


const $962c828014ed43f3$export$61f12a353e32d6b4 = "challenges";
const $962c828014ed43f3$export$b1acc9d748d757e8 = "sidcp";
const $962c828014ed43f3$export$911cde4811331c58 = "@SLASHID/CSRF_TOKEN";
const $962c828014ed43f3$export$3f272757255eeb30 = "@SLASHID/PKCE_CODE_VERIFIER";
const $962c828014ed43f3$export$fc7d295eacb42f43 = "@SLASHID/OIDC_CLIENT_ID";
const $962c828014ed43f3$export$9dfd5bd22831bc40 = "@SLASHID/OIDC_REDIRECT_URI";


var $6c3db34ca8f899b2$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType[MessageType["StorageGetItem"] = 0] = "StorageGetItem";
    MessageType[MessageType["StorageSetItem"] = 1] = "StorageSetItem";
    MessageType[MessageType["Ping"] = 2] = "Ping";
    MessageType[MessageType["ChallengeWebauthnCreate"] = 3] = "ChallengeWebauthnCreate";
    MessageType[MessageType["ChallengeWebauthnGet"] = 4] = "ChallengeWebauthnGet";
    MessageType[MessageType["SSOChallenge"] = 5] = "SSOChallenge";
})($6c3db34ca8f899b2$export$80edbf15fa61a4db || ($6c3db34ca8f899b2$export$80edbf15fa61a4db = {}));
class $6c3db34ca8f899b2$export$e863b19988e8aafd {
    constructor(){
        this.id = $6c3db34ca8f899b2$var$randomId();
        this.type = 2;
    }
}
class $6c3db34ca8f899b2$export$612749e00a84ad10 {
    constructor(id, error){
        this.id = id;
        this.error = error;
    }
}
class $6c3db34ca8f899b2$export$561665cd9d5caa15 {
    constructor(options, challenge){
        this.type = 3;
        this.id = $6c3db34ca8f899b2$var$randomId();
        this.slashIDOptions = options;
        this.challenge = challenge;
    }
}
class $6c3db34ca8f899b2$export$8b7d42a6791cdca9 {
    constructor(id, attestation, error){
        this.id = id;
        this.attestation = attestation;
        this.error = error;
    }
}
class $6c3db34ca8f899b2$export$b2a6577196c1aa92 {
    constructor(options, challenge){
        this.type = 4;
        this.id = $6c3db34ca8f899b2$var$randomId();
        this.slashIDOptions = options;
        this.challenge = challenge;
    }
}
class $6c3db34ca8f899b2$export$85b72b60e2ec2ca5 {
    constructor(id, attestation, error){
        this.id = id;
        this.attestation = attestation;
        this.error = error;
    }
}
class $6c3db34ca8f899b2$export$f01d2f4fd62a4592 {
    constructor(key){
        this.type = 0;
        this.id = $6c3db34ca8f899b2$var$randomId();
        this.key = key;
    }
}
class $6c3db34ca8f899b2$export$b622fa8237033579 {
    constructor(id, value, error){
        this.id = id;
        this.value = value;
        this.error = error;
    }
}
class $6c3db34ca8f899b2$export$cbc7b39b5c005822 {
    constructor(key, value){
        this.id = $6c3db34ca8f899b2$var$randomId();
        this.type = 1;
        this.key = key;
        this.value = value;
    }
}
class $6c3db34ca8f899b2$export$b19581adb4c22a0e {
    constructor(id, error){
        this.id = id;
        this.error = error;
    }
}
function $6c3db34ca8f899b2$var$randomId() {
    const rndArray = new Uint32Array(1);
    window.crypto.getRandomValues(rndArray);
    return rndArray[0];
}
function $6c3db34ca8f899b2$export$e3ec70811b10f90d(queryString) {
    const urlParams = new URLSearchParams(queryString);
    const ssoChallengeID = urlParams.get("sso_challenge_id");
    const ssoCode = urlParams.get("sso_code");
    const csrfToken = urlParams.get("csrf_token");
    if (!ssoChallengeID || !ssoCode || !csrfToken) return null;
    return {
        ssoChallengeID: ssoChallengeID,
        ssoCode: ssoCode,
        csrfToken: csrfToken
    };
}
function $6c3db34ca8f899b2$export$2f1c2e17db43d9ae(message) {
    return message.type === 3;
}
function $6c3db34ca8f899b2$export$3d155c9fa32292c(message) {
    return message.type === 4;
}
function $6c3db34ca8f899b2$export$68ca8012194a4829(message) {
    return message && message.type === 5;
}
function $6c3db34ca8f899b2$export$68a74503f112f3ea(message) {
    return message.type === 2;
}


// Map from the string values above to method option types
class $f02bc98e6bb876be$var$FactorMethodOptionsTypeMap {
}
function $f02bc98e6bb876be$export$51e4260dae945f14(environment) {
    return typeof environment === "object" && Boolean(environment.baseURL) && Boolean(environment.sdkURL);
}
function $f02bc98e6bb876be$export$c51332e5b5280a9f(handleType) {
    return handleType === "email_address" || handleType === "phone_number";
}




var $91e59605951c3712$exports = {};

$parcel$export($91e59605951c3712$exports, "ERROR_NAMES", function () { return $91e59605951c3712$export$daceac3b97803ce1; });
$parcel$export($91e59605951c3712$exports, "isFlowCancelledError", function () { return $91e59605951c3712$export$fbcc115299f660c; });
$parcel$export($91e59605951c3712$exports, "isHandlePatternNotAllowedError", function () { return $91e59605951c3712$export$383ea5b2e29d8119; });
$parcel$export($91e59605951c3712$exports, "isSignUpAwaitingApprovalError", function () { return $91e59605951c3712$export$3176c4f9177c827; });
$parcel$export($91e59605951c3712$exports, "isSignInAwaitingApprovalError", function () { return $91e59605951c3712$export$b39f48fbaa61f6ef; });
$parcel$export($91e59605951c3712$exports, "isSelfRegistrationNotAllowedError", function () { return $91e59605951c3712$export$e77249f11b3becf7; });
$parcel$export($91e59605951c3712$exports, "isNoPasswordSetError", function () { return $91e59605951c3712$export$3bfbe7e1e4370b9a; });
$parcel$export($91e59605951c3712$exports, "isNonReachableHandleTypeError", function () { return $91e59605951c3712$export$b3a935821f1baeb0; });
$parcel$export($91e59605951c3712$exports, "isTimeoutError", function () { return $91e59605951c3712$export$f47339bf28a93789; });
$parcel$export($91e59605951c3712$exports, "isRateLimitError", function () { return $91e59605951c3712$export$a8908c3867f6f20b; });
$parcel$export($91e59605951c3712$exports, "isBadPasskeyScopeError", function () { return $91e59605951c3712$export$62f820c3bd739e62; });
$parcel$export($91e59605951c3712$exports, "isPasskeyPromptError", function () { return $91e59605951c3712$export$2d8742981298631e; });
$parcel$export($91e59605951c3712$exports, "isAPIResponseError", function () { return $91e59605951c3712$export$5a62b7ffa29b147c; });
$parcel$export($91e59605951c3712$exports, "isInvalidSlashIDConfigurationError", function () { return $91e59605951c3712$export$2e53c7453e352ae5; });
$parcel$export($91e59605951c3712$exports, "isInvalidURLParamsError", function () { return $91e59605951c3712$export$b50161abe6d1888e; });
$parcel$export($91e59605951c3712$exports, "isInvalidAuthenticationMethodError", function () { return $91e59605951c3712$export$e53d48902fc18ef; });
$parcel$export($91e59605951c3712$exports, "isInvalidActionError", function () { return $91e59605951c3712$export$1aedaf54d72debec; });
$parcel$export($91e59605951c3712$exports, "isPersonExistsError", function () { return $91e59605951c3712$export$5376529ff6d74e7e; });
$parcel$export($91e59605951c3712$exports, "isInvalidEmailAddressFormatError", function () { return $91e59605951c3712$export$7217cc8708dd65ea; });
$parcel$export($91e59605951c3712$exports, "isInvalidPhoneNumberFormatError", function () { return $91e59605951c3712$export$74db601249abc762; });
$parcel$export($91e59605951c3712$exports, "isUnexpectedError", function () { return $91e59605951c3712$export$68de2e41a5e9d0c3; });
$parcel$export($91e59605951c3712$exports, "createSlashIDError", function () { return $91e59605951c3712$export$f59d87dc47407b7f; });
$parcel$export($91e59605951c3712$exports, "isSlashIDError", function () { return $91e59605951c3712$export$ea73e85faa39c9c0; });
$parcel$export($91e59605951c3712$exports, "isClientGeneratedErrorSlug", function () { return $91e59605951c3712$export$6fbf0ec11a25c8b2; });
$parcel$export($91e59605951c3712$exports, "CLIENT_GENERATED_ERROR_SLUGS", function () { return $60b6642fd39ba43b$export$866513626aaa7357; });
$parcel$export($91e59605951c3712$exports, "ERROR_NAMES_TO_SLUGS_MAP", function () { return $60b6642fd39ba43b$export$b972448359fee0f0; });

const $60b6642fd39ba43b$export$c663841bdeb76d42 = async (error)=>{
    var _errors_, _errors;
    var _errors__message;
    if ($60b6642fd39ba43b$export$a98b3b17ec378e54(error)) return (_errors__message = (_errors = (await error.response.clone().json()).errors) === null || _errors === void 0 ? void 0 : (_errors_ = _errors[0]) === null || _errors_ === void 0 ? void 0 : _errors_.message) !== null && _errors__message !== void 0 ? _errors__message : error.message;
    if ($60b6642fd39ba43b$export$ea73e85faa39c9c0(error)) {
        var _error_context_response;
        if (!((_error_context_response = error.context.response) === null || _error_context_response === void 0 ? void 0 : _error_context_response.body)) return error.message;
        try {
            var _error_context_response1, _body_errors_, _body_errors;
            const body = JSON.parse((_error_context_response1 = error.context.response) === null || _error_context_response1 === void 0 ? void 0 : _error_context_response1.body);
            var _body_errors__message;
            return (_body_errors__message = (_body_errors = body.errors) === null || _body_errors === void 0 ? void 0 : (_body_errors_ = _body_errors[0]) === null || _body_errors_ === void 0 ? void 0 : _body_errors_.message) !== null && _body_errors__message !== void 0 ? _body_errors__message : error.message;
        } catch  {
            return error.message;
        }
    }
    if (error instanceof Error) return error.message;
    return "";
};
const $60b6642fd39ba43b$var$errorToResponseStatusCode = (error)=>{
    var _error_context_response, _error_response;
    if ($60b6642fd39ba43b$export$a98b3b17ec378e54(error)) return error.response.status;
    if ($60b6642fd39ba43b$export$ea73e85faa39c9c0(error)) return (_error_context_response = error.context.response) === null || _error_context_response === void 0 ? void 0 : _error_context_response.status;
    return (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status;
};
function $60b6642fd39ba43b$export$a98b3b17ec378e54(error) {
    return error.name === "ResponseError" && error.response instanceof Response;
}
const $60b6642fd39ba43b$export$d1e90a466859723f = {
    SlashIDCorrelationID: "slashid-correlation-id"
};
const $60b6642fd39ba43b$export$65ed285adeaeb183 = async (error)=>{
    const data = {
        status: error.response.status,
        statusText: error.response.statusText,
        url: error.response.url,
        type: error.response.type,
        ok: error.response.ok,
        redirected: error.response.redirected,
        headers: Object.fromEntries(error.response.headers),
        body: JSON.stringify(await error.response.clone().json(), null, 2)
    };
    return data;
};
async function $60b6642fd39ba43b$export$3bfbe7e1e4370b9a(error) {
    const status = $60b6642fd39ba43b$var$errorToResponseStatusCode(error);
    const message = await $60b6642fd39ba43b$export$c663841bdeb76d42(error);
    return status === 403 && message === "no password set";
}
async function $60b6642fd39ba43b$export$e77249f11b3becf7(error) {
    const status = $60b6642fd39ba43b$var$errorToResponseStatusCode(error);
    const message = await $60b6642fd39ba43b$export$c663841bdeb76d42(error);
    return status === 403 && message === "self-registration not allowed for this organization";
}
async function $60b6642fd39ba43b$export$383ea5b2e29d8119(error) {
    const status = $60b6642fd39ba43b$var$errorToResponseStatusCode(error);
    const message = await $60b6642fd39ba43b$export$c663841bdeb76d42(error);
    return status === 403 && message === "person cannot be registered";
}
async function $60b6642fd39ba43b$export$3176c4f9177c827(error) {
    const status = $60b6642fd39ba43b$var$errorToResponseStatusCode(error);
    const message = await $60b6642fd39ba43b$export$c663841bdeb76d42(error);
    return status === 403 && message === "person is not active";
}
async function $60b6642fd39ba43b$export$b39f48fbaa61f6ef(error) {
    const status = $60b6642fd39ba43b$var$errorToResponseStatusCode(error);
    const message = await $60b6642fd39ba43b$export$c663841bdeb76d42(error);
    // the SDK doesn't have person ID to match
    return status === 403 && message.includes("Person") && message.includes("is inactive");
}
function $60b6642fd39ba43b$export$a8908c3867f6f20b(error) {
    const status = $60b6642fd39ba43b$var$errorToResponseStatusCode(error);
    return status === 429;
}
async function $60b6642fd39ba43b$export$f47339bf28a93789(error) {
    const status = $60b6642fd39ba43b$var$errorToResponseStatusCode(error);
    const message = await $60b6642fd39ba43b$export$c663841bdeb76d42(error);
    return (status === 401 || status === 403) && message === "authentication has expired";
}
async function $60b6642fd39ba43b$export$962d82e4f8aa9684(error) {
    const status = $60b6642fd39ba43b$var$errorToResponseStatusCode(error);
    const message = await $60b6642fd39ba43b$export$c663841bdeb76d42(error);
    return status === 409 && message === "person exists";
}
async function $60b6642fd39ba43b$export$c4397d750cfa1d04(error) {
    const status = $60b6642fd39ba43b$var$errorToResponseStatusCode(error);
    const message = await $60b6642fd39ba43b$export$c663841bdeb76d42(error);
    return status === 400 && message.startsWith("malformed e-mail address");
}
async function $60b6642fd39ba43b$export$d899f0be2b68ca7d(error) {
    const status = $60b6642fd39ba43b$var$errorToResponseStatusCode(error);
    const message = await $60b6642fd39ba43b$export$c663841bdeb76d42(error);
    return status === 400 && message.startsWith("malformed phone number");
}
async function $60b6642fd39ba43b$export$62f820c3bd739e62(error) {
    const regexp = /selected scope '(.*?)' is not equal to or a registrable domain suffix of origin '(.*?)'/;
    const status = $60b6642fd39ba43b$var$errorToResponseStatusCode(error);
    const message = await $60b6642fd39ba43b$export$c663841bdeb76d42(error);
    return status === 400 && regexp.test(message);
}
async function $60b6642fd39ba43b$export$2d8742981298631e(error) {
    const chromeRegexp = /The operation either timed out or was not allowed. See: https:\/\/www.w3.org\/TR\/webauthn-2\/#sctn-privacy-considerations-client./;
    const safariRegexp = /This request has been cancelled by the user./;
    const firefoxRegexp = /The operation was aborted./;
    const iosRegExp = /Operation failed./;
    const notAvailableRegexp = /The WebAuthn API is not available in the current environment/;
    const credentialManagerRegexp = /An unknown error occurred while talking to the credential manager./;
    const message = await $60b6642fd39ba43b$export$c663841bdeb76d42(error);
    return error instanceof Error && (chromeRegexp.test(message) || safariRegexp.test(message) || firefoxRegexp.test(message) || iosRegExp.test(message) || notAvailableRegexp.test(message) || credentialManagerRegexp.test(message));
}
function $60b6642fd39ba43b$export$5f71bfa25cb0590e(response) {
    return typeof response === "object" && Array.isArray(response.errors) && response.errors.every((error)=>{
        return typeof error.httpcode === "number" && typeof error.message === "string";
    });
}
function $60b6642fd39ba43b$export$df846a7dbca1e3d2(response) {
    return response.errors.some((error)=>error.message === "authentication has expired");
}
function $60b6642fd39ba43b$export$dbb6fdd470346077(response) {
    return response.errors.some((error)=>error.httpcode === 429);
}
async function $60b6642fd39ba43b$export$cb6677d413c01a7a(error) {
    const regex = /Popup blocked, please consider redirect instead/;
    const message = await $60b6642fd39ba43b$export$c663841bdeb76d42(error);
    return error instanceof DOMException && regex.test(message);
}
function $60b6642fd39ba43b$export$476aa014e2fd89d5(error, response) {
    if (error instanceof TypeError && !response) return true;
    return false;
}
const $60b6642fd39ba43b$export$866513626aaa7357 = [
    // these slugs are generated from events
    "incorrect_otp_code_via_email",
    "incorrect_otp_code_via_sms",
    "incorrect_otp_code",
    "invalid_password",
    "incorrect_password",
    "recovery_failed",
    "oidc_popup_blocked",
    "client_side_error",
    "unspecified",
    // these slugs are generated from SlashIDError instances
    "no_password_set",
    "flow_cancelled",
    "handle_pattern_not_allowed",
    "sign_up_awaiting_approval",
    "sign_in_awaiting_approval",
    "self_registration_not_allowed",
    "recover_non_reachable_handle_type",
    "timeout",
    "rate_limit_exceeded",
    "passkey_bad_scope",
    "passkey_prompt_failed",
    "api_response_error",
    "invalid_slashid_configuration",
    "invalid_slashid_url_params",
    "invalid_authentication_method",
    "invalid_action",
    "invalid_email_address_format",
    "invalid_phone_number_format",
    "person_exists"
];
const $60b6642fd39ba43b$export$b972448359fee0f0 = {
    noPasswordSet: "no_password_set",
    UnexpectedError: "unspecified",
    FlowCancelledError: "flow_cancelled",
    HandlePatternNotAllowedError: "handle_pattern_not_allowed",
    SignUpAwaitingApprovalError: "sign_up_awaiting_approval",
    SignInAwaitingApprovalError: "sign_in_awaiting_approval",
    SelfRegistrationNotAllowed: "self_registration_not_allowed",
    recoverNonReachableHandleType: "recover_non_reachable_handle_type",
    TimeoutError: "timeout",
    RateLimitError: "rate_limit_exceeded",
    BadPasskeyScopeError: "passkey_bad_scope",
    PasskeyPromptError: "passkey_prompt_failed",
    APIResponseError: "api_response_error",
    InvalidSlashIDConfigurationError: "invalid_slashid_configuration",
    InvalidSlashIDURLParamsError: "invalid_slashid_url_params",
    InvalidAuthenticationMethodError: "invalid_authentication_method",
    InvalidActionError: "invalid_action",
    InvalidEmailAddressFormatError: "invalid_email_address_format",
    InvalidPhoneNumberFormatError: "invalid_phone_number_format",
    PersonExistsError: "person_exists"
};
class $60b6642fd39ba43b$export$f471a06c79be5983 extends Error {
    constructor({ name: name = (0, $91e59605951c3712$export$daceac3b97803ce1).unknown, message: message = "An error occured in @slashid/slashid", context: context = {}, cause: cause }){
        super(message, {
            cause: cause
        });
        this.name = name;
        this.context = context;
    }
}
function $60b6642fd39ba43b$export$ea73e85faa39c9c0(error) {
    return error instanceof $60b6642fd39ba43b$export$f471a06c79be5983;
}
async function $60b6642fd39ba43b$export$65efd56077f75087(responseError, context) {
    // specific to webauthn
    if (await $60b6642fd39ba43b$export$62f820c3bd739e62(responseError)) return new $60b6642fd39ba43b$export$f471a06c79be5983({
        name: (0, $91e59605951c3712$export$daceac3b97803ce1).badPasskeyScopeError,
        message: "Passkey scope is invalid",
        cause: responseError
    });
    if ($60b6642fd39ba43b$export$a8908c3867f6f20b(responseError)) {
        const rateLimitMessage = await $60b6642fd39ba43b$export$c663841bdeb76d42(responseError);
        const serialisedResponse = await $60b6642fd39ba43b$export$65ed285adeaeb183(responseError);
        return new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).rateLimitError,
            message: rateLimitMessage,
            cause: responseError,
            context: {
                response: serialisedResponse,
                ...context
            }
        });
    }
    if (await $60b6642fd39ba43b$export$3bfbe7e1e4370b9a(responseError)) return new $60b6642fd39ba43b$export$f471a06c79be5983({
        name: (0, $91e59605951c3712$export$daceac3b97803ce1).noPasswordSet,
        message: responseError.message,
        context: {
            ...context
        }
    });
    if (await $60b6642fd39ba43b$export$e77249f11b3becf7(responseError)) return new $60b6642fd39ba43b$export$f471a06c79be5983({
        name: (0, $91e59605951c3712$export$daceac3b97803ce1).selfRegistrationNotAllowed,
        message: responseError.message,
        context: {
            ...context
        }
    });
    if (await $60b6642fd39ba43b$export$383ea5b2e29d8119(responseError)) return new $60b6642fd39ba43b$export$f471a06c79be5983({
        name: (0, $91e59605951c3712$export$daceac3b97803ce1).handlePatternNotAllowed,
        message: responseError.message,
        context: {
            ...context
        }
    });
    if (await $60b6642fd39ba43b$export$3176c4f9177c827(responseError)) return new $60b6642fd39ba43b$export$f471a06c79be5983({
        name: (0, $91e59605951c3712$export$daceac3b97803ce1).signUpAwaitingApproval,
        message: responseError.message,
        context: {
            ...context
        }
    });
    if (await $60b6642fd39ba43b$export$b39f48fbaa61f6ef(responseError)) return new $60b6642fd39ba43b$export$f471a06c79be5983({
        name: (0, $91e59605951c3712$export$daceac3b97803ce1).signInAwaitingApproval,
        message: responseError.message,
        context: {
            ...context
        }
    });
    if (await $60b6642fd39ba43b$export$f47339bf28a93789(responseError)) return new $60b6642fd39ba43b$export$f471a06c79be5983({
        name: (0, $91e59605951c3712$export$daceac3b97803ce1).timeoutError,
        message: "Authentication has expired",
        cause: responseError
    });
    if (await $60b6642fd39ba43b$export$62f820c3bd739e62(responseError)) return new $60b6642fd39ba43b$export$f471a06c79be5983({
        name: (0, $91e59605951c3712$export$daceac3b97803ce1).badPasskeyScopeError,
        message: "Passkey scope is invalid",
        cause: responseError
    });
    if (await $60b6642fd39ba43b$export$962d82e4f8aa9684(responseError)) return new $60b6642fd39ba43b$export$f471a06c79be5983({
        name: (0, $91e59605951c3712$export$daceac3b97803ce1).personExistsError,
        message: "Person with the given handle already exists",
        cause: responseError
    });
    if (await $60b6642fd39ba43b$export$c4397d750cfa1d04(responseError)) return new $60b6642fd39ba43b$export$f471a06c79be5983({
        name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidEmailAddressFormatError,
        message: "Email address is malformed",
        cause: responseError
    });
    if (await $60b6642fd39ba43b$export$d899f0be2b68ca7d(responseError)) return new $60b6642fd39ba43b$export$f471a06c79be5983({
        name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidPhoneNumberFormatError,
        message: "Phone number is malformed",
        cause: responseError
    });
    // catch-all, in case nothing was matched
    const response = await $60b6642fd39ba43b$export$65ed285adeaeb183(responseError);
    return new $60b6642fd39ba43b$export$f471a06c79be5983({
        name: (0, $91e59605951c3712$export$daceac3b97803ce1).apiResponseError,
        message: "An error occured in @slashid/slashid while processing the response",
        context: {
            response: response,
            correlationId: response.headers[$60b6642fd39ba43b$export$d1e90a466859723f.SlashIDCorrelationID]
        },
        cause: responseError
    });
}
async function $60b6642fd39ba43b$export$ed0b6181311676c(value) {
    if (value instanceof $60b6642fd39ba43b$export$f471a06c79be5983) return value;
    if (value instanceof Error) {
        // webauthn specific errors
        if (await $60b6642fd39ba43b$export$2d8742981298631e(value)) return new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).passkeyPromptError,
            message: "Passkey prompt was dismissed",
            cause: value
        });
        if ($60b6642fd39ba43b$export$a98b3b17ec378e54(value)) return await $60b6642fd39ba43b$export$65efd56077f75087(value);
        return new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).unknown,
            message: `Unknown error: ${value.message}`,
            cause: value
        });
    }
    // in some cases the response body is thrown instead of the error or the full response object
    if ($60b6642fd39ba43b$export$5f71bfa25cb0590e(value)) {
        // special case for thrown responses with a timeout error in the payload
        if ($60b6642fd39ba43b$export$df846a7dbca1e3d2(value)) return new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).timeoutError,
            message: "Authentication has expired",
            context: {
                thrownResponse: value
            }
        });
        // special case for thrown responses with a rate limit error in the payload
        if ($60b6642fd39ba43b$export$dbb6fdd470346077(value)) return new $60b6642fd39ba43b$export$f471a06c79be5983({
            message: "Rate limit exceeded",
            context: {
                thrownResponse: value
            },
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).rateLimitError
        });
        return new $60b6642fd39ba43b$export$f471a06c79be5983({
            message: "An error occured in @slashid/slashid",
            context: {
                thrownResponse: value
            },
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).apiResponseError
        });
    }
    let stringified = "[Unable to stringify the thrown value]";
    try {
        stringified = JSON.stringify(value);
    } catch  {
    // ignore
    }
    const error = new Error(`Non-Error thrown: ${stringified}`);
    return new $60b6642fd39ba43b$export$f471a06c79be5983({
        name: (0, $91e59605951c3712$export$daceac3b97803ce1).unknown,
        message: error.message,
        cause: error
    });
}
function $60b6642fd39ba43b$export$f0ff5c81573c8df0(value) {
    if (value instanceof Error) return value;
    let stringified = "[Unable to stringify the thrown value]";
    try {
        stringified = JSON.stringify(value);
    } catch  {
    // ignore
    }
    const error = new Error(`Non-Error thrown: ${stringified}`);
    return error;
}
async function $60b6642fd39ba43b$export$82f46aa4e6535a45(error) {
    const normalisedError = $60b6642fd39ba43b$export$ea73e85faa39c9c0(error) ? error : await $60b6642fd39ba43b$export$ed0b6181311676c(error);
    return normalisedError.message;
}
async function $60b6642fd39ba43b$export$7f84d4628fc07381(error, { authenticationFactor: authenticationFactor, handle: handle, previousToken: previousToken, challengeId: challengeId }) {
    const slashIDError = await $60b6642fd39ba43b$export$ed0b6181311676c(error);
    const errorSlug = $60b6642fd39ba43b$export$b972448359fee0f0[slashIDError.name];
    const event = {
        authenticationFactor: authenticationFactor,
        handle: handle,
        errorText: errorSlug || "client_side_error",
        previousToken: previousToken,
        challengeId: challengeId,
        failureDetail: await $60b6642fd39ba43b$export$82f46aa4e6535a45(error)
    };
    return event;
}


const $91e59605951c3712$export$daceac3b97803ce1 = {
    noPasswordSet: "noPasswordSet",
    // TODO not standardised yet
    unknown: "UnexpectedError",
    flowCancelled: "FlowCancelledError",
    handlePatternNotAllowed: "HandlePatternNotAllowedError",
    signUpAwaitingApproval: "SignUpAwaitingApprovalError",
    signInAwaitingApproval: "SignInAwaitingApprovalError",
    selfRegistrationNotAllowed: "SelfRegistrationNotAllowed",
    recoverNonReachableHandleType: "recoverNonReachableHandleType",
    timeoutError: "TimeoutError",
    rateLimitError: "RateLimitError",
    badPasskeyScopeError: "BadPasskeyScopeError",
    passkeyPromptError: "PasskeyPromptError",
    apiResponseError: "APIResponseError",
    invalidSlashIDConfigurationError: "InvalidSlashIDConfigurationError",
    invalidSlashIDURLParamsError: "InvalidSlashIDURLParamsError",
    invalidAuthenticationMethodError: "InvalidAuthenticationMethodError",
    invalidActionError: "InvalidActionError",
    invalidEmailAddressFormatError: "InvalidEmailAddressFormatError",
    invalidPhoneNumberFormatError: "InvalidPhoneNumberFormatError",
    personExistsError: "PersonExistsError"
};
function $91e59605951c3712$export$fbcc115299f660c(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.flowCancelled;
}
function $91e59605951c3712$export$383ea5b2e29d8119(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.handlePatternNotAllowed;
}
function $91e59605951c3712$export$3176c4f9177c827(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.signUpAwaitingApproval;
}
function $91e59605951c3712$export$b39f48fbaa61f6ef(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.signInAwaitingApproval;
}
function $91e59605951c3712$export$e77249f11b3becf7(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.selfRegistrationNotAllowed;
}
function $91e59605951c3712$export$3bfbe7e1e4370b9a(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.noPasswordSet;
}
function $91e59605951c3712$export$b3a935821f1baeb0(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.recoverNonReachableHandleType;
}
function $91e59605951c3712$export$f47339bf28a93789(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.timeoutError;
}
function $91e59605951c3712$export$a8908c3867f6f20b(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.rateLimitError;
}
function $91e59605951c3712$export$62f820c3bd739e62(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.badPasskeyScopeError;
}
function $91e59605951c3712$export$2d8742981298631e(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.passkeyPromptError;
}
function $91e59605951c3712$export$5a62b7ffa29b147c(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.apiResponseError;
}
function $91e59605951c3712$export$2e53c7453e352ae5(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.invalidSlashIDConfigurationError;
}
function $91e59605951c3712$export$b50161abe6d1888e(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.invalidSlashIDURLParamsError;
}
function $91e59605951c3712$export$e53d48902fc18ef(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.invalidAuthenticationMethodError;
}
function $91e59605951c3712$export$1aedaf54d72debec(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.invalidActionError;
}
function $91e59605951c3712$export$5376529ff6d74e7e(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.personExistsError;
}
function $91e59605951c3712$export$7217cc8708dd65ea(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.invalidEmailAddressFormatError;
}
function $91e59605951c3712$export$74db601249abc762(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.invalidPhoneNumberFormatError;
}
function $91e59605951c3712$export$68de2e41a5e9d0c3(error) {
    return error instanceof (0, $60b6642fd39ba43b$export$f471a06c79be5983) && error.name === $91e59605951c3712$export$daceac3b97803ce1.unknown;
}
function $91e59605951c3712$export$f59d87dc47407b7f({ message: message, name: name, cause: cause, context: context }) {
    const error = new (0, $60b6642fd39ba43b$export$f471a06c79be5983)({
        message: message,
        name: name,
        cause: cause,
        context: context
    });
    // we know this must be a SlashIDError as we created it
    return error;
}
function $91e59605951c3712$export$ea73e85faa39c9c0(error) {
    return (0, $60b6642fd39ba43b$export$ea73e85faa39c9c0)(error);
}
const $91e59605951c3712$export$6fbf0ec11a25c8b2 = (text)=>{
    return (0, $60b6642fd39ba43b$export$866513626aaa7357).includes(text);
};



const $561d3dd760db35d2$var$ACCEPTED_BASE_URL_PROTOCOLS = [
    "http:",
    "https:"
];
function $561d3dd760db35d2$export$7586e69c60094c9d(options) {
    if (!options) throw new (0, $60b6642fd39ba43b$export$f471a06c79be5983)({
        message: "options cannot be null",
        name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
        context: {
            options: options
        }
    });
    if (options.environment) {
        if (typeof options.environment === "string" && options.environment !== "production" && options.environment !== "sandbox") throw new (0, $60b6642fd39ba43b$export$f471a06c79be5983)({
            message: "If 'environment' is set as a string, it must be either 'production' or 'sandbox'",
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
            context: {
                options: options
            }
        });
        if (typeof options.environment === "object") {
            if (typeof options.environment.baseURL !== "string") throw new (0, $60b6642fd39ba43b$export$f471a06c79be5983)({
                message: "'environment.baseURL' must be a string",
                name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
                context: {
                    options: options
                }
            });
            if (typeof options.environment.sdkURL !== "string") throw new (0, $60b6642fd39ba43b$export$f471a06c79be5983)({
                message: "'environment.sdkURL' must be a string",
                name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
                context: {
                    options: options
                }
            });
        }
    }
    if (options.environment && (options.baseURL || options.sdkURL)) throw new (0, $60b6642fd39ba43b$export$f471a06c79be5983)({
        message: "If 'environment' is set, 'baseURL' and 'sdkURL' cannot be set at the same time. Use a custom environment instead.",
        name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
        context: {
            options: options
        }
    });
    if (options.baseURL) {
        if (typeof options.baseURL !== "string") throw new (0, $60b6642fd39ba43b$export$f471a06c79be5983)({
            message: "'baseURL' must be a string",
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
            context: {
                options: options
            }
        });
        let url;
        try {
            url = new URL(options.baseURL);
        } catch (_) {
            throw new (0, $60b6642fd39ba43b$export$f471a06c79be5983)({
                message: "'baseURL' must be a valid URL",
                name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
                context: {
                    options: options
                }
            });
        }
        if ($561d3dd760db35d2$var$ACCEPTED_BASE_URL_PROTOCOLS.indexOf(url.protocol) === -1) throw new (0, $60b6642fd39ba43b$export$f471a06c79be5983)({
            message: "'baseURL' must be either an http or https URL",
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
            context: {
                options: options
            }
        });
    }
    if (options.sdkURL) {
        if (typeof options.sdkURL !== "string") throw new (0, $60b6642fd39ba43b$export$f471a06c79be5983)({
            message: "'sdkURL' must be a string",
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
            context: {
                options: options
            }
        });
        try {
            new URL(options.sdkURL);
        } catch (_) {
            throw new (0, $60b6642fd39ba43b$export$f471a06c79be5983)({
                message: "'sdkURL' must be a valid URL",
                name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
                context: {
                    options: options
                }
            });
        }
    }
    const { analyticsEnabled: analyticsEnabled = true, oid: oid, identityProviderInitiatedSSOEnabled: identityProviderInitiatedSSOEnabled = false } = options;
    if (analyticsEnabled && !oid) throw new (0, $60b6642fd39ba43b$export$f471a06c79be5983)({
        message: "Analytics require the 'oid' parameter to be set when instantiating SlashID()",
        name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
        context: {
            options: options
        }
    });
    if (identityProviderInitiatedSSOEnabled && !oid) throw new (0, $60b6642fd39ba43b$export$f471a06c79be5983)({
        message: "Identity provider initiated SSO requires the 'oid' parameter to be set when instantiating SlashID()",
        name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
        context: {
            options: options
        }
    });
}
function $561d3dd760db35d2$var$getSlashIDURLsFromOptions(options) {
    // prefer the environment setting
    if (options.environment) return $561d3dd760db35d2$var$getSlashIDURLsFromEnvironment(options.environment);
    // default to production if individual options are not set
    return {
        baseURL: options.baseURL || $561d3dd760db35d2$export$58b6d978d250d3b1.production.baseURL,
        sdkURL: options.sdkURL || $561d3dd760db35d2$export$58b6d978d250d3b1.production.sdkURL
    };
}
const $561d3dd760db35d2$export$58b6d978d250d3b1 = {
    production: {
        baseURL: "https://api.slashid.com",
        sdkURL: "https://cdn.slashid.com/sdk.html"
    },
    sandbox: {
        baseURL: "https://api.sandbox.slashid.com",
        sdkURL: "https://cdn.sandbox.slashid.com/sdk.html"
    }
};
function $561d3dd760db35d2$var$getSlashIDURLsFromEnvironment(environment) {
    if (typeof environment === "string") return $561d3dd760db35d2$export$58b6d978d250d3b1[environment];
    if ((0, $f02bc98e6bb876be$export$51e4260dae945f14)(environment)) return {
        baseURL: environment.baseURL,
        sdkURL: environment.sdkURL
    };
    throw new TypeError("'environment' must be either a string or an object");
}
function $561d3dd760db35d2$export$851d251ce7109e65(options) {
    const urls = $561d3dd760db35d2$var$getSlashIDURLsFromOptions(options);
    var _options_analyticsEnabled, _options_identityProviderInitiatedSSOEnabled;
    const config = {
        oid: options.oid,
        analyticsEnabled: (_options_analyticsEnabled = options.analyticsEnabled) !== null && _options_analyticsEnabled !== void 0 ? _options_analyticsEnabled : true,
        identityProviderInitiatedSSOEnabled: (_options_identityProviderInitiatedSSOEnabled = options.identityProviderInitiatedSSOEnabled) !== null && _options_identityProviderInitiatedSSOEnabled !== void 0 ? _options_identityProviderInitiatedSSOEnabled : false,
        ...urls
    };
    return config;
}
class $561d3dd760db35d2$export$1fd9c30e1b817ee4 {
    constructor(obj){
        this.getOTP = obj === null || obj === void 0 ? void 0 : obj.getOTP;
    }
}
class $561d3dd760db35d2$export$b9ee3a7fe7868e4b {
    constructor(obj){
        this.getOTP = obj === null || obj === void 0 ? void 0 : obj.getOTP;
    }
}
async function $561d3dd760db35d2$export$af64486b3e452a98(authenticationFactor) {
    if (authenticationFactor.method !== "oidc") throw new Error(`Can't create OIDC extras for method: ${authenticationFactor.method}`);
    let extras = {};
    const { client_id: client_id, provider: provider } = authenticationFactor.options;
    let { ux_mode: ux_mode, redirect_target: redirect_target } = authenticationFactor.options;
    if (!ux_mode) ux_mode = (0, $d978296a495364e5$export$947f28fa7e24f5f5).Popup;
    if (!redirect_target) redirect_target = window.location.href;
    if (ux_mode === (0, $d978296a495364e5$export$947f28fa7e24f5f5).Redirect) {
        if (!(0, $3943e8c808f9150b$export$fc99885b7e473d08)(redirect_target)) throw new Error(`If OIDC ux_mode was set to "redirect" a "redirect_target" is required, got ${redirect_target}`);
    }
    if (ux_mode === (0, $d978296a495364e5$export$947f28fa7e24f5f5).Popup) {
        const [popup, setPopupUrl] = (0, $1d209ce78d67cb65$export$5d0606a13b21f3f8)();
        extras = {
            ...extras,
            popup: popup,
            setPopupUrl: setPopupUrl
        };
    }
    return {
        ...authenticationFactor,
        options: {
            ...authenticationFactor.options,
            client_id: client_id,
            provider: provider,
            ux_mode: ux_mode,
            redirect_target: redirect_target
        },
        extras: extras
    };
}
async function $561d3dd760db35d2$export$98f5d2f2dc6acbbd(authenticationFactor) {
    if (authenticationFactor.method !== "saml") throw new Error(`Can't create SAML extras for method: ${authenticationFactor.method}`);
    let extras = {};
    let { ux_mode: ux_mode, redirect_target: redirect_target } = authenticationFactor.options;
    if (!ux_mode) ux_mode = (0, $13463f5a948e6169$export$6dc0f627c99c13a9).Popup;
    if (!redirect_target) redirect_target = window.location.href;
    if (ux_mode === (0, $13463f5a948e6169$export$6dc0f627c99c13a9).Redirect) {
        if (!(0, $3943e8c808f9150b$export$fc99885b7e473d08)(redirect_target)) throw new Error(`If SAML ux_mode was set to "redirect" a "redirect_target" is required, got ${redirect_target}`);
    }
    if (ux_mode === (0, $13463f5a948e6169$export$6dc0f627c99c13a9).Popup) {
        const [popup, setPopupUrl] = (0, $1d209ce78d67cb65$export$5d0606a13b21f3f8)();
        extras = {
            ...extras,
            popup: popup,
            setPopupUrl: setPopupUrl
        };
    }
    return {
        ...authenticationFactor,
        options: {
            ...authenticationFactor.options,
            ux_mode: ux_mode,
            redirect_target: redirect_target
        },
        extras: extras
    };
}
const $561d3dd760db35d2$export$1a3951e5faecec2e = "iss";
function $561d3dd760db35d2$var$isValidIssuer(iss) {
    const parts = iss.split(":");
    return parts.length === 3 && parts[0] === "social";
}
function $561d3dd760db35d2$export$b75ec5c826df5f51(queryString) {
    const urlParams = new URLSearchParams(queryString);
    const iss = urlParams.get($561d3dd760db35d2$export$1a3951e5faecec2e);
    if (!iss || !$561d3dd760db35d2$var$isValidIssuer(iss)) return null;
    return {
        iss: iss
    };
}
function $561d3dd760db35d2$export$8f4f34b0b24b2663(location) {
    const url = new URL(location.href);
    url.searchParams.delete($561d3dd760db35d2$export$1a3951e5faecec2e);
    return url.toString();
}
async function $561d3dd760db35d2$export$7c6a3491e5c44625(params) {
    // social: prefix is unused at the moment
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, provider, client_id] = params.iss.split(":");
    return $561d3dd760db35d2$export$af64486b3e452a98({
        method: "oidc",
        options: {
            provider: provider,
            client_id: client_id,
            ux_mode: (0, $d978296a495364e5$export$947f28fa7e24f5f5).Redirect,
            redirect_target: $561d3dd760db35d2$export$8f4f34b0b24b2663(window.location)
        }
    });
}


function $50a898cc017f886c$var$e(e) {
    this.message = e;
}
$50a898cc017f886c$var$e.prototype = new Error, $50a898cc017f886c$var$e.prototype.name = "InvalidCharacterError";
var $50a898cc017f886c$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $50a898cc017f886c$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $50a898cc017f886c$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($50a898cc017f886c$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $50a898cc017f886c$var$r(t);
    }
}
function $50a898cc017f886c$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $50a898cc017f886c$var$o(e, r) {
    if ("string" != typeof e) throw new $50a898cc017f886c$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($50a898cc017f886c$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $50a898cc017f886c$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$50a898cc017f886c$export$b9721ef022f71a68.prototype = new Error, $50a898cc017f886c$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $50a898cc017f886c$export$2e2bcd8739ae039 = $50a898cc017f886c$var$o;






const $36a5d67002440f9c$export$d7905dc64d88e9a = {
    end_user_read_write: "end_user_read_write",
    end_user_read_only: "end_user_read_only",
    end_user_no_access: "end_user_no_access",
    "person_pool-end_user_read_write": "person_pool-end_user_read_write",
    "person_pool-end_user_read_only": "person_pool-end_user_read_only",
    "person_pool-end_user_no_access": "person_pool-end_user_no_access"
};
class $36a5d67002440f9c$export$356eb44c374cfc19 {
    /**
     * Retrieve attributes for a person from the bucket
     *
     * @param attributeNames You can optionally filter which attributes to retrieve by supplying a list of attribute names. If you don't the method returns all attributes.
     *
     * @returns A map from `string` to basic types containing user data previously associated with {@link set}.
     * @throws `Error` if the operation fails.
     */ async get(attributeNames) {
        const response = await this.user.getAttributesClient().getAttributesBucketName({
            bucketName: this.bucketName,
            attributes: attributeNames,
            slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw
        }, {
            cache: "no-cache"
        });
        const errors = response.errors;
        if (errors) throw errors;
        return response.result;
    }
    /**
     * Set attributes for a person in the bucket
     *
     * @param attributes A serializable object to associate with the user credential.
     * @throws `Error` if the operation fails.
     */ async set(attributes) {
        const response = await this.user.getAttributesClient().putAttributesBucketName({
            bucketName: this.bucketName,
            body: attributes,
            slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw
        }, {
            cache: "no-cache"
        });
        const errors = response.errors;
        if (errors) throw errors;
        return;
    }
    /**
     * Delete person attributes from the bucket
     *
     * @param attributeNames You must specify which data attributes to delete by supplying a list of filter strings.
     * @throws `Error` if the operation fails.
     */ async delete(attributeNames) {
        const response = await this.user.getAttributesClient().deleteAttributesBucketName({
            bucketName: this.bucketName,
            slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw,
            attributes: attributeNames
        }, {
            cache: "no-cache"
        });
        const errors = response.errors;
        if (errors) throw errors;
        return;
    }
    constructor({ user: user, bucketName: bucketName }){
        this.user = user;
        this.bucketName = bucketName;
    }
}






function $be25baf6593a301c$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}


const $91df54dff839f8b0$var$RETRY_COUNT_HEADER = "SlashID-SdkRetryCount";
function $91df54dff839f8b0$var$getRetryCount(init) {
    if (!init.headers) return 0;
    const headers = new Headers(init.headers);
    const retryCountHeader = headers.get($91df54dff839f8b0$var$RETRY_COUNT_HEADER);
    return retryCountHeader ? parseInt(retryCountHeader) : 0;
}
function $91df54dff839f8b0$export$ee3eb40e76801bba({ baseDelayMs: baseDelayMs, maxRetries: maxRetries }) {
    // alternative: pass context through init (SlashID-SDK-retry header) or error
    // alternative: wrapper on top of the client, proxy to retry
    // cache (url, init) => retries - clear on success/max retries after throwing an error
    return {
        onError: async ({ error: error, response: response, url: url, init: init, fetch: fetchApi })=>{
            if ((0, $60b6642fd39ba43b$export$476aa014e2fd89d5)(error, response)) {
                const retryCount = $91df54dff839f8b0$var$getRetryCount(init);
                if (retryCount >= maxRetries) return response;
                await (0, $be25baf6593a301c$export$e772c8ff12451969)(Math.pow(2, retryCount) * baseDelayMs);
                return await fetchApi(url, {
                    ...init,
                    headers: {
                        ...init.headers,
                        [$91df54dff839f8b0$var$RETRY_COUNT_HEADER]: `${retryCount + 1}`
                    }
                });
            }
            return response;
        }
    };
}


const $2f64056e835cba42$export$48a8ffe18f8d9950 = async ({ environment: environment, oid: oid })=>{
    const { baseURL: baseURL } = (0, $561d3dd760db35d2$export$851d251ce7109e65)({
        environment: environment
    });
    const personsClient = new $9490672e7bca0fe8$export$f5f4fdd1b1ffabb3(new $168d06aed8b3cdb0$export$fa89be98fe0936f2({
        ...$168d06aed8b3cdb0$export$ac4f8128ea29c5,
        basePath: baseURL,
        middleware: [
            (0, $91df54dff839f8b0$export$ee3eb40e76801bba)({
                maxRetries: 5,
                baseDelayMs: 500
            })
        ]
    }));
    try {
        const { result: token } = await personsClient.postPersonsAnonymous({
            slashIDOrgID: oid,
            anonymousPersonCreateReq: {}
        });
        return token;
    } catch (e) {
        if (e instanceof Error) throw $60b6642fd39ba43b$export$ed0b6181311676c(e);
        throw e;
    }
};
function $2f64056e835cba42$var$checkOid(options) {
    if (typeof options.oid !== "string") throw new TypeError("'oid' must be of type string");
}
const $2f64056e835cba42$export$a96acc74924a1a1 = (context)=>{
    (0, $561d3dd760db35d2$export$7586e69c60094c9d)(context);
    const options = (0, $561d3dd760db35d2$export$851d251ce7109e65)(context);
    $2f64056e835cba42$var$checkOid(options);
    const { baseURL: baseURL, sdkURL: sdkURL, oid: oid } = options;
    const tokenCreateOptions = {
        environment: {
            baseURL: baseURL,
            sdkURL: sdkURL
        },
        oid: oid
    };
    return tokenCreateOptions;
};




function $0a8aed675f99e0c3$var$isTokenContainer(token) {
    if (!token) return false;
    if (typeof token.user_token === "string") return true;
    return false;
}
class $0a8aed675f99e0c3$export$d3bddec52a513503 {
    static async createAnonymousUser(options) {
        const createAnonUserOptions = (0, $2f64056e835cba42$export$a96acc74924a1a1)(options);
        const token = await (0, $2f64056e835cba42$export$48a8ffe18f8d9950)(createAnonUserOptions);
        return new $0a8aed675f99e0c3$export$d3bddec52a513503(token, options);
    }
    /**
     * Must be called in the constructor, before anything else happens.
     * Initializes the internal state of the instance.
     */ initialize(token, options) {
        try {
            // try JSON-decode it, just in case this is somehow coming back from a
            // previous JSON.stringify(user) without having been JSON-parsed first
            token = JSON.parse(token);
        } catch (_) {
        // ignored
        }
        if (typeof token !== "string") throw new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: $91e59605951c3712$export$daceac3b97803ce1.invalidActionError,
            message: "token must be a string",
            context: {
                token: token
            }
        });
        try {
            const decodedToken = (0, $50a898cc017f886c$export$2e2bcd8739ae039)(token);
            if ($0a8aed675f99e0c3$var$isTokenContainer(decodedToken)) {
                this._token = decodedToken.user_token;
                this._tokenContainer = token;
            } else this._token = token;
        } catch (e) {
            throw new $60b6642fd39ba43b$export$f471a06c79be5983({
                name: $91e59605951c3712$export$daceac3b97803ce1.unknown,
                message: `error when decoding token: ${e.toString()}`,
                cause: e,
                context: {
                    token: token
                }
            });
        }
        // TODO get the environment config from the token
        this._clientOptions = (0, $561d3dd760db35d2$export$851d251ce7109e65)(options !== null && options !== void 0 ? options : {});
        this.initializeClients();
    }
    /**
     * Use a new token to update the internal state of the user. Same set of options is reused.
     */ updateToken(token) {
        this.initialize(token, this._clientOptions);
    }
    get decoded() {
        if (!this._token) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: $91e59605951c3712$export$daceac3b97803ce1.invalidActionError,
            message: "Cannot call methods on unauthenticated user"
        });
        try {
            return (0, $50a898cc017f886c$export$2e2bcd8739ae039)(this._token);
        } catch (e) {
            throw new $60b6642fd39ba43b$export$f471a06c79be5983({
                name: $91e59605951c3712$export$daceac3b97803ce1.unknown,
                message: `error when decoding token: ${e.toString()}`,
                cause: e,
                context: {
                    token: this._token
                }
            });
        }
    }
    /**
     * The claims of the user token.
     * @returns {UserToken}
     */ get tokenClaims() {
        return this.decoded;
    }
    get decodedTokenContainer() {
        if (!this._tokenContainer) return;
        try {
            return (0, $50a898cc017f886c$export$2e2bcd8739ae039)(this._tokenContainer);
        } catch (e) {
            throw new $60b6642fd39ba43b$export$f471a06c79be5983({
                name: $91e59605951c3712$export$daceac3b97803ce1.unknown,
                message: `error when decoding token container: ${e.toString()}`,
                cause: e,
                context: {
                    tokenContainer: this._tokenContainer
                }
            });
        }
    }
    /**
     * If the user instance is created with a {@link Types.TokenContainer} this will return the claims of the token container.
     * Otherwise it will return undefined.
     * @returns {api.TokenContainer | undefined}
     */ get tokenContainerClaims() {
        return this.decodedTokenContainer;
    }
    updateClient(token) {
        this._token = token;
        this.initializeClients();
    }
    /**
     * Initializes every client with new Configuration based on currently stored
     * _clientOptions and _token.
     */ initializeClients() {
        var _this__clientOptions;
        const clientConfig = new (0, $168d06aed8b3cdb0$export$fa89be98fe0936f2)({
            ...(0, $168d06aed8b3cdb0$export$ac4f8128ea29c5),
            ...((_this__clientOptions = this._clientOptions) === null || _this__clientOptions === void 0 ? void 0 : _this__clientOptions.baseURL) && {
                basePath: this._clientOptions.baseURL
            },
            accessToken: this._token
        });
        this._apiClient = new $8dabc67a561e7dc0$export$872437fb2a17cd0e(clientConfig);
        this._attrsClient = new $de791efae2088fc4$export$95d3101c7670792a(clientConfig);
        this._tokenClient = new (0, $01183d3ef1e1dae1$export$72bb25602803ae5f)(clientConfig);
        this._personConsentsApi = new $e758e522c3e01abb$export$f2ae3e6781ddb521(clientConfig);
    }
    /**
     * This user's ID. Use this property in your backend services when interacting with the [SlashID User Management API](https://developer.slashid.dev/docs/category/api/persons).
     */ get ID() {
        return this.decoded.person_id;
    }
    /**
     * The entire, signed authentication token of this user.
     */ get token() {
        var _this__token;
        return (_this__token = this._token) !== null && _this__token !== void 0 ? _this__token : "";
    }
    /**
     * The entire token container
     * @returns either the token container string or an empty string
     */ get tokenContainer() {
        return this._tokenContainer || "";
    }
    /**
     * The organization ID this user belongs to.
     */ get oid() {
        return this.decoded.oid;
    }
    /**
     * Indicates whether the user has been just registered, otherwise it's a returning user.
     */ get firstLogin() {
        return this.decoded.first_token;
    }
    /**
     * Indicates which authentication methods the user has been verified with. It can contain multiple items in case of multi factor authentication.
     */ get authentication() {
        return this.decoded.authenticated_methods || [];
    }
    /**
     * Indicates which authentication methods the user has been verified with, including the handles used for each method.
     */ get authentications() {
        return this.decoded.authentications || [];
    }
    /**
     * Indicates if the user is an anonymous user
     */ get anonymous() {
        return this.decoded.person_type === "anonymous";
    }
    /**
     * Indicates if the user is authenticated
     *
     * For anonymous users this will return `false`
     */ async isAuthenticated() {
        const { valid: valid } = await this.validateToken();
        return valid && this.decoded.person_type !== "anonymous";
    }
    /**
     * Create a DirectID based on your token
     * @returns directID token
     */ async createDirectID() {
        const { result: directID } = await this._apiClient.postDirectId({
            slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw
        });
        return directID;
    }
    /**
     * Log out of the current session. Clears the SlashID token.
     * Will attempt revoking the token server-side.
     */ async logout() {
        try {
            await this._tokenClient.postTokenRevoke({
                slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw,
                revokeTokenReq: {
                    token: this.token
                }
            });
        } catch (_) {
        // we ignore the error as revoking the token is a side effect
        // this endpoint will return a 400 any time you try to revoke a token that is already revoked or expired
        // we expect this to happen frequently
        }
        this.updateClient(undefined);
        this._tokenContainer = undefined;
    }
    /**
     * Resolves to a token validity info object which tells if the token is genuine and if it has expired yet.
     * @returns {Promise} Token validity info
     */ async validateToken() {
        var _this__tokenClient;
        const response = await ((_this__tokenClient = this._tokenClient) === null || _this__tokenClient === void 0 ? void 0 : _this__tokenClient.postTokenValidate({
            validateTokenReq: {
                token: this.token
            },
            slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw
        }, {
            cache: "no-cache"
        }));
        const errors = response.errors;
        if (errors) throw errors;
        return response.result;
    }
    /**
     * Get an array of group names that the user belongs to.
     */ getGroups() {
        const groupsClaimName = this.decoded.groups_claim_name || "groups";
        const token = this.decoded;
        return token[groupsClaimName];
    }
    /**
     * Exposes the attributes client so the Bucket instance can access it
     */ getAttributesClient() {
        return this._attrsClient;
    }
    /**
     *  Creates a {@link Types.Bucket} object used to access attributes.
     *
     * @param bucketName name of the bucket we want to access - uses "end_user_read_write" as default.
     * You can pass in any string that corresponds to a name of a bucket set up for your organization.
     * You can use any of the preset bucket names with corresponding permissions and scopes - {@link Types.DefaultBucketName}.
     * @returns
     */ getBucket(bucketName = (0, $36a5d67002440f9c$export$d7905dc64d88e9a).end_user_read_write) {
        const bucket = new (0, $36a5d67002440f9c$export$356eb44c374cfc19)({
            user: this,
            bucketName: bucketName
        });
        return bucket;
    }
    /**
     * @deprecated Use {@link getBucket} instead.
     */ async get(attributeNames) {
        const endUserReadWriteBucket = this.getBucket();
        return endUserReadWriteBucket.get(attributeNames);
    }
    /**
     * @deprecated Use {@link getBucket} instead.
     */ async set(attributes) {
        const endUserReadWriteBucket = this.getBucket();
        return endUserReadWriteBucket.set(attributes);
    }
    /**
     * @deprecated Use {@link getBucket} instead.
     */ async delete(attributeNames) {
        const endUserReadWriteBucket = this.getBucket();
        return endUserReadWriteBucket.delete(attributeNames);
    }
    /**
     * Fetch the GDPR consent levels for the current user.
     * @returns {Promise} GDPR consent info
     */ async getGDPRConsent() {
        const response = await this._personConsentsApi.getConsentGdpr({
            slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw
        });
        const errors = response.errors;
        if (errors) throw errors;
        return response.result;
    }
    /**
     * Set the GDPR consent levels for the current user.
     * This will overwrite any existing consent levels and set the consent levels to only the ones included with the request.
     *
     * @param {api.GDPRConsentRequest} request with consentLevels to set
     * @returns {Promise} GDPR consent info
     */ async setGDPRConsent({ consentLevels: consentLevels }) {
        const response = await this._personConsentsApi.putConsentGdpr({
            gDPRConsentRequest: {
                consent_levels: consentLevels
            },
            slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw
        });
        const errors = response.errors;
        if (errors) throw errors;
        return response.result;
    }
    /**
     * Add the GDPR consent levels to the current user.
     * Consent levels not included in the request will not be changed.
     *
     * @param {api.GDPRConsentRequest} request with consent levels to add
     * @returns {Promise} GDPR consent info
     */ async addGDPRConsent({ consentLevels: consentLevels }) {
        const response = await this._personConsentsApi.postConsentGdpr({
            gDPRConsentRequest: {
                consent_levels: consentLevels
            },
            slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw
        });
        const errors = response.errors;
        if (errors) throw errors;
        return response.result;
    }
    /**
     * Remove the GDPR consent levels from the current user.
     * Consent levels not included in the request will not be changed.
     *
     * @param {api.ConsentGdprDeleteRequest} request with consentLevels to remove
     */ async removeGDPRConsent({ consentLevels: consentLevels }) {
        return this._personConsentsApi.deleteConsentGdpr({
            slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw,
            consentLevels: consentLevels
        });
    }
    /**
     * Remove all stored GDPR consent levels from the current user.
     * Consent levels not included in the request will not be changed, unless deleteAll flag is set to true.
     */ async removeGDPRConsentAll() {
        return this._personConsentsApi.deleteConsentGdpr({
            slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw,
            deleteAll: true
        });
    }
    /**
     * Get the organizations the user belongs to.
     * @returns {Promise} A list of organizations the user belongs to
     */ async getOrganizations() {
        const response = await this._apiClient.getMe();
        const errors = response.errors;
        if (errors) throw errors;
        return response.result.organizations;
    }
    /**
     * Fetch all the handles associated with this user from the SlashID API.
     * @returns {Promise} A list of handles available for the user
     */ async getHandles() {
        const { errors: errors, result: result } = await this._apiClient.getMe();
        if (errors) throw errors;
        return result.handles;
    }
    /**
     * Given an organization ID, get a new token for the same user in the Organization specified by the Organization ID.
     *
     * For the call to succeed the following conditions must be met:
     * - the token must be valid at the time of the request
     * - the two Organizations must share the same person pool
     * - the user must be a member of both Organizations
     *
     * This operation does not count as an authentication, so the new token will have the same expiration time as the original.
     * @param oid
     * @returns {Promise} A new token for the specified Organization ID
     */ async getTokenForOrganization(oid) {
        const response = await this._apiClient.getToken({
            slashIDOrgID: oid,
            slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw
        });
        const errors = response.errors;
        if (errors) throw errors;
        return response.result;
    }
    /**
     * User objects stringify to their token value for convenience:
     *
     * @example
     * ```js
     * user.toString() === "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiSm9obiBTbWl0aCIsImlhdCI6MTUxNjIzOTAyMn0.dzKuKf6u9G7Crk9tsFnS2cey1zglWTFQv_hjWjmtXms"
     * ```
     */ toString() {
        var _this__tokenContainer, _ref;
        return (_ref = (_this__tokenContainer = this._tokenContainer) !== null && _this__tokenContainer !== void 0 ? _this__tokenContainer : this._token) !== null && _ref !== void 0 ? _ref : "";
    }
    /**
     * User objects encode to JSON as a string containing their token value.
     *
     * @example
     * ```js
     * JSON.stringify(user) === "\"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiSm9obiBTbWl0aCIsImlhdCI6MTUxNjIzOTAyMn0.dzKuKf6u9G7Crk9tsFnS2cey1zglWTFQv_hjWjmtXms\""
     * ```
     */ toJSON() {
        var _this__tokenContainer, _ref;
        return `${(_ref = (_this__tokenContainer = this._tokenContainer) !== null && _this__tokenContainer !== void 0 ? _this__tokenContainer : this._token) !== null && _ref !== void 0 ? _ref : ""}`;
    }
    /**
     * Reconstruct an authenticated user from its token value.
     *
     * @param token A user {@link token} value.
     * @param optionsOrSid SlashID instance or SlashID connection options. It is preferred to pass in the SlashID instance
     *
     * @throws `TypeError` If the given `optionsOrSid`, if defined, fail validation, or
     * the given token cannot be decoded.
     */ constructor(token, options){
        this.initialize(token, options);
    }
}






/**
 * @ignore
 *
 * @param str Base64 string with URL-safe alphabet as described
 * in https://datatracker.ietf.org/doc/html/rfc4648#section-5, either
 * padded or unpadded.
 * @returns typed array of the decoded data
 */ function $aae5e813cb61d169$export$2f872c0f2117be69(str) {
    const urlEncodedStr = str.replace(/_/g, "/").replace(/-/g, "+");
    const binStr = atob(urlEncodedStr);
    return Uint8Array.from(binStr, (c)=>c.charCodeAt(0));
}
function $aae5e813cb61d169$export$c564cdbbe6da493(data, urlSafe = true) {
    const binStr = String.fromCharCode(...data);
    const str = btoa(binStr);
    if (urlSafe) return str.replace(/\//g, "_").replace(/\+/g, "-").replace(/=/g, "");
    else return str;
}



async function $185870848aa59297$export$d245da411ccc251b() {
    const hadFocus = document.hasFocus();
    // Polling document.hasFocus() is not ideal but its result reliably changes
    // when the window gets focus, unlike the "focus" and "focusin" events, which
    // only get triggered when an input field gets focus.
    while(!hadFocus && !document.hasFocus())await $be25baf6593a301c$export$e772c8ff12451969(50);
    return hadFocus;
}
const $185870848aa59297$export$32deff8ed92da53f = {
    PopupBlocked: "Popup blocked",
    BadOAuthURL: "Bad OAuth sign in URL"
};
const $185870848aa59297$export$af2e6529191b5a73 = {
    PopupBlocked: "Popup blocked",
    BadAuthURL: "Bad authentication URL"
};
const $185870848aa59297$export$4b60518ae108432a = {
    ApiCallFailed: "API call failed"
};
function $185870848aa59297$export$2d39cf9e3832749f(event) {
    return event.errorText === "client_side_error";
}
const $185870848aa59297$export$dff4d4401577a965 = [
    "otpSmsSent",
    "otpCodeSent",
    "totpKeyGenerated",
    "totpCodeRequested",
    "otpIncorrectCodeSubmitted",
    "passwordSetReady",
    "passwordResetReady",
    "passwordVerifyReady",
    "invalidPasswordSubmitted",
    "incorrectPasswordSubmitted",
    "oauthFlowStarted",
    "oauthFlowFailed",
    "userAuthenticatedFromURL",
    "idFlowSucceeded",
    "idFlowStarted",
    "idFlowFailed",
    "recoveryFlowStarted",
    "recoveryFlowSucceeded",
    "recoveryFlowFailed",
    "webAuthnChallengeProcessed",
    "redirectUriDiscovered",
    "uiCustomizationReceived",
    "authnContextUpdateChallengeReceivedEvent"
];
const $185870848aa59297$export$b7ca98e78eb4b7f2 = [
    "otpCodeSubmitted",
    "passwordSubmitted",
    "flowCancelled"
];
const $185870848aa59297$var$PRIVATE_EVENTS = [
    "clientSideError"
];
function $185870848aa59297$export$ab1e84ca8f5ea7e(evt) {
    return $185870848aa59297$export$dff4d4401577a965.includes(evt);
}
function $185870848aa59297$export$fdd1788388ec077b(evt) {
    return $185870848aa59297$export$b7ca98e78eb4b7f2.includes(evt);
}
function $185870848aa59297$export$a447b62f94c26639(evt) {
    return $185870848aa59297$var$PRIVATE_EVENTS.includes(evt);
}
function $185870848aa59297$export$45e9ff32b647b1fa() {
    const legacyToWrappedHandlerMap = new Map();
    function decorate(legacyHandler) {
        function decoratedHandler(event) {
            // TODO type check fails because of event payload types that are void or string
            // @ts-expect-error
            legacyHandler(event.payload);
        }
        legacyToWrappedHandlerMap.set(legacyHandler, decoratedHandler);
        return decoratedHandler;
    }
    function getDecorator(legacyHandler) {
        if (legacyToWrappedHandlerMap.has(legacyHandler)) return legacyToWrappedHandlerMap.get(legacyHandler);
        return undefined;
    }
    return {
        decorate: decorate,
        getDecorator: getDecorator
    };
}






async function $98dcef32dd30b893$export$ccfc10b8bad1155a(win) {
    // eslint-disable-next-line
    const pong = new Promise(async (resolve, reject)=>{
        const request = new $6c3db34ca8f899b2$export$e863b19988e8aafd();
        let ponged = false;
        const responseListener = (event)=>{
            const response = event.data;
            if (response.id !== request.id) return;
            window.removeEventListener("message", responseListener);
            if (response.error) reject(response.error);
            else {
                ponged = true;
                resolve(win);
            }
        };
        window.addEventListener("message", responseListener);
        while(!ponged){
            win.postMessage(request, "*");
            await $be25baf6593a301c$export$e772c8ff12451969(50);
        }
    });
    return pong;
}


class $b16ebbc972dd3e11$export$68371093923cfc31 {
    async getRemoteWindow() {
        var _this_remote;
        const win = (_this_remote = this.remote) === null || _this_remote === void 0 ? void 0 : _this_remote.contentWindow;
        if (!win) throw new Error("this context has no remote");
        if (this.remoteReady) return win;
        await $98dcef32dd30b893$export$ccfc10b8bad1155a(win);
        this.remoteReady = true;
        return win;
    }
    async processEvent(event) {
        let sourceWindow = null;
        if (window.parent && event.source === window.parent) sourceWindow = window.parent;
        if (!sourceWindow) return;
        switch(event.data.type){
            case $6c3db34ca8f899b2$export$80edbf15fa61a4db.StorageGetItem:
                {
                    const msg = event.data;
                    try {
                        const value = await this.localGetItem(msg.key);
                        sourceWindow.postMessage(new $6c3db34ca8f899b2$export$b622fa8237033579(event.data.id, value), "*");
                    } catch (e) {
                        sourceWindow.postMessage(new $6c3db34ca8f899b2$export$b622fa8237033579(event.data.id, null, e), "*");
                    }
                }
                break;
            case $6c3db34ca8f899b2$export$80edbf15fa61a4db.StorageSetItem:
                {
                    const msg = event.data;
                    try {
                        await this.localSetItem(msg.key, msg.value);
                        sourceWindow.postMessage(new $6c3db34ca8f899b2$export$b19581adb4c22a0e(event.data.id), "*");
                    } catch (e) {
                        sourceWindow.postMessage(new $6c3db34ca8f899b2$export$b19581adb4c22a0e(event.data.id, e), "*");
                    }
                }
                break;
            default:
                break;
        }
    }
    async localGetItem(key) {
        return window.localStorage.getItem(key);
    }
    async remoteGetItem(key) {
        let remoteValue = null;
        if (this.remote) remoteValue = await new Promise((resolve, reject)=>{
            const request = new $6c3db34ca8f899b2$export$f01d2f4fd62a4592(key);
            const responseListener = (event)=>{
                const response = event.data;
                if (response.id !== request.id) return;
                window.removeEventListener("message", responseListener);
                if (response.error) reject(response.error);
                else resolve(response.value);
            };
            window.addEventListener("message", responseListener);
            this.getRemoteWindow().then((win)=>{
                win.postMessage(request, "*");
            });
        });
        return remoteValue;
    }
    async localSetItem(key, value) {
        return window.localStorage.setItem(key, value);
    }
    async remoteSetItem(key, value) {
        if (this.remote) await new Promise((resolve, reject)=>{
            const request = new $6c3db34ca8f899b2$export$cbc7b39b5c005822(key, value);
            const responseListener = (event)=>{
                const response = event.data;
                if (response.id !== request.id) return;
                window.removeEventListener("message", responseListener);
                if (response.error) reject(response.error);
                else resolve();
            };
            window.addEventListener("message", responseListener);
            this.getRemoteWindow().then((win)=>{
                win.postMessage(request, "*");
            });
        });
    }
    constructor(iframe, remoteOrigin){
        this.remoteReady = false;
        this.remote = iframe;
        this.remoteOrigin = remoteOrigin;
        if (!this.remote) // we are the remote => expect request messages
        window.addEventListener("message", this.processEvent.bind(this));
    }
}
class $b16ebbc972dd3e11$var$StorageBase {
    constructor(store){
        this.store = store;
    }
}
class $b16ebbc972dd3e11$export$720664048a0262dc extends $b16ebbc972dd3e11$var$StorageBase {
    stringify(identifiers) {
        return JSON.stringify(identifiers);
    }
    parse(value) {
        if (!value) return [];
        const identifiers = JSON.parse(value);
        return identifiers;
    }
    async getAll() {
        const localIdentifiers = this.parse(await this.store.localGetItem($b16ebbc972dd3e11$export$720664048a0262dc.LOCAL_STORAGE_IDENTIFIERS_KEY));
        const remoteIdentifiers = this.parse(await this.store.remoteGetItem($b16ebbc972dd3e11$export$720664048a0262dc.LOCAL_STORAGE_IDENTIFIERS_KEY));
        return $b16ebbc972dd3e11$export$720664048a0262dc.merge(localIdentifiers, remoteIdentifiers);
    }
    async add(identifier) {
        const identifiers = await this.getAll();
        const updatedIdentifiers = this.stringify($b16ebbc972dd3e11$export$720664048a0262dc.merge(identifiers, [
            identifier
        ]));
        await this.store.localSetItem($b16ebbc972dd3e11$export$720664048a0262dc.LOCAL_STORAGE_IDENTIFIERS_KEY, updatedIdentifiers);
        await this.store.remoteSetItem($b16ebbc972dd3e11$export$720664048a0262dc.LOCAL_STORAGE_IDENTIFIERS_KEY, updatedIdentifiers);
    }
    static identifiersEqual(id1, id2) {
        return id1.type === id2.type && id1.value === id2.value;
    }
    static merge(ids1, ids2) {
        return ids1.concat(...ids2).reduce((acc, cur)=>{
            for (const id of acc){
                if ($b16ebbc972dd3e11$export$720664048a0262dc.identifiersEqual(id, cur)) return acc;
            }
            acc.push(cur);
            return acc;
        }, []);
    }
}
$b16ebbc972dd3e11$export$720664048a0262dc.LOCAL_STORAGE_IDENTIFIERS_KEY = "SLASHID_IDENTIFIERS";
class $b16ebbc972dd3e11$var$CredentialsStorageBase extends $b16ebbc972dd3e11$var$StorageBase {
    static identifiersEqual(id1, id2) {
        return id1 === id2;
    }
    static merge(ids1, ids2) {
        return ids1.concat(...ids2).reduce((acc, cur)=>{
            for (const id of acc){
                if ($b16ebbc972dd3e11$var$CredentialsStorageBase.identifiersEqual(id, cur)) return acc;
            }
            acc.push(cur);
            return acc;
        }, []);
    }
}
class $b16ebbc972dd3e11$export$24dd33171b764b1e extends $b16ebbc972dd3e11$var$CredentialsStorageBase {
    stringify(credIds) {
        return JSON.stringify(credIds);
    }
    parse(value) {
        if (!value) return [];
        let parsed = null;
        try {
            parsed = JSON.parse(value);
        } catch (e) {
            return [
                value
            ];
        }
        if (!Array.isArray(parsed)) return [];
        const credIds = parsed.filter((item)=>typeof item === "string");
        return credIds;
    }
    async getAll() {
        const localCredIds = this.parse(await this.store.localGetItem($b16ebbc972dd3e11$export$24dd33171b764b1e.LOCAL_STORAGE_WEBAUTHN_CREDENTIAL_ID_KEY));
        const remoteCredIds = this.parse(await this.store.remoteGetItem($b16ebbc972dd3e11$export$24dd33171b764b1e.LOCAL_STORAGE_WEBAUTHN_CREDENTIAL_ID_KEY));
        return $b16ebbc972dd3e11$export$24dd33171b764b1e.merge(localCredIds, remoteCredIds);
    }
    async add(credId) {
        const credIds = await this.getAll();
        const updatedCredIds = this.stringify($b16ebbc972dd3e11$export$24dd33171b764b1e.merge(credIds, [
            credId
        ]));
        await this.store.localSetItem($b16ebbc972dd3e11$export$24dd33171b764b1e.LOCAL_STORAGE_WEBAUTHN_CREDENTIAL_ID_KEY, updatedCredIds);
        await this.store.remoteSetItem($b16ebbc972dd3e11$export$24dd33171b764b1e.LOCAL_STORAGE_WEBAUTHN_CREDENTIAL_ID_KEY, updatedCredIds);
    }
}
$b16ebbc972dd3e11$export$24dd33171b764b1e.LOCAL_STORAGE_WEBAUTHN_CREDENTIAL_ID_KEY = "SLASHID_WEBAUTHN_CREDENTIAL_ID";
class $b16ebbc972dd3e11$export$28d449e9c93b4ea6 extends $b16ebbc972dd3e11$var$CredentialsStorageBase {
    stringify(credIdsMap) {
        return JSON.stringify(credIdsMap);
    }
    parse(value) {
        if (!value) return {};
        let parsed = null;
        try {
            parsed = JSON.parse(value);
        } catch (e) {
            return {};
        }
        if (typeof parsed !== "object") return {};
        const credIdsMap = {};
        for (const scope of Object.keys(parsed)){
            if (typeof scope !== "string") continue;
            if (!Array.isArray(parsed[scope])) continue;
            const credIds = parsed[scope].filter((item)=>typeof item === "string");
            credIdsMap[scope] = credIds;
        }
        return credIdsMap;
    }
    async getAll() {
        const localCredIdsMap = this.parse(await this.store.localGetItem($b16ebbc972dd3e11$export$28d449e9c93b4ea6.LOCAL_STORAGE_WEBAUTHN_CREDENTIAL_ID_KEY_V2));
        return localCredIdsMap;
    }
    async get(scope) {
        if (!this.store.remoteOrigin || this.store.remoteOrigin.endsWith(scope)) return this.v1Storage.getAll();
        const localCredIds = (await this.getAll())[scope] || [];
        return localCredIds;
    }
    async add(scope, credId) {
        if (!this.store.remoteOrigin || this.store.remoteOrigin.endsWith(scope)) {
            this.v1Storage.add(credId);
            return;
        }
        const localCredIdsMap = await this.getAll();
        const localCredIds = localCredIdsMap[scope] || [];
        for (const id of localCredIds)if (id === credId) {
            console.warn(`Attempted to add already present credential ID: scope=${scope} credId=${credId}`);
            return;
        }
        localCredIds.push(credId);
        localCredIdsMap[scope] = localCredIds;
        const updatedCredIdsMap = this.stringify(localCredIdsMap);
        await this.store.localSetItem($b16ebbc972dd3e11$export$28d449e9c93b4ea6.LOCAL_STORAGE_WEBAUTHN_CREDENTIAL_ID_KEY_V2, updatedCredIdsMap);
    }
    constructor(store){
        super(store);
        this.v1Storage = new $b16ebbc972dd3e11$export$24dd33171b764b1e(store);
    }
}
$b16ebbc972dd3e11$export$28d449e9c93b4ea6.LOCAL_STORAGE_WEBAUTHN_CREDENTIAL_ID_KEY_V2 = "SLASHID_WEBAUTHN_CREDENTIAL_ID_V2";





class $31425f702a7b168e$export$ec7121d802e738bd extends (0, $0a8aed675f99e0c3$export$d3bddec52a513503) {
    /**
     * Request the user to authenticate with the given method. This method is essentially equivalent to
     * {@link SlashID.id}, but since the user is already authenticated you can omit the `handle` or
     * `authenticationFactor` parameters, depending on the desired outcome. Please refer to the examples
     * for the use cases this method covers.
     *
     * @param handle A user handle, either a new one to be associated to the user, or an existing
     * one to deliver the authetication request to.
     *
     * @param authenticationFactor The authentication factor, please to refer to {@link SlashID.id}
     * documentation for details.
     *
     * @throws `slashid.errors.InvalidAuthenticationMethodError` if the chosen method is
     * incompatible with the given handle or is not available on the current device.
     * `Error` if the operation fails otherwise.
     *
     * @example
     *
     * One thing you can do with `mfa()` is attach other handles to the user.
     * For example, the user has already authenticated via e-mail magic link with
     * {@link SlashID.id}, but you want to also attach their phone number. In that case all
     * the method requires is the handle, not
     *
     * ```js
     * await user.mfa({
     *   type: "phone_number",
     *   value: "+13337777777"
     * })
     * ```
     *
     * SlashID will send a challenge SMS to the phone number to verify it. If `mfa()` returns
     * without throwing any error the procedure is complete and the user object will have been
     * updated with a refreshed {@link token}. For future authentications the user will be able
     * to use the newly-attached phone number as an alternative to the e-mail address. Consider
     * though that this call only verified ownership of the phone number and added it to the user
     * handles, as such the {@link authentication} array stays unchanged.
     *
     * If you want to step-up the user authentication, or simply re-authenticate the user,
     * you can do so by also providing an authentication factor. For example let's assume
     * you want to send a magic link to one of the user's e-mail address:
     *
     * ```js
     * await user.mfa({
     *   type: "email_address",
     *   value: "..." // one previously-attached address, or a new one to be attached
     * }, {
     *   method: "email_link"
     * })
     * ```
     *
     * If the e-mail address provided above was not attached to the user, SlashID will verify it
     * and also perform the authentication. Once again, when `mfa()` returns the user will have
     * a refreshed {@link token}, but this time its {@link authentication} array will also include
     * `"email_link"` in addition to the method chosen for the first authentication with
     * {@link SlashID.id}.
     *
     * The only edge case to note is that for performing MFA with WebAuthn authentication
     * there's no need to specify an handle, as the ceremony happens on the current device:
     *
     * ```js
     * await user.mfa(undefined, {
     *   method: "webauthn"
     * })
     * ```
     */ async mfa(handleOrFactor, authenticationFactor) {
        let handle = undefined;
        if (!handleOrFactor) throw new Error("at least one of PersonHandle or Factor is required");
        if (handleOrFactor.type && handleOrFactor.value) handle = handleOrFactor;
        if (handleOrFactor.method) authenticationFactor = handleOrFactor;
        // On WebAuthn, if the key does not exist on the authenticator:
        //  - Firefox throws "InvalidStateError: An attempt was made to use an object that is not, or is no longer, usable"
        //  - Chrome throws "NotAllowedError: The operation either timed out or was not allowed. See: https://www.w3.org/TR/webauthn-2/#sctn-privacy-considerations-client."
        const updatedUser = await this._slashid._id(this.decoded.oid, handle, authenticationFactor, this._token);
        this.updateToken(updatedUser.toString());
        return;
    }
    constructor(token, optionsOrSid){
        // both the options and SlashID instances have the same fields (baseURL, sdkURL, oid)
        super(token, optionsOrSid);
        this._slashid = optionsOrSid instanceof (0, $708a5f26294b10cd$export$261888861cdb8a55) ? optionsOrSid : new (0, $708a5f26294b10cd$export$261888861cdb8a55)(optionsOrSid);
    }
}


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $223ce62d92e952f1$var$getRandomValues;
var $223ce62d92e952f1$var$rnds8 = new Uint8Array(16);
function $223ce62d92e952f1$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$223ce62d92e952f1$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $223ce62d92e952f1$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$223ce62d92e952f1$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $223ce62d92e952f1$var$getRandomValues($223ce62d92e952f1$var$rnds8);
}


var $19a53ccdb45819f0$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $98dbfcf47d2aa778$var$validate(uuid) {
    return typeof uuid === "string" && (0, $19a53ccdb45819f0$export$2e2bcd8739ae039).test(uuid);
}
var $98dbfcf47d2aa778$export$2e2bcd8739ae039 = $98dbfcf47d2aa778$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $1a32167e8210dffc$var$byteToHex = [];
for(var $1a32167e8210dffc$var$i = 0; $1a32167e8210dffc$var$i < 256; ++$1a32167e8210dffc$var$i)$1a32167e8210dffc$var$byteToHex.push(($1a32167e8210dffc$var$i + 0x100).toString(16).substr(1));
function $1a32167e8210dffc$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($1a32167e8210dffc$var$byteToHex[arr[offset + 0]] + $1a32167e8210dffc$var$byteToHex[arr[offset + 1]] + $1a32167e8210dffc$var$byteToHex[arr[offset + 2]] + $1a32167e8210dffc$var$byteToHex[arr[offset + 3]] + "-" + $1a32167e8210dffc$var$byteToHex[arr[offset + 4]] + $1a32167e8210dffc$var$byteToHex[arr[offset + 5]] + "-" + $1a32167e8210dffc$var$byteToHex[arr[offset + 6]] + $1a32167e8210dffc$var$byteToHex[arr[offset + 7]] + "-" + $1a32167e8210dffc$var$byteToHex[arr[offset + 8]] + $1a32167e8210dffc$var$byteToHex[arr[offset + 9]] + "-" + $1a32167e8210dffc$var$byteToHex[arr[offset + 10]] + $1a32167e8210dffc$var$byteToHex[arr[offset + 11]] + $1a32167e8210dffc$var$byteToHex[arr[offset + 12]] + $1a32167e8210dffc$var$byteToHex[arr[offset + 13]] + $1a32167e8210dffc$var$byteToHex[arr[offset + 14]] + $1a32167e8210dffc$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $98dbfcf47d2aa778$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1a32167e8210dffc$export$2e2bcd8739ae039 = $1a32167e8210dffc$var$stringify;


function $9d6b13a2a5a8c65c$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $223ce62d92e952f1$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1a32167e8210dffc$export$2e2bcd8739ae039)(rnds);
}
var $9d6b13a2a5a8c65c$export$2e2bcd8739ae039 = $9d6b13a2a5a8c65c$var$v4;







const $253bab93fc68fb43$var$BROWSERS_WITHOUT_KEEPALIVE_SUPPORT = /firefox|fxios|deno/i;
const $253bab93fc68fb43$export$9e4ae37cd458911c = (fetch, config)=>{
    return {
        sendEvent: async (payload)=>{
            try {
                await fetch(`${config.baseURL}/actions/sdk`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                });
            } catch (error) {
                console.error("@slashid/slashid-sdk: failed to send event", {
                    error: error,
                    event: payload
                });
            }
        }
    };
};
const $253bab93fc68fb43$export$b4a760bcaae97034 = (config)=>{
    return {
        sendEvent: async (payload)=>{
            const blob = new Blob([
                JSON.stringify(payload)
            ], {
                type: "application/json"
            });
            navigator.sendBeacon(`${config.baseURL}/actions/sdk`, blob);
        }
    };
};
const $253bab93fc68fb43$export$406a9cc5152be3c5 = (fetch, config)=>{
    return {
        sendEvent: async (payload)=>{
            const noKeepAliveSupport = $253bab93fc68fb43$var$BROWSERS_WITHOUT_KEEPALIVE_SUPPORT.test(navigator.userAgent);
            try {
                await fetch(`${config.baseURL}/actions/sdk`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload),
                    keepalive: !noKeepAliveSupport
                });
            } catch (error) {
                console.error("@slashid/slashid-sdk: failed to send event", {
                    error: error,
                    event: payload
                });
            }
        }
    };
};


class $837680a10c4cc3c3$export$e2273de0aec30cd2 {
    createCorrelationID() {
        return (0, $9d6b13a2a5a8c65c$export$2e2bcd8739ae039)();
    }
    createEventMetadata({ location: location, userAgent: userAgent } = {
        location: "/",
        userAgent: ""
    }) {
        var _this_user;
        var _this_config_oid, _ref;
        return {
            organization_id: (_ref = (_this_config_oid = this.config.oid) !== null && _this_config_oid !== void 0 ? _this_config_oid : (_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.oid) !== null && _ref !== void 0 ? _ref : "",
            analytics_correlation_id: this.correlationId,
            window_location: location,
            user_agent: userAgent
        };
    }
    sendEvent(payload) {
        this.transport.sendEvent(payload);
    }
    trackPersonIdentified({ user: user }) {
        const personIdentifiedEvent = {
            event_name: (0, $d393f165a83b0afb$export$8e49444f78fbbdb8).PersonIdentifiedV1,
            person_id: user.ID
        };
        const payload = {
            ...this.createEventMetadata(),
            event_data: personIdentifiedEvent
        };
        this.sendEvent(payload);
    }
    trackPersonLoggedOut(e) {
        const user = new (0, $0a8aed675f99e0c3$export$d3bddec52a513503)(e.token, this.config);
        const personLoggedOut = {
            event_name: (0, $d393f165a83b0afb$export$8e49444f78fbbdb8).PersonLoggedOutV1,
            person_id: user.ID
        };
        const payload = {
            ...this.createEventMetadata(),
            event_data: personLoggedOut
        };
        this.sendEvent(payload);
    }
    /**
     * Identifies a user for the purpose of user activity tracking. Where possible
     * user identification is done automatically.
     *
     * @param user The user being identified.
     */ identify(user) {
        this.user = user;
        this.trackPersonIdentified({
            user: user
        });
    }
    /**
     * Logs the user out from the point-of-view of the {@link Types.BaseAnalytics} class only,
     * this method does not have a side-effect which affects the logged in state of the user.
     *
     * After removing a stored token this method should be called to record the log out event.
     */ logout() {
        const user = this.user;
        if (!user) return;
        this.trackPersonLoggedOut({
            token: user.token
        });
        this.user = undefined;
    }
    /**
     * Tracks a virtual page view
     *
     * A virtual page view allows you to track a page view, even when a page is not physically
     * loaded in the browser. For example, when navigating using a client-side router in a
     * single page application, or navigating within a sub-section of a page (like a tabbed pane,
     * or navigation drawer) without changing the page itself.
     *
     * The exact meaning of a virtual page view will vary by implementation, it depends on your
     * routing paradigm and what you're trying to track. You will need to implement this event
     * in a way which makes sense for your product.
     *
     * @param options.url The URL of the page to track as the subject of the virtual page view.
     */ trackVirtualPageView(options) {
        const { url: url = "" } = options;
        const virtualPageLoadEvent = {
            event_name: (0, $d393f165a83b0afb$export$8e49444f78fbbdb8).VirtualPageLoadedV1,
            ...this.user && {
                person_id: this.user.ID
            }
        };
        var _options_userAgent;
        const payload = {
            ...this.createEventMetadata({
                location: url,
                userAgent: (_options_userAgent = options.userAgent) !== null && _options_userAgent !== void 0 ? _options_userAgent : ""
            }),
            event_data: virtualPageLoadEvent
        };
        this.sendEvent(payload);
    }
    constructor({ options: options, user: user, transport: transport }){
        if (options) (0, $561d3dd760db35d2$export$7586e69c60094c9d)(options);
        this.config = (0, $561d3dd760db35d2$export$851d251ce7109e65)(options !== null && options !== void 0 ? options : {});
        this.transport = transport !== null && transport !== void 0 ? transport : (0, $253bab93fc68fb43$export$9e4ae37cd458911c)(fetch, this.config);
        this.eventsAPI = new (0, $6d6044a55374bf35$export$9d7eae2d04d44e94)(new (0, $168d06aed8b3cdb0$export$fa89be98fe0936f2)({
            ...(0, $168d06aed8b3cdb0$export$ac4f8128ea29c5),
            basePath: this.config.baseURL
        }));
        this.user = user;
        // how do we keep this in sync with the server side
        this.correlationId = this.createCorrelationID();
    }
}





class $ae675a4b3b3cae53$export$a7b0438860379c35 extends (0, $837680a10c4cc3c3$export$e2273de0aec30cd2) {
    createCorrelationID() {
        const CORRELATION_ID_STORAGE_KEY = "@slashid/EVENTS_CORRELATION_ID";
        try {
            const storedCorrelationID = sessionStorage.getItem(CORRELATION_ID_STORAGE_KEY);
            if (storedCorrelationID) return storedCorrelationID;
        } catch  {
        // web storage is not available
        }
        const correlationID = (0, $9d6b13a2a5a8c65c$export$2e2bcd8739ae039)();
        try {
            sessionStorage.setItem(CORRELATION_ID_STORAGE_KEY, correlationID);
        } catch  {
        // web storage is not available
        }
        return correlationID;
    }
    createEventMetadata({ location: location, userAgent: userAgent } = {
        location: window.location.href,
        userAgent: navigator.userAgent
    }) {
        return super.createEventMetadata({
            location: location,
            userAgent: userAgent
        });
    }
    subscribeToDomainEvents() {
        this.sdk.subscribe("idFlowSucceeded", (e)=>this.trackAuthenticationSuccess(e));
        this.sdk.subscribe("idFlowFailed", (e)=>this.trackAuthenticationFailure(e));
        this.sdk.subscribe("invalidPasswordSubmitted", (e)=>this.trackAuthenticationFailure({
                ...e,
                errorText: "invalid_password"
            }));
        this.sdk.subscribe("incorrectPasswordSubmitted", (e)=>this.trackAuthenticationFailure({
                ...e,
                errorText: "incorrect_password"
            }));
        this.sdk.subscribe("otpIncorrectCodeSubmitted", (e)=>{
            var _e_factor;
            const reason = (()=>{
                var _e_factor, _e_factor1;
                if (((_e_factor = e.factor) === null || _e_factor === void 0 ? void 0 : _e_factor.method) === "otp_via_email") return "incorrect_otp_code_via_email";
                if (((_e_factor1 = e.factor) === null || _e_factor1 === void 0 ? void 0 : _e_factor1.method) === "otp_via_sms") return "incorrect_otp_code_via_sms";
                return "incorrect_otp_code";
            })();
            this.trackAuthenticationFailure({
                errorText: reason,
                authenticationFactor: {
                    method: (_e_factor = e.factor) === null || _e_factor === void 0 ? void 0 : _e_factor.method
                },
                challengeId: e.challengeId
            });
        });
        const internal = (0, $708a5f26294b10cd$export$5f74d2b45f2a2732)(this.sdk);
        internal.subscribe("clientSideError", (event)=>{
            this.trackAuthenticationFailure({
                ...event,
                errorText: "client_side_error"
            });
        });
    }
    trackAuthenticationSuccess(e) {
        var _e_authenticationFactor;
        const user = this.sdk.getUser(e.token);
        this.identify(user);
        const authenticationSucceededEvent = {
            event_name: (0, $d393f165a83b0afb$export$8e49444f78fbbdb8).AuthenticationSucceededV1,
            person_id: user.ID,
            success_authn_method: (_e_authenticationFactor = e.authenticationFactor) === null || _e_authenticationFactor === void 0 ? void 0 : _e_authenticationFactor.method,
            authenticated_methods: user.authentication,
            ...e.handle && {
                handle: e.handle
            }
        };
        const payload = {
            ...this.createEventMetadata(),
            event_data: authenticationSucceededEvent
        };
        this.sendEvent(payload);
    }
    trackAuthenticationFailure(e) {
        var _e_authenticationFactor;
        const user = e.previousToken ? this.sdk.getUser(e.previousToken) : this.user;
        const authenticationFailedEvent = {
            event_name: (0, $d393f165a83b0afb$export$8e49444f78fbbdb8).AuthenticationFailedV1,
            failed_authn_method: (_e_authenticationFactor = e.authenticationFactor) === null || _e_authenticationFactor === void 0 ? void 0 : _e_authenticationFactor.method,
            authenticated_methods: user === null || user === void 0 ? void 0 : user.authentication,
            failure_reason: e.errorText,
            ...e.handle && {
                handle: e.handle
            },
            ...e.challengeId && {
                challenge_id: e.challengeId
            },
            ...e.failureDetail && {
                failure_detail: e.failureDetail
            },
            ...user && {
                person_id: user.ID
            }
        };
        const payload = {
            ...this.createEventMetadata(),
            event_data: authenticationFailedEvent
        };
        this.sendEvent(payload);
    }
    trackSdkLoaded() {
        const payload = {
            ...this.createEventMetadata(),
            event_data: {
                event_name: (0, $d393f165a83b0afb$export$8e49444f78fbbdb8).SlashIdsdkLoadedV1
            }
        };
        this.sendEvent(payload);
    }
    /**
     * Tracks a virtual page view
     *
     * A virtual page view allows you to track a page view, even when a page is not physically
     * loaded in the browser. For example, when navigating using a client-side router in a
     * single page application, or navigating within a sub-section of a page (like a tabbed pane,
     * or navigation drawer) without changing the page itself.
     *
     * The exact meaning of a virtual page view will vary by implementation, it depends on your
     * routing paradigm and what you're trying to track. You will need to implement this event
     * in a way which makes sense for your product.
     *
     * @param options.url The URL of the page to track as the subject of the virtual page view.
     */ trackVirtualPageView(options) {
        const { url: url = window.location.href, userAgent: userAgent = navigator.userAgent } = options;
        super.trackVirtualPageView({
            url: url,
            userAgent: userAgent
        });
    }
    constructor({ sdk: sdk, user: user }){
        const options = {
            oid: sdk.oid,
            baseURL: sdk.baseURL,
            sdkURL: sdk.sdkURL,
            analyticsEnabled: true
        };
        const config = (0, $561d3dd760db35d2$export$851d251ce7109e65)(options);
        super({
            options: options,
            user: user,
            transport: (0, $253bab93fc68fb43$export$406a9cc5152be3c5)(fetch, config)
        });
        this.sdk = sdk;
        this.subscribeToDomainEvents();
        this.trackSdkLoaded();
    }
}


















function $d1a645aed26b74f9$export$7cd497ab1d81979(rule) {
    var _rule_pattern_qualifiers;
    const flags = (_rule_pattern_qualifiers = rule.pattern_qualifiers) === null || _rule_pattern_qualifiers === void 0 ? void 0 : _rule_pattern_qualifiers.reduce((acc, flag)=>{
        if (flag === "case_insensitive") return acc + "i";
        return acc;
    }, "");
    const regexp = new RegExp(rule.pattern, flags);
    return regexp;
}
function $d1a645aed26b74f9$export$633e2a16484dff95(challenge) {
    // right now we only support Regex rules
    const regexRules = challenge.options.validation_rules.regular_expressions;
    if (!regexRules) return [];
    const rules = regexRules.map((rule)=>{
        const regexp = $d1a645aed26b74f9$export$7cd497ab1d81979(rule);
        return {
            type: "regex",
            name: rule.name,
            regexp: regexp,
            matchType: rule.match_type
        };
    });
    return rules;
}
function $d1a645aed26b74f9$export$a22775fa5e2eebd9({ password: password, rules: rules }) {
    const failedRules = [];
    rules.forEach((rule)=>{
        const match = rule.regexp.test(password);
        if (match && rule.matchType === "must_not_match") failedRules.push(rule);
        else if (!match && rule.matchType === "must_match") failedRules.push(rule);
    });
    if (failedRules.length === 0) return {
        valid: true,
        failedRules: []
    };
    return {
        valid: false,
        failedRules: failedRules
    };
}



const $d4f5d8469042fea9$var$OTP_CHALLENGES = new Set([
    $6efd4ce2feb2bdc3$export$7962c6bffc1da42.Otp,
    $6efd4ce2feb2bdc3$export$7962c6bffc1da42.TotpRegister,
    $6efd4ce2feb2bdc3$export$7962c6bffc1da42.TotpVerify
]);
function $d4f5d8469042fea9$export$4502c327d844b59c(challenge) {
    return $d4f5d8469042fea9$var$OTP_CHALLENGES.has(challenge);
}
class $d4f5d8469042fea9$export$3b603621c2caaf6c {
    listenForEvents() {
        this.emitter.on("flowCancelled", ()=>{
            this.flowCancelled = true;
        });
    }
    updateClient(token) {
        this.authnClient = new $8dabc67a561e7dc0$export$872437fb2a17cd0e(new (0, $168d06aed8b3cdb0$export$fa89be98fe0936f2)({
            ...(0, $168d06aed8b3cdb0$export$ac4f8128ea29c5),
            basePath: this.slashID.baseURL,
            middleware: [
                (0, $91df54dff839f8b0$export$ee3eb40e76801bba)({
                    maxRetries: 5,
                    baseDelayMs: 500
                })
            ],
            ...token && {
                accessToken: token
            }
        }));
    }
    async processChallenges({ challenges: challenges, authnFactor: authnFactor, previousToken: previousToken }) {
        this.updateClient(previousToken);
        this.authnFactor = authnFactor;
        let userToken = undefined;
        // TODO make sure the challenge detail is added to the error if it happens
        for (const ch of challenges)userToken = await this.process(ch, this.authnFactor);
        // clear auth factor
        this.authnFactor = undefined;
        if (!userToken) throw new Error("no user token in attestation response");
        return userToken;
    }
    async process(challenge, authnFactor) {
        let attestation;
        switch(challenge.type){
            case $6efd4ce2feb2bdc3$export$7962c6bffc1da42.AuthnContextUpdate:
                return this.processAuthnContextUpdateChallenge(challenge);
            case $6efd4ce2feb2bdc3$export$7962c6bffc1da42.Proxy:
                return this.processProxyChallenge(challenge);
            case $6efd4ce2feb2bdc3$export$7962c6bffc1da42.Nonce:
                attestation = await this.processNonceChallenge(challenge);
                break;
            case $6efd4ce2feb2bdc3$export$7962c6bffc1da42.Otp:
                {
                    const otpOpts = new (0, $561d3dd760db35d2$export$1fd9c30e1b817ee4)(authnFactor === null || authnFactor === void 0 ? void 0 : authnFactor.options);
                    attestation = await this.processOTPChallenge(challenge, otpOpts);
                    break;
                }
            case $6efd4ce2feb2bdc3$export$7962c6bffc1da42.TotpRegister:
                attestation = await this.processTOTPRegisterChallenge(challenge);
                break;
            case $6efd4ce2feb2bdc3$export$7962c6bffc1da42.TotpVerify:
                attestation = await this.processTOTPVerifyChallenge(challenge);
                break;
            case $6efd4ce2feb2bdc3$export$7962c6bffc1da42.WebauthnGet:
                attestation = await this.processWebAuthnGetChallenge(challenge);
                break;
            case $6efd4ce2feb2bdc3$export$7962c6bffc1da42.WebauthnCreate:
                attestation = await this.processWebAuthnCreateChallenge(challenge);
                break;
            case $6efd4ce2feb2bdc3$export$7962c6bffc1da42.Oidc:
                return this.processOIDCChallenge(challenge, authnFactor);
            case $6efd4ce2feb2bdc3$export$7962c6bffc1da42.Saml:
                return this.processSAMLChallenge(challenge, authnFactor);
            case $6efd4ce2feb2bdc3$export$7962c6bffc1da42.PasswordSet:
                attestation = await this.processPasswordSetChallenge(challenge);
                break;
            case $6efd4ce2feb2bdc3$export$7962c6bffc1da42.PasswordVerify:
                attestation = await this.processPasswordVerifyChallenge(challenge);
                break;
            case $6efd4ce2feb2bdc3$export$7962c6bffc1da42.PasswordReset:
                attestation = await this.processPasswordResetChallenge(challenge);
                break;
            case $6efd4ce2feb2bdc3$export$7962c6bffc1da42.UiCustomization:
                return this.processUiCustomizationChallenge(challenge);
            default:
                console.warn("Please update the SDK to the latest version. Ignoring unhandled challenge type: " + JSON.stringify(challenge));
                return "";
        }
        let response;
        let headers;
        let originalError;
        try {
            const resp = await this.authnClient.postAttestationV3Raw({
                // @ts-expect-error challenge_type is typed as possible undefined
                attestation: attestation,
                slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw
            }, {
                cache: "no-cache"
            });
            response = await resp.value();
            headers = resp.raw.headers;
        } catch (e) {
            if ($60b6642fd39ba43b$export$a98b3b17ec378e54(e)) {
                response = await e.response.clone().json();
                headers = e.response.headers;
                originalError = e;
            } else throw e;
        }
        const headersIncludesLocation = headers.has("location");
        if (headersIncludesLocation) {
            const redirectUri = headers.get("location");
            if (typeof redirectUri === "string" && Boolean(redirectUri)) this.emitter.emit({
                name: "redirectUriDiscovered",
                payload: {
                    redirectUri: redirectUri
                },
                meta: {
                    access: "public"
                }
            });
        }
        if ($60b6642fd39ba43b$export$5f71bfa25cb0590e(response) && response.errors.length) {
            // retryable errors
            if (response.errors[0].httpcode === 400 && challenge.type === $6efd4ce2feb2bdc3$export$7962c6bffc1da42.PasswordSet) {
                // password validation failed server side
                this.notifySlashID("invalidPasswordSubmitted", {
                    failedRules: [],
                    authenticationFactor: authnFactor,
                    challengeId: challenge.id,
                    failureDetail: response.errors[0].message
                });
                return this.process(challenge, authnFactor);
            }
            if (response.errors[0].httpcode === 401 && challenge.type === $6efd4ce2feb2bdc3$export$7962c6bffc1da42.PasswordVerify) {
                // password does not match what is recorded for the given handle
                this.notifySlashID("incorrectPasswordSubmitted", {
                    authenticationFactor: authnFactor,
                    challengeId: challenge.id,
                    failureDetail: response.errors[0].message
                });
                return this.process(challenge, authnFactor);
            }
            if (response.errors[0].httpcode === 401 && $d4f5d8469042fea9$export$4502c327d844b59c(challenge.type)) {
                // unlike all other challenges OTPs are potentially subject to user errors => retry on Unauthorized
                this.notifySlashID("otpIncorrectCodeSubmitted", {
                    factor: authnFactor,
                    challengeId: challenge.id
                });
                return this.process(challenge, authnFactor);
            }
            const sidError = await $60b6642fd39ba43b$export$ed0b6181311676c(originalError);
            throw sidError;
        }
        const userToken = response.result.token;
        if (!userToken) throw new Error("no user token in attestation response");
        if (challenge.type === $6efd4ce2feb2bdc3$export$7962c6bffc1da42.WebauthnCreate) {
            const options = challenge.options;
            this.slashID.credentialStorage.add(options.rp.id, attestation.data.rawId);
        }
        return userToken;
    }
    async processProxyChallenge(challenge) {
        let userToken = undefined;
        while(!userToken){
            if (this.flowCancelled) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
                name: $91e59605951c3712$export$daceac3b97803ce1.flowCancelled,
                message: "The flow has been cancelled!",
                context: {
                    challenge: challenge
                }
            });
            await $be25baf6593a301c$export$e772c8ff12451969(1000);
            // TODO review
            const response = await this.authnClient.getChallengeChallengeIdV2({
                challengeId: challenge.options.challenge_id,
                slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw
            }, {
                cache: "no-cache"
            });
            if (response.errors) {
                if (response.errors.length !== 1 || response.errors[0].httpcode !== 202) throw response;
            }
            userToken = response.result;
        }
        return userToken;
    }
    /**
     * When the server sends an AuthnContextUpdateChallenge, the client can subscribe to this event so it can update the authn context
     */ async processAuthnContextUpdateChallenge(challenge) {
        this.notifySlashID("authnContextUpdateChallengeReceivedEvent", {
            targetOrgId: challenge.options.target_org_id,
            factor: challenge.options.factor
        });
        // update the internal context
        if (challenge.options.factor) {
            this.authnFactor = challenge.options.factor;
            // SSO - client side effects
            switch(this.authnFactor.method){
                case $d180e6976bd68c99$export$8279f5e63c6521d8.Oidc:
                    this.authnFactor = await (0, $561d3dd760db35d2$export$af64486b3e452a98)(this.authnFactor);
                    break;
                case $d180e6976bd68c99$export$8279f5e63c6521d8.Saml:
                    this.authnFactor = await (0, $561d3dd760db35d2$export$98f5d2f2dc6acbbd)(this.authnFactor);
                    break;
            }
        }
        // this should never be the final challenge
        return "";
    }
    async processNonceChallenge(challenge) {
        var _challenge_options;
        const attestation = {
            challenge_id: challenge.id,
            challenge_type: challenge.type,
            data: {
                challenge: (_challenge_options = challenge.options) === null || _challenge_options === void 0 ? void 0 : _challenge_options.challenge
            }
        };
        return attestation;
    }
    shouldProcessEvent(event) {
        var _this_flowMeta, _event_meta, _this_flowMeta1, _event_meta1;
        if (!event.meta) return true;
        if (!event.meta.authFlowId && !event.meta.recoveryFlowId) return true;
        if (((_this_flowMeta = this.flowMeta) === null || _this_flowMeta === void 0 ? void 0 : _this_flowMeta.authFlowId) && ((_event_meta = event.meta) === null || _event_meta === void 0 ? void 0 : _event_meta.authFlowId) !== this.flowMeta.authFlowId) return false;
        if (((_this_flowMeta1 = this.flowMeta) === null || _this_flowMeta1 === void 0 ? void 0 : _this_flowMeta1.recoveryFlowId) && ((_event_meta1 = event.meta) === null || _event_meta1 === void 0 ? void 0 : _event_meta1.recoveryFlowId) !== this.flowMeta.recoveryFlowId) return false;
        return true;
    }
    async processOTPChallenge(challenge, otpFactorOptions) {
        this.notifySlashID("otpSmsSent");
        this.notifySlashID("otpCodeSent");
        const handleOtpInput = new Promise((resolve)=>{
            const getOtp = (event)=>{
                if (!this.shouldProcessEvent(event)) return;
                // @ts-expect-error payload types do not match because of string & void types
                this.emitter.off("otpCodeSubmitted", getOtp);
                resolve(event.payload);
            };
            // @ts-expect-error payload types do not match because of string & void types
            this.emitter.on("otpCodeSubmitted", getOtp);
        });
        // backward compatibility - in case a client sends in getOTP we wrap it with the event
        if (typeof otpFactorOptions.getOTP === "function") otpFactorOptions.getOTP().then((otp)=>this.notifySlashID("otpCodeSubmitted", otp));
        const otpCode = await handleOtpInput;
        if (!otpCode) throw new Error("no OTP code provided");
        const attestation = {
            challenge_id: challenge.id,
            challenge_type: challenge.type,
            data: {
                otp: otpCode
            }
        };
        return attestation;
    }
    async processTOTPRegisterChallenge(challenge) {
        var _challenge_options, _challenge_options1, _challenge_options2;
        this.notifySlashID("totpKeyGenerated", {
            uri: (_challenge_options = challenge.options) === null || _challenge_options === void 0 ? void 0 : _challenge_options.key_uri,
            qrCode: (_challenge_options1 = challenge.options) === null || _challenge_options1 === void 0 ? void 0 : _challenge_options1.qr_code_data_b64,
            recoveryCodes: (_challenge_options2 = challenge.options) === null || _challenge_options2 === void 0 ? void 0 : _challenge_options2.recovery_codes
        });
        const handleTotpInput = new Promise((resolve)=>{
            const getOtp = (event)=>{
                if (!this.shouldProcessEvent(event)) return;
                // @ts-expect-error payload types do not match because of string & void types
                this.emitter.off("otpCodeSubmitted", getOtp);
                resolve(event.payload);
            };
            // @ts-expect-error payload types do not match because of string & void types
            this.emitter.on("otpCodeSubmitted", getOtp);
        });
        const totpCode = await handleTotpInput;
        if (!totpCode) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: $91e59605951c3712$export$daceac3b97803ce1.invalidActionError,
            message: "no TOTP code provided",
            context: {
                challengeId: challenge.id
            }
        });
        const attestation = {
            challenge_id: challenge.id,
            challenge_type: challenge.type,
            data: {
                otp: totpCode
            }
        };
        return attestation;
    }
    async processTOTPVerifyChallenge(challenge) {
        this.notifySlashID("totpCodeRequested");
        const handleTotpInput = new Promise((resolve)=>{
            const getOtp = (event)=>{
                if (!this.shouldProcessEvent(event)) return;
                // @ts-expect-error payload types do not match because of string & void types
                this.emitter.off("otpCodeSubmitted", getOtp);
                resolve(event.payload);
            };
            // @ts-expect-error payload types do not match because of string & void types
            this.emitter.on("otpCodeSubmitted", getOtp);
        });
        const totpCode = await handleTotpInput;
        if (!totpCode) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: $91e59605951c3712$export$daceac3b97803ce1.invalidActionError,
            message: "no TOTP code provided",
            context: {
                challengeId: challenge.id
            }
        });
        const attestation = {
            challenge_id: challenge.id,
            challenge_type: challenge.type,
            data: {
                otp: totpCode
            }
        };
        return attestation;
    }
    async processWebAuthnGetChallenge(challenge) {
        // Calling WebAuthn API needs focus
        const hadFocus = await $185870848aa59297$export$d245da411ccc251b();
        const options = challenge.options;
        if (!this.slashID.isLocalScope(options.rpId)) {
            const sdkURL = this.slashID.getSDKUrl();
            let sdkWindow;
            if (await (0, $708a5f26294b10cd$export$261888861cdb8a55).canGetPublicKeyCredentialsInIFrame()) {
                sdkWindow = this.slashID.iframe.contentWindow;
                if (!sdkWindow) throw new Error("cannot get global id iframe");
            } else {
                // Empirically if we don't wait here the "popup"
                // on Chrome is created but doesn't get focus
                if (!hadFocus) await $be25baf6593a301c$export$e772c8ff12451969(200);
                // no target, features args => should open a tab, not a popup
                sdkWindow = window.open(sdkURL.toString());
                if (!sdkWindow) throw new Error("cannot open global id window");
            }
            const attestationPromise = new Promise((resolve, reject)=>{
                const request = new $6c3db34ca8f899b2$export$b2a6577196c1aa92({
                    baseURL: this.slashID.baseURL,
                    sdkURL: this.slashID.sdkURL
                }, challenge);
                const responseListener = (event)=>{
                    const response = event.data;
                    if (response.id !== request.id) return;
                    // has no effect on an IFrame
                    sdkWindow.close();
                    window.removeEventListener("message", responseListener);
                    if (response.error) reject(response.error);
                    else resolve(response.attestation);
                };
                window.addEventListener("message", responseListener);
                // TODO handle retries
                $98dcef32dd30b893$export$ccfc10b8bad1155a(sdkWindow).then((win)=>{
                    win.postMessage(request, sdkURL.origin);
                });
            });
            return attestationPromise;
        } else {
            const decodedOptions = {
                challenge: $aae5e813cb61d169$export$2f872c0f2117be69(options.challenge),
                extensions: options.extensions,
                rpId: options.rpId,
                timeout: options.timeout,
                userVerification: options.userVerification
            };
            const allowCredentials = options.allowCredentials;
            if (allowCredentials) {
                decodedOptions.allowCredentials = new Array(allowCredentials.length);
                for(let idx = 0; idx < allowCredentials.length; idx++){
                    const credential = allowCredentials[idx];
                    decodedOptions.allowCredentials[idx] = {
                        id: $aae5e813cb61d169$export$2f872c0f2117be69(credential.id),
                        type: credential.type,
                        transports: credential.transports
                    };
                }
            }
            const credential = await navigator.credentials.get({
                publicKey: decodedOptions
            });
            if (!credential) throw new Error("could not create assert credential");
            const attestationResponse = credential.response;
            const rawId = $aae5e813cb61d169$export$c564cdbbe6da493(new Uint8Array(credential.rawId));
            const encodedCredential = {
                id: credential.id,
                rawId: rawId,
                type: credential.type,
                clientExtensionResults: credential.getClientExtensionResults(),
                response: {
                    clientDataJSON: $aae5e813cb61d169$export$c564cdbbe6da493(new Uint8Array(attestationResponse.clientDataJSON)),
                    authenticatorData: $aae5e813cb61d169$export$c564cdbbe6da493(new Uint8Array(attestationResponse.authenticatorData)),
                    signature: $aae5e813cb61d169$export$c564cdbbe6da493(new Uint8Array(attestationResponse.signature)),
                    userHandle: attestationResponse.userHandle ? $aae5e813cb61d169$export$c564cdbbe6da493(new Uint8Array(attestationResponse.userHandle)) : null
                }
            };
            const attestation = {
                challenge_id: challenge.id,
                challenge_type: challenge.type,
                data: encodedCredential
            };
            this.notifySlashID("webAuthnChallengeProcessed", {
                credentialId: rawId
            });
            return attestation;
        }
    }
    async processWebAuthnCreateChallenge(challenge) {
        // Calling WebAuthn API needs focus
        const hadFocus = await $185870848aa59297$export$d245da411ccc251b();
        const options = challenge.options;
        if (!this.slashID.isLocalScope(options.rp.id)) {
            // Empirically if we don't wait here the "popup"
            // on Chrome is created but doesn't get focus
            if (!hadFocus) await $be25baf6593a301c$export$e772c8ff12451969(200);
            const attestationPromise = new Promise((resolve, reject)=>{
                const sdkURL = this.slashID.getSDKUrl();
                // no target, features args => should open a tab, not a popup
                const sdkWindow = window.open(sdkURL.toString());
                if (!sdkWindow) {
                    reject(new Error("cannot open global id window"));
                    return;
                }
                const request = new $6c3db34ca8f899b2$export$561665cd9d5caa15({
                    baseURL: this.slashID.baseURL,
                    sdkURL: this.slashID.sdkURL
                }, challenge);
                const responseListener = (event)=>{
                    const response = event.data;
                    if (response.id !== request.id) return;
                    sdkWindow.close();
                    window.removeEventListener("message", responseListener);
                    if (response.error) reject(response.error);
                    else resolve(response.attestation);
                };
                window.addEventListener("message", responseListener);
                // TODO handle retries
                $98dcef32dd30b893$export$ccfc10b8bad1155a(sdkWindow).then((win)=>{
                    win.postMessage(request, sdkURL.origin);
                });
            });
            return attestationPromise;
        } else {
            const decodedOptions = {
                challenge: $aae5e813cb61d169$export$2f872c0f2117be69(options.challenge),
                rp: options.rp,
                user: {
                    id: $aae5e813cb61d169$export$2f872c0f2117be69(options.user.id),
                    name: options.user.name,
                    displayName: options.user.displayName
                },
                pubKeyCredParams: options.pubKeyCredParams,
                authenticatorSelection: options.authenticatorSelection,
                timeout: options.timeout,
                extensions: options.extensions,
                attestation: options.attestation
            };
            const excludeCredentials = options.excludeCredentials;
            if (excludeCredentials) {
                decodedOptions.excludeCredentials = new Array(excludeCredentials.length);
                for(let idx = 0; idx < excludeCredentials.length; idx++){
                    const credential = excludeCredentials[idx];
                    decodedOptions.excludeCredentials[idx] = {
                        id: $aae5e813cb61d169$export$2f872c0f2117be69(credential.id),
                        type: credential.type,
                        transports: credential.transports
                    };
                }
            }
            const credential = await navigator.credentials.create({
                publicKey: decodedOptions
            });
            if (!credential) throw new Error("cannot create credential");
            const attestationResponse = credential.response;
            const rawId = $aae5e813cb61d169$export$c564cdbbe6da493(new Uint8Array(credential.rawId));
            const encodedCredential = {
                id: credential.id,
                rawId: rawId,
                type: credential.type,
                clientExtensionResults: credential.getClientExtensionResults(),
                response: {
                    attestationObject: $aae5e813cb61d169$export$c564cdbbe6da493(new Uint8Array(attestationResponse.attestationObject)),
                    clientDataJSON: $aae5e813cb61d169$export$c564cdbbe6da493(new Uint8Array(attestationResponse.clientDataJSON))
                }
            };
            const attestation = {
                challenge_id: challenge.id,
                challenge_type: challenge.type,
                data: encodedCredential
            };
            this.notifySlashID("webAuthnChallengeProcessed", {
                credentialId: rawId
            });
            return attestation;
        }
    }
    async processOIDCChallenge(challenge, authenticationFactor) {
        if (authenticationFactor.options.ux_mode === $d978296a495364e5$export$947f28fa7e24f5f5.Popup) {
            var _challenge_options;
            const handle = authenticationFactor.extras.setPopupUrl(challenge.options.auth_code_url);
            if (!(challenge === null || challenge === void 0 ? void 0 : (_challenge_options = challenge.options) === null || _challenge_options === void 0 ? void 0 : _challenge_options.auth_code_url)) {
                var _challenge_options1;
                this.notifySlashID("oauthFlowFailed", {
                    ...authenticationFactor.options,
                    reason: $185870848aa59297$export$32deff8ed92da53f.BadOAuthURL
                });
                throw new Error(`Bad OAuth URL - got ${challenge === null || challenge === void 0 ? void 0 : (_challenge_options1 = challenge.options) === null || _challenge_options1 === void 0 ? void 0 : _challenge_options1.auth_code_url}`);
            }
            if (!handle) {
                this.notifySlashID("oauthFlowFailed", {
                    ...authenticationFactor.options,
                    reason: $185870848aa59297$export$32deff8ed92da53f.PopupBlocked
                });
                throw new Error("OIDC flow unsuccesful!");
            }
        } else if (authenticationFactor.options.ux_mode === $d978296a495364e5$export$947f28fa7e24f5f5.Redirect) window.location.assign(challenge.options.auth_code_url);
        else throw new Error(`Unsupported OAuth ux_mode - got ${authenticationFactor.options.ux_mode}`);
        this.notifySlashID("oauthFlowStarted", authenticationFactor.options);
        // no token yet - proxy challenge will result with a token
        return "";
    }
    async processSAMLChallenge(challenge, authenticationFactor) {
        if (authenticationFactor.options.ux_mode === $13463f5a948e6169$export$6dc0f627c99c13a9.Popup) {
            var _challenge_options;
            const popup = authenticationFactor.extras.setPopupUrl(challenge.options.start_authentication_url);
            if (!(challenge === null || challenge === void 0 ? void 0 : (_challenge_options = challenge.options) === null || _challenge_options === void 0 ? void 0 : _challenge_options.start_authentication_url)) {
                var _challenge_options1;
                this.notifySlashID("popupFailed", {
                    reason: $185870848aa59297$export$af2e6529191b5a73.BadAuthURL
                });
                throw new Error(`Bad authentication URL - got ${challenge === null || challenge === void 0 ? void 0 : (_challenge_options1 = challenge.options) === null || _challenge_options1 === void 0 ? void 0 : _challenge_options1.start_authentication_url}`);
            }
            if (!popup) {
                this.notifySlashID("popupFailed", {
                    reason: $185870848aa59297$export$af2e6529191b5a73.PopupBlocked
                });
                throw new Error("SAML flow unsuccesful!");
            }
        } else if (authenticationFactor.options.ux_mode === $13463f5a948e6169$export$6dc0f627c99c13a9.Redirect) window.location.assign(challenge.options.start_authentication_url);
        else throw new Error(`Unsupported SAML ux_mode - got ${authenticationFactor.options.ux_mode}`);
        // no token yet - proxy challenge will result with a token
        return "";
    }
    async processPasswordSetChallenge(challenge) {
        // let the client know the password input is ready
        this.notifySlashID("passwordSetReady");
        // wait for the client to submit the password
        const handlePasswordInput = new Promise((resolve)=>{
            const getPassword = (passwordEvent)=>{
                if (!this.shouldProcessEvent(passwordEvent)) return;
                // @ts-expect-error payload types do not match because of string & void types
                this.emitter.off("passwordSubmitted", getPassword);
                resolve(passwordEvent.payload);
            };
            // @ts-expect-error payload types do not match because of string & void types
            this.emitter.on("passwordSubmitted", getPassword);
        });
        const password = await handlePasswordInput;
        const passwordValidation = (0, $d1a645aed26b74f9$export$a22775fa5e2eebd9)({
            password: password,
            rules: (0, $d1a645aed26b74f9$export$633e2a16484dff95)(challenge)
        });
        if (!passwordValidation.valid) {
            this.notifySlashID("invalidPasswordSubmitted", {
                failedRules: passwordValidation.failedRules,
                challengeId: challenge.id,
                authenticationFactor: {
                    method: $d180e6976bd68c99$export$8279f5e63c6521d8.Password
                },
                failureDetail: `invalid_password: ${passwordValidation.failedRules.map((rule)=>rule.name).join(",")}`
            });
            return await this.processPasswordSetChallenge(challenge);
        }
        const attestation = {
            challenge_id: challenge.id,
            challenge_type: challenge.type,
            data: {
                password: password
            }
        };
        return attestation;
    }
    processPasswordVerifyChallenge(challenge) {
        // let the client know the password input is ready
        this.notifySlashID("passwordVerifyReady");
        // wait for the client to submit the password
        const handlePasswordInput = new Promise((resolve)=>{
            const getPassword = (passwordEvent)=>{
                if (!this.shouldProcessEvent(passwordEvent)) return;
                // @ts-expect-error payload types do not match because of string & void types
                this.emitter.off("passwordSubmitted", getPassword);
                resolve(passwordEvent.payload);
            };
            // @ts-expect-error payload types do not match because of string & void types
            this.emitter.on("passwordSubmitted", getPassword);
        });
        return handlePasswordInput.then((password)=>{
            if (!password) throw new Error("No password provided");
            const attestation = {
                challenge_id: challenge.id,
                challenge_type: challenge.type,
                data: {
                    password: password
                }
            };
            return attestation;
        });
    }
    /**
     * TODO complete copy paste of password set challenge
     * TODO write docs
     */ async processPasswordResetChallenge(challenge) {
        // let the client know the password input is ready
        this.notifySlashID("passwordResetReady");
        // wait for the client to submit the password
        const handlePasswordInput = new Promise((resolve)=>{
            const getPassword = (passwordEvent)=>{
                if (!this.shouldProcessEvent(passwordEvent)) return;
                // @ts-expect-error payload types do not match because of string & void types
                this.emitter.off("passwordSubmitted", getPassword);
                resolve(passwordEvent.payload);
            };
            // @ts-expect-error payload types do not match because of string & void types
            this.emitter.on("passwordSubmitted", getPassword);
        });
        const password = await handlePasswordInput;
        const passwordValidation = (0, $d1a645aed26b74f9$export$a22775fa5e2eebd9)({
            password: password,
            rules: (0, $d1a645aed26b74f9$export$633e2a16484dff95)(challenge)
        });
        if (!passwordValidation.valid) {
            this.notifySlashID("invalidPasswordSubmitted", {
                authenticationFactor: {
                    method: $d180e6976bd68c99$export$8279f5e63c6521d8.Password
                },
                failedRules: passwordValidation.failedRules,
                challengeId: challenge.id,
                failureDetail: `invalid_password: ${passwordValidation.failedRules.map((rule)=>rule.name).join(",")}`
            });
            return await this.processPasswordSetChallenge(challenge);
        }
        const attestation = {
            challenge_id: challenge.id,
            challenge_type: challenge.type,
            data: {
                password: password
            }
        };
        return attestation;
    }
    async processUiCustomizationChallenge(challenge) {
        var _challenge_options;
        const customizationProperties = (_challenge_options = challenge.options) === null || _challenge_options === void 0 ? void 0 : _challenge_options.authn_redirect_page_ui_config;
        if (!customizationProperties) throw new Error("No customization properties provided!");
        this.notifySlashID("uiCustomizationReceived", {
            customizationProperties: customizationProperties
        });
        // this challenge is processed at the beginning, before actual authentication
        return "";
    }
    constructor(slashID, emitter, flowMeta){
        this.flowCancelled = false;
        this.notifySlashID = (key, event)=>{
            // @ts-expect-error payload types do not match because of string & void types
            this.emitter.emit({
                name: key,
                payload: event,
                meta: {
                    access: "public",
                    ...this.flowMeta
                }
            });
        };
        // TODO do we need the whole config?
        this.slashID = slashID;
        this.authnClient = new $8dabc67a561e7dc0$export$872437fb2a17cd0e(new (0, $168d06aed8b3cdb0$export$fa89be98fe0936f2)({
            ...(0, $168d06aed8b3cdb0$export$ac4f8128ea29c5),
            basePath: this.slashID.baseURL,
            middleware: [
                (0, $91df54dff839f8b0$export$ee3eb40e76801bba)({
                    maxRetries: 5,
                    baseDelayMs: 500
                })
            ]
        }));
        this.emitter = emitter;
        this.flowMeta = flowMeta;
        this.listenForEvents();
    }
}







function $2593f0fc9dd6d83e$export$5fb04c0b31ecb34c(params) {
    // set up the client ID and redirect URI in the session storage
    window.sessionStorage.setItem((0, $962c828014ed43f3$export$fc7d295eacb42f43), params.clientId);
    window.sessionStorage.setItem((0, $962c828014ed43f3$export$9dfd5bd22831bc40), params.redirectUri);
}
function $2593f0fc9dd6d83e$export$a2218d2039ce5af0() {
    const clientId = window.sessionStorage.getItem((0, $962c828014ed43f3$export$fc7d295eacb42f43));
    const redirectUri = window.sessionStorage.getItem((0, $962c828014ed43f3$export$9dfd5bd22831bc40));
    if (!clientId || !redirectUri) // TODO make this a SlashID error
    throw new Error("Client ID or redirect URI not found in session storage");
    return {
        clientId: clientId,
        redirectUri: redirectUri
    };
}
function $2593f0fc9dd6d83e$export$8af8138ab9f57e02() {
    window.sessionStorage.removeItem((0, $962c828014ed43f3$export$fc7d295eacb42f43));
    window.sessionStorage.removeItem((0, $962c828014ed43f3$export$9dfd5bd22831bc40));
}
async function $2593f0fc9dd6d83e$export$9f45878548a7cf78() {
    const csrf_token = (0, $9d6b13a2a5a8c65c$export$2e2bcd8739ae039)();
    const pkce_code_verifier = (0, $9d6b13a2a5a8c65c$export$2e2bcd8739ae039)() + (0, $9d6b13a2a5a8c65c$export$2e2bcd8739ae039)() // recommended increased entropy
    ;
    const data = new TextEncoder().encode(pkce_code_verifier);
    const hash = await window.crypto.subtle.digest("SHA-256", data);
    const pkce_code_challenge = $aae5e813cb61d169$export$c564cdbbe6da493(new Uint8Array(hash));
    // TODO side effect, consider moving outside
    window.localStorage.setItem((0, $962c828014ed43f3$export$911cde4811331c58), csrf_token);
    window.localStorage.setItem((0, $962c828014ed43f3$export$3f272757255eeb30), pkce_code_verifier);
    return {
        csrf_token: csrf_token,
        pkce_code_challenge: pkce_code_challenge
    };
}
function $2593f0fc9dd6d83e$export$2a015c1c89819b5a(queryString) {
    const urlParams = new URLSearchParams(queryString);
    const ssoCode = urlParams.get("code");
    // TODO this is specific to our flow
    const csrfToken = urlParams.get("state");
    if (!ssoCode || !csrfToken) return null;
    return {
        ssoCode: ssoCode,
        csrfToken: csrfToken
    };
}
async function $2593f0fc9dd6d83e$export$64ca83e534616343(input) {
    const csrf_token = window.localStorage.getItem((0, $962c828014ed43f3$export$911cde4811331c58));
    const pkce_code_verifier = window.localStorage.getItem((0, $962c828014ed43f3$export$3f272757255eeb30));
    if (!csrf_token || !pkce_code_verifier) throw new Error("CSRF token or PKCE code verifier not found");
    if (csrf_token !== input.csrfToken) throw new Error("CSRF token mismatch");
    const payload = new URLSearchParams();
    payload.set("client_id", input.clientId);
    payload.set("code", input.ssoCode);
    payload.set("code_verifier", pkce_code_verifier);
    payload.set("grant_type", "authorization_code");
    payload.set("redirect_uri", input.redirectUri);
    // TODO proper error handling
    const response = await fetch(`${input.apiBaseURL}/oauth2/tokens`, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body: payload.toString()
    });
    if (!response.ok) // TODO throw proper error
    throw new Error("Failed to obtain access token");
    const data = await response.json();
    return data;
}


class $04c0a7b87d2e29c2$export$4d9fb5586e103031 {
    shouldProcessEvent(event) {
        var _event_meta;
        if (this.flowId && ((_event_meta = event.meta) === null || _event_meta === void 0 ? void 0 : _event_meta.authFlowId) !== this.flowId) return false;
        return true;
    }
    /**
     * Returns a User instance upon successful authentication.
     * If authContextUpdateEnabled flag is raised, login flow will block and wait until the corresponding ACK event is submitted.
     */ async _id({ oid: oid, authenticationFactor: authenticationFactor, handle: handle, prevToken: prevToken }) {
        if (authenticationFactor) switch(authenticationFactor.method){
            case $d180e6976bd68c99$export$8279f5e63c6521d8.Webauthn.toString():
                {
                    if (!(navigator && window.PublicKeyCredential)) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
                        name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidAuthenticationMethodError,
                        message: "The WebAuthn API is not available in the current environment",
                        context: {
                            method: $d180e6976bd68c99$export$8279f5e63c6521d8.Webauthn,
                            handle: handle,
                            authenticationFactor: authenticationFactor
                        }
                    });
                    let opts = authenticationFactor.options;
                    if (!opts) opts = {};
                    // default to local scope
                    if (!opts.scope) opts.scope = window.location.hostname;
                    const knownCredIds = await this.slashID.credentialStorage.get(opts.scope);
                    if (knownCredIds) opts.available_credential_ids = knownCredIds;
                    // fallback to default SlashID WebAuthn options if not provided explicitly
                    if (!opts.attachment) opts.attachment = $db804c8fc7fc378a$export$51952aaa367c79db.Any;
                    if (!opts.user_verification) opts.user_verification = $4422b127d07e08ac$export$1bc598454e9d0dfc.Preferred;
                    if (!opts.resident_key) opts.resident_key = $5d22f1c59e3d2c7d$export$df3e12f65ba023ba.Preferred;
                    if (!opts.attestation) opts.attestation = $fd99e17397a87416$export$c1ff3c79d2429507.None;
                    if (opts.attachment === $db804c8fc7fc378a$export$51952aaa367c79db.Platform) {
                        const hasPlatformAuthenticator = await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
                        if (!hasPlatformAuthenticator) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
                            name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidAuthenticationMethodError,
                            message: "This device has no platform authenticator available",
                            context: {
                                method: $d180e6976bd68c99$export$8279f5e63c6521d8.Webauthn,
                                handle: handle,
                                authenticationFactor: authenticationFactor
                            }
                        });
                    }
                    authenticationFactor.options = opts;
                }
                break;
            case $d180e6976bd68c99$export$8279f5e63c6521d8.EmailLink.toString():
            case $d180e6976bd68c99$export$8279f5e63c6521d8.OtpViaEmail.toString():
                if (handle && handle.type !== $1221773f83e5dbf8$export$885886f088cd0586.EmailAddress) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
                    name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidAuthenticationMethodError,
                    message: `A handle of type '${$1221773f83e5dbf8$export$885886f088cd0586.EmailAddress}' is required, got '${handle.type}' instead`,
                    context: {
                        method: $d180e6976bd68c99$export$8279f5e63c6521d8.EmailLink,
                        handle: handle,
                        authenticationFactor: authenticationFactor
                    }
                });
                break;
            case $d180e6976bd68c99$export$8279f5e63c6521d8.SmsLink.toString():
            case $d180e6976bd68c99$export$8279f5e63c6521d8.OtpViaSms.toString():
                if (handle && handle.type !== $1221773f83e5dbf8$export$885886f088cd0586.PhoneNumber) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
                    name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidAuthenticationMethodError,
                    message: `A handle of type '${$1221773f83e5dbf8$export$885886f088cd0586.PhoneNumber}' is required, got '${handle.type}' instead`,
                    context: {
                        method: $d180e6976bd68c99$export$8279f5e63c6521d8.SmsLink,
                        handle: handle,
                        authenticationFactor: authenticationFactor
                    }
                });
                authenticationFactor.options = new (0, $561d3dd760db35d2$export$1fd9c30e1b817ee4)(authenticationFactor.options);
                break;
            case $d180e6976bd68c99$export$8279f5e63c6521d8.Oidc.toString():
                {
                    //OIDC should not be used with handles
                    if (handle) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
                        name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidAuthenticationMethodError,
                        message: "OIDC should not be used with handles",
                        context: {
                            method: $d180e6976bd68c99$export$8279f5e63c6521d8.Oidc,
                            handle: handle,
                            authenticationFactor: authenticationFactor
                        }
                    });
                    authenticationFactor = await (0, $561d3dd760db35d2$export$af64486b3e452a98)(authenticationFactor);
                    const cleanUpAfterError = (event)=>{
                        var _oidcOptions_extras, _oidcOptions_extras1;
                        if (!this.shouldProcessEvent(event)) return;
                        const oidcOptions = authenticationFactor;
                        if (oidcOptions === null || oidcOptions === void 0 ? void 0 : (_oidcOptions_extras = oidcOptions.extras) === null || _oidcOptions_extras === void 0 ? void 0 : _oidcOptions_extras.popup) oidcOptions === null || oidcOptions === void 0 ? void 0 : (_oidcOptions_extras1 = oidcOptions.extras) === null || _oidcOptions_extras1 === void 0 ? void 0 : _oidcOptions_extras1.popup.close();
                        this.emitter.off("oauthFlowFailed", cleanUpAfterError);
                    };
                    this.emitter.on("oauthFlowFailed", cleanUpAfterError);
                }
                break;
            case $d180e6976bd68c99$export$8279f5e63c6521d8.Saml.toString():
                {
                    if (handle) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
                        name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidAuthenticationMethodError,
                        message: "SAML should not be used with handles",
                        context: {
                            method: $d180e6976bd68c99$export$8279f5e63c6521d8.Saml,
                            handle: handle,
                            authenticationFactor: authenticationFactor
                        }
                    });
                    authenticationFactor = await (0, $561d3dd760db35d2$export$98f5d2f2dc6acbbd)(authenticationFactor);
                    const cleanUpAfterError = (event)=>{
                        var _saml_extras, _saml_extras1;
                        if (!this.shouldProcessEvent(event)) return;
                        const saml = authenticationFactor;
                        if (saml === null || saml === void 0 ? void 0 : (_saml_extras = saml.extras) === null || _saml_extras === void 0 ? void 0 : _saml_extras.popup) saml === null || saml === void 0 ? void 0 : (_saml_extras1 = saml.extras) === null || _saml_extras1 === void 0 ? void 0 : _saml_extras1.popup.close();
                        this.emitter.off("popupFailed", cleanUpAfterError);
                    };
                    this.emitter.on("popupFailed", cleanUpAfterError);
                }
                break;
            default:
                break;
        }
        const factor = {
            method: authenticationFactor === null || authenticationFactor === void 0 ? void 0 : authenticationFactor.method,
            options: authenticationFactor === null || authenticationFactor === void 0 ? void 0 : authenticationFactor.options
        };
        if (factor.method !== undefined) factor.options = {
            ...factor.options,
            method: factor.method
        };
        this.emitter.emit({
            name: "idFlowStarted",
            payload: {
                authenticationFactor: authenticationFactor
            },
            meta: {
                authFlowId: this.flowId,
                access: "public"
            }
        });
        const authnClient = new $8dabc67a561e7dc0$export$872437fb2a17cd0e(new (0, $168d06aed8b3cdb0$export$fa89be98fe0936f2)({
            ...(0, $168d06aed8b3cdb0$export$ac4f8128ea29c5),
            basePath: this.slashID.baseURL,
            middleware: [
                (0, $91df54dff839f8b0$export$ee3eb40e76801bba)({
                    maxRetries: 5,
                    baseDelayMs: 500
                })
            ],
            ...prevToken && {
                accessToken: prevToken
            }
        }));
        const metadata = await (0, $2593f0fc9dd6d83e$export$9f45878548a7cf78)();
        const response = await authnClient.postIdV2({
            slashIDOrgID: oid,
            slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw,
            iDRequestV2: {
                handle: handle,
                factor: factor,
                metadata: metadata
            }
        }, {
            cache: "no-cache"
        });
        if (response.errors) throw response;
        const challenges = response.result;
        if (!challenges) throw new Error("no challenges in ID response");
        const challengeProcessor = new (0, $d4f5d8469042fea9$export$3b603621c2caaf6c)(this.slashID, this.emitter, {
            authFlowId: this.flowId
        });
        const token = await challengeProcessor.processChallenges({
            challenges: challenges,
            authnFactor: authenticationFactor,
            previousToken: prevToken
        });
        if (handle) try {
            this.slashID.identifiersStorage.add(handle);
        } catch (e) {
            console.warn(e);
        }
        /**
         *
         * @event {@link Types.IdFlowSucceededEvent}
         */ this.emitter.emit({
            name: "idFlowSucceeded",
            payload: {
                token: `${token}`,
                authenticationFactor: authenticationFactor,
                handle: handle
            },
            meta: {
                authFlowId: this.flowId,
                access: "public"
            }
        });
        return this.slashID.getUser(token);
    }
    /**
     * Use a verified handle and a factor to start the account recovery flow.
     * The user will receive instructions on how to proceed using a delivery mechanism based on the given handle.
     * After this method resolves, the user will be able to authenticate using the same handle and factor.
     */ async recover({ handle: handle, factor: factor }) {
        const authnClient = new $8dabc67a561e7dc0$export$872437fb2a17cd0e(new (0, $168d06aed8b3cdb0$export$fa89be98fe0936f2)({
            ...(0, $168d06aed8b3cdb0$export$ac4f8128ea29c5),
            basePath: this.slashID.baseURL,
            middleware: [
                (0, $91df54dff839f8b0$export$ee3eb40e76801bba)({
                    maxRetries: 5,
                    baseDelayMs: 500
                })
            ]
        }));
        const { result: challenges } = await authnClient.postRecover({
            recoverRequest: {
                handle: handle,
                factor: factor
            },
            slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw,
            slashIDOrgID: this.slashID.oid
        });
        if (!challenges) // TODO improve handling
        throw new Error("no result in recover response");
        const challengeProcessor = new (0, $d4f5d8469042fea9$export$3b603621c2caaf6c)(this.slashID, this.emitter, {
            recoveryFlowId: this.flowId
        });
        await challengeProcessor.processChallenges({
            challenges: challenges,
            authnFactor: factor
        });
    }
    constructor(slashID, emitter){
        this.slashID = slashID;
        this.flowId = (0, $9d6b13a2a5a8c65c$export$2e2bcd8739ae039)();
        this.emitter = emitter;
    }
}



function $a6ffb5df14caab21$export$abfecd6a8e6070c1() {
    const eventHandlers = {};
    const middlewares = new Set();
    function on(eventName, handler) {
        if (!eventHandlers[eventName]) eventHandlers[eventName] = new Set();
        eventHandlers[eventName].add(handler);
    }
    function off(eventName, handler) {
        const handlers = eventHandlers[eventName];
        if (handlers) handlers.delete(handler);
    }
    function emit(event) {
        const handlers = eventHandlers[event.name];
        if (!handlers || !handlers.size) return;
        let cancelled = false;
        const eventWithMiddleware = middlewares.size > 0 ? [
            ...middlewares
        ].reduce((eventAggregate, middleware)=>{
            if (cancelled) return eventAggregate;
            return middleware(eventAggregate, ()=>{
                cancelled = true;
            }) || eventAggregate;
        }, event) : event;
        if (cancelled) return;
        handlers.forEach((handler)=>handler(eventWithMiddleware));
    }
    /**
     * Each middleware is called in the order it was added.
     * It must either return an event (potentially modified) or call the cancel function to stop the event from being emitted.
     */ function use(middleware) {
        middlewares.add(middleware);
    }
    return {
        on: on,
        off: off,
        emit: emit,
        use: use
    };
}




class $b826b7a224886278$export$97e23b13d26a722 extends (0, $0a8aed675f99e0c3$export$d3bddec52a513503) {
    /**
     *  Authenticates the [AnonymousUser], on success the user is now a permanently registered user.
     *
     *  @returns `Promise<BrowserUser>`
     */ async id(handle, authenticationFactor) {
        return this._slashid._id(this.decoded.oid, handle, authenticationFactor, this.token);
    }
    /**
     * Reconstruct an anonymous user from its token value. Call the `id` method to authenticate the user.
     * If this results with registering a new user, the underlying user ID will be the same as the originating anonymous user.
     *
     * Instances can only be constructed in a browser environment due to dependency on {@link SlashID}.
     *
     * @param token A user {@link token} value.
     * @param slashid SlashID instance
     *
     * @throws `TypeError` the given token cannot be decoded.
     */ constructor(token, slashid){
        // both the options and SlashID instances have the same fields (baseURL, sdkURL, oid)
        super(token, slashid);
        if (this.decoded.person_type !== "anonymous") throw new Error("Token must have person_type 'anonymous'");
        this._slashid = slashid;
    }
}




const $708a5f26294b10cd$var$SlashIDIFrameID = "__SlashID_iframe";
const $708a5f26294b10cd$var$PRIVATE_PUBLISH = Symbol();
const $708a5f26294b10cd$var$PRIVATE_SUBSCRIBE = Symbol();
const $708a5f26294b10cd$var$PRIVATE_UNSUBSCRIBE = Symbol();
const $708a5f26294b10cd$export$5f74d2b45f2a2732 = (sid)=>({
        publish: (type, event)=>sid[$708a5f26294b10cd$var$PRIVATE_PUBLISH](type, event),
        subscribe: (type, handler)=>sid[$708a5f26294b10cd$var$PRIVATE_SUBSCRIBE](type, handler),
        unsubscribe: (type, handler)=>sid[$708a5f26294b10cd$var$PRIVATE_UNSUBSCRIBE](type, handler)
    });
class $708a5f26294b10cd$export$261888861cdb8a55 {
    /**
     * Get an instance of the Analytics class. Use the instance to track virtual page views.
     * @throws `Error` If analytics is not enabled or oid is not set.
     * @returns Analytics instance
     */ getAnalytics() {
        if (!this.analytics) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
            message: "Analytics has to be enabled to use this method"
        });
        return this.analytics;
    }
    static async canGetPublicKeyCredentialsInIFrame() {
        const jsWindow = window;
        const isChrome = !!jsWindow.chrome && (!!jsWindow.chrome.webstore || !!jsWindow.chrome.runtime);
        return isChrome;
    }
    /**
     * Starts the login flow with a redirect to the hosted login page.
     */ async startHostedLoginFlow(params) {
        // ensure the session storage is ready before starting a new flow
        (0, $2593f0fc9dd6d83e$export$5fb04c0b31ecb34c)(params);
        const { csrf_token: csrf_token, pkce_code_challenge: pkce_code_challenge } = await (0, $2593f0fc9dd6d83e$export$9f45878548a7cf78)();
        const url = new URL("/oauth2/authorize", this.baseURL);
        url.searchParams.set("redirect_uri", params.redirectUri);
        url.searchParams.set("client_id", params.clientId);
        url.searchParams.set("response_type", "code");
        url.searchParams.set("state", csrf_token);
        url.searchParams.set("scope", "openid");
        url.searchParams.set("code_challenge", pkce_code_challenge);
        url.searchParams.set("code_challenge_method", "S256");
        // navigate
        window.location.assign(url);
    }
    /**
     * Resolves the previously started login flow with a redirect to the hosted login page.
     * Call this method on the page where the hosted login page redirects to.
     */ async resolveHostedLoginFlow() {
        const oidcParams = (0, $2593f0fc9dd6d83e$export$2a015c1c89819b5a)(window.location.search);
        if (oidcParams) {
            const { clientId: clientId, redirectUri: redirectUri } = (0, $2593f0fc9dd6d83e$export$a2218d2039ce5af0)();
            // POST to /oauth2/tokens
            // TODO no API client for this
            try {
                const { id_token: id_token } = await (0, $2593f0fc9dd6d83e$export$64ca83e534616343)({
                    ...oidcParams,
                    clientId: clientId,
                    redirectUri: redirectUri,
                    apiBaseURL: this.baseURL
                });
                const user = this.getUser(id_token);
                if (this.analytics) this.getAnalytics().identify(user);
                (0, $2593f0fc9dd6d83e$export$8af8138ab9f57e02)();
                return user;
            } catch (e) {
                await this.processError(e, {});
                throw await $60b6642fd39ba43b$export$ed0b6181311676c(e);
            }
        }
    }
    /**
     * Event emitter middleware that prevents events leaking between flows
     */ createFlowScopeMiddleware() {
        const sdk = this;
        return function middleware(event, cancel) {
            var _sdk_authFlow, _sdk_authFlow1, _sdk_recoveryFlow, _sdk_recoveryFlow1;
            if (event.meta && event.meta.authFlowId && ((_sdk_authFlow = sdk.authFlow) === null || _sdk_authFlow === void 0 ? void 0 : _sdk_authFlow.flowId) && ((_sdk_authFlow1 = sdk.authFlow) === null || _sdk_authFlow1 === void 0 ? void 0 : _sdk_authFlow1.flowId) !== event.meta.authFlowId) return cancel();
            if (event.meta && event.meta.recoveryFlowId && ((_sdk_recoveryFlow = sdk.recoveryFlow) === null || _sdk_recoveryFlow === void 0 ? void 0 : _sdk_recoveryFlow.flowId) && ((_sdk_recoveryFlow1 = sdk.recoveryFlow) === null || _sdk_recoveryFlow1 === void 0 ? void 0 : _sdk_recoveryFlow1.flowId) !== event.meta.recoveryFlowId) return cancel();
            return event;
        };
    }
    /**
     * Publish an event to the SDK. Currently available events are listed in {@link Types.PublicWriteEvents}.
     * @param type
     * @param event
     */ publish(type, event) {
        var _this_authFlow, _this_recoveryFlow;
        if (!$185870848aa59297$export$fdd1788388ec077b(type)) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).unknown,
            message: `Trying to publish an unsupported event: ${type}`,
            context: {
                type: type,
                event: event
            }
        });
        this.emitter.emit({
            name: type,
            payload: event,
            meta: {
                access: "public",
                authFlowId: (_this_authFlow = this.authFlow) === null || _this_authFlow === void 0 ? void 0 : _this_authFlow.flowId,
                recoveryFlowId: (_this_recoveryFlow = this.recoveryFlow) === null || _this_recoveryFlow === void 0 ? void 0 : _this_recoveryFlow.flowId
            }
        });
    }
    /**
     * Variant of [publish] for private events
     */ [$708a5f26294b10cd$var$PRIVATE_PUBLISH](type, event) {
        var _this_authFlow, _this_recoveryFlow;
        if (!$185870848aa59297$export$a447b62f94c26639(type)) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).unknown,
            message: `Trying to publish an unsupported event: ${type}`,
            context: {
                type: type,
                event: event
            }
        });
        this.emitter.emit({
            name: type,
            payload: event,
            meta: {
                access: "private",
                authFlowId: (_this_authFlow = this.authFlow) === null || _this_authFlow === void 0 ? void 0 : _this_authFlow.flowId,
                recoveryFlowId: (_this_recoveryFlow = this.recoveryFlow) === null || _this_recoveryFlow === void 0 ? void 0 : _this_recoveryFlow.flowId
            }
        });
    }
    /**
     * Subscribe to the events published by the SDK. Currently available events are listed in {@link Types.PublicReadEvents}.
     * @param type
     * @param handler
     */ subscribe(type, handler) {
        if (!$185870848aa59297$export$ab1e84ca8f5ea7e(type)) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).unknown,
            message: `Trying to subscribe to unsupported event: ${type}`,
            context: {
                type: type
            }
        });
        // TODO type check fails because of event payload types that are void or string
        // @ts-expect-error
        const wrappedHandler = this.emitterDecoratorFactory.decorate(handler);
        this.emitter.on(type, wrappedHandler);
    }
    /**
     * Variant of [subscribe] for private events
     */ [$708a5f26294b10cd$var$PRIVATE_SUBSCRIBE](type, handler) {
        if (!$185870848aa59297$export$a447b62f94c26639(type)) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).unknown,
            message: `Trying to subscribe to unsupported event: ${type}`,
            context: {
                type: type
            }
        });
        // TODO type check fails because of event payload types that are void or string
        // @ts-expect-error
        const wrappedHandler = this.emitterDecoratorFactory.decorate(handler);
        this.emitter.on(type, wrappedHandler);
    }
    /**
     * Unsubscribe from the SDK events. Currently available events are listed in {@link Types.PublicReadEvents}.
     * @param type
     * @param handler
     */ unsubscribe(type, handler) {
        if (!$185870848aa59297$export$ab1e84ca8f5ea7e(type)) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).unknown,
            message: `Trying to unsubscribe from an unsupported event: ${type}`,
            context: {
                type: type
            }
        });
        // TODO type check fails because of event payload types that are void or string
        // @ts-expect-error
        const decoratedHandler = this.emitterDecoratorFactory.getDecorator(handler);
        if (decoratedHandler) this.emitter.off(type, decoratedHandler);
    }
    /**
     * Variant of [subscribe] for private events
     */ [$708a5f26294b10cd$var$PRIVATE_UNSUBSCRIBE](type, handler) {
        if (!$185870848aa59297$export$a447b62f94c26639(type)) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).unknown,
            message: `Trying to unsubscribe from an unsupported event: ${type}`,
            context: {
                type: type
            }
        });
        // TODO type check fails because of event payload types that are void or string
        // @ts-expect-error
        const decoratedHandler = this.emitterDecoratorFactory.getDecorator(handler);
        if (decoratedHandler) this.emitter.off(type, decoratedHandler);
    }
    /**
     * Get a Promise that resolves to an array of challenge objects.
     */ async getChallengesFromURL() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let challengeObjs = undefined;
        const challengePackId = urlParams.get($962c828014ed43f3$export$b1acc9d748d757e8);
        const encodedChallenges = urlParams.get($962c828014ed43f3$export$61f12a353e32d6b4);
        if (challengePackId && encodedChallenges) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidSlashIDURLParamsError,
            message: "found both 'challenges' and 'sidcp' URL query parameters",
            context: {
                challengePackId: challengePackId,
                encodedChallenges: encodedChallenges,
                queryString: queryString
            }
        });
        if (challengePackId) try {
            // we got a challenge pack ID => get the challenges
            const response = await this.authnClient.getChallengePackChallengePackId({
                challengePackId: challengePackId,
                slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw
            }, {
                cache: "no-cache"
            });
            if (response.errors) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
                name: (0, $91e59605951c3712$export$daceac3b97803ce1).apiResponseError,
                message: "error fetching challenges",
                context: {
                    errors: response.errors
                }
            });
            challengeObjs = response.result;
        } catch (e) {
            throw await $60b6642fd39ba43b$export$ed0b6181311676c(e);
        }
        else if (encodedChallenges) {
            // check whether challenges are encoded directly in the params
            const challengesData = $aae5e813cb61d169$export$2f872c0f2117be69(encodedChallenges);
            const challengesStr = new TextDecoder("utf-8").decode(challengesData);
            challengeObjs = JSON.parse(challengesStr);
        }
        return challengeObjs;
    }
    /**
     * Process authentication challenges from the URL query parameters.
     * You can use this in conjunction with the Direct-ID API to allow your users to land on your
     * target page already authenticated.
     *
     * If Identity Provider Initiated SSO is enabled and the organization ID is set,
     * this method will also start the SSO flow given the correct parameters.
     *
     * @returns The authenticated user from the `challenges` URL parameter, if present, `null` otherwise.
     */ async getUserFromURL() {
        // processing challenges consumes them, it's not idempotent => on success we memoize the result
        if (!this.userFromURL) {
            // decide what to process
            // #1 IdP-initiated flow
            if (this.config.identityProviderInitiatedSSOEnabled && this.oid) {
                const idpInitiatedSSOParams = (0, $561d3dd760db35d2$export$b75ec5c826df5f51)(window.location.search);
                if (idpInitiatedSSOParams) try {
                    const ssoOptions = await (0, $561d3dd760db35d2$export$7c6a3491e5c44625)(idpInitiatedSSOParams);
                    this._id(this.oid, undefined, ssoOptions);
                } catch (e) {
                    await this.processError(e, {});
                    throw await $60b6642fd39ba43b$export$ed0b6181311676c(e);
                }
            }
            // #2 challenges - regular flow
            let challengeObjs;
            try {
                challengeObjs = await this.getChallengesFromURL();
            } catch (e) {
                await this.processError(e, {});
                throw await $60b6642fd39ba43b$export$ed0b6181311676c(e);
            }
            if (challengeObjs) {
                var _this_userFromURL_authentications;
                const ssoParams = $6c3db34ca8f899b2$export$e3ec70811b10f90d(window.location.search);
                if (ssoParams) this.resolveSSOChallenge(ssoParams) // should not block challenge processing
                ;
                let token = undefined;
                try {
                    const challengeProcessor = new (0, $d4f5d8469042fea9$export$3b603621c2caaf6c)(this, this.emitter);
                    token = await challengeProcessor.processChallenges({
                        challenges: challengeObjs
                    });
                } catch (e) {
                    // check if we could extract the challenge ID from the
                    await this.processError(e, {});
                    const isHandlePatternNotAllowedError = $60b6642fd39ba43b$export$a98b3b17ec378e54(e) && await $60b6642fd39ba43b$export$383ea5b2e29d8119(e);
                    if (isHandlePatternNotAllowedError) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
                        name: $91e59605951c3712$export$daceac3b97803ce1.handlePatternNotAllowed,
                        message: e.message,
                        cause: e
                    });
                    const isSignUpAwaitingApprovalError = $60b6642fd39ba43b$export$a98b3b17ec378e54(e) && await $60b6642fd39ba43b$export$3176c4f9177c827(e);
                    if (isSignUpAwaitingApprovalError) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
                        name: $91e59605951c3712$export$daceac3b97803ce1.signUpAwaitingApproval,
                        message: e.message,
                        cause: e
                    });
                    throw await $60b6642fd39ba43b$export$ed0b6181311676c(e);
                }
                this.userFromURL = new (0, $0a8aed675f99e0c3$export$d3bddec52a513503)(token, {
                    baseURL: this.baseURL,
                    sdkURL: this.sdkURL
                });
                if ((_this_userFromURL_authentications = this.userFromURL.authentications) === null || _this_userFromURL_authentications === void 0 ? void 0 : _this_userFromURL_authentications.length) {
                    const lastAuthentication = this.userFromURL.authentications[this.userFromURL.authentications.length - 1];
                    this.emitter.emit({
                        name: "idFlowSucceeded",
                        payload: {
                            token: token,
                            authenticationFactor: {
                                method: lastAuthentication.method
                            },
                            handle: lastAuthentication.handle
                        },
                        meta: {
                            access: "public"
                        }
                    });
                }
            }
        }
        if (this.userFromURL) this.emitter.emit({
            name: "userAuthenticatedFromURL",
            payload: {
                token: this.userFromURL.token
            },
            meta: {
                access: "public"
            }
        });
        return this.userFromURL;
    }
    /**
     * This method first checks for URL params associated with SSO. If they are present, it:
     *  - performs CSRF protection checks
     *  - resolves SSO challenge
     * @returns void
     */ async resolveSSOChallenge({ ssoChallengeID: ssoChallengeID, ssoCode: ssoCode, csrfToken: csrfToken }) {
        if (!ssoChallengeID || !ssoCode || !csrfToken) return;
        try {
            const storedCsrfToken = window.localStorage.getItem($962c828014ed43f3$export$911cde4811331c58);
            if (!storedCsrfToken) throw new Error("no CSRF token stored");
            if (csrfToken !== storedCsrfToken) throw new Error("CSRF token mismatch");
            const pkceCodeVerifier = window.localStorage.getItem($962c828014ed43f3$export$3f272757255eeb30);
            if (!pkceCodeVerifier) throw new Error("no PKCE code verifier stored");
            await this.authnClient.postSsoResolve({
                slashIDOrgID: this.oid,
                postSsoResolveRequest: {
                    challenge_id: ssoChallengeID,
                    code: ssoCode,
                    pkce_code_verifier: pkceCodeVerifier
                }
            });
        } catch (err) {
            this.processError(err, {});
        } finally{
            window.localStorage.removeItem($962c828014ed43f3$export$911cde4811331c58);
            window.localStorage.removeItem($962c828014ed43f3$export$3f272757255eeb30);
        }
    }
    async processEvent(event) {
        // CSRF protection for SSO popup mode
        if ($6c3db34ca8f899b2$export$68ca8012194a4829(event.data)) {
            if (event.origin !== this.baseURL) return;
            const ssoParams = $6c3db34ca8f899b2$export$e3ec70811b10f90d(event.data.urlParams);
            if (ssoParams) await this.resolveSSOChallenge(ssoParams);
            return;
        }
        let sourceWindow = null;
        if (window.opener && event.source === window.opener) sourceWindow = window.opener;
        if (window.parent && event.source === window.parent) sourceWindow = window.parent;
        if (!sourceWindow) return;
        if ($6c3db34ca8f899b2$export$68a74503f112f3ea(event.data)) {
            const request = event.data;
            try {
                sourceWindow.postMessage(new $6c3db34ca8f899b2$export$612749e00a84ad10(request.id), "*");
            } catch (e) {
                sourceWindow.postMessage(new $6c3db34ca8f899b2$export$612749e00a84ad10(request.id, e.toString()), "*");
            }
        }
        if ($6c3db34ca8f899b2$export$2f1c2e17db43d9ae(event.data)) {
            const request = event.data;
            try {
                const challengeProcessor = new (0, $d4f5d8469042fea9$export$3b603621c2caaf6c)(this, this.emitter);
                const attestation = await challengeProcessor.processWebAuthnCreateChallenge(request.challenge);
                sourceWindow.postMessage(new $6c3db34ca8f899b2$export$8b7d42a6791cdca9(request.id, attestation), "*");
            } catch (e) {
                sourceWindow.postMessage(new $6c3db34ca8f899b2$export$8b7d42a6791cdca9(request.id, null, e.toString()), "*");
            }
        }
        if ($6c3db34ca8f899b2$export$3d155c9fa32292c(event.data)) {
            const request = event.data;
            try {
                const challengeProcessor = new (0, $d4f5d8469042fea9$export$3b603621c2caaf6c)(this, this.emitter);
                const attestation = await challengeProcessor.processWebAuthnGetChallenge(request.challenge);
                sourceWindow.postMessage(new $6c3db34ca8f899b2$export$85b72b60e2ec2ca5(request.id, attestation), "*");
            } catch (e) {
                sourceWindow.postMessage(new $6c3db34ca8f899b2$export$85b72b60e2ec2ca5(request.id, null, e.toString()), "*");
            }
        }
    }
    async listenForEvents() {
        window.addEventListener("message", this.processEvent.bind(this));
    }
    setupIFrame() {
        const sdkURLStr = this.getSDKUrl().toString();
        // No need, we're already in the target context
        if ((0, $3943e8c808f9150b$export$ca8daecbc0756b1b)(new URL(window.location.href), new URL(this.sdkURL))) return null;
        // Try to find an existing one by ID
        let slashIDIFrame = document.getElementById($708a5f26294b10cd$var$SlashIDIFrameID);
        if (slashIDIFrame && slashIDIFrame.src !== sdkURLStr) {
            slashIDIFrame.remove();
            slashIDIFrame = null;
        }
        if (!slashIDIFrame) {
            // Not found, create an invisible one
            slashIDIFrame = document.createElement("iframe");
            slashIDIFrame.id = $708a5f26294b10cd$var$SlashIDIFrameID;
            slashIDIFrame.allow = "publickey-credentials-get *";
            slashIDIFrame.src = sdkURLStr;
            slashIDIFrame.style.display = "none";
            document.body.appendChild(slashIDIFrame);
        }
        return slashIDIFrame;
    }
    /**
     * List the available authentication methods for the chosen handle type. Currently available
     * authentication methods are listed in {@link Types.FactorMethod}. Before choosing a method to pass
     * to {@link id} you should consult the result of this method. In particular the availability of
     * the {@link Types.FactorMethod['Webauthn']} method depends on the current device configuration and
     * might not always be available.
     *
     * It's important to note that you can rely on some authentication methods to always be available:
     *
     *  - for {@link PersonHandleType['EmailAddress']}: {@link Types.FactorMethod['OtpViaEmail']} and
     *    {@link Types.FactorMethod['EmailLink']} are always available;
     *  - for {@link PersonHandleType['PhoneNumber']}: {@link Types.FactorMethod['OtpViaSms']} and
     *    {@link Types.FactorMethod['SmsLink']} are always available;
     *
     * On the contrary, the availability of {@link Types.FactorMethod['Webauthn']} depends exclusively on the
     * current device configuration.
     *
     * @remarks The availability of authetication methods can vary over time, you probably should not
     * cache or store the result and instead invoke the method any time you need to authenticate a user.
     *
     * @example
     *
     * SlashID supports a number of handle types, each in turn supporting a set of
     * authentication methods. Supposing you identify your users with e-mail addresses,
     * you should check the authentication methods available on the current device before
     * kicking off the authentication flow:
     *
     * ```js
     * const availableMethods = sid.getAvailableAuthenticationMethods("email_address")
     * // => availableMethods === ["webauthn", "email_link"]
     * ```
     *
     * At this point you can choose which method to use in {@link id}. You could decide based on
     * one or a combination of:
     *
     *  - Your static preference: e.g. require WebAuthn, prefer WebAuthn ({@link Types.FactorMethod['Webauthn']})
     *    if available, otherwise fallback to magic link via e-mail ({@link Types.FactorMethod['EmailLink']})
     *    ```
     *    const chosenMethod = availableMethods.includes("webauthn") ? "webauthn" : "email_link"
     *    ```
     *  - User's choice: you could present your users with a selection of the available methods;
     *
     * In general the SlashID SDK does not impose any restriction on how you decide to choose which
     * authentication method to use.
     *
     * @param handleType Available handle types are ``"email_address"``, ``"phone_number"`` and ``"username"``.
     * @returns  An array of the available authentication methods on this device.
     */ async getAvailableAuthenticationMethods(handleType) {
        const availableMethods = [
            $d180e6976bd68c99$export$8279f5e63c6521d8.Password,
            $d180e6976bd68c99$export$8279f5e63c6521d8.Totp
        ];
        switch(handleType){
            case $1221773f83e5dbf8$export$885886f088cd0586.EmailAddress:
                availableMethods.push($d180e6976bd68c99$export$8279f5e63c6521d8.EmailLink, $d180e6976bd68c99$export$8279f5e63c6521d8.OtpViaEmail);
                break;
            case $1221773f83e5dbf8$export$885886f088cd0586.PhoneNumber:
                availableMethods.push($d180e6976bd68c99$export$8279f5e63c6521d8.SmsLink, $d180e6976bd68c99$export$8279f5e63c6521d8.OtpViaSms);
                break;
            case $1221773f83e5dbf8$export$885886f088cd0586.Username:
                break;
            default:
                throw new $60b6642fd39ba43b$export$f471a06c79be5983({
                    name: (0, $91e59605951c3712$export$daceac3b97803ce1).unknown,
                    message: `unhandled handle type: ${handleType}`
                });
        }
        if (navigator && window.PublicKeyCredential && $f02bc98e6bb876be$export$c51332e5b5280a9f(handleType)) availableMethods.unshift($d180e6976bd68c99$export$8279f5e63c6521d8.Webauthn);
        return availableMethods;
    }
    /**
     * Preferred way of creating  a {@link Types.BaseUser} instance based on an existing token.
     *
     * @param token A user {@link Types.UserTokenText} value.
     * @returns User instance
     */ getUser(token) {
        const user = new (0, $31425f702a7b168e$export$ec7121d802e738bd)(token, this);
        return user;
    }
    /**
     * Identify a user. This method implements the SlashID authentication flow.
     * In particular the flow is:
     *
     *  - **passwordless**: all you need to specify to authenticate a user is their handle,
     *    be it an e-mail address or phone number, and how they wish to authenticate; please see
     *    the parameters documentation for more details;
     *
     *  - **unified**: it does not require you to differentiate between first registration and
     *    subsequent logins attempts. The SlashID service takes care of the distinction and will
     *    perform the necessary verification ceremonies on your behalf under the hood.
     *
     *  - **synchronous**: on successful return the user has verified their identity; even when
     *    the authentication spans multiple devices and is comprised of multiple steps (e.g
     *    clicking a magic link on the provided e-mail address and creating a new biometric
     *    credential on the current device), this method will not return until all steps have
     *    completed or errors have been encountered.
     *
     *
     * Before utilizing any authentication method you should check whether it is available with {@link getAvailableAuthenticationMethods}.
     *
     * The currently available options for the `authenticationFactor.method` field are:
     *
     *  - **``"webauthn"``**: Authenticate the user via WebAuthn on this device. If available this
     *    usually entails built-in biometric authentication or the use of an external FIDO key, with a
     *    preference for the former. Please also see the [WebAuthn scope](#webauthn_scope) and
     *    [WebAuthn attachment](#webauthn_attachment) sections below for details.
     *
     *  - **``"email_link"``**: Deliver a magic link via e-mail.
     *
     *  - **``"otp_via_email"``**: Deliver an OTP security code via e-mail. This authentication method requires you to {@link publish} an
     *    `otpCodeSubmitted` event to the SDK. The event payload must be a string containing the OTP
     *    value, which your user will receive via e-mail.
     *
     *  - **``"sms_link"``**: Deliver a magic link via SMS.
     *
     *  - **``"otp_via_sms"``**: Deliver an OTP security code via SMS. This authentication method requires you to {@link publish} an
     *    `otpCodeSubmitted` event to the SDK. The event payload must be a string containing the OTP
     *    value, which your user will receive via SMS.
     *
     *  - **``oidc``**: Authenticate the user using OIDC through a preconfigured Identity Provider.
     *
     *  - **``totp``**: Authenticate the user with a TOTP code. This authentication method requires you to {@link publish} an
     *    `otpCodeSubmitted` event to the SDK. The event payload must be a string containing the OTP
     *    code, which your user will retrieve from their authenticator app or device.
     *
     * <a name="webauthn_scope"></a>
     * <b>WebAuthn scope</b>
     *
     * In case you have chosen the WebAuthn method, you have the option to specify a `scope`
     * in the `options` field. This field allows you to control the breadth of your users' WebAuthn credentials.
     * The field is optional, but if specified it can either be your domain or any "registrable domain suffix" of it.
     * E.g. if your domain is `shop.domain.com` you have two options to choose from:
     *
     *  - `shop.domain.com`: scope your users to the current domain. Credentials created here will not be shared with sibling domains such as `services.domain.com`;
     *  - `domain.com`: scope your users to the least specific domain. Credentials created here will be allowed to access all subdomains such as `services.domain.com`;
     *
     * Please consult the HTML spec for the formal definition of [registrable domain suffix](https://html.spec.whatwg.org/multipage/origin.html#is-a-registrable-domain-suffix-of-or-is-equal-to)
     * if you need detailed information. When not specified the `scope` option defaults to the current origin, `shop.domain.com`
     * in the example above.
     *
     * <a name="webauthn_attachment"></a>
     * <b>WebAuthn attachment</b>
     *
     * Users can perform WebAuthn either with built-in authenticators (FaceID, TouchID, fingerprint readers, etc.)
     * or external security keys, and in case you have a preference you can control which authenticator type to use
     * by specifying an `attachment` option field in the `options` field.
     * The field is optional and has 3 allowed values from the {@link WebAuthnAuthenticatorAttachment} enum:
     *
     *  - `"platform"`: mandate use of built-in authenticators;
     *  - `"cross-platform"`: mandate use of external security keys;
     *  - `"any"`: the default value if unspecified, allows both types;
     *
     * If left unspecified (or explicitly set to `"any"`) the user will be prompted with a system dialog to choose
     * which type of authenticator they prefer. By providing one of the other options instead (e.g. `"platform"`)
     * you explicitly limit the authenticator types the user can choose from. On most devices this results in the
     * most seamless WebAuthn user experience possible, as the system dialog will not be shown and the user will be
     * prompted to authenticate directly.
     *
     * @param oid Your organization ID.
     * @param handle How the user wishes to identify, e.g. their e-mail address.
     * @param authenticationFactor How to verify the user's identity matches the handle.
     *
     * @throws `slashid.errors_INTERNAL_ONLY.InvalidAuthenticationMethodError` if the chosen method is
     * incompatible with the given handle or is not available on the current device.
     *
     * @fires {@link Types.IdFlowSucceededEvent} when the flow resolves successfully
     *
     * @returns The authenticated user.
     *
     * @example
     *
     * Authenticating a user is as simple as:
     *
     * ```js
     * const user = await slashID.id({
     *   type: "phone_number",
     *   value: "+13337777777",
     * }, {
     *   method: "webauthn"
     * })
     * ```
     *
     * At this point the user has been authenticated; either registered or logged in.
     *
     * You can use it in a header in your HTTP requests:
     *
     * ```js
     * const response = await fetch(url, {
     *   ...
     *   headers: {
     *     'Authorization': `Bearer ${user.token}`,
     *      ...
     *   }
     * });
     * ```
     *
     * You can collect and associate user attributes:
     *
     * ```js
     * const userDetails = { name: "...", streetAddress: "..." }
     * await user.set(userDetails)
     * ```
     *
     * You can perform multi-factor authentication before proceeding with your application logic:
     *
     * ```js
     * await user.mfa({
     *   type: "email_address",
     *   value: "my.email@example.com"
     * }, {
     *   method: "email_link"
     * })
     * ```
     */ async id(oid, handle, authenticationFactor) {
        return this._id(oid, handle, authenticationFactor);
    }
    createAuthFlow() {
        const flow = new (0, $04c0a7b87d2e29c2$export$4d9fb5586e103031)(this, this.emitter);
        this.authFlow = flow;
        return flow;
    }
    clearAuthFlow(flow) {
        if (this.authFlow === flow) this.authFlow = null;
    }
    createRecoveryFlow() {
        const flow = new (0, $04c0a7b87d2e29c2$export$4d9fb5586e103031)(this, this.emitter);
        this.recoveryFlow = flow;
        return flow;
    }
    clearRecoveryFlow(flow) {
        if (this.recoveryFlow === flow) this.recoveryFlow = null;
    }
    /**
     * @internal
     */ async _id(oid, handle, authenticationFactor, prevToken) {
        const flow = this.createAuthFlow();
        try {
            const user = await flow._id({
                oid: oid,
                handle: handle,
                authenticationFactor: authenticationFactor,
                prevToken: prevToken
            });
            return user;
        } catch (e) {
            await this.processError(e, {
                authenticationFactor: authenticationFactor,
                handle: handle,
                previousToken: prevToken
            });
            if ($60b6642fd39ba43b$export$a98b3b17ec378e54(e)) throw await $60b6642fd39ba43b$export$65efd56077f75087(e, {
                handle: handle,
                authenticationFactor: authenticationFactor,
                oid: oid
            });
            throw await $60b6642fd39ba43b$export$ed0b6181311676c(e);
        } finally{
            this.clearAuthFlow(flow);
        }
    }
    /**
     * List the handles previously used to authenticate successfully.
     *
     * @remarks Use of this method is in no way required to authenticate with SlashID. The SDK
     * provides it to allow you to more easily implement loging suggestion drop-down lists
     * and similar UX niceties, by e.g. tying it to a `<datalist>`:
     *
     * ```js
     * const handles = await sid.getAvailableIdentifiers()
     * const options = handles.map((handle) => {
     *   const option = document.createElement("option")
     *   option.value = handle.value
     *   return option
     * })
     * const datalist = document.getElementById("available_identifiers")
     * datalist.replaceChildren(...options)
     *
     * ...
     *
     * <input ... list="available_identifiers" />
     * ```
     *
     * Depending on browser settings, it may not be possible to discover these
     * identifiers.
     *
     * @returns An array of identifiers of previously-authenticated users.
     */ async getAvailableIdentifiers() {
        try {
            return this.identifiersStorage.getAll();
        } catch (e) {
            console.warn(e);
            return [];
        }
    }
    /**
     * Use a verified handle and a factor to start the account recovery flow.
     * The user will receive instructions on how to proceed using a delivery mechanism based on the given handle.
     * After this method resolves, the user will be able to authenticate using the same handle and factor.
     */ async recover({ handle: handle, factor: factor }) {
        if (!this.oid) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidSlashIDConfigurationError,
            message: "oid is required - please initialize the SDK with an organization ID"
        });
        // @ts-expect-error ensure this works in runtime if someone ignores TypeScript
        if (handle.type === $1221773f83e5dbf8$export$885886f088cd0586.Username) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).recoverNonReachableHandleType,
            message: "Username is not a reachable handle type"
        });
        const flow = this.createRecoveryFlow();
        this.emitter.emit({
            name: "recoveryFlowStarted",
            payload: {
                handle: handle,
                authenticationFactor: factor
            },
            meta: {
                access: "public",
                recoveryFlowId: flow.flowId
            }
        });
        try {
            await flow.recover({
                handle: handle,
                factor: factor
            });
            this.recoveryFlow = null;
            this.emitter.emit({
                name: "recoveryFlowSucceeded",
                payload: {
                    handle: handle,
                    authenticationFactor: factor
                },
                meta: {
                    access: "public",
                    recoveryFlowId: flow.flowId
                }
            });
        } catch (error) {
            const failureDetail = await $60b6642fd39ba43b$export$82f46aa4e6535a45(error);
            const errorEvent = {
                errorText: "recovery_failed",
                authenticationFactor: factor,
                handle: handle,
                failureDetail: failureDetail
            };
            this.emitter.emit({
                name: "recoveryFlowFailed",
                payload: errorEvent,
                meta: {
                    access: "public",
                    recoveryFlowId: flow.flowId
                }
            });
            throw await $60b6642fd39ba43b$export$ed0b6181311676c(error);
        } finally{
            this.clearRecoveryFlow(flow);
        }
    }
    getSDKUrl() {
        const sdkURL = new URL(this.sdkURL);
        sdkURL.searchParams.append("v", (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw);
        return sdkURL;
    }
    isLocalScope(rpID) {
        return window.location.hostname.endsWith(rpID);
    }
    /**
     * Examine the error object and publish the proper event as a reaction to it.
     */ async processError(error, { authenticationFactor: authenticationFactor, handle: handle, previousToken: previousToken, challengeId: challengeId }) {
        var _this_authFlow, _this_recoveryFlow;
        console.log({
            error: error
        });
        if ($91e59605951c3712$export$fbcc115299f660c(error)) // cancelling a flow is not an error
        // TODO later turn this into a proper event
        return;
        const errorEvent = await $60b6642fd39ba43b$export$7f84d4628fc07381(error, {
            authenticationFactor: authenticationFactor,
            handle: handle,
            previousToken: previousToken,
            challengeId: challengeId
        });
        if ($185870848aa59297$export$2d39cf9e3832749f(errorEvent)) {
            // TODO: dedupe this in @slashid/react
            const internal = $708a5f26294b10cd$export$5f74d2b45f2a2732(this);
            internal.publish("clientSideError", errorEvent);
        } else this.emitter.emit({
            name: "idFlowFailed",
            payload: errorEvent,
            meta: {
                access: "public",
                authFlowId: (_this_authFlow = this.authFlow) === null || _this_authFlow === void 0 ? void 0 : _this_authFlow.flowId,
                recoveryFlowId: (_this_recoveryFlow = this.recoveryFlow) === null || _this_recoveryFlow === void 0 ? void 0 : _this_recoveryFlow.flowId
            }
        });
    }
    async createAnonymousUser() {
        const createAnonUserOptions = (0, $2f64056e835cba42$export$a96acc74924a1a1)(this);
        const token = await (0, $2f64056e835cba42$export$48a8ffe18f8d9950)(createAnonUserOptions);
        return new (0, $b826b7a224886278$export$97e23b13d26a722)(token, this);
    }
    /**
     * @example
     *
     * For production you can simply create your _SlashID_ instance with:
     *
     * ```js
     * import * as slashid from "slashid"
     * const sid = new slashid.SlashID()
     * ```
     *
     * If you want to experiment and connect to the sandbox environment instead:
     *
     * ```js
     * const sid = new slashid.SlashID({
     *   environment: "sandbox"
     * })
     * ```
     *
     * @param options Your SlashID connection options.
     * @throws `TypeError` If the given `options`, if defined, fail validation
     */ constructor(options){
        if (options) (0, $561d3dd760db35d2$export$7586e69c60094c9d)(options);
        this.config = (0, $561d3dd760db35d2$export$851d251ce7109e65)(options !== null && options !== void 0 ? options : {});
        const { baseURL: baseURL, sdkURL: sdkURL, oid: oid, analyticsEnabled: analyticsEnabled = true } = this.config;
        this.baseURL = baseURL;
        this.sdkURL = sdkURL;
        this.oid = oid;
        this.authFlow = null;
        this.recoveryFlow = null;
        this.authnClient = new $8dabc67a561e7dc0$export$872437fb2a17cd0e(new (0, $168d06aed8b3cdb0$export$fa89be98fe0936f2)({
            ...(0, $168d06aed8b3cdb0$export$ac4f8128ea29c5),
            basePath: this.baseURL,
            middleware: [
                (0, $91df54dff839f8b0$export$ee3eb40e76801bba)({
                    maxRetries: 5,
                    baseDelayMs: 500
                })
            ]
        }));
        this.personsClient = new $9490672e7bca0fe8$export$f5f4fdd1b1ffabb3(new (0, $168d06aed8b3cdb0$export$fa89be98fe0936f2)({
            ...(0, $168d06aed8b3cdb0$export$ac4f8128ea29c5),
            basePath: this.baseURL,
            middleware: [
                (0, $91df54dff839f8b0$export$ee3eb40e76801bba)({
                    maxRetries: 5,
                    baseDelayMs: 500
                })
            ]
        }));
        this.iframe = this.setupIFrame();
        const crossDomainStore = new (0, $b16ebbc972dd3e11$export$68371093923cfc31)(this.iframe, this.getSDKUrl().origin);
        this.identifiersStorage = new (0, $b16ebbc972dd3e11$export$720664048a0262dc)(crossDomainStore);
        this.credentialStorage = new (0, $b16ebbc972dd3e11$export$28d449e9c93b4ea6)(crossDomainStore);
        this.userFromURL = null;
        this.emitter = (0, $a6ffb5df14caab21$export$abfecd6a8e6070c1)();
        this.emitter.use(this.createFlowScopeMiddleware());
        this.emitterDecoratorFactory = $185870848aa59297$export$45e9ff32b647b1fa();
        this.analytics = analyticsEnabled ? new (0, $ae675a4b3b3cae53$export$a7b0438860379c35)({
            sdk: this
        }) : undefined;
        this.listenForEvents();
    }
}





var $lDZ5d = parcelRequire("lDZ5d");
const $40ee1c4c9ac19588$export$3af5f95c25016942 = /^[v^~<>=]*?(\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+))?(?:-([\da-z\-]+(?:\.[\da-z\-]+)*))?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i;
const $40ee1c4c9ac19588$export$a587e8cd55d12c1e = (version)=>{
    if (typeof version !== "string") throw new TypeError("Invalid argument expected string");
    const match = version.match($40ee1c4c9ac19588$export$3af5f95c25016942);
    if (!match) throw new Error(`Invalid argument not valid semver ('${version}' received)`);
    match.shift();
    return match;
};
const $40ee1c4c9ac19588$var$isWildcard = (s)=>s === "*" || s === "x" || s === "X";
const $40ee1c4c9ac19588$var$tryParse = (v)=>{
    const n = parseInt(v, 10);
    return isNaN(n) ? v : n;
};
const $40ee1c4c9ac19588$var$forceType = (a, b)=>typeof a !== typeof b ? [
        String(a),
        String(b)
    ] : [
        a,
        b
    ];
const $40ee1c4c9ac19588$var$compareStrings = (a, b)=>{
    if ($40ee1c4c9ac19588$var$isWildcard(a) || $40ee1c4c9ac19588$var$isWildcard(b)) return 0;
    const [ap, bp] = $40ee1c4c9ac19588$var$forceType($40ee1c4c9ac19588$var$tryParse(a), $40ee1c4c9ac19588$var$tryParse(b));
    if (ap > bp) return 1;
    if (ap < bp) return -1;
    return 0;
};
const $40ee1c4c9ac19588$export$469e457e9b5db249 = (a, b)=>{
    for(let i = 0; i < Math.max(a.length, b.length); i++){
        const r = $40ee1c4c9ac19588$var$compareStrings(a[i] || "0", b[i] || "0");
        if (r !== 0) return r;
    }
    return 0;
};


const $fcaff04a9bd114e9$export$66e1c0999abad646 = (v1, v2)=>{
    // validate input and split into segments
    const n1 = (0, $40ee1c4c9ac19588$export$a587e8cd55d12c1e)(v1);
    const n2 = (0, $40ee1c4c9ac19588$export$a587e8cd55d12c1e)(v2);
    // pop off the patch
    const p1 = n1.pop();
    const p2 = n2.pop();
    // validate numbers
    const r = (0, $40ee1c4c9ac19588$export$469e457e9b5db249)(n1, n2);
    if (r !== 0) return r;
    // validate pre-release
    if (p1 && p2) return (0, $40ee1c4c9ac19588$export$469e457e9b5db249)(p1.split("."), p2.split("."));
    else if (p1 || p2) return p1 ? -1 : 1;
    return 0;
};


const $39ffef1dcb1699ea$var$supported = {
    "Mac OS": {
        // Ventura
        osVersion: "13.0.0",
        browsers: {
            Chrome: "108",
            Safari: "16.1",
            Firefox: "122",
            Opera: "97"
        }
    },
    Windows: undefined,
    Linux: undefined,
    iOS: {
        osVersion: "16",
        browsers: {
            "Mobile Safari": "16",
            Chrome: "108"
        }
    },
    Android: {
        osVersion: "9",
        browsers: {
            Chrome: "108"
        }
    }
};
const $39ffef1dcb1699ea$var$useExperimentalUserAgentData = async ()=>{
    if ("userAgentData" in navigator) {
        const uad = navigator.userAgentData;
        if ("getHighEntropyValues" in uad) return await uad.getHighEntropyValues([
            "platform",
            "platformVersion",
            "fullVersionList",
            "mobile"
        ]);
    }
    return undefined;
};
const $39ffef1dcb1699ea$var$legacyUserAgentBasedDetection = ()=>{
    const runtime = new (0, $lDZ5d.UAParser)(globalThis.navigator.userAgent);
    const browser = runtime.getBrowser();
    const os = runtime.getOS();
    if (!browser.name || !browser.version || !os.name || !os.version) return false;
    const minimum = $39ffef1dcb1699ea$var$supported[os.name];
    if (!minimum) return false;
    const minimumBrowserVersion = minimum === null || minimum === void 0 ? void 0 : minimum.browsers[browser.name];
    if (!minimumBrowserVersion) return false;
    /**
     * We trust that any approved browser on MacOS will work
     *
     * Unfortunately we can't do better targeting on MacOS
     * for the platform version because it always returns
     * 10.15.7
     */ if (os.name === "Mac OS") return true;
    if ((0, $fcaff04a9bd114e9$export$66e1c0999abad646)(browser.version, minimumBrowserVersion) === -1) return false;
    return (0, $fcaff04a9bd114e9$export$66e1c0999abad646)(os.version, minimum.osVersion) !== -1;
};
const $39ffef1dcb1699ea$var$useExperimentalUserAgentDataBasedDetection = (uad)=>{
    const uadBrowserNames = [
        "Google Chrome",
        "Microsoft Edge",
        "Opera"
    ];
    const uadBrandToBrowserName = {
        "Google Chrome": "Chrome",
        "Microsoft Edge": "Edge",
        Opera: "Opera"
    };
    const uadBrandToBrowserNameMobile = {
        "Google Chrome": "Chrome",
        "Microsoft Edge": "Edge",
        Opera: "Opera Mini"
    };
    const uadPlatformToPlatform = {
        macOS: "Mac OS",
        Android: "Android"
    };
    const uadBrowser = uad.fullVersionList.find((entry)=>{
        return uadBrowserNames.includes(entry.brand);
    });
    if (!uadBrowser || !uad.platform || !uad.platformVersion) return false;
    const browserName = uad.mobile ? uadBrandToBrowserNameMobile[uadBrowser.brand] : uadBrandToBrowserName[uadBrowser.brand];
    const browserVersion = uadBrowser.version;
    const platformName = uadPlatformToPlatform[uad.platform];
    const minimum = $39ffef1dcb1699ea$var$supported[platformName];
    if (!minimum) return false;
    if ((0, $fcaff04a9bd114e9$export$66e1c0999abad646)(uad.platformVersion, minimum.osVersion) === -1) return false;
    const minimumBrowserVersion = minimum === null || minimum === void 0 ? void 0 : minimum.browsers[browserName];
    if (!minimumBrowserVersion) return false;
    return (0, $fcaff04a9bd114e9$export$66e1c0999abad646)(browserVersion, minimumBrowserVersion) !== -1;
};
const $39ffef1dcb1699ea$export$bc87d993f6c87f93 = async ()=>{
    try {
        const experimentalUserAgentData = await $39ffef1dcb1699ea$var$useExperimentalUserAgentData();
        if (experimentalUserAgentData) return $39ffef1dcb1699ea$var$useExperimentalUserAgentDataBasedDetection(experimentalUserAgentData);
        return $39ffef1dcb1699ea$var$legacyUserAgentBasedDetection();
    } catch  {
        return false;
    }
};


















function $2847a2b4e283fe27$export$8eeb8027c4bf9150(challenge) {
    return challenge.type === (0, $6efd4ce2feb2bdc3$export$7962c6bffc1da42).Nonce;
}
function $2847a2b4e283fe27$export$ec5e6b950e2171b2(challenge) {
    return challenge.type === (0, $6efd4ce2feb2bdc3$export$7962c6bffc1da42).Proxy;
}




class $248b8a397269ca8e$export$3b603621c2caaf6c {
    updateClient(token) {
        this.authnClient = new $8dabc67a561e7dc0$export$872437fb2a17cd0e(new $168d06aed8b3cdb0$export$fa89be98fe0936f2({
            ...$168d06aed8b3cdb0$export$ac4f8128ea29c5,
            basePath: this.config.baseURL,
            middleware: [
                (0, $91df54dff839f8b0$export$ee3eb40e76801bba)({
                    maxRetries: 5,
                    baseDelayMs: 500
                })
            ],
            fetchApi: this.fetchApi,
            ...token && {
                accessToken: token
            }
        }));
    }
    /**
     * Input must be a query string containig either 'challenges' or 'sidcp' URL query parameters.
     * Get a Promise that resolves to an array of challenge objects.
     * Theses objects are either nonce or proxy challenges.
     */ async parseChallenges(queryString) {
        const urlParams = new URLSearchParams(queryString);
        let challengeObjs = [];
        const challengePackId = urlParams.get($962c828014ed43f3$export$b1acc9d748d757e8);
        const encodedChallenges = urlParams.get($962c828014ed43f3$export$61f12a353e32d6b4);
        if (challengePackId && encodedChallenges) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidSlashIDURLParamsError,
            message: "Both 'challenges' and 'sidcp' URL query parameters are provided.",
            context: {
                queryString: queryString
            }
        });
        if (challengePackId) {
            // we got a challenge pack ID => get the challenges
            const response = await this.authnClient.getChallengePackChallengePackId({
                challengePackId: challengePackId,
                slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw
            }, {
                cache: "no-cache"
            });
            if (response.errors) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
                name: (0, $91e59605951c3712$export$daceac3b97803ce1).apiResponseError,
                message: "API response error",
                context: {
                    queryString: queryString,
                    responseDetails: response
                }
            });
            challengeObjs = response.result;
        } else if (encodedChallenges) {
            // check whether challenges are encoded directly in the params
            const challengesData = $aae5e813cb61d169$export$2f872c0f2117be69(encodedChallenges);
            const challengesStr = new TextDecoder("utf-8").decode(challengesData);
            challengeObjs = JSON.parse(challengesStr);
        }
        // must return null if no challenges are found
        if (!challengeObjs || challengeObjs.length === 0) return null;
        return challengeObjs.filter((challenge)=>(0, $2847a2b4e283fe27$export$8eeb8027c4bf9150)(challenge) || (0, $2847a2b4e283fe27$export$ec5e6b950e2171b2)(challenge));
    }
    /**
     * Process an array of challenges. The challenges must be either nonce or proxy challenges.
     * Returns a Promise that resolves to a user token if the challenge resolution is successful.
     */ async processChallenges({ challenges: challenges, previousToken: previousToken }) {
        this.updateClient(previousToken);
        let userToken = undefined;
        try {
            for (const ch of challenges)userToken = await this.process(ch);
            if (!userToken) throw new Error("no user token in attestation response");
            return userToken;
        } catch (e) {
            // ensure that the top level error is a SlashIDError
            throw await $60b6642fd39ba43b$export$ed0b6181311676c(e);
        }
    }
    async process(challenge) {
        let attestation;
        switch(challenge.type){
            case $6efd4ce2feb2bdc3$export$7962c6bffc1da42.Proxy:
                return this.processProxyChallenge(challenge);
            case $6efd4ce2feb2bdc3$export$7962c6bffc1da42.Nonce:
                attestation = await this.processNonceChallenge(challenge);
                break;
            default:
                throw new Error("unhandled challenge type: " + JSON.stringify(challenge));
        }
        let response;
        try {
            response = await this.authnClient.postAttestationV3({
                // @ts-expect-error challenge_type is typed as possible undefined
                attestation: attestation,
                slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw
            }, {
                cache: "no-cache",
                headers: {
                    origin: this.requestOrigin.toString(),
                    accept: "application/json",
                    "content-type": "application/json"
                }
            });
        } catch (e) {
            if ($60b6642fd39ba43b$export$a98b3b17ec378e54(e)) response = await e.response.clone().json();
            else throw e;
        }
        if ($60b6642fd39ba43b$export$5f71bfa25cb0590e(response) && response.errors.length) throw response;
        const userToken = response.result.token;
        if (!userToken) throw new Error("no user token in attestation response");
        return userToken;
    }
    async processProxyChallenge(challenge) {
        let userToken = undefined;
        let count = 0;
        const threshold = 30;
        while(!userToken){
            if (count++ > threshold) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
                name: (0, $91e59605951c3712$export$daceac3b97803ce1).timeoutError,
                message: "Timed out waiting for user token",
                context: {
                    challenge: challenge
                }
            });
            await $be25baf6593a301c$export$e772c8ff12451969(1000);
            // TODO review
            const response = await this.authnClient.getChallengeChallengeIdV2({
                challengeId: challenge.options.challenge_id,
                slashIDSdkVersion: (0, $0c9d6ccd124360dc$export$f9582ef3c55143f).raw
            }, {
                cache: "no-cache"
            });
            if (response.errors) {
                if (response.errors.length !== 1 || response.errors[0].httpcode !== 202) throw response;
            }
            userToken = response.result;
        }
        return userToken;
    }
    async processNonceChallenge(challenge) {
        var _challenge_options;
        const attestation = {
            challenge_id: challenge.id,
            challenge_type: challenge.type,
            data: {
                challenge: (_challenge_options = challenge.options) === null || _challenge_options === void 0 ? void 0 : _challenge_options.challenge
            }
        };
        return attestation;
    }
    constructor({ origin: origin = "http://localhost", environment: environment, fetchApi: fetchApi } = {}){
        // create the API client
        // make sure it is compatible - min node version or isomorphic-fetch
        this.config = (0, $561d3dd760db35d2$export$851d251ce7109e65)({
            environment: environment
        });
        this.fetchApi = fetchApi || fetch;
        if (!(0, $3943e8c808f9150b$export$fc99885b7e473d08)(origin)) throw new $60b6642fd39ba43b$export$f471a06c79be5983({
            name: (0, $91e59605951c3712$export$daceac3b97803ce1).invalidActionError,
            message: "Invalid origin URL",
            context: {
                origin: origin
            }
        });
        this.requestOrigin = new URL(origin);
        this.authnClient = new $8dabc67a561e7dc0$export$872437fb2a17cd0e(new $168d06aed8b3cdb0$export$fa89be98fe0936f2({
            ...$168d06aed8b3cdb0$export$ac4f8128ea29c5,
            basePath: this.config.baseURL,
            middleware: [
                (0, $91df54dff839f8b0$export$ee3eb40e76801bba)({
                    maxRetries: 5,
                    baseDelayMs: 500
                })
            ],
            fetchApi: this.fetchApi
        }));
    }
}


const $6fc43efda371d022$export$8f376290db229087 = {
    User: (0, $0a8aed675f99e0c3$export$d3bddec52a513503),
    Analytics: (0, $837680a10c4cc3c3$export$e2273de0aec30cd2),
    createAnonymousUserToken: $2f64056e835cba42$export$48a8ffe18f8d9950,
    ChallengeProcessor: (0, $248b8a397269ca8e$export$3b603621c2caaf6c)
};
// re-exporting does not work without creating a new object
const $6fc43efda371d022$export$30f3b02011db23c0 = {
    ...$91e59605951c3712$exports
};
// for naming consistency - namespaces are PascalCase
const $6fc43efda371d022$export$b8e9cd941e8016ac = {
    ...$6fc43efda371d022$export$30f3b02011db23c0
};
const $6fc43efda371d022$export$d2ca453b913dcdea = {
    runtimeSupportsBestPasskeyUX: $39ffef1dcb1699ea$export$bc87d993f6c87f93,
    isReachablePersonHandleType: $f02bc98e6bb876be$export$c51332e5b5280a9f,
    PUBLIC_READ_EVENTS: $185870848aa59297$export$dff4d4401577a965,
    PUBLIC_WRITE_EVENTS: $185870848aa59297$export$b7ca98e78eb4b7f2
};


export {$6fc43efda371d022$export$8f376290db229087 as SSR, $6fc43efda371d022$export$30f3b02011db23c0 as errors, $6fc43efda371d022$export$b8e9cd941e8016ac as Errors, $6fc43efda371d022$export$d2ca453b913dcdea as Utils, $708a5f26294b10cd$export$261888861cdb8a55 as SlashID, $708a5f26294b10cd$export$5f74d2b45f2a2732 as __INTERNAL_ONLY, $31425f702a7b168e$export$ec7121d802e738bd as User, $b826b7a224886278$export$97e23b13d26a722 as AnonymousUser, $2f64056e835cba42$export$48a8ffe18f8d9950 as createAnonymousUserToken, $0c9d6ccd124360dc$export$f9582ef3c55143f as version, $db804c8fc7fc378a$export$51952aaa367c79db as WebAuthnAuthenticatorAttachment, $1221773f83e5dbf8$export$885886f088cd0586 as PersonHandleType};
//# sourceMappingURL=slashid.esm.js.map
